(function () {
    'use strict';

    /**
     * Main module of the Rapi/W3
     */
    angular
            .module('rapi.w3', [
                'toastr',
                //'ngFileUpload',
                'rapi.w3.config',
                
                // services available
                // 'rapi.w3.pusher',
                // 'rapi.w3.plugin.rollbar',
            ]);


})();

(function() {
  'use strict';

  angular
    .module('rapi.w3')
    .directive('w3ButtonUpload', w3ButtonUploadDirective)
    .controller('w3ButtonUploadController', w3ButtonUploadController);

  /**
   * Gera o botão de upload com atributo model
   *
   * use: <w3-button-upload path="vm.row.logo" path-src="vm.row.logo_src" gallery="nomeGaleria" config="configUpload"></w3-button-upload>
   *
   *  Modelo de configuração
   *  config = {
   *      url: w3Utils.urlApi('/uploads'),
   *      params: {
   *          'owner_type': 'LDM\\Casal\\Casal',
   *          'owner_id': null
   *      }
   *  }
   *
   @ngInject */
  function w3ButtonUploadDirective() {
    return {
      restrict: 'E',
      templateUrl: '/app/external/w3/components/w3-uploud/button-upload/button-upload.html',
      controller: 'w3ButtonUploadController as vm',
      scope: {
        'path': '=',
        'pathSrc': '=',
        'gallery': '@',
        'title': '@',
        'size': '@',
        'config': '='
      }
    };
  }

  /** @ngInject */
  function w3ButtonUploadController($log, $scope, w3Upload) {
    /* jshint validthis: true */
    var vm = this,
      config = {};

    // Data
    vm.files = null;
    vm.title = null;

    // Methods
    vm.clean = clean;
    vm.upload = upload;

    active();

    //-------------------------------
    function active() {
      vm.title = $scope.title || "Selecionar arquivo";

      var defaultConfig = {
        params: {}
      };

      config = angular.isObject($scope.config) ? $scope.config : defaultConfig;

      if ($scope.gallery) {
        config.params.gallery = $scope.gallery;
      }
    }

    function clean() {
      $scope.pathSrc = null;
      $scope.path = null;
      vm.files = null;
    }

    function successUpload(result) {
      var key = $scope.size ? 'path_' + $scope.size : 'path';
      var keySrc = key + '_src';

      $scope.pathSrc = result[keySrc];
      $scope.path = result[key];
    }

    function upload() {
      w3Upload.uploadToRapiPlugin(vm.file, null, config).then(function(result) {
        successUpload(result);
      });
    }


  }



})();

(function ()
{
    'use strict';

    angular
        .module('rapi.fuse.layouts', []);

})();

(function () {
    'use strict';

    angular
        .module('rapi.fuse.layouts')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService, w3Config, RfAuthValidation) {
        var vm = this;

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');
        vm.logo = w3Config.get('logo');
        vm.sigla = w3Config.get('sigla');
        vm.customIcon = w3Config.get('toolbar_custom_icon');
        vm.title_project = w3Config.get('title_project');
        vm.openMenu = w3Config.get('menuOpenFrom');
        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon': 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon': 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon': 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            en: {
                'title': 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code': 'en',
                'flag': 'us'
            },
            es: {
                'title': 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code': 'es',
                'flag': 'es'
            },
            tr: {
                'title': 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code': 'tr',
                'flag': 'tr'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;
        vm.onClickIconCalendar = onClickIconCalendar;


        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];

            setWatchers();
        }

        function setWatchers() {
            $rootScope.$on('profileUpdated', onProfileUpdated);
        }


        function onProfileUpdated(event, args) {
            setResource(args);
        }

        function setResource(data) {
            $rootScope.rapiProfile.thumb_src = data.thumb_src;
            $rootScope.rapiProfile.thumb = data.thumb;
            $rootScope.rapiProfile.name = data.name;
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status) {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout() {
            // Do logout here..
            RfAuthValidation.logout();
            $state.go('auth.logout');
        }

        /**
         * Change Language
         */
        function changeLanguage(lang) {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if (lang.code !== 'en') {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position: 'top right',
                    parent: '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded() {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query) {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for (var x = 0; x < flatNavigation.length; x++) {
                if (flatNavigation[x].uisref) {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if (query) {
                navigation = navigation.filter(function (item) {
                    if (angular.lowercase(item.title).search(angular.lowercase(query)) > -1) {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function () {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item) {
            // If item has a link
            if (item.uisref) {
                // If there are state params,
                // use them...
                if (item.stateParams) {
                    $state.go(item.state, item.stateParams);
                }
                else {
                    $state.go(item.state);
                }
            }
        }

        function onClickIconCalendar() {
            $rootScope.$broadcast('toolbar.customIcon.clicked');
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('rapi.fuse.layouts')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController()
    {
        var vm = this;

        // Data
     
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };
        vm.activities = [
            {
                created_at: '12/12/2017',
                description: 'Atividade x em dd',
                link: '',
                profile: {
                    name: 'Pessoa A'
                }
            },
            {
                created_at: '12/12/2017',
                description: 'Atividade x em dd',
                link: '',
                profile: {
                    name: 'Pessoa A'
                }
            }
        ];

        // Methods

        //////////
    }

})();
(function() {
    'use strict';

    angular
        .module('rapi.fuse.layouts')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope, w3Config) {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };
        vm.logo = w3Config.get('logo_painel');
        vm.credits_logo = w3Config.get('credits_logo');
        vm.credits_link = w3Config.get('credits_link');
        vm.versao = w3Config.get('versao');
        vm.sigla = w3Config.get('sigla');
        vm.title_project = w3Config.get('title_project');
        vm.openMenu = w3Config.get('menuOpenFrom');
        
        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded() {
         
            vm.folded = !vm.folded;
      
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function() {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();

(function() {
  'use strict';

  angular
    .module('commons.pedido', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, w3ConfigProvider) {
    // State
    $stateProvider
      .state('xsession.pedido.show', {
        url: '/detalhes/',
        checkSessionRequest: true,
        views: {
          'content@app': {
            templateUrl: '/app/external/pedido/pedido-by-status-show.html',
            controller: 'PedidoByStatusController as vm'
          }
        },
        params: {
          filter: null
        }
      })
      .state('xsession.select-otica', {
        url: '/pedidos/novo-selecionar-otica',
        checkSessionRequest: true,
        views: {
          'content@app': {
            templateUrl: '/app/external/pedido/pedido-select-otica.html',
            controller: 'PedidoSelectOtica as vm'
          }
        }
      })
      .state('xsession.pedido', {
        url: '/pedidos/:status',
        checkSessionRequest: true,
        views: {
          'content@app': {
            templateUrl: '/app/external/pedido/pedido-by-status-archive.html',
            controller: 'PedidoByStatusListController as vm'
          }
        }
      })
      .state('xsession.pedido.new', {
        url: '/novo/{otica_id}',
        checkSessionRequest: true,
        views: {
          'content@app': {
            templateUrl: '/app/external/pedido/pedido-form.html',
            controller: 'PedidoFormController as vm'
          }
        }
      })
      .state('xsession.pedido.edit', {
        url: '/{id}/editar',
        checkSessionRequest: true,
        views: {
          'content@app': {
            templateUrl: '/app/external/pedido/pedido-form.html',
            controller: 'PedidoFormController as vm'
          }
        }
      });


    msNavigationServiceProvider.saveItem('pedido', {
      title: 'PEDIDO.NAVIGATION_MENU.GROUP_TITLE',
      icon: 'icon-cart',
      group : true,
      weight: 10
    });

    msNavigationServiceProvider.saveItem('pedido.all', {
      title: 'All requests',
      translate: 'PEDIDO.NAVIGATION_MENU.ALL_REQUESTS_TITLE',
      // icon: 'icon-cart',
      state: 'xsession.pedido',
      stateParams: {
        'status': 'todos'
      },
      weight: 10
    });

    msNavigationServiceProvider.saveItem('pedido.new_request_otica', {
      title: 'Not sent requests',
      translate: 'PEDIDO.NAVIGATION_MENU.NEW_REQUEST_OTICA_TITLE',
      // icon: 'icon-cart',
      state: 'xsession.pedido',
      stateParams: {
        'status': 'rascunho'
      },
      hidden: hideNavOtica,
      weight: 20
    });

    msNavigationServiceProvider.saveItem('pedido.received_otica', {
      title: 'Received requests',
      translate: 'PEDIDO.NAVIGATION_MENU.RECEIVE_OTICA_TITLE',
      // icon: 'icon-cart',
      state: 'xsession.pedido',
      stateParams: {
        'status': 'envio_otica'
      },
      hidden: hideNavOtica,
      weight: 30
    });

    msNavigationServiceProvider.saveItem('pedido.waiting_polo', {
      title: 'New requests',
      translate: 'PEDIDO.NAVIGATION_MENU.WAITING_POLO_TITLE',
      // icon: 'icon-cart',
      state: 'xsession.pedido',
      stateParams: {
        'status': 'aguardando_polo'
      },
      hidden: hideNavPolo,
      weight: 20
    });

    msNavigationServiceProvider.saveItem('pedido.sending_polo', {
      title: 'Delivered requests',
      translate: 'PEDIDO.NAVIGATION_MENU.RECEIVE_POLO_TITLE',
      // icon: 'icon-cart',
      state: 'xsession.pedido',
      stateParams: {
        'status': 'envio_polo'
      },
      hidden: hideNavPolo,
      weight: 30
    });

    msNavigationServiceProvider.saveItem('pedido.waiting_admin', {
      title: 'New requests',
      translate: 'PEDIDO.NAVIGATION_MENU.WAITING_ADMIN_TITLE',
      // icon: 'icon-cart',
      state: 'xsession.pedido',
      stateParams: {
        'status': 'aguardando_admin'
      },
      hidden: hideNavAdmin,
      weight: 20
    });

    msNavigationServiceProvider.saveItem('pedido.sending_admin', {
      title: 'Delivered requests',
      translate: 'PEDIDO.NAVIGATION_MENU.RECEIVE_ADMIN_TITLE',
      // icon: 'icon-cart',
      state: 'xsession.pedido',
      stateParams: {
        'status': 'envio_admin'
      },
      hidden: hideNavAdmin,
      weight: 30
    });

    msNavigationServiceProvider.saveItem('pedido.waiting_lab', {
      title: 'New requests',
      translate: 'PEDIDO.NAVIGATION_MENU.WAITING_LAB_TITLE',
      // icon: 'icon-cart',
      state: 'xsession.pedido',
      stateParams: {
        'status': 'aguardando_lab'
      },
      hidden: hideNavLab,
      weight: 20
    });

    msNavigationServiceProvider.saveItem('pedido.manufacturing_lab', {
      title: 'Request in producstion',
      translate: 'PEDIDO.NAVIGATION_MENU.MANUFACTURING_LAB_TITLE',
      // icon: 'icon-cart',
      state: 'xsession.pedido',
      stateParams: {
        'status': 'executando_lab'
      },
      hidden: hideNavLab,
      weight: 30
    });


    function hideNavPolo() {
      return !isUserPolo();
    }

    function hideNavOtica() {
      return !isUserOtica();
    }

    function hideNavLab() {
      return !isUserLab();
    }

    function hideNavAdmin() {
      return !isUserAdmin();
    }

    function isUserLab() {
      return w3ConfigProvider.getConfig('module') == 'laboratory';
    }

    function isUserPolo() {
      return w3ConfigProvider.getConfig('module') == 'polo';
    }

    function isUserOtica() {
      return w3ConfigProvider.getConfig('module') == 'optical_shop';
    }

    function isUserAdmin() {
      return w3ConfigProvider.getConfig('module') == 'admin';
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('commons.pedido')
        .controller('PedidoDialogSendRequestOtica', PedidoDialogSendRequestOtica);

    /** @ngInject */
    function PedidoDialogSendRequestOtica(Pedido, w3Config, $mdDialog, request) {
        var vm = this;

        vm.cancel = cancel;
        vm.close = close;


        vm.sendRequest = sendRequest;
        vm.isUserLab = isUserLab;
        vm.getFrameModelURL = getFrameModelURL;
        vm.hasCorteRemoto = hasCorteRemoto;
        activate();

        //---------------

        function activate() {
            vm.request = request;
            console.log('sending *********', vm.request);
        }

        function isUserLab() {
            return w3Config.get('module') === 'laboratory';
        }

        function getFrameModelURL() {
            return Pedido.getFrameModel(vm.request.tipo_armacao).img_src;
        }

        function sendRequest() {

            var data = {
                'id': vm.request.id
            }
            Pedido.sendRequestFromOticaToPolo(data.id).then(sendRequestSucess, function (erro) {
                close(data);
            });

            function sendRequestSucess(result) {
                var data = {
                    'box': result.box,
                    'cod_rastreamento': result.cod_rastreamento,
                    'status_label': result.status_label,
                    'status': result.status,
                }
                close(data);
            }
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function close(data) {
            $mdDialog.hide(data);
        }


        function hasCorteRemoto() {
            return Array.isArray(vm.request.adicionais) && vm.request.adicionais.some(function(item) {
                return item.codigo === 'corte_remoto';
            });
        };
    }

})();

(function() {
  'use strict';

  angular
    .module('commons.pedido')
    .controller('DetailItemDialog', DetailItemDialog);

  /** @ngInject */
  /**
   * @param Pedido
   * @param $mdDialog
   * @param productId: NUMBER
   * @param tipo = 'PRODUCT_NORMAL' | 'PRODUCT_GRESSIVE' | 'MATERIAL' | 'TRATAMENTO' | 'ITEM_PRODUCT_GRESSIVE' | 'ITRACKLINE'
   * @constructor
   */
  function DetailItemDialog(Pedido, $mdDialog, productId, tipo, Produto, Material, Tratamento, Gressive) {
    var vm = this;
    vm.tipo = 'PRODUCT_NORMAL';
    vm.productId = null;
    vm.row = null;
    vm.title = 'Detalhe do item';
    vm.toolbarColor = 'rgb(3,155,229)';


    vm.cancel = cancel;
    vm.close = close;

    activate();

    function activate() {

      vm.tipo = tipo;

      switch (tipo) {
        case  'PRODUCT_NORMAL':
          vm.title = 'Detalhes do produto';
          vm.toolbarColor = 'rgb(3,155,229)';
          Produto.find(productId, {}).then(function(result) {
            vm.row = result;
            if(vm.row.tipo === 'GRESSIVE'){
              vm.toolbarColor = '#FFCA28';
            }
            console.log('result', result);
          });
          break;
        case  'MATERIAL':
          vm.title = 'Detalhes do material';
          vm.toolbarColor = '#9933ff';
          Material.find(productId, {}).then(function(result) {
            vm.row = result;
            console.log('result', result);
          });
          break;

          case  'TRATAMENTO':
          vm.title = 'Detalhes do tratamento';
          vm.toolbarColor = '#00cc99';
          Tratamento.find(productId, {}).then(function(result) {
            vm.row = result;
            console.log('result', result);
          });
          break;
        case  'PRODUCT_GRESSIVE':
          vm.title = 'Detalhes do produto';
          vm.toolbarColor = '#FFCA28';
          Produto.find('gressive', {}).then(function(result) {
            vm.row = result;
            console.log('result', result);
          });
          break;
        case  'ITEM_PRODUCT_GRESSIVE':
          vm.title = 'Detalhes do produto';
          vm.toolbarColor = '#FFCA28';
          Gressive.find(productId, {}).then(function(result) {
            vm.row = result;
            console.log('result', result);
          });
          break;

        case  'ITRACKLINE':
          vm.title = 'Detalhes do código iTRACKLINE';
          vm.toolbarColor = '#00854c';
          Tratamento.find(productId, {}).then(function(result) {
            vm.row = result;

            if(!vm.row.thumb){
              vm.row.thumb_src = 'app/external/assets/images/itrackline-image.jpeg';
            }

          });
          break;
      }

    }

    function cancel() {
      $mdDialog.cancel();
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('commons.pedido')
        .controller('CancelarPedidoDialog', CancelarPedidoDialog);

    /** @ngInject */
    function CancelarPedidoDialog(Pedido, $mdDialog, person, pedido) {
        var vm = this;
        vm.row = null;
        vm.pedido = null;

        vm.cancelPedido = cancelPedido;
        vm.close = close;

        activate();

        //------------------------

        function activate() {
            vm.pedido = pedido;
            vm.row = {
                status: 'CANCELADO_' + person.toUpperCase(),
                obs_cancelamento: ''
            };
        }

        function cancelPedido() {
            Pedido.cancel(pedido.id, vm.row).then(
                $mdDialog.hide(true)
            );
        }

        function close() {
            $mdDialog.cancel();
        }
    }

})();

(function() {
  'use strict';

  angular
    .module('commons.pedido')
    .controller('AlterarValorPedidoDialog', AlterarValorPedidoDialog);

  /** @ngInject */
  function AlterarValorPedidoDialog(Pedido, $mdDialog, row) {
    var vm = this;
    vm.row = null;
    vm.toolbarColor = 'rgb(3,155,229)';
    vm.dataRow = {
      vl_total: 0,
      vl_acrescimo: 0,
      vl_desconto: 0,
      vl_fabricacao: 0,
      vl_comissao: 0,
      vl_comissao_polo: 0,
    };

    vm.cancel = cancel;
    vm.save = save;
    vm.close = close;

    activate();

    function activate() {

      vm.row = row;
      vm.dataRow = {
        vl_total: row.vl_total,
        vl_acrescimo: row.vl_acrescimo,
        vl_desconto: row.vl_desconto,
        vl_fabricacao: row.vl_fabricacao,
        vl_comissao: row.vl_comissao,
        vl_comissao_polo: row.vl_comissao_polo,
      };
    }

    function save() {
      Pedido.changeVlsPedido(vm.row.id, vm.dataRow)
          .then(function (result) {
            $mdDialog.hide(result);
          });
    }

    function cancel() {
      $mdDialog.cancel();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('commons.pedido')
    .directive('productSpecificationsGressive', ProductSpecificationsGressiveDirective);

  /** @ngInject */
  function ProductSpecificationsGressiveDirective() {
    return {
      restrict: 'E',
      scope: {
        product: '=',
        defaultGressiveItens: '=?'
      },
      templateUrl: '/app/external/pedido/directive/product-specifications-gressive/product-specifications-gressive.html',
      controller: ProductSpecificationsGressiveController,
      controllerAs: 'vm',
      bindToController: true
    };
  }

  /** @ngInject */
  function ProductSpecificationsGressiveController($scope, Pedido, $filter) {
    var vm = this;
    vm.codigo = '';
    vm.price = 0;
    vm.ref = 0;
    vm.longe = null;
    vm.intermediario = null;
    vm.perto = null;
    vm.itens = null;

    vm.showDetail = showDetail;
    vm.setCodigo = setCodigo;
    vm.setItensByCodigo = setItensByCodigo;

    // ------------
    $scope.$watch('product', activate);
    $scope.$watch('defaultGressiveItens', setDefaultGressiveItens);

    function activate() {
      _loadItensGressive();

      if(vm.product){
        vm.price = vm.product.preco;
      } else{
        vm.price = 0;
      }

    }

    function setDefaultGressiveItens() {
      vm.perto = vm.defaultGressiveItens && vm.defaultGressiveItens.perto? vm.defaultGressiveItens.perto : null;
      vm.intermediario = vm.defaultGressiveItens && vm.defaultGressiveItens.intermediario? vm.defaultGressiveItens.intermediario : null;
      vm.longe = vm.defaultGressiveItens && vm.defaultGressiveItens.longe? vm.defaultGressiveItens.longe : null;
    }

    function _loadItensGressive() {
      Pedido.gressiveItensByProduct(vm.product.id).then(function(result) {
        vm.loadingOthers = false;
        vm.itens = $filter('w3groupBy')(result, 'tipo');
      }, function () {
        vm.loadingOthers = false;
      });
    }

    function setCodigo(){
      vm.codigo = ((vm.longe? vm.longe.nome: '') + (vm.intermediario? vm.intermediario.nome: '') + (vm.perto? vm.perto.nome: '')).toUpperCase();

      setGressivePrice();
      setGressiveRef();

      var dataChange = {
        codigo: vm.codigo,
        preco: vm.price,
        ref: vm.ref,
        itemLonge: vm.longe? vm.longe: null,
        itemInterm: vm.intermediario? vm.intermediario: null,
        itemPerto: vm.perto? vm.perto: null,
        ids: {
          item_longe_id: vm.longe? vm.longe.id : null,
          item_interm_id: vm.intermediario? vm.intermediario.id : null,
          item_perto_id: vm.perto? vm.perto.id : null,
        }
      };

      $scope.$emit('changeProductTotals', dataChange);
    }

    function setGressivePrice() {
      vm.price = +(vm.product ? vm.product.preco: 0) + (vm.perto? vm.perto.preco: 0) + (vm.intermediario? vm.intermediario.preco: 0) + (vm.longe? vm.longe.preco: 0);
    }
    function setGressiveRef() {
      vm.ref =  +( vm.perto? +vm.perto._ref: 0) + (vm.intermediario? +vm.intermediario._ref: 0) + (vm.longe? +vm.longe._ref: 0);
    }

    function setItensByCodigo() {
      const clearCode = vm.codigo.toUpperCase();
      clearCode.replace(',','');
      const arrayClearCode = clearCode.split(/(\d+)/);

      // set LONGE CODE
      const indexL = arrayClearCode.findIndex(function (it) {
        return it === 'L';
      });
      const codeL = indexL !== -1 ? arrayClearCode[indexL] + arrayClearCode[indexL+1] : '';
      if( codeL && (!vm.longe || codeL !== vm.longe.nome)){
        vm.longe = vm.itens.longe.find(function (item) {
          return item.nome === codeL;
        });
      }
      // set INTERMEDIARIO CODE
      const indexI = arrayClearCode.findIndex(function (it) {
        return it === 'I';
      });
      const codeI = indexI !== -1 ? arrayClearCode[indexI] + arrayClearCode[indexI+1] : '';
      if( codeI && (!vm.intermediario || codeI !== vm.intermediario.nome)){
        vm.intermediario = vm.itens.intermediario.find(function (item) {
          return item.nome === codeI;
        });
      }
      // set perto CODE
      const indexP = arrayClearCode.findIndex(function (it) {
        return it === 'P';
      });
      const codeP = indexP !== -1 ? arrayClearCode[indexP] + arrayClearCode[indexP+1] : '';
      if( codeP && (!vm.perto || codeP !== vm.perto.nome)){
        vm.perto = vm.itens.perto.find(function (item) {
          return item.nome === codeP;
        });
      }

      setGressivePrice();
      setGressiveRef();

      $scope.$emit('changeProductTotals', {codigo: vm.codigo, preco: vm.price, ref: vm.ref});
    }

    function showDetail(tipo) {
      Pedido.showDetailDialog(vm.product.id, tipo);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('commons.pedido')
    .directive('productSpecifications', ProductSpecificationsDirective);

  /** @ngInject */
  function ProductSpecificationsDirective() {
    return {
      restrict: 'E',
      scope: {
        product: '='
      },
      templateUrl: '/app/external/pedido/directive/product-specifications/product-specifications.html',
      controller: ProductSpecificationsController,
      controllerAs: 'vm',
      bindToController: true
    };
  }

  /** @ngInject */
  function ProductSpecificationsController($scope, Pedido) {
    var vm = this;

    vm.showDetail = showDetail;
    // ------------
    $scope.$watch('product', init);

    function init() {
      console.log('ProductSpecifications', vm.product);
    }

    function showDetail() {
      Pedido.showDetailDialog(vm.product.id, 'PRODUCT_NORMAL');
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('commons.pedido')
    .directive('productCardSwitch', ProductCardSwitchDirective);

  /** @ngInject */
  function ProductCardSwitchDirective() {
    return {
      restrict: 'E',
      scope: {
        request: '=',
        defaultGressiveItens: '=?'
      },
      templateUrl: '/app/external/pedido/directive/product-card-switch/product-card-switch.html',
      controller: ProductCardSwitchController,
      controllerAs: 'vm',
      bindToController: true
    };
  }

  /** @ngInject */
  function ProductCardSwitchController($scope) {
    var vm = this;


  }
})();

(function() {
  'use strict';

  angular
    .module('commons.pedido')
    // .controller('PedidoLabelController', PedidoLabelController)
    .directive('pedidoLabel', PedidoLabelDirective);

  /** @ngInject */
  function PedidoLabelDirective() {
    return {
      restrict: 'E',
      scope: {
        id: '=',
        label: '='
      },
      templateUrl: '/app/external/pedido/directive/pedido-label/pedido-label.html',
      controller: PedidoLabelController,
      controllerAs: 'vm',
      bindToController: true
    };
  }

  /** @ngInject */
  function PedidoLabelController(w3Config) {
    var vm = this;

    vm.isUserAdmin = isUserAdmin;
    vm.isUserPolo = isUserPolo;
    vm.isUserOtica = isUserOtica;
    vm.isUserLab = isUserLab;

    function isUserAdmin() {
      return w3Config.get('module') == 'admin';
    }

    function isUserPolo() {
      return w3Config.get('module') == 'polo';
    }

    function isUserOtica() {
      return w3Config.get('module') == 'optical_shop';
    }

    function isUserLab() {
      return w3Config.get('module') == 'laboratory';
    }

    // console.log('==');
    // console.log('pedido-lavel vm', vm);
    // console.log('pedido-lavel vm stringfly', JSON.stringify(vm));
    // console.log('pedido-lavel vm keys', Object.keys(vm));
    // console.log('pedido-lavel vm.id', vm.id, vm.label);
    // console.log('pedido-lavel vm.label',  vm.label);
    // console.log('==');

  }
})();

(function() {
  'use strict';

  angular
    .module('commons.pedido')
    .controller('pedidoDetalhesController', pedidoDetalhesController)
    .directive('pedidoDetalhes', pedidoDetalhesDirective);

  /** @ngInject */
  function pedidoDetalhesDirective() {
    return {
      restrict: 'E',
      scope: {
        request: '='
      },
      templateUrl: '/app/external/pedido/directive/pedido-show-details/pedido-show-details.html',
      controller: 'pedidoDetalhesController as vm'
    };
  }

  /** @ngInject */
  function pedidoDetalhesController(
    $scope,
    $timeout,
    $mdDialog,
    Pedido,
    w3Config) {
    var vm = this;

    // Data
    vm.row = {};

    vm.showCanceledMessage = false;

    // Methods

    //// formats
    vm.formatCity = formatCity;
    vm.formatStreet = formatStreet;

    //// conditions
    vm.getFrameModelURL = getFrameModelURL;
    vm.isActived = isActived;
    vm.isDisabled = isDisabled;
    vm.isImageValid = isImageValid;
    vm.isRequestValid = isRequestValid;
    vm.isUserAdmin = isUserAdmin;
    vm.isUserOtica = isUserOtica;
    vm.isUserPolo = isUserPolo;
    vm.isUserLab = isUserLab;
    vm.showButtonChangeAmount = showButtonChangeAmount;
    vm.changeOrderAmount = changeOrderAmount;
    // vm.showCanceledMessage = showCanceledMessage;
    vm.hasCorteRemoto = hasCorteRemoto;

    activate();

    function activate() {
      $scope.$watch('request.id', setCanceled);
    }

    function setCanceled(newValue, oldValue) {
      if (oldValue != newValue) {
        vm.showCanceledMessage =
          ($scope.request.status != null) &&
          ($scope.request.status.indexOf('CANCELADO') !== -1) &&
          (
            (vm.isUserPolo() && ($scope.request.status == 'CANCELADO_POLO' || $scope.request.status == 'CANCELADO_ADMIN')) ||
            (vm.isUserOtica() && ($scope.request.status == 'CANCELADO_POLO' || $scope.request.status == 'CANCELADO_OTICA')) ||
            (vm.isUserAdmin()));

      }
    }

    // function showCanceledMessage() {
    //   console.log('$scope.request.status', $scope.request);
    //   return ($scope.request.status.indexOf('CANCELADO') !== -1) && (((vm.isUserOtica() || vm.isUserPolo()) && $scope.request.status == 'CANCELADO_POLO') || (vm.isUserAdmin()));
    // }

    function isUserOtica() {
      return w3Config.get('module') == 'optical_shop';
    }

    function isUserAdmin() {
      return w3Config.get('module') == 'admin';
    }

    function isUserPolo() {
      return w3Config.get('module') == 'polo';
    }

    function isUserLab() {
      return w3Config.get('module') == 'laboratory';
    }

    function isRequestValid() {
      return $scope.request != null && !angular.equals($scope.request, {});
    }

    function isActived() {
      return !isDeleted();
    }

    function isDisabled() {
      return isDeleted();
    }

    function isDeleted() {
      return vm.row.deleted_at != null;
    }

    function isImageValid(img) {
      return img != null;
    }

    function formatCity(city) {
      if (city) {
        return city.city_name + ' (' + city.state.state_code + ')';
      }
      return '';
    }

    function getFrameModelURL() {
      return Pedido.getFrameModel($scope.request.tipo_armacao).img_src;
    }

    function formatStreet(streetName, streetNumber) {
      var str = '';
      if (streetName) {
        str += streetName;
        if (streetNumber) {
          str += ", " + streetNumber;
        }
      }
      return str;
    }

    function showButtonChangeAmount() {
      // verifica se é o admin que está vendo, se está aguardando o admin, e se ainda não foi aprovado
      return vm.isUserAdmin() && ['AGUARDANDO_POLO', 'RASCUNHO', 'AGUARDANDO_ADMIN', 'AGUARDANDO_LAB', 'EXECUTANDO_LAB', 'ENVIO_ADMIN'].includes($scope.request.status) ;
    }

    function changeOrderAmount(ev) {
      var dialog = {
        controller: 'AlterarValorPedidoDialog',
        controllerAs: 'vm',
        templateUrl: '/app/external/pedido/dialog/alterar-pedido-valor/alterar-pedido-valor-dialog.html',
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          'row': $scope.request
        }
      };


      $mdDialog.show(dialog).then(function(result) {
        if(result){
          $scope.request = angular.merge({}, $scope.request, result);
        }
      });
    }


    function hasCorteRemoto() {
      return Array.isArray($scope.request.adicionais) && $scope.request.adicionais.some(function(item) {
        return item.codigo === 'corte_remoto';
      });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('commons.pedido')
    .controller('pedidoCommentsController', pedidoCommentsController)
    .directive('pedidoComments', pedidoCommentsDirective);

  /** @ngInject */
  function pedidoCommentsDirective() {
    return {
      restrict: 'E',
      scope: {
        requestId: '@'
      },
      templateUrl: '/app/external/pedido/directive/pedido-comment/pedido-comment.html',
      controller: 'pedidoCommentsController as vm'
    };
  }

  /** @ngInject */
  function pedidoCommentsController($scope) {
    var vm = this;

    vm.row = {};
    vm.commetConfig = {
      params: {
        // Table in Database
        owner_type: 'Make\\Polo\\Pedido\\Pedido ',
        // Object ID
        owner_id: $scope.requestId
      },
      types: [{
          key: 'mensagem',
          label: 'Mensagem'
        },
        {
          key: 'observacao',
          label: 'Observação'
        },
        {
          key: 'aviso',
          label: 'Aviso'
        },
        {
          key: 'sugestao',
          label: 'Sugestão'
        }
      ]
    };

    $scope.$watch('requestId', function() {
      vm.commetConfig.params.owner_id = $scope.requestId;
    });

  }
})();

(function() {
  'use strict';

  angular
    .module('commons.pedido')
    .controller('pedidoActionsController', pedidoActionsController)
    .directive('pedidoActions', pedidoActionsDirective);

  /** @ngInject */
  function pedidoActionsDirective() {
    return {
      restrict: 'E',
      scope: {
        request: '='
      },
      templateUrl: '/app/external/pedido/directive/pedido-actions/pedido-actions.html',
      controller: 'pedidoActionsController as vm'
    };
  }

  /** @ngInject */
  function pedidoActionsController(Pedido, Impressora, $scope, $translate, $mdDialog, w3Config, w3Local) {
    var vm = this;

    //// Permission to do action
    vm.canAdminRefuseRequest = canAdminRefuseRequest;
    vm.canAdminSendRequestToLab = canAdminSendRequestToLab;
    vm.canAdminSendRequestToPolo = canAdminSendRequestToPolo;
    vm.canLabAcceptRequest = canLabAcceptRequest;
    vm.canLabRefuseRequest = canLabRefuseRequest;
    vm.canLabSendRequestToAdmin = canLabSendRequestToAdmin;
    vm.canOticaFinishRequest = canOticaFinishRequest;
    vm.canOticaRefuseRequest = canOticaRefuseRequest;
    vm.canPoloRefuseRequest = canPoloRefuseRequest;
    vm.canPoloSendRequestToAdmin = canPoloSendRequestToAdmin;
    vm.canPoloSendRequestToOtica = canPoloSendRequestToOtica;

    //// Condition validation
    vm.isStatusEqualsDeliverToOtica = isStatusEqualsDeliverToOtica;
    vm.isStatusEqualsDeliverToPolo = isStatusEqualsDeliverToPolo;
    vm.isStatusEqualsToFinish = isStatusEqualsToFinish;
    vm.isStatusEqualsToNew = isStatusEqualsToNew;
    vm.isStatusEqualsWaitingAdmin = isStatusEqualsWaitingAdmin;
    vm.isStatusEqualsWaitingPolo = isStatusEqualsWaitingPolo;
    vm.isUserAdmin = isUserAdmin;
    vm.isUserLab = isUserLab;
    vm.isUserOtica = isUserOtica;
    vm.isUserPolo = isUserPolo;

    //// Dialog calls
    vm.callAcceptRequestFromAdminDialog = callAcceptRequestFromAdminDialog;
    vm.callDeclineRequestDialog = callDeclineRequestDialog;
    vm.callFinishRequest = callFinishRequest;
    vm.callSendRequestFromAdminToLab = callSendRequestFromAdminToLab;
    vm.callSendRequestFromAdminToPolo = callSendRequestFromAdminToPolo;
    vm.callSendRequestFromLabToAdmin = callSendRequestFromLabToAdmin;
    vm.callSendRequestFromOticaToPolo = callSendRequestFromOticaToPolo;
    vm.callSendRequestFromPoloToAdmin = callSendRequestFromPoloToAdmin;
    vm.callSendRequestFromPoloToOtica = callSendRequestFromPoloToOtica;

    //// Print
    vm.printPackingLabel = printPackingLabel;
    vm.printPvcCarc = printPvcCarc;
    vm.printSelelrAwardLabel = printSelelrAwardLabel;
    vm.printServiceOrder = printServiceOrder;
    // vm.printDetails = printDetails;

    //// Others
    vm.enableCancel = enableCancel;
    vm.openPrintMenu = openPrintMenu;
    vm.openConfigureImpressora = openConfigureImpressora;
    vm.cancelConfirm = cancelConfirm;

    activate();

    //-----------------------

    function activate() {
      if(isUserAdmin() && w3Local.get('defaultImpressora')){
        vm.impressora = w3Local.get('defaultImpressora');
      }else{
        vm.impressora = null;
      }
    }

    ////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////
    // CAN Functions

    ////////////////////////////////////////////////////////////////////////////
    //// CAN Functions -- ADMIN

    function canAdminRefuseRequest() {
      return !isStatusEqualsCanceled();
    }

    function canAdminSendRequestToPolo() {
      return isStatusEqualsDeliverToPolo();
    }

    function canAdminSendRequestToLab() {
      return isStatusEqualsWaitingAdmin();
    }

    //////////////////////////////////////////////////////////
    //// CAN Functions -- LAB
    function canLabAcceptRequest() {
      return isStatusEqualsWaitingLab();
    }

    function canLabRefuseRequest() {
      return !isStatusEqualsCanceled() && isStatusEqualsWaitingLab();
    }

    function canLabSendRequestToAdmin() {
      return isStatusEqualsExecutinLab();
    }

    //////////////////////////////////////////////////////////
    //// CAN Functions -- OTICA

    function canOticaFinishRequest() {
      return isStatusEqualsToFinish();
    }

    function canOticaRefuseRequest() {
      return !isStatusEqualsCanceled();
    }

    //////////////////////////////////////////////////////////

    function canPoloRefuseRequest() {
      return !isStatusEqualsCanceled();
    }

    function canPoloSendRequestToAdmin() {
      return isStatusEqualsWaitingPolo();
    }

    function canPoloSendRequestToOtica() {
      return isStatusEqualsDeliverToOtica();
    }

    ////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////
    // IS functions

    //////////////////////////////////////////////////////////
    //// IS Functions -- ADMIN

    function isStatusEqualsDeliverToPolo() {
      return $scope.request.status == 'ENVIO_ADMIN';
    }

    function isStatusEqualsWaitingAdmin() {
      return $scope.request.status == 'AGUARDANDO_ADMIN';
    }

    function isUserAdmin() {
      return w3Config.get('module') == 'admin';
    }

    function enableCancel() {
      return isUserAdmin() && $scope.request.status != 'CANCELADO_ADMIN' && $scope.request.status != 'CANCELADO_OTICA';
    }

    //////////////////////////////////////////////////////////
    //// IS Functions -- LAB
    function isStatusEqualsWaitingLab() {
      return $scope.request.status == 'AGUARDANDO_LAB';
    }

    function isStatusEqualsExecutinLab() {
      return $scope.request.status == 'EXECUTANDO_LAB';
    }

    function isUserLab() {
      return w3Config.get('module') == 'laboratory';
    }

    //////////////////////////////////////////////////////////
    //// IS Functions -- OTICA

    function isStatusEqualsToFinish() {
      return $scope.request.status == 'ENVIO_OTICA';
    }

    function isStatusEqualsToNew() {
      return $scope.request.status == 'RASCUNHO';
    }

    function isUserOtica() {
      return w3Config.get('module') == 'optical_shop';
    }

    //////////////////////////////////////////////////////////
    //// IS Functions -- POLO
    function isStatusEqualsWaitingPolo() {
      return $scope.request.status == "AGUARDANDO_POLO";
    }

    function isStatusEqualsDeliverToOtica() {
      return $scope.request.status == "ENVIO_POLO";
    }

    function isUserPolo() {
      return w3Config.get('module') == 'polo';
    }

    //////////////////////////////////////////////////////////
    //// IS Functions -- GENERAL
    function isStatusEqualsCanceled() {
      return $scope.request.status != null && $scope.request.status.indexOf('CANCELADO') !== -1;
    }

    function isStatusEqualsFinished() {
      return $scope.request.status == "FINALIZADO";
    }


    ////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////
    // Dialog call functions

    //////////////////////////////////////////////////////////
    //// Dialog call functions -- ADMIN
    function callSendRequestFromAdminToLab(ev) {
      var data = {
        'id': $scope.request.id,
        'person_prefix': 'o',
        'person': 'Laboratório',
        'type': 'send',
        'status': $scope.request.status,
      }

      var dialog = {
        controller: 'PedidoDialogSendRequest',
        controllerAs: 'vm',
        templateUrl: '/app/external/pedido/dialog/pedido-dialog-send-request.html',
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          'request': data
        }
      }

      return $mdDialog.show(dialog).then(changeStatusSucess);

      function changeStatusSucess(response) {
        updateStatus(response);
      }
    }

    function callSendRequestFromAdminToPolo(ev) {
      var data = {
        'id': $scope.request.id,
        'person_prefix': 'a',
        'person': 'Polo',
        'type': 'deliver',
        'status': $scope.request.status,
      }

      var dialog = {
        controller: 'PedidoDialogSendRequest',
        controllerAs: 'vm',
        templateUrl: '/app/external/pedido/dialog/pedido-dialog-send-request.html',
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          'request': data,
        }
      }

      return $mdDialog.show(dialog).then(changeStatusSucess);

      function changeStatusSucess(response) {
        updateStatus(response);
        $scope.request.cod_rastreamento = response.cod_rastreamento;
      }
    }

    //////////////////////////////////////////////////////////
    //// Dialog call functions -- LAB
    function callAcceptRequestFromAdminDialog(ev) {
      var data = {
        'id': $scope.request.id,
        'person_prefix': 'pelo',
        'person': 'Admin',
        'type': 'produce',
        'status': $scope.request.status,
      }

      var dialog = {
        controller: 'PedidoDialogSendRequest',
        controllerAs: 'vm',
        templateUrl: '/app/external/pedido/dialog/pedido-dialog-send-request.html',
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          'request': data
        }
      }

      return $mdDialog.show(dialog).then(changeStatusSucess);

      function changeStatusSucess(response) {
        updateStatus(response);
      }
    }

    function callSendRequestFromLabToAdmin(ev) {
      var data = {
        'id': $scope.request.id,
        'person_prefix': 'o',
        'person': 'Admin',
        'type': 'deliver',
        'status': $scope.request.status,
      }

      var dialog = {
        controller: 'PedidoDialogSendRequest',
        controllerAs: 'vm',
        templateUrl: '/app/external/pedido/dialog/pedido-dialog-send-request.html',
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          'request': data
        }
      }

      return $mdDialog.show(dialog).then(changeStatusSucess);

      function changeStatusSucess(response) {
        updateStatus(response);
      }
    }

    //////////////////////////////////////////////////////////
    //// Dialog call functions -- OTICA
    function callSendRequestFromOticaToPolo(ev) {
      var data = {
        'id': $scope.request.id,
        'person_prefix': 'a',
        'person': 'Polo',
        'type': 'send',
        'status': $scope.request.status,
      };

      var dialog = {
        controller: 'PedidoDialogSendRequest',
        controllerAs: 'vm',
        templateUrl: '/app/external/pedido/dialog/pedido-dialog-send-request.html',
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          'request': data
        }
      }

      return $mdDialog.show(dialog).then(changeStatusSucess);

      function changeStatusSucess(response) {
        updateStatus(response);
      }
    }

    function callFinishRequest(ev) {
      var data = {
        'id': $scope.request.id,
        'status': $scope.request.status,
        'type': 'end',
      };

      var dialog = {
        controller: 'PedidoDialogSendRequest',
        controllerAs: 'vm',
        templateUrl: '/app/external/pedido/dialog/pedido-dialog-send-request.html',
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          'request': data
        }
      }

      return $mdDialog.show(dialog).then(changeStatusSucess);

      function changeStatusSucess(response) {
        updateStatus(response);
      }
    }

    //////////////////////////////////////////////////////////
    //// Dialog call functions -- POLO

    function callSendRequestFromPoloToOtica(ev) {
      var data = {
        'id': $scope.request.id,
        'person_prefix': 'a',
        'person': 'Ótica',
        'type': 'deliver',
        'status': $scope.request.status,
      }

      var dialog = {
        controller: 'PedidoDialogSendRequest',
        controllerAs: 'vm',
        templateUrl: '/app/external/pedido/dialog/pedido-dialog-send-request.html',
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          'request': data
        }
      }

      return $mdDialog.show(dialog).then(changeStatusSucess);

      function changeStatusSucess(response) {
        updateStatus(response);
        $scope.request.cod_rastreamento = response.cod_rastreamento;
      }
    }

    function callSendRequestFromPoloToAdmin(ev) {
      var data = {
        'id': $scope.request.id,
        'person_prefix': 'o',
        'person': 'Admin',
        'type': 'send',
        'status': $scope.request.status,
      }

      var dialog = {
        controller: 'PedidoDialogSendRequest',
        controllerAs: 'vm',
        templateUrl: '/app/external/pedido/dialog/pedido-dialog-send-request.html',
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          'request': data
        }
      }

      return $mdDialog.show(dialog).then(changeStatusSucess);

      function changeStatusSucess(response) {
        updateStatus(response);
        $scope.request.box = response.box;
      }
    }

    //////////////////////////////////////////////////////////
    //// Dialog call functions -- GENERAL
    function callDeclineRequestDialog(ev) { // POLO -- LAB -- ADMIN
      var data = {
        'id': $scope.request.id,
        'status': $scope.request.status,
      }

      var dialog = {
        controller: 'PedidoDialogDeclineRequest',
        controllerAs: 'vm',
        templateUrl: '/app/external/pedido/dialog/pedido-dialog-decline-request.html',
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          'request': data
        }
      }

      return $mdDialog.show(dialog).then(changeStatusSucess);

      function changeStatusSucess(response) {
        updateStatus(response);
      }
    }

    function dispatchPrint(template) {
      if(!vm.impressora || !vm.impressora.host || !vm.impressora.nome){
        openConfigureImpressora(null);
      }

      Impressora.printByTemplate(vm.impressora.host, vm.impressora.nome, template, $scope.request.id);
    }

    // Print Functions
    function printPackingLabel() {
      dispatchPrint('id');
    //   window.open($scope.request.printers.envelope);
    // printJS($scope.request.printers.envelope, 'image'); //printers.pedido
    }

    function printPvcCarc() {
      dispatchPrint('garantia');
    //   window.open($scope.request.printers.cartao_garantia);
    // printJS($scope.request.printers.cartao_garantia, 'image'); //printers.pedido
    }

    function printSelelrAwardLabel() {
      dispatchPrint('premio');
    //   window.open($scope.request.printers.cartao_bonus);
    // printJS($scope.request.printers.cartao_bonus, 'image'); //printers.pedido
    }

    // function printDetails() {
    //   printJS($scope.request.printers.pedido, 'html'); //printers.pedido
    // }

    function printServiceOrder() {
      window.open($scope.request.printers.etiqueta)
    printJS($scope.request.printers.etiqueta, 'image'); //printers.pedido
    }

    // Others functions
    function openPrintMenu($mdMenu, ev) {
      vm.printMenuEvent = ev;
      $mdMenu.open(ev);
    }

    function updateStatus(data) {
      $scope.request.status = data.status;
      $scope.request.status_label = data.status_label;
    }

    function openConfigureImpressora(ev) {
      Impressora.openConfigPrintDialog(ev).then(function (imp) {
        if(imp){
          vm.impressora = imp;
        }
      });
    }

    function cancelConfirm(ev) {
      Pedido.showCancelDialog('ADMIN', $scope.request, ev).then(function (result) {
        if (result) {
          activate();
        }
      });
    }
  }
})();

(function () {
    'use strict';
    angular
            .module('rapi.w3.pusher', ['pusher-angular'])
//            .config(config)
            .factory('w3Pusher', w3Pusher);

    /** @ngInject */
    //mytodo: transformar em plugin
//    function config(w3ConfigProvider, RollbarProvider)
//    {
//        var pusherPlugin = w3ConfigProvider.makePlugin('pusher');
//
//        pusherPlugin.init = function (token)
//        {
//            RollbarProvider.init({
//                accessToken: token,
//                captureUncaught: true
//            });
//        };
//
//        var turorial = [
//            '###BOWER INSTAL:',
//            'bower install ng-rollbar --save',
//            '###index.config:',
//            'import module [rapi.w3.plugin.rollbar]',
//            'w3ConfigProvider.plugin(\'rollbar\').init(\'YOUR_TOKEN\')',
//            'https://github.com/tandibar/ng-rollbar'
//        ];
//
//        pusherPlugin.setTutotial(turorial);
//
//        w3ConfigProvider.addPluginProvider(pusherPlugin);
//    }

    /**
     REF: https://github.com/pusher/pusher-angular
     
     Outra package interessante
     https://github.com/doowb/angular-pusher
     
     Proprio blog do pusher falando deste a cima
     https://blog.pusher.com/making-angular-js-realtime-with-pusher/
     
     */

    /** @ngInject */
    function w3Pusher($pusher, w3Config, $window) {

        var config = w3Config.get('pusher');
        console.log('Init w3Pusher', config);

        // Enable pusher logging - don't include this in production
        var host = w3Config.get('host').env;
        if(host === 'development' || host === 'local'){
          $window.Pusher.logToConsole = true;
        }

        var client = new Pusher(config.key, {
            //authEndpoint: "http://example.com/pusher/auth"
            cluster: config.cluster,
            encrypted: true
        });

        var pusher = $pusher(client);

        return pusher;
    }


})();

(function () {
  'use strict';

  angular
      .module('rapi.w3.plugin.rollbar',
          [
            'rapi.w3.config',
            'tandibar/ng-rollbar'
          ]);

})();
(function () {
  'use strict';

  angular
      .module('rapi.w3.plugin.rollbar')
      .run(runBlock);

  /** @ngInject */
  function runBlock($rootScope, $log, Rollbar, w3Rollbar) {
    init();

    function init() {
      if (w3Rollbar.isActive()) {
        setWatches();
        // setVerbose();
      }
    }

    function setWatches() {
      $rootScope.$on('w3Auth:loginSuccess', onLoginSuccess);
      $rootScope.$on('w3Auth:logout', onLogoutSuccess);
      $rootScope.$on('RefreshToken:error', onRefreshTokenError);
    }

    function setVerbose() {
      Rollbar.verbose();
    }

    function onLogoutSuccess() {
      updateGuestPayload();
    }

    function onRefreshTokenError() {
      updateGuestPayload();
    }

    function onLoginSuccess(user) {
      updatePersonPayload(user);
    }

    function updatePersonPayload(user) {
      var config = {
        payload: {
          person: w3Rollbar.payload.makePerson(user)
        }
      };

      Rollbar.configure(config);
    }

    function updateGuestPayload() {
      var config = {
        payload: {
          person: w3Rollbar.payload.makeGuestPerson()
        }
      };

      Rollbar.configure(config);
    }

  }

})();
(function () {
  'use strict';

  angular
      .module('rapi.w3.plugin.rollbar')
      .provider('w3RollbarProvider', w3RollbarProvider);

  /** @ngInject */
  function w3RollbarProvider() {
    this.$get = ["w3Rollbar", getRollbar];

    function getRollbar(w3Rollbar) {
      return w3Rollbar;
    }
  }

})();
(function () {
  'use strict';

  angular
      .module('rapi.w3.plugin.rollbar')
      .factory('w3Rollbar', w3RollbarService);

  /** @ngInject */
  function w3RollbarService($window, $log, w3Config) {
    var services = {
      payload: {
        makePerson: makePersonPayload,
        makeGuestPerson: makeGuestPayload
      },
      isActive: isActiveInThisEnviroment,
      makeRollbarConfig: makeRollbarConfig,
      disableRollbarOnAdBlock: disableRollbarOnAdBlock,
      logConfig: logConfig
    };

    var defaultIgnoredHttpCodes = [400, 401];
    var defaultIgnoredCodes = ['WRONG_ARGS'];
    var defaultIgnoredMessages = ['The token has been blacklisted'];

    return services;

    function makeRollbarConfig() {
      return {
        accessToken: getRollbarToken(),
        captureUncaught: true,
        captureUnhandledRejections: true,
        payload: {
          environment: getCurrentEnvironment(),
          person: makePersonPayload(),
          client: {
            javascript: {
              code_version: getCurrentVersion(),
              source_map_enabled: false,
              guess_uncaught_frames: false
            }
          }
        },
        ignoredMessages: getIgnoredMessages(),
        checkIgnore: checkIgnore
      };
    }

    function getIgnoredMessages() {
      var ignoredMessages = [];
      var appIgnoredMessages = w3Config.get('rollbar').ignoredMessages;

      if (!w3Config.get('rollbar').overrideIgnoredMessages) {
        ignoredMessages = ignoredMessages.concat(defaultIgnoredMessages);
      }

      if (appIgnoredMessages) {
        ignoredMessages = ignoredMessages.concat(appIgnoredMessages);
      }

      return ignoredMessages;
    }

    // https://rollbar.com/blog/reduce-noise-logging-javascript-exceptions/
    function checkIgnore(isUncaught, args, payload) {
      var err = null;
      var ignore = false;

      if (isErrFromHttpRequest(args[0])) {
        err = parseArgs(args[0]);
        if (isHttpCodeIgnored(err.data.error.http_code) ||
            isCodeIgnored(err.data.error.code)) {
          ignore = true;
        }
      }

      // $log.info('Rollback error notification check');
      // $log.info();
      // $log.info('received args', args);
      // $log.info('used args', err);
      // $log.info('Http codes to be ignored', defaultIgnoredHttpCodes.concat(w3Config.get('rollbar').ignoredHttpCodes));
      // $log.info('Codes to be ignored', defaultIgnoredCodes.concat(w3Config.get('rollbar').ignoredCodes));
      // $log.info('Decision to ignore', ignore);
      // $log.info();

      return ignore;
    }

    function isErrFromHttpRequest(args) {
      return (typeof args) === 'string';
    }

    function parseArgs(args) {
      var startIndex = args.indexOf('{');
      var str = args.substr(startIndex);

      return JSON.parse(str);
    }

    function isHttpCodeIgnored(code) {
      var ignoredCodes = [];
      var appIgnoredCodes = w3Config.get('rollbar').ignoredHttpCodes;

      if (!w3Config.get('rollbar').overrideIgnoredHttpCodes) {
        ignoredCodes = ignoredCodes.concat(defaultIgnoredHttpCodes);
      }

      if (appIgnoredCodes) {
        ignoredCodes = ignoredCodes.concat(appIgnoredCodes);
      }

      return ignoredCodes.includes(code);
    }

    function isCodeIgnored(code) {
      var ignoredCodes = [];
      var appIgnoredCodes = w3Config.get('rollbar').ignoredCodes;

      if (!w3Config.get('rollbar').overrideIgnoredCodes) {
        ignoredCodes = ignoredCodes.concat(defaultIgnoredCodes);
      }

      if (appIgnoredCodes) {
        ignoredCodes = ignoredCodes.concat(appIgnoredCodes);
      }

      return ignoredCodes.includes(code);
    }

    function isActiveInThisEnviroment() {
      var environments = w3Config.get('rollbar').activeOnEnvironments;
      var currentEnvironment = w3Config.get('host').env;

      return environments.includes(currentEnvironment);
    }

    function makePersonPayload(user) {
      var person;
      user = user ? user : getUserData();

      if (user) {
        person = {
          id: user.id,
          username: user.name,
          email: user.email
        }
      } else {
        person = makeGuestPayload();
      }

      $log.info('w3Rollbar - Generate person payload', person);

      return person;
    }

    function makeGuestPayload() {
      $log.info('w3Rollbar - Generate guest person payload');
      return {
        id: 0,
        username: 'Guest'
      }
    }

    function getUserData() {
      return JSON.parse($window.localStorage.getItem('rapi.auth.user'));
    }

    function getRollbarToken() {
      return w3Config.get('rollbar').token;
    }

    function getCurrentEnvironment() {
      return w3Config.get('host').env;
    }

    function getCurrentVersion() {
      return w3Config.get('versao').replace('V', '').replace('v', '');
    }

    function disableRollbar() {
      Rollbar.configure({enabled: false});
    }

    function checkForAds() {
      var bait = document.getElementById("blocker-bait");

      if (bait == null) {
        disableRollbar();
        return;
      }

      var baitStyles = window.getComputedStyle(bait);
      if (baitStyles && (
          baitStyles.getPropertyValue('display') === 'none' ||
          baitStyles.getPropertyValue('visibility') === 'hidden')) {
        disableRollbar();
      }
    }

    function onLoadStartAdCheck() {
      // Ad blockers generally execute just after load, let's delay ourselves to get behind it.
      setTimeout(checkForAds, 1);
    }

    function disableRollbarOnAdBlock() {
      if (window.addEventListener !== undefined) {
        window.addEventListener('load', onLoadStartAdCheck, false);
      } else {
        window.attachEvent('onload', onLoadStartAdCheck);
      }
    }

    function logConfig(config) {
      var clonedConfigs = angular.copy(config);

      delete clonedConfigs.accessToken;

      clonedConfigs.overrideIgnoredHttpCodes = w3Config.get('rollbar').overrideIgnoredHttpCodes;
      clonedConfigs.ignoredHttpCodes = defaultIgnoredHttpCodes;

      if (w3Config.get('rollbar').ignoredHttpCodes) {
        clonedConfigs.ignoredHttpCodes = clonedConfigs.ignoredHttpCodes.concat(w3Config.get('rollbar').ignoredHttpCodes);
      }

      clonedConfigs.overrideIgnoredCodes = w3Config.get('rollbar').overrideIgnoredCodes;
      clonedConfigs.ignoredCodes = defaultIgnoredCodes;

      if (w3Config.get('rollbar').ignoredCodes) {
        clonedConfigs.ignoredCodes = clonedConfigs.ignoredCodes.concat(w3Config.get('rollbar').ignoredCodes);
      }

      $log.info('Rollbar configurations', clonedConfigs);
    }

  }

})();
(function () {
    'use strict';

    angular
            .module('rapi.w3')
            .directive('w3ImageDialog', w3ImageDialogDirective)
            .controller('DialogController', DialogController)
            .controller('w3ImageDialogController', w3ImageDialogController);

    /**
     * use: <w3-image-dialog path="vm.row.logo" path-src="vm.row.logo_src" gallery="nomeGaleria" title="Selecione uma foto" config="configUpload"></w3-image-dialog>
     *
     * Modelo de configuração
     *  config = {
     *      url: w3Utils.urlApi('/uploads'),
     *      params: {
     *          'owner_type': 'LDM\\Casal\\Casal',
     *          'owner_id': null
     *      }
     *  }
     *
     @ngInject  */
    function w3ImageDialogDirective()
    {
        return {
            restrict: 'E',
            templateUrl: '/app/external/w3/components/w3-uploud/button-upload.html',
            controller: 'w3ImageDialogController as vm',
            bindToController: true,
            scope: {
                'path': '=',
                'pathSrc': '=',
                'gallery': '@',
                'title': '@',
                'size': '@',
                'config': '=',
                'imgHeight': '@',
                'imgWidth': '@',
                'onUploaded' : '&'
            }
        };
    }


    /** @ngInject */
    function w3ImageDialogController($log, $mdMedia, $mdDialog, $timeout)
    {
        /* jshint validthis: true */
        var vm = this;

        vm.path = "";
        vm.pathSrc = "";
        vm.title = "";
        vm.gallery = "";

        vm.styles = {};

      $timeout(makeStyles,1);

      vm.showpicker = function (ev)
        {
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'));

            var config = angular.isObject(vm.config) ? vm.config : {params:{}};
            config.params.gallery = vm.gallery;

            $log.debug('w3ImageDialogDirective:showpicker', config);

            $mdDialog.show({
                controller: DialogController,
                controllerAs: 'modal',
                templateUrl: '/app/external/w3/components/w3-uploud/dialog-file-uploud.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: useFullScreen,
                resolve: {
                    path: function () {
                        return vm.path;
                    },
                    pathSrc: function () {
                        return vm.pathSrc;
                    },
                    title: function () {
                        return vm.title;
                    },
                    config: function () {
                        return config;
                    }
                }
            }).then(function (result) {
                result.$isChange = vm.path !== result.path;
                vm = angular.extend(vm, result);
                console.log('---------w3', result);

                if(vm.size && vm.path){
                    vm.path = vm.path.replace('-large', '-' + vm.size);
                    vm.pathSrc = vm.pathSrc.replace('-large', '-' + vm.size);
                }

                if(angular.isFunction(vm.onUploaded)) {
                    vm.onUploaded({$event: result});
                }

            });

        };

      function makeStyles() {
        if (vm.imgHeight) {
          vm.styles['max-height'] = vm.imgHeight;
        } else {
          vm.styles['max-height'] = '150px';
        }

        if (vm.imgWidth) {
          vm.styles['width'] = vm.imgWidth;
        } else {
          vm.styles['width'] = '300px';
        }
      }
    }

    /** @ngInject */
    function DialogController($mdDialog, w3Upload, path, pathSrc, title, config)
    {
        /* jshint validthis: true */
        var modal = this;

        //Data
        modal.files = {};
        modal.title = title;
        modal.pathSrc = pathSrc;
        modal.path = path;

        //Methods
        modal.close = close;
        modal.clean = clean;
        modal.upload = upload;

        //------------------------------
        function clean()
        {
            modal.pathSrc = null;
            modal.path = null;
            modal.files = null;
            close();
        }

        function close()
        {
            $mdDialog.hide({
                'path': modal.path,
                'pathSrc': modal.pathSrc
            });
        }

        function upload()
        {
            w3Upload.uploadToRapiPlugin(modal.file, null, config).then(function (result) {
                modal.pathSrc = result._pathLargeSrc;
                modal.path = result.path_large;
                close();
            });
        }

    }

})();


(function () {
    'use strict';

    angular
            .module('rapi.w3')
            .directive('w3FilesDrop', w3FilesDropDirective)
            .controller('w3FilesDropController', w3FilesDropController);


    /**
     * Permite selecionar mais de uma imagem e retorna um array de #uploadTransformer
     * 
     * use: <w3-files-drop config="vm.config" gallery="vm.gal" on-uploaded="vm.files"></w3-files-drop>
     @ngInject */
    function w3FilesDropDirective()
    {
        return {
            restrict: 'E',
            templateUrl: '/app/external/w3/components/w3-uploud/file-uploud-drop.html',
            controller: 'w3FilesDropController as vm',
            bindToController: true,
            scope: {
                'onUploaded': '&',
                'config': '=',
                'gallery': '='
            }
        };
    }

    /** @ngInject */
    function w3FilesDropController($log, w3Upload)
    {
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.files = [];

        //Methods
        vm.addFiles = addFiles;
        vm.removeFiles = removeFiles;
        vm.upload = upload;
        vm.reset = reset;

        //------------------------------
        function upload()
        {
            var config = {
                'params': {'gallery': vm.gallery}
            };

            console.log(vm.config);
            config = angular.merge(config, vm.config);

            console.log(config);

            w3Upload.uploadAllToRapiPlugin(vm.files, null, config).then(function (result) {
                reset();
                handleCallback(result)
            });
        }

        function handleCallback(files)
        {
            if (angular.isFunction(vm.onUploaded)) {
                vm.onUploaded({'$files': files});
            } else {
                $log.error('w3FilesDrop:onUploaded não é uma função');
            }
        }

        function reset()
        {
            vm.files = [];
        }

        function addFiles(files)
        {
            angular.forEach(files, function (file) {
                file.progress = 0;
                vm.files.push(file);
            });
        }

        function removeFiles($index)
        {
            vm.files.splice($index, 1);
        }

    }

})();
(function () {
    'use strict';

    angular
            .module('rapi.w3')
            .factory('w3Upload', uploadFactory);

    /** @ngInject */
    function uploadFactory($rootScope, Upload, $q, $log, w3Utils, w3Config) {

        var headersUpload = {
            'Content-Type': 'application/json'
        };
        var responses = [];

        var service = {
            uploadToRapiPlugin: uploadRapi,
            uploadAllToRapiPlugin: uploadAllRapi
        };

        return service;
        //---------------------------------------

        function uploadServer(file, url_server, fields_server)
        {
            file.progress = 0;
            fields_server = fields_server || {};
            
            $log.debug(url_server, fields_server);
            
            if(!angular.isObject($rootScope.w3Reload)){
                $rootScope.w3Reload = {};
            }
            
            $rootScope.w3Reload['uploadRapi'] = true;

            return Upload.upload({
                url: url_server,
                fields: fields_server,
                headers: getHeaders(),
                file: file
            }).progress(function (evt) {
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                file.progress = progressPercentage;
            }).then(function (result) {
                file.progress = 100;
                responses.push(result.data.data);
                $rootScope.w3Reload['uploadRapi'] = false;
                return result.data.data;
            });
        }

        function uploadAll(files, url, fields_server)
        {
            var tasks = [];
            responses = [];

            files.forEach(function (file) {
                tasks.push(uploadServer(file, url, fields_server));
            });

            return $q.all(tasks).then(function () {
                return responses;
            });
        }

        function getHeaders()
        {
            return headersUpload;
        }

        function getParams(merge)
        {
            /**
             *  name: null, //'demo'  nome do arquivo (opcional)        
             *  gallery: null, //nome da galeria (required)  
             *  token: null //token de acesso  (required) (vai depender das configurações em Config::get('rapi_upload.token')
             */
            var config = w3Config.get('upload', config);
            return angular.extend(config, merge);
        }

        function uploadRapi(file, fields_server, config)
        {
            var data = resolveParams(fields_server, config);
            var url = resolveUrl(config);
            return uploadServer(file, url, data);
        }

        function uploadAllRapi(files, fields_server, config)
        {
            var data = resolveParams(fields_server, config);
            var url = resolveUrl(config);
            return uploadAll(files, url, data);
        }

        function resolveUrl(config)
        {
            return config && config.url ? config.url : w3Utils.urlApi('/rapi/fuse/uploads');
        }
        
        function resolveParams(fields_server, config)
        {
            var data = fields_server || {};
            
            if(config && angular.isObject(config.params)){
                data = angular.extend(data, config.params);
            }
            
            return getParams(data);
        }
    }



})();

(function () {
    'use strict';

    angular
            .module('rapi.w3')
            .directive('w3ImagePicker', imagePickerDirective)
            .directive('w3FileUploudDrop', fileUploudDropDirective)
            .controller('imagePickerController', imagePickerController)
            .controller('fileUploudController', fileUploudController);

    /**
     * Permite selecionar mais de uma imagem e retorna um array de #uploadTransformer
     * use: <rp-file-uploud-drop model="vm.row.logo" config="configUpload"></rp-file-uploud-drop>
     @ngInject */
    function fileUploudDropDirective() 
    {
        return {
            restrict: 'E',
            templateUrl: '/app/external/w3/components/w3-uploud/file-uploud-drop.html',
            controller: 'fileUploudController as vm',
            bindToController: true,
            scope: {
                'model': '=',
                'config': '='
            }
        };
    }

    /**
     * use: <rp-image-picker path="vm.row.logo" config="configUpload" path-src="vm.row.logo_src"></rp-image-picker>
     @ngInject  */
    function imagePickerDirective()
    {
        return {
            restrict: 'E',
            templateUrl: '/app/external/w3/components/w3-uploud/button-upload.html',
            controller: 'imagePickerController as vm',
            bindToController: true,
            scope: {
                'config': '=',
                'path': '=',
                'pathSrc': '=',
                'title': '@'
            }
        };
    }

    /** @ngInject */
    function fileUploudController(w3Upload, $log) {

        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.files = [];
        vm.model = [];

        //Methods
        vm.addFiles = addFiles;
        vm.removeFiles = removeFiles;
        vm.upload = upload;
        vm.reset = reset;
        
        $log.warn('w3FileUploudDrop is deprected use <w3-button-upload config="vm.config" gallery="vm.gal" on-uploaded="vm.files"></w3-button-upload>');

        //------------------------------
        function upload() 
        {
            w3Upload.uploadAllToRapiPlugin(vm.files, vm.config).then(function (result) {
                reset();
                vm.model = result;
            });
        }

        function reset() 
        {
            vm.files = [];
        }

        function addFiles(files) 
        {
            angular.forEach(files, function (file) {
                file.progress = 0;
                vm.files.push(file);
            });
        }

        function removeFiles($index)
        {
            vm.files.splice($index, 1);
        }

    }

    /** @ngInject */
    function imagePickerController($mdMedia, $mdDialog, $log)
    {       
        /* jshint validthis: true */
        var vm = this;

        vm.path = "";
        vm.pathSrc = "";
        vm.title = "";
        
        $log.warn('w3ImagePicker directive is deprected! Use w3ImageDialog');

        vm.showpicker = function (ev)
        {
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'));

            $mdDialog.show({
                controller: DialogController,
                controllerAs: 'modal',
                templateUrl: '/app/external/w3/components/w3-uploud/dialog-file-uploud.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: useFullScreen,
                resolve: {
                    path: function () {
                        return vm.path;
                    },
                    pathSrc: function () {
                        return vm.pathSrc;
                    },
                    title: function () {
                        return vm.title;
                    },
                    config: function () {
                        return vm.config;
                    }
                }
            }).then(function (result) {
                vm = angular.extend(vm, result);
            });

        };
    }
    
    /** @ngInject */
    function DialogController($mdDialog, w3Upload, path, pathSrc, title, config)
    {
        /* jshint validthis: true */
        var modal = this;

        //Data
        modal.files = {};
        modal.title = title;
        modal.pathSrc = pathSrc;
        modal.path = path;

        //Methods
        modal.close = close;
        modal.clean = clean;
        modal.upload = upload;

        //------------------------------
        function clean() 
        {
            modal.pathSrc = null;
            modal.path = null;
            modal.files = null;
            close();
        }

        function close() 
        {
            $mdDialog.hide({
                'path': modal.path,
                'pathSrc': modal.pathSrc
            });
        }

        function upload() 
        {
            w3Upload.uploadToRapiPlugin(modal.file, config).then(function (result) {
                modal.pathSrc = result.path_large_src;
                modal.path = result.path_large;
                close();
            });
        }

    }

})();

(function () {
    'use strict';

    angular
            .module('rapi.w3')
            .controller('w3reportDateController', w3reportDateController)
            .directive('w3ReportDate', w3ReportDate);


    /**
     * USAGE:
     * <w3-report-date  w3-extra-options="" w3-date-ini="" w3-date-end="" w3-on-change="" ></w3-report-date>
     * w3-on-change function : usado para disparar funções quando os parâmetros são alterados
     * w3-extra-options => array [{param: 'column_name', label:''}] vm.dt_column para pegar o tipo de data
     * @constructor
     */

    /** @ngInject */
    function w3ReportDate() {
        return {
            restrict: 'E',
            scope: {
                w3OnChange: '&',
                w3DateIni: '=',
                w3DateEnd: '=',
                w3ExtraOptions: '=',
                getClass: "@setClass"
            },
            controller: 'w3reportDateController as vm',
            templateUrl: '/app/external/w3/components/w3-report-date/w3-report-date.tmpl.html'
        };
    }

    /** @ngInject */
    function w3reportDateController($scope, $locale, w3Date)
    {

        var now = new Date();
        var vm = this;

        //Data
        vm.optionsFilter = [];
        vm.dt_start = null;
        vm.dt_end = null;

        //Methods
        vm.setFilter = setFilter;

        activate();
        //------------------- Functions

        $scope.$watch('[vm.dt_start, vm.dt_end, vm.dt_column]', setDates);
        $scope.$watch('[w3ExtraOptions]', setextraOptions);

        function activate()
        {
            setoptionsFilter();
            setextraOptions();
            
        }

        function setDates()
        {
            if (!vm.dt_start && !vm.dt_end)
                return;

            var dtParams = {
                dt_column: vm.dt_column,
                dt_start: vm.dt_start,
                dt_end: vm.dt_end
            };

            $scope.w3OnChange({'$dtParams': dtParams});
        }

        function setFilter(option)
        {
            var dt;

            switch (option.type)
            {
                case 'now':
                    vm.dt_start = now;
                    vm.dt_end = now;
                    break;

                case 'last_days':
                    vm.dt_start = w3Date.subDays(now, option.param);
                    vm.dt_end = now;
                    break;

                case 'this_month':
                    var date = new Date();
                    vm.dt_start =  new Date(date.getFullYear(), date.getMonth(), 1);
                    vm.dt_end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                    break;

                case 'month':
                    dt = w3Date.subMonthsInteval(now, option.param);
                    vm.dt_start = dt[0];
                    vm.dt_end = dt[1];
                    break;

                case 'year':
                    dt = w3Date.subYearsInteval(now, option.param);
                    vm.dt_start = dt[0];
                    vm.dt_end = dt[1];
                    break;
            }
        }

        function setextraOptions()
        {
            vm.optionsTypeFilter = [
            ];
            angular.forEach($scope.w3ExtraOptions, function (values) {
                vm.optionsTypeFilter.push(values);
                
                //seta valor default do dt_column
                vm.dt_column = vm.optionsTypeFilter[0].param;

            });
        }

        function setoptionsFilter()
        {
            var mesLabel;
            vm.optionsFilter = [
                {
                    "type": "now",
                    "label": "Hoje",
                    "param": null
                },
                {
                    "type": "last_days",
                    "label": "Últimos 7 dias",
                    "param": 7
                },
                {
                    "type": "this_month",
                    "label": "Este mês",
                    "param": 30
                },
                {
                    "type": "last_days",
                    "label": "Últimos 30 dias",
                    "param": 30
                }
            ];

            mesLabel = $locale.DATETIME_FORMATS.MONTH[ (now.getMonth() - 1) ];

            vm.optionsFilter.push({
                "type": "month",
                "label": mesLabel,
                "param": 1
            });

            mesLabel = $locale.DATETIME_FORMATS.MONTH[ (now.getMonth() - 2) ];

            vm.optionsFilter.push({
                "type": "month",
                "label": mesLabel,
                "param": 2
            });

            vm.optionsFilter.push({
                "type": "year",
                "label": now.getFullYear(),
                "param": 0
            });
        }
    }

})();

(function () {
    'use strict';

    angular
            .module('rapi.w3')
            .controller('w3InputCityController', w3InputCityController)
            .directive('w3InputCity', w3InputCityDirective);

    /**
     * EX: <w3-input-city ng-model="vm.row.city_id" w3-city="vm.row.city" w3-open-create="false" flex-gt-xs="75"></w3-input-city>
     *
     * */
    /** @ngInject */
    function w3InputCityDirective() {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                ngModel: '=',
                city: '=w3City',
                openCreate: '@w3OpenCreate'
            },
            templateUrl: '/app/external/w3/components/w3-input-city/w3-input-city.tpl.html',
            controller: 'w3InputCityController as vm'
        };
    }

    /** @ngInject */
    function w3InputCityController($scope, City, $log) {
        var vm = this;

        // Data
        vm.archive = [];

        // Methods
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.showCreateCity = showCreateCity;

        activate();
        //-----------------------

        $scope.$watch('city', setCity);

        function setCity(obj) {
            vm.selectedItem = obj;
            if (obj) {
                vm.selectedItem.city_name = obj.city_name + ", " + obj.state.state_code + ' - ' + obj.state.country.country_code;
            }
        }

        function activate() {
            
             $log.warn('Deprecation warning: w3InputCity is deprecated, use <rf-input-city ng-model="vm.row.city_id" rf-city="vm.row.city" rf-open-create="false" flex-gt-xs="75"></rf-input-city>');
            vm.openCreate = ($scope.openCreate === 'false') ? false : true;
        }

        function querySearch(query) {
            return City.search({
                'q': query,
                'take': 5,
                'sort': 'city_name',
                'include': 'state.country'
            });
        }

        function selectedItemChange(item) {

            $scope.$evalAsync(function () {
                $scope.ngModel = (item) ? item.id : null;
            });

        }

        function showCreateCity(ev) {
            var data = {
                'city_name': vm.searchText,
                'include': 'state.country'
            };
            City.dialog.create([], ev, data).then(function (result) {
                if (result)
                    setCity(result);

            });
        }

    }

})();

(function () {
    'use strict';

    angular
            .module('rapi.w3')
            .directive('w3Comments', Comments)
            .controller('w3CommentsController', w3CommentsController);

    /**
     * USAGE:
     * <w3-comments w3-token="vm.row.token_morph.token"></w3-comments>
     *
     * @constructor
     */
    function Comments() {
        return {
            restrict: 'E',
            scope: {
                token: "=w3Token"
            },
            controller: 'w3CommentsController as vm',
            templateUrl: '/app/external/w3/components/w3-comments/comments.tmpl.html'
        };
    }

    /** @ngInject */
    function w3CommentsController($scope, RapiComment, $log) {

        var vm = this;

        vm.rowComment = {
            'token_morph': null,
            'message': '',
            'type': 'mensagem',
            'include': 'profile'
        };
        vm.comments = [];

        /*  methods */
        vm.addNewComment = addNewComment;

        /////////////////////////////////////////////
        $scope.$watch('token', activate);

        function activate()
        {
             $log.warn('Deprecation warning: w3Comments is deprecated, use <rf-comments rf-token="vm.row.token_morph.token"></rf-comments>');
            
            if ($scope.token) {
                loadMessages();
            }
        }

        function loadMessages() {
            var data = {
                'token_morph': $scope.token,
                'include': 'profile',
                'sort': '-created_at'
            };

            RapiComment.search(data).then(function (result) {
                vm.comments = result;
            });
        }

        /**
         * Add new comment
         *
         * @param newCommentText
         */
        function addNewComment() {
            
            var data = angular.copy(vm.rowComment);
            data.token_morph = $scope.token;
            
            RapiComment.save(data).then(function (result) {
                vm.comments = [result].concat(vm.comments);
                vm.rowComment.message = '';
            });

        }

    }

})();

(function () {
    'use strict';

    angular
            .module('rapi.w3')
            .factory('RapiComment', RapiCommentService);

     //mytodo isso deveria estar no fuse
    /** @ngInject */
    function RapiCommentService(w3Resource) {
        var urlApi = "/rapi/comments";
        var service = {
            name: 'comment'
        };
        return w3Resource.extend(urlApi, service);
    }
})();
(function () {
    'use strict';

    //mytodo destruir essa diretiva, pois já foi migrada pro fuse para rfActivities

    angular
            .module('rapi.w3')
            .directive('w3Activities', activitiesDirective)
            .controller('w3ActivitiesController', activitiesController);


    /**
     * USAGE:
     * <w3-activities w3-token="vm.row.token_morph.token"></w3-activities>
     *
     * @constructor
     */
    function activitiesDirective() {
        return {
            restrict: 'E',
            scope: {
                token: "=w3Token"
            },
            controller: 'w3ActivitiesController as vm',
            templateUrl: '/app/external/w3/components/w3-activities/activities.tmpl.html'
        };
    }

    /** @ngInject */
    function activitiesController($scope, $http, $log, w3Utils)
    {
        var vm = this;
        vm.activities = [];

        /*  methods */



        /////////////////////////////////////////////
        $scope.$watch('token', activate);

        function activate()
        {

            $log.warn('Deprecation warning: w3Activities is deprecated, use <rf-activities rf-token></rf-activities>');

            if ($scope.token) {
                loadLogs();
            }

            $scope.$on('w3Activities.reload', function(){// este callback envia um paramentro event
                //event.preventDefault();//myFeature implements pusher socket io
                loadLogs();
            });
        }

        function loadLogs() {

            var data = {
                params: {
                    'token_morph': $scope.token,
                    'include': 'causer',
                    'sort': '-created_at',
                    'take': -1 //mytodo paginar result (colocar btn de ler mais) page++
                }
            };

            var url = w3Utils.urlApi('/rapi/activities');

            $http.get(url, data).then(function (result) {
                vm.activities = result.data.data;
            });
        }

    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : '/app/external/fuse-core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : '/app/external/fuse-core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: '/app/external/fuse-core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    // {
                    //     'title'      : 'Sample',
                    //     'icon'       : 'icon-tile-four',
                    //     'state'      : 'app.sample',
                    //     'weight'     : 1,
                    //     'children'   : [],
                    //     '_id'        : 'sample',
                    //     '_path'      : 'apps.sample',
                    //     'uisref'     : 'app.sample',
                    //     'hasShortcut': true
                    // }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : '/app/external/fuse-core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : '/app/external/fuse-core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: '/app/external/fuse-core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: '/app/external/fuse-core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: '/app/external/fuse-core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: '/app/external/fuse-core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
            .module('rapi.fuse.user', ['rapi.fuse.acl.role'])
            .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        var permissions = 'guardian.profile.view_full';
        // State
        $stateProvider
                .state('app.user', {
                    url: '/usuarios',
                    views: {
                        'content@app': {
                            templateUrl: '/app/external/fuse/user/user-archive.html',
                            controller: 'UserController as vm'
                        }
                    },
                    needPermissions: permissions
                })
                .state('app.user.new', {
                    url: '/novo',
                    views: {
                        'content@app': {
                            templateUrl: '/app/external/fuse/user/user-form.html',
                            controller: 'UserFormController as vm'
                        }
                    },
                    needPermissions: permissions
                })
                .state('app.user.show', {
                    url: '/{id}',
                    views: {
                        'content@app': {
                            templateUrl: '/app/external/fuse/user/user-show.html',
                            controller: 'UserShowController as vm'
                        }
                    },
                    needPermissions: permissions
                })
                .state('app.user.edit', {
                    url: '/{id}/editar',
                    views: {
                        'content@app': {
                            templateUrl: '/app/external/fuse/user/user-form.html',
                            controller: 'UserFormController as vm'
                        }
                    },
                    needPermissions: permissions
                });


//        msNavigationServiceProvider.saveItem('user', {
//            title: 'USER.MENU',
//            icon: 'icon-account',
//            state: 'app.user',
//            weight: 10
//        });

    }
})();

(function () {
    'use strict';

    angular
            .module('rapi.fuse.user')
            .controller('NewUserDialogController', NewUserDialogController);

    /** @ngInject */
    function NewUserDialogController(RfUser, $mdDialog, RfPassword, w3Config, permisisons, row, table_id, table_type, url_callback, toastr) {
        var vm = this;

        // Data
        vm.row = {is_owner: false};
        vm.user = {first_name: ''};
        vm.permissions = [];
        vm.searchText = null;
        vm.showFormUser = false;
        vm.autoPassword = false;
        vm.sendAccess = true;
        vm.message = '';

        // Method
        vm.querySearchUser = querySearchUser;
        vm.closeDialog = closeDialog;
        vm.save = save;
        vm.setUser = setUser;
        vm.createUser = createUser;
        vm.cancelCreateUser = cancelCreateUser;
        vm.saveUser = saveUser;

        vm.isMultiplePermissons = isMultiplePermissons;

        activate();

        //-----------------------

        function activate()
        {
            vm.permissions = permisisons;

            if (!isMultiplePermissons() && vm.permissions.length > 0) {
              setPermission();
            }
        }

        function setPermission() {
          vm.row.permission = vm.permissions[0].key;
        }

        function isMultiplePermissons() {
          return vm.permissions.length > 1;
        }

        function setUser(us)
        {
            if (us){
              vm.row.user_id = us.id;
            } else {
              toastr.error('Falha em selecionar o usuário');
            }
        }

        function querySearchUser(query)
        {
            return RfUser.search({q: query});
        }

        function closeDialog(params)
        {
            $mdDialog.hide(params);
        }

        function save()
        {
            vm.row.include = 'user';
            vm.row.table_id = table_id;
            vm.row.table_type = table_type;

            if(!vm.row.permission){
                vm.row.permission = 'default';
            }

            RfUser.saveShared(vm.row).then(function (result) {
                closeDialog(result);
            });
        }

        function createUser()
        {
            vm.user.first_name = vm.searchText;
            vm.showFormUser = true;
        }

        function saveUser()
        {
            vm.showFormUser = true;
            vm.user.welcome = true;
            vm.user.url_callback =  getUrlCallback() + '?welcome=1';

            if(vm.autoPassword){
                delete vm.user.password;
                delete vm.user.password_confirmation;
            }

            RfUser.save(vm.user).then(function (result) {
                setUser(result);
                vm.selectedItem = result;
                vm.showFormUser = false;

                if (vm.sendAccess) {
                  sendAccesEmail();
                }
            });

        }

        function sendAccesEmail()
        {
            var data = {
                'email': vm.user.email,
                'welcome': true,
                'message': vm.message,
                'url_callback': getUrlCallback()
            };

            RfPassword.remind(data);
        }

        function getUrlCallback()
        {
            // console.log('url_callback', url_callback);

            if(url_callback){
                return url_callback;
            }

            return RfPassword.makeUrlReset()
        }

        function cancelCreateUser()
        {
            vm.showFormUser = false;
        }

    }

})();

(function () {
    'use strict';

    angular
            .module('rapi.fuse.report', []);

})();
(function () {
    angular.module('rapi.fuse.report')
            .controller('reportSidenavController', reportSidenavController)
            .directive('rfReportSidenav', reportSidnavDirective);

    /**
     * <rf-report-sidenav rf-list="" ></rf-report-sidenav>
     * 
     */
    /** @ngInject */
    function reportSidnavDirective()
    {

        var directive = {
//            link: link,
            restrict: 'E',
            replace: false,
            templateUrl: '/app/external/fuse/report/sidenav/sidenav.html',
            scope: {
                list: '=rfList',
                onChange : '&'
            },
            controller: 'reportSidenavController as rp'

        };
        return directive;


    }


    /** @ngInject */
    function reportSidenavController($scope)
    {
        //DATA
        var rp = this;


        //METHODS
        rp.setParams = setParams;

        //--------------------

        function setParams(item)
        {   
            $scope.onChange({'$report':item});
        }
    }

})();
(function () {
    angular.module('rapi.fuse.report')
            .directive('rfReportBox', reportBoxDirective);

    /**
     * <rf-report-box rf-report=" " ></rf-report-box>
     * 
     */
    /** @ngInject */
    function reportBoxDirective()
    {
        var directive = {
            restrict: 'E',
            templateUrl: '/app/external/fuse/report/box/box.html',
            replace: true,
            transclude: true,
            scope: {
                report: '=rfReport'
            }
        };
        return directive;
    }



})();
(function () {
    angular.module('rapi.fuse.report')
            .controller('reportActionsController', reportActionsController)
            .directive('rfReportActions', reportActionsDirective);

    /**
     * <rf-report-actions rfreport="" rf-disable=" rfaction="" ></rf-report-actions>
     * 
     */
    /** @ngInject */
    function reportActionsDirective()
    {

        var directive = {
            restrict: 'E',
            replace: false,
            templateUrl: '/app/external/fuse/report/actions/actions.html',
            transclude: true,
            controller: 'reportActionsController as rp',
            scope: {
                report: '=rfreport',
                disable: '<rfDisable',
                rfaction: '&rfaction'
            }

        };
        return directive;


    }

    /** @ngInject */
    function reportActionsController($scope)
    {
        //DATA
        var rp = this;
   
        //METHODS
        rp.execute = execute;

        //-----------------------
        
   
        
        function execute(format)
        {
            $scope.rfaction({'$format': format});
        }
     
    }



})();
(function ()
{
    'use strict';

    angular
            .module('rapi.fuse.logs', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider

                .state('app.logs', {
                    url: '/logs',
                    views: {
                        'content@app': {
                            templateUrl: '/app/external/fuse/logs/logs-archive.html',
                            controller: 'LogsController as vm'
                        }
                    }
                });

        //            Deve ser adicionado na mão
        //            msNavigationServiceProvider.saveItem('logs', {
        //              title: 'CITIES.MENU',
        //              icon: 'icon-city',
        //              state: 'app.cities.tabbed',
        //              weight: 15
        //            });
    }
})();

(function() {
  'use strict';

  angular
    .module('rapi.fuse.logs')
    .controller('logsDialogController', logsDialogController);

  /** @ngInject */
  function logsDialogController($mdDialog, row) {

    var vm = this;

    //Data
    vm.row   = {};

    //Methods
    vm.closeDialog = closeDialog;

    activate();
    //-----------------------------------

    function activate() {
      vm.row   = angular.copy(row);
            
    }


    function closeDialog(params) {
      $mdDialog.hide(params);
    }

  }


})();

/*!
 * rrule.js - Library for working with recurrence rules for calendar dates.
 * https://github.com/jkbrzt/rrule
 *
 * Copyright 2010, Jakub Roztocil and Lars Schoning
 * Licenced under the BSD licence.
 * https://github.com/jkbrzt/rrule/blob/master/LICENCE
 */


(function (window) {

    'use strict';

    /**
     * Return true if a value is in an array
     */
    var contains = function (arr, val) {
        return arr.indexOf(val) !== -1;
    };

    /**
     * General date-related utilities.
     * Also handles several incompatibilities between JavaScript and Python
     *
     */
    var dateutil = {
        MONTH_DAYS: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
        /**
         * Number of milliseconds of one day
         */
        ONE_DAY: 1000 * 60 * 60 * 24,
        /**
         * @see: <http://docs.python.org/library/datetime.html#datetime.MAXYEAR>
         */
        MAXYEAR: 9999,
        /**
         * Python uses 1-Jan-1 as the base for calculating ordinals but we don't
         * want to confuse the JS engine with milliseconds > Number.MAX_NUMBER,
         * therefore we use 1-Jan-1970 instead
         */
        ORDINAL_BASE: new Date(1970, 0, 1),
        /**
         * Python: MO-SU: 0 - 6
         * JS: SU-SAT 0 - 6
         */
        PY_WEEKDAYS: [6, 0, 1, 2, 3, 4, 5],
        /**
         * py_date.timetuple()[7]
         */
        getYearDay: function (date) {
            var dateNoTime = new Date(
                    date.getFullYear(), date.getMonth(), date.getDate())
            return Math.ceil(
                    (dateNoTime - new Date(date.getFullYear(), 0, 1)) / dateutil.ONE_DAY) + 1
        },
        isLeapYear: function (year) {
            if (year instanceof Date)
                year = year.getFullYear()
            return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0)
        },
        /**
         * @return {Number} the date's timezone offset in ms
         */
        tzOffset: function (date) {
            return date.getTimezoneOffset() * 60 * 1000
        },
        /**
         * @see: <http://www.mcfedries.com/JavaScript/DaysBetween.asp>
         */
        daysBetween: function (date1, date2) {
            // The number of milliseconds in one day
            // Convert both dates to milliseconds
            var date1_ms = date1.getTime() - dateutil.tzOffset(date1)
            var date2_ms = date2.getTime() - dateutil.tzOffset(date2)
            // Calculate the difference in milliseconds
            var difference_ms = Math.abs(date1_ms - date2_ms)
            // Convert back to days and return
            return Math.round(difference_ms / dateutil.ONE_DAY)
        },
        /**
         * @see: <http://docs.python.org/library/datetime.html#datetime.date.toordinal>
         */
        toOrdinal: function (date) {
            return dateutil.daysBetween(date, dateutil.ORDINAL_BASE)
        },
        /**
         * @see - <http://docs.python.org/library/datetime.html#datetime.date.fromordinal>
         */
        fromOrdinal: function (ordinal) {
            var millisecsFromBase = ordinal * dateutil.ONE_DAY
            return new Date(dateutil.ORDINAL_BASE.getTime() -
                    dateutil.tzOffset(dateutil.ORDINAL_BASE) +
                    millisecsFromBase +
                    dateutil.tzOffset(new Date(millisecsFromBase)))
        },
        /**
         * @see: <http://docs.python.org/library/calendar.html#calendar.monthrange>
         */
        monthRange: function (year, month) {
            var date = new Date(year, month, 1)
            return [dateutil.getWeekday(date), dateutil.getMonthDays(date)]
        },
        getMonthDays: function (date) {
            var month = date.getMonth()
            return month === 1 && dateutil.isLeapYear(date)
                    ? 29 : dateutil.MONTH_DAYS[month]
        },
        /**
         * @return {Number} python-like weekday
         */
        getWeekday: function (date) {
            return dateutil.PY_WEEKDAYS[date.getDay()]
        },
        /**
         * @see: <http://docs.python.org/library/datetime.html#datetime.datetime.combine>
         */
        combine: function (date, time) {
            time = time || date
            return new Date(
                    date.getFullYear(), date.getMonth(), date.getDate(),
                    time.getHours(), time.getMinutes(), time.getSeconds(),
                    time.getMilliseconds())
        },
        clone: function (date) {
            var dolly = new Date(date.getTime())
            return dolly
        },
        cloneDates: function (dates) {
            var clones = []
            for (var i = 0; i < dates.length; i++) {
                clones.push(dateutil.clone(dates[i]))
            }
            return clones
        },
        /**
         * Sorts an array of Date or dateutil.Time objects
         */
        sort: function (dates) {
            dates.sort(function (a, b) {
                return a.getTime() - b.getTime()
            })
        },
        timeToUntilString: function (time) {
            var comp

            var date = new Date(time);

            var comps = [
                date.getUTCFullYear(),
                date.getUTCMonth() + 1,
                date.getUTCDate(),
                'T',
                date.getUTCHours(),
                date.getUTCMinutes(),
                date.getUTCSeconds(),
                'Z'
            ]

            for (var i = 0; i < comps.length; i++) {
                comp = comps[i]
                if (!/[TZ]/.test(comp) && comp < 10)
                    comps[i] = '0' + String(comp)
            }
            return comps.join('')
        },
        untilStringToDate: function (until) {
            var re = /^(\d{4})(\d{2})(\d{2})(T(\d{2})(\d{2})(\d{2})Z)?$/
            var bits = re.exec(until)
            if (!bits)
                throw new Error('Invalid UNTIL value: ' + until)
            return new Date(Date.UTC(
                    bits[1],
                    bits[2] - 1,
                    bits[3],
                    bits[5] || 0,
                    bits[6] || 0,
                    bits[7] || 0))
        }
    }

    dateutil.Time = function (hour, minute, second, millisecond) {
        this.hour = hour
        this.minute = minute
        this.second = second
        this.millisecond = millisecond || 0
    }

    dateutil.Time.prototype = {
        constructor: dateutil.Time,
        getHours: function () {
            return this.hour
        },
        getMinutes: function () {
            return this.minute
        },
        getSeconds: function () {
            return this.second
        },
        getMilliseconds: function () {
            return this.millisecond
        },
        getTime: function () {
            return ((this.hour * 60 * 60) + (this.minute * 60) + this.second) * 1000 +
                    this.millisecond
        }
    }

    var RRule = function (conf) {
        conf = conf || {};

        // used by toString()
        this.options = {};
        this.origOptions = {};

        var invalid = [];
        var keys = Object.keys(conf);
        var defaultKeys = Object.keys(RRule.DEFAULT_OPTIONS);

        // Shallow copy for origOptions and check for invalid
        keys.forEach(function (key) {
            this.origOptions[key] = conf[key];
            if (!contains(defaultKeys, key))
                invalid.push(key);
        }, this);

        if (invalid.length)
            throw new Error('Invalid options: ' + invalid.join(', '));

        if (!RRule.FREQUENCIES[conf.freq] && conf.byeaster === null) {
            throw new Error('Invalid frequency: ' + String(conf.freq));
        }

        // Merge in default options
        defaultKeys.forEach(function (key) {
            if (!contains(keys, key))
                conf[key] = RRule.DEFAULT_OPTIONS[key];
        });

        this.options = conf;
    };


// RRule class 'constants'

    RRule.FREQUENCIES = [
        'YEARLY', 'MONTHLY', 'WEEKLY', 'DAILY',
        'HOURLY', 'MINUTELY', 'SECONDLY'
    ];

    RRule.YEARLY = 0;
    RRule.MONTHLY = 1;
    RRule.WEEKLY = 2;
    RRule.DAILY = 3;
    RRule.HOURLY = 4;
    RRule.MINUTELY = 5;
    RRule.SECONDLY = 6;

    RRule.MO = new Weekday(0);
    RRule.TU = new Weekday(1);
    RRule.WE = new Weekday(2);
    RRule.TH = new Weekday(3);
    RRule.FR = new Weekday(4);
    RRule.SA = new Weekday(5);
    RRule.SU = new Weekday(6);

    RRule.DEFAULT_OPTIONS = {
        freq: null,
        dtstart: null,
        interval: 1,
        wkst: RRule.MO,
        count: null,
        until: null,
        bysetpos: null,
        bymonth: null,
        bymonthday: null,
        bynmonthday: null,
        byyearday: null,
        byweekno: null,
        byweekday: null,
        bynweekday: null,
        byhour: null,
        byminute: null,
        bysecond: null,
        byeaster: null
    };

    RRule.optionsToString = function (options) {
        var key, value, strValues;
        var pairs = []
        var keys = Object.keys(options)
        var defaultKeys = Object.keys(RRule.DEFAULT_OPTIONS)

        for (var i = 0; i < keys.length; i++) {
            if (!contains(defaultKeys, keys[i]))
                continue

            key = keys[i].toUpperCase()
            value = options[keys[i]]
            strValues = []

            if (value === null || value instanceof Array && !value.length)
                continue

            switch (key) {
                case 'FREQ':
                    value = RRule.FREQUENCIES[options.freq]
                    break
                case 'WKST':
                    value = value.toString()
                    break
                case 'BYWEEKDAY':
                    /*
                     NOTE: BYWEEKDAY is a special case.
                     RRule() deconstructs the rule.options.byweekday array
                     into an array of Weekday arguments.
                     On the other hand, rule.origOptions is an array of Weekdays.
                     We need to handle both cases here.
                     It might be worth change RRule to keep the Weekdays.

                     Also, BYWEEKDAY (used by RRule) vs. BYDAY (RFC)

                     */
                    key = 'BYDAY'
                    if (!(value instanceof Array))
                        value = [value]

                    for (var wday, j = 0; j < value.length; j++) {
                        wday = value[j]
                        if (wday instanceof Weekday) {
                            // good
                        } else if (wday instanceof Array) {
                            wday = new Weekday(wday[0], wday[1])
                        } else {
                            wday = new Weekday(wday)
                        }
                        strValues[j] = wday.toString()
                    }
                    value = strValues
                    break
                case 'DTSTART':                    
                    value = dateutil.timeToUntilString(value)
                    break
                case 'UNTIL':
                    value.addDays(1); //Adiciona mais um dia para que o sistema possa contabilizar o dia ainda
                    value = dateutil.timeToUntilString(value)
                    break
                default:
                    if (value instanceof Array) {
                        for (j = 0; j < value.length; j++)
                            strValues[j] = String(value[j])
                        value = strValues
                    } else {
                        value = String(value)
                    }

            }
            pairs.push([key, value])
        }

        var strings = []
        for (i = 0; i < pairs.length; i++) {
            var attr = pairs[i]
            strings.push(attr[0] + '=' + attr[1].toString())
        }
        return strings.join(';')
    };

    RRule.prototype = {
        constructor: RRule,
        /**
         * Converts the rrule into its string representation
         * @see <http://www.ietf.org/rfc/rfc2445.txt>
         * @return String
         */
        toString: function () {
            return RRule.optionsToString(this.origOptions)
        }
    };
//// WEEK
    function Weekday(weekday, n) {
        if (n === 0)
            throw new Error("Can't create weekday with n == 0")
        this.weekday = weekday
        this.n = n
    }

    Weekday.prototype = {
        constructor: Weekday,
        // __call__ - Cannot call the object directly, do it through
        // e.g. RRule.TH.nth(-1) instead,
        nth: function (n) {
            return this.n === n ? this : new Weekday(this.weekday, n)
        },
        // __eq__
        equals: function (other) {
            return this.weekday === other.weekday && this.n === other.n
        },
        // __repr__
        toString: function () {
            var s = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'][this.weekday]
            if (this.n)
                s = (this.n > 0 ? '+' : '') + String(this.n) + s
            return s
        },
        getJsWeekday: function () {
            return this.weekday === 6 ? 0 : this.weekday + 1
        }

    }


    window.RRule = RRule;

})(window);

///////////////////
//var vm = {
//    row: {
//        frequencia: RRule.MONTHLY,
//        dt_prevista: new Date(),
//        frequencia_fim: new Date()
//    }
//};
//
//var rule = new RRule({
//    freq: vm.row.frequencia,
//    interval: 1,
//    dtstart: vm.row.dt_prevista,
//    until: vm.row.frequencia_fim
//});
//
//var str = rule.toString();
//
//
//console.log('RULE', str);

(function() {
  'use strict';

  /**
   * Main module of the Fuse
   */
  angular
    .module('rapi.fuse', [
      //'rapi.fuse.layouts',
      'rapi.fuse.auth',
      'rapi.fuse.acl',
      'rapi.w3'

      //#MODULES AVALABLES
      //'rapi.fuse.profile'
      //'rapi.fuse.cities'
    ])

    /** @ngInject */
    .run(function($rootScope, $window, $state, $timeout, RfAcl, w3Config, w3Auth, w3Local, toastr,RfAuthValidation) {
      var inTimeout = false;

      $rootScope.rapiProfile = w3Auth.profile();

      $rootScope.$on('w3Auth:loginSuccess', function() {
        $rootScope.rapiProfile = w3Auth.profile();
      });

      $rootScope.$on('w3Auth:logout', function() {
        $rootScope.rapiProfile = null;
      });

      $rootScope.$on('w3HttpInterceptor:loginRequired', function() {
        var callback = w3Config.get('auth').onLoginRequired;

        if (angular.isFunction(callback)) {
          console.log('callback', callback);
          callback();
        }
      });


      // Verifica as configurações de acesso da URL em carregamento
      var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
        // console.log('=================');
        // console.log('Fuse Rotas');
        // console.log('');
        // console.log('event', event);
        // console.log('toState', toState);
        // console.log('toParams', toParams);
        // console.log('fromState', fromState);
        // console.log('fromParams', fromParams);
        $rootScope.loadingProgress = true;


        if (requireAuth(toState['auth']) && w3Auth.check() === false)
        {
          if (!(fromState.abstract === true || fromState.name === 'auth.login')){
            toastr.error('Acesso negado. Você precisa estar logado para acessar esse recurso!');
          }
          event.preventDefault();
          $state.go('auth.login');

        }
        else if(w3Auth.check() && !RfAuthValidation.hasAccessToModule() && fromState.ignoreAuthAccessModule !== true){

          if(fromState.abstract && toState.name === w3Config.get('auth').routeSuccess){
            // console.log('VEIO DO ROOT PARA A ROTA DEFAULT');
            if(!inTimeout){
              RfAuthValidation.noAccessToModuleNotification();
              RfAuthValidation.logout();
              RfAuthValidation.navigateToHome();
              inTimeout = true;
              $timeout(function () {
                inTimeout = false;
              },5000);
            }

            event.preventDefault();
          } else if(!toState.name.includes('auth') && !toState.name !== 'home' && fromState.name !== 'auth.login'){
            event.preventDefault();
            RfAuthValidation.noAccessToModuleNotification();
            RfAuthValidation.logout();
            RfAuthValidation.navigateToHome();
          }
        }
        else if (toState['external'])
        {

          event.preventDefault();
          var target = toState.target || '_blank';
          $window.open(toState.url, target);
          $rootScope.loadingProgress = false;

        }
        else if (notEmpty(toState['needRoles']) && RfAcl.hasRole(toState['needRoles']) === false)
        {

          // toastr.error('Acesso negado. Voce não possui os papéis necessários para acessar esse recurso! Acesso permitido apenas para os usuários com os papéis: ' + joinElements(toState['needRoles']));
          toastr.error('Acesso negado. Voce não possui os papéis necessários para acessar esse recurso! Caso achar que isso seja um erro, contate o administrador.');
          event.preventDefault();
          $rootScope.loadingProgress = false;

        }
        else if (notEmpty(toState['needPermissions']) && RfAcl.hasPerms(toState['needPermissions']) === false)
        {

          // toastr.error('Acesso negado. Voce não possui as permissões necessárias para acessar esse recurso! Acesso permitido apenas para os usuários com as pemrissões: ' + joinElements(toState['needPermissions']));
          toastr.error('Acesso negado. Voce não possui as permissões necessárias para acessar esse recurso! Caso achar que isso seja um erro, contate o administrador.');
          event.preventDefault();
          $rootScope.loadingProgress = false;

        }

      });

      function joinElements(elem)
      {
        var str = '';
        if (_.isArray(elem)) {
          str = _.join(elem, ', ');
        } else if (_.isString(elem)) {
          str = elem;
        }
        return str;
      }

      function notEmpty(str)
      {
        return (_.isArray(str) && !isArrayEmpty(str)) || (_.isString(str) && str != '');
      }

      function isArrayEmpty(array)
      {
        return array == null || array == undefined || array.length == 0;
      }

      function requireAuth(auth)
      {
        return auth == null || auth !== false;
      }

      // De-activate loading indicator
      var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function() {
        $timeout(function() {
          $rootScope.loadingProgress = false;
        });
      });

      // Store state in the root scope for easy access
      $rootScope.state = $state;

      // Cleanup
      $rootScope.$on('$destroy', function() {
        stateChangeStartEvent();
        stateChangeSuccessEvent();
      });

      $rootScope.fmask = {
        data: '39/19/9999', //data PT
        cpf: '999.999.999-99',
        rg: '99.999.999-9?9',
        cnpj: '99.999.999/9999-99',
        tel: '(99) 9?9999-9999',
        cel: '(99) 9?9999-9999',
        cep: '99999-999',
        porcentage: '1?9?9?.99?9?'
      };

    });

})();

(function () {

    angular
            .module('rapi.fuse')
            .directive('rfInputDateBr', rfInputDateBrDirective);

    /**
     * Gera input text com mascara de data BR
     * Faz bind com model, para retornar um obj Date
     * 
     * @usage <rf-input-date-br rf-model="vm.row.data_nasc" rf-required="true"></rf-input-date-br>
     */

    /** @ngInject */
    function rfInputDateBrDirective(w3Date) {

        var directive = {
            link: link,
            restrict: 'EA',
            replace: true,
            template: '<input ng-model="date" mask="{{$root.fmask.data}}" type="text" ng-required="{{rf.required}}" />',
            controllerAs: 'rf',
            scope: {
                model: '=rfModel',
                required: '=rfRequired'
            }
        };

        return directive;

        function link(scope, element) {

            scope.$watch('model', function (novo) {
                if (novo) {
                    scope.date = w3Date.dateToPt(novo);
                }
            });

            element.on('blur', function () {
                scope.model = w3Date.ptToDate(element.val());
            });

        }
    }

})();
(function () {
    'use strict';

    angular
            .module('rapi.fuse')
            .controller('rfInputCityController', rfInputCityController)
            .directive('rfInputCity', rfInputCityDirective);

    /**
     * EX: <rf-input-city ng-model="vm.row.city_id" rf-required="" rf-city="vm.row.city" rf-open-create="false" flex-gt-xs="75"></rf-input-city>
     *
     * */
    /** @ngInject */
    function rfInputCityDirective() {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                ngModel: '=',
                city: '=rfCity',
                placeholder: '=rfPlaceholder',
                required: '@rfRequired',
                openCreate: '@rfOpenCreate'
            },
            templateUrl: '/app/external/fuse/components/rf-input-city/rf-input-city.tpl.html',
            controller: 'rfInputCityController as vm'
        };
    }

    /** @ngInject */
    function rfInputCityController($scope, City, $log) {
        var vm = this;

        // Data
        vm.archive = [];

        // Methods
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.showCreateCity = showCreateCity;

        activate();
        //-----------------------
        $scope.$watch('city', setCity);
        $scope.$watch('placeholder', setCity);

        function setCity(obj)
        {
            $log.debug('rfInputCity:$watch', obj);

            if (obj !== undefined) {
              if (!obj) {
                vm.selectedItem = null;
              } else if (angular.isString(obj)) {

                vm.selectedItem = {city_name: obj, id: false};
              } else if (angular.isObject(obj)) {
                var name = obj.city_name;
                name += (obj.state) ? ' (' + obj.state.state_code + ')' : '';
                name += (obj.state && obj.state.country) ? ', ' + obj.state.country.country_name: '';
                vm.selectedItem = {'city_name': name, id: obj.id};
              }
            }
        }

        function activate()
        {
            vm.openCreate = ($scope.openCreate === 'false') ? false : true;
            vm.required = ($scope.required === 'false') ? false : true;
        }

        function querySearch(query)
        {
            return City.search({
                'q': query,
                'take': 5,
                'sort': 'city_name',
                'include': 'state.country'
            });
        }

        function selectedItemChange(item)
        {
            $scope.$evalAsync(function () {
                if (item && item.id !== false)
                    $scope.ngModel = (item) ? item.id : null;
            });
        }

        function showCreateCity(ev)
        {
            var data = {
                'city_name': vm.searchText,
                'include': 'state.country'
            };

            City.dialog.create([], ev, data).then(function (result) {
                if (result)
                    setCity(result);

            });
        }

    }

})();

(function () {
    'use strict';

    angular
            .module('rapi.fuse')
            .directive('rfGallery', rfGalleryDirective)
            .controller('rfGalleryDirectiveController', rfGalleryDirectiveController);

    /**
     * use: <rf-gallery></rf-gallery>
     *
     *
     @ngInject  */
    function rfGalleryDirective()
    {
        return {
            restrict: 'E',
            templateUrl: '/app/external/fuse/components/rf-gallery/rf-gallery.html',
            controller: 'rfGalleryDirectiveController as vm',
//            bindToController: true,
            scope: {
                config: '=',
                title: '@'
            }
        };
    }

    /** @ngInject */
    function rfGalleryDirectiveController(MetaLoadHelper, $scope)
    {
        /* jshint validthis: true */
        var vm = this;
        var defaultGallery = [];

        //Data
        vm.galeria = [];

        vm.config = $scope.config;
        vm.title = $scope.title;

        //Methods
        vm.onFilesUploaded = onFilesUploaded;


        activate();
        //------------------------------

        function activate()
        {
            MetaLoadHelper(vm.config.params.owner_type, vm.config.params.owner_id).then(function ($metas) {
                vm.galeria = $metas.fetch('galeria', 'produto', defaultGallery).$toArray();
            });

        }


        function tranformFileToGaleria(file)
        {
            return {
                imgLarge: file.path_large_src,
                imgThumb: file.path_thumb_src
            };
        }




        function onFilesUploaded($files)
        {

            angular.forEach($files, function (file) {
                vm.galeria.$push(tranformFileToGaleria(file));
            });

            vm.galeria.$save();
        }

    }


})();

(function () {
    'use strict';

    angular
            .module('rapi.fuse')
            .directive('rfComments', Comments)
            .controller('rfCommentsController', rfCommentsController);

    /**
     * USAGE:
     * <rf-comments config=""></rf-comments>
     * config={
     * params:{
     * owner_id: '',
     * owner_type: ''
     * },
     * types: [
     *  {
                    key: 'mensagem',
                    label: 'Mensagem'
                },
                {
                    key: 'observacao',
                    label: 'Observação'
                },
     * ]
     * }
     * @constructor
     */
    function Comments() {
        return {
            restrict: 'E',
            scope: {
                config: "=config"
            },
            controller: 'rfCommentsController as vm',
            templateUrl: '/app/external/fuse/components/rf-comments/comments.tmpl.html'
        };
    }

    /** @ngInject */
    function rfCommentsController(RapiComment, $scope, w3Local) {

        var vm = this;
        var defaultConfig = {
            params: {
                owner_type: 'Cliente',
                owner_id: null
            },
            types: [
                {
                    key: 'mensagem',
                    label: 'Mensagem'
                },
                {
                    key: 'observacao',
                    label: 'Observação'
                },
                {
                    key: 'aviso',
                    label: 'Aviso'
                },
                {
                    key: 'sugestao',
                    label: 'Sugestão'
                }
            ]
        };
        vm.rowComment = {
            'message': '',
            'type': 'mensagem',
            'include': 'profile',
            profile : {}
        };
        vm.comments = [];
      

        /*  methods */
        vm.addNewComment = addNewComment;

        activate();

        /////////////////////////////////////////////


        function activate()
        {
            vm.config = angular.extend(defaultConfig, $scope.config);
            
            loadMessages();
            
            vm.rowComment.profile = w3Local.get('rapi.auth.profile');
            
        }

        function loadMessages() {
            var data = {
                'include': 'profile',
                'sort': '-created_at'
            };

            data = angular.extend(data, vm.config.params);

            RapiComment.search(data).then(function (result) {
                vm.comments = result;
            });
        }

        /**
         * Add new comment
         *
         * @param newCommentText
         */
        function addNewComment() {

            var data = angular.copy(vm.rowComment);
            data = angular.extend(data, vm.config.params);

            RapiComment.save(data).then(function (result) {
                vm.comments = [result].concat(vm.comments);
                vm.rowComment.message = '';
            });

        }

    }

})();

(function () {
    'use strict';

    angular
            .module('rapi.fuse')
            .directive('rfCommentsList', CommentsList)
            .controller('rfCommentsListController', rfCommentsListController);

    /**
     * USAGE:
     * <rf-comments-list config=""></rf-comments-list>
     * config={
     * params:{
     * owner_id: '',
     * owner_type: ''
     * },
     * types: [
     *  {
                    key: 'mensagem',
                    label: 'Mensagem'
                },
                {
                    key: 'observacao',
                    label: 'Observação'
                },
     * ]
     * }
     * @constructor
     */
    function CommentsList() {
        return {
            restrict: 'E',
            scope: {
                config: "=config"
            },
            controller: 'rfCommentsListController as vm',
            templateUrl: '/app/external/fuse/components/rf-comments/rf-comments-list.tmpl.html'
        };
    }

    /** @ngInject */
    function rfCommentsListController(RapiComment, $scope) {

        var vm = this;
        var defaultConfig = {
            params: {
                owner_type: 'Cliente',
                owner_id: null
            },
            types: [
                {
                    key: 'mensagem',
                    label: 'Mensagem'
                },
                {
                    key: 'observacao',
                    label: 'Observação'
                },
                {
                    key: 'aviso',
                    label: 'Aviso'
                },
                {
                    key: 'sugestao',
                    label: 'Sugestão'
                }
            ]
        };
   
        vm.comments = [];
      

       
        activate();

        /////////////////////////////////////////////


        function activate()
        {
            vm.config = angular.extend(defaultConfig, $scope.config);
            console.log(vm.config);
            loadMessages();
            
         
        }

        function loadMessages() {
            var data = {
                'include': 'profile',
                'sort': '-created_at'
            };

            data = angular.extend(data, vm.config.params);

            RapiComment.search(data).then(function (result) {
                vm.comments = result;
            });
        }

 

    }

})();

(function () {
    'use strict';

    angular
            .module('rapi.fuse')
            .factory('RapiComment', RapiCommentService);

     //mytodo isso deveria estar no fuse
    /** @ngInject */
    function RapiCommentService(w3Resource) {
        var urlApi = '/rapi/fuse/comments';
        var service = {
            name: 'comment'
        };
        return w3Resource.extend(urlApi, service);
    }
})();

(function () {
    'use strict';

    angular
            .module('rapi.fuse')
            .directive('rfAvatar', Avatar);


    /**
     * USAGE:
     * <rf-avatar  rf-size="80" rf-profile="vm.perfil" rf-only-text="true" ></rf-avatar>
     * rf-size *5 <= 500 OR *8<=800
     * rf-only-text boolean
     * rf-profile objeto com dados do usuário
     * @constructor
     */

    /** @ngInject */
    function Avatar($filter) {
        return {
            restrict: 'EA',
            scope: {
                c: "=rfProfile",
                size: "=rfSize",
                onlyText: "=rfOnlyText",
                disable: "=?",
                presenter: "@w3Presenter"
            },
            link: function (scope) {

                scope.classColor = 'grey-400-bg';
                scope.profile = {
                    sex: null,
                    name: '',
                    thumb_src: null
                };



                scope.$watch('c', build);

                function build(newProfile) {

                  if (!newProfile) {
                        return;
                    }

                    // if (scope.presenter) {
                    //     scope.profile = angular.copy($filter(scope.presenter)(newProfile));
                    // } else {
                        scope.profile = newProfile;
                    // }

                    scope.classColor = 'grey-400-bg';

                    if (scope.profile.sex === "female" || scope.profile.sex === "F" ) {
                        scope.classColor = 'pink-400-bg';
                    } else if (scope.profile.sex === "male" || scope.profile.sex === "M") {
                        scope.classColor = 'md-blue-400-bg';
                    }

                }

            },
            templateUrl: '/app/external/fuse/components/rf-avatar/rf-avatar.tmpl.html'
        };
    }




})();

(function () {
    'use strict';

    angular
            .module('rapi.fuse')
            .directive('rfActivities', activitiesDirective)
            .controller('rfActivitiesController', activitiesController);


    /**
     * USAGE:
     * <rf-activities rf-token="vm.row.token_morph.token"></rf-activities>
     *
     * @constructor
     */
    function activitiesDirective() {
        return {
            restrict: 'E',
            scope: {
                token: "=rfToken"
            },
            controller: 'rfActivitiesController as vm',
            templateUrl: '/app/external/fuse/components/rf-activities/activities.tmpl.html'
        };
    }

    /** @ngInject */
    function activitiesController($scope, $http, rfUtils)
    {
        var vm = this;

        //Data
        vm.activities = [];

        //--------------------------------
        $scope.$watch('token', activate);

        function activate()
        {
            if ($scope.token) {
                loadLogs();
            }

            $scope.$on('rfActivities.reload', function(){// este callback envia um paramentro event
                //event.preventDefault();//myFeature implements pusher socket io
                loadLogs();
            });
        }

        function loadLogs() {

            var data = {
                params: {
                    'token_morph': $scope.token,
                    'include': 'causer',
                    'sort': '-created_at',
                    'take': -1 //mytodo paginar result (colocar btn de ler mais) page++
                }
            };

            var url = rfUtils.urlApi('/rapi/fuse/activities');

            $http.get(url, data).then(function (result) {
                vm.activities = result.data.data;
            });
        }

    }


})();

(function () {
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
            .module('rapi.fuse.auth', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider) {

        //path folder plugin
        var path = '/app/external/fuse';

        // State definitions
        $stateProvider
                .state('auth', {
                    abstract: true,
                    url: '/auth',
                    views: {
                        'main@': {
                            templateUrl: path + '/layouts/content/content.html',
                            controller: 'AuthController as vm'
                        }
                    },
                    auth: false
                })
                .state('auth.login', {
                    url: '/login',
                    views: {
                        'content': {
                            templateUrl: path + '/auth/login-v2/login-v2.html',
                            controller: 'LoginV2Controller as vm'
                        }
                    },
                    bodyClass: 'login-v2',
                    auth: false
                })
                .state('auth.token', {
                    url: '/token?access_token',
                    views: {
                        'content': {
                            controller: 'LoginTokenController'
                        }
                    },
                    auth: false
                })
                .state('auth.logout', {
                    url: '/logout',
                    views: {
                        'content': {
                            template: 'Efetuando logout...',
                            controller: 'LogoutController'
                        }
                    }
                })
                .state('auth.reset', {
                    url: '/reset/:token?:welcome&:email',
                    views: {
                        'content': {
                            templateUrl: path + '/auth/reset-password/reset-password.html',
                            controller: 'ResetPasswordController as vm'
                        }
                    },
                    bodyClass: 'reset-password',
                    auth: false
                })
                .state('auth.forgot', {
                    url: '/remind',
                    views: {
                        'content': {
                            templateUrl: path + '/auth/forgot-password/forgot-password.html',
                            controller: 'ForgotPasswordController as vm'
                        }
                    },
                    bodyClass: 'forgot-password',
                    auth: false
                }
                );



        // Translation
        //$translatePartialLoaderProvider.addPart('/assets//app/external/fuse/components/auth');
    }

})();

(function ()
{
    'use strict';

    angular
            .module('rapi.fuse.auth')
            .controller('ResetPasswordController', ResetPasswordController);

    /** @ngInject */
    function ResetPasswordController(RfPassword, w3Config, $stateParams, $log, $state)
    {
        // Data
        var vm = this;

        vm.bg_auth = w3Config.get('bg_auth');
        vm.logo = w3Config.get('logo');
        vm.sigla = w3Config.get('sigla');
        vm.form = {};
        vm.welcome = false;
        vm.appTitle = '';

        vm.resetPassword = resetPassword;

        //////////

        activate();

        function activate() {
          if($stateParams.welcome){
              vm.appTitle = w3Config.get('title_project');
              vm.welcome = true;
          }
        }

        function resetPassword()
        {
            vm.form.token = $stateParams.token;

            RfPassword.reset(vm.form)
                    .then(resetPasswordComplete)
                    .catch(resetPasswordFailed);

            function resetPasswordComplete() {
                $log.info('Password have been successful reseted');
                $state.go("auth.login");
            }

            function resetPasswordFailed(error) {
                $log.error('XHR Failed for resetPassword.\n' + angular.toJson(error.data, true));
            }
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('rapi.fuse.auth')
            .controller('LoginV2Controller', LoginV2Controller);

    /** @ngInject */
    function LoginV2Controller(w3Config, w3Auth, $state, $window, RfAuthValidation) {

        var vm = this;

        // Data
        vm.credentials = {
            include: 'profile',
            type: w3Config.get('auth').type
        };

        vm.welcome = w3Config.get('welcome');
        vm.welcome_text = w3Config.get('welcome_text');
        vm.credits_auth_logo = w3Config.get('credits_auth_logo');
        vm.credits_link = w3Config.get('credits_link');
        vm.bg_auth = w3Config.get('bg_auth');
        vm.logo = w3Config.get('logo');
        vm.showLogo = w3Config.get('showLogo');
        vm.sigla = w3Config.get('sigla');

        // Methods
        vm.login = login;
        vm.returnHome = returnHome;

      //--------------------
      function login() {
        w3Auth.login(vm.credentials).then(function () {
        //   if (RfAuthValidation.hasAccessToModule(result)) {
        //     $state.go(w3Config.get('auth').routeSuccess);
        //   } else {
        //     RfAuthValidation.noAccessToModuleNotification();
        //     RfAuthValidation.logout();
        //     RfAuthValidation.navigateToHome();
        //   }
        //
        });
      }

        function returnHome() {
          $window.open(document.location.origin, '_self');
        }

    }
})();

(function ()
{
    'use strict';

    angular
            .module('rapi.fuse.auth')
            .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController(RfPassword, w3Config, $log)
    {
        // Data
        var vm = this;

        vm.bg_auth = w3Config.get('bg_auth');
        vm.logo = w3Config.get('logo');
        vm.sigla = w3Config.get('sigla');
        vm.form = {};

        // Methods
        vm.sendResetPasswordLink = sendResetPasswordLink;

        //////////

        function sendResetPasswordLink()
        {
            RfPassword.remind(vm.form)
                    .then(resetPasswordComplete)
                    .catch(resetPasswordFailed);

            function resetPasswordComplete() {
                vm.form = {};
                $log.info('Password reset link have been sent.');
            }

            function resetPasswordFailed(error) {
                $log.error('XHR Failed for sendResetPasswordLink.\n' + angular.toJson(error.data, true));
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
            .module('rapi.fuse.cities', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        //mytodo Criar filtro buscar cidades por pais ou estados
        //mytodo Criar Diaog para selecionar o pais, depois os estados do pais selecionado e so entao o campo nome da cidades
        //mytodo Melhorar btns de cadastr cidades
        $stateProvider
                .state('app.cities', {
                    abstract: true,
                    url: '/cities',
                    bodyClass: 'cities'
                })
                .state('app.cities.tabbed', {
                    url: '/city',
                    views: {
                        'content@app': {
                            templateUrl: '/app/external/fuse/cities/tabbed.html'
                        },
                        'viewTabCity@app.cities.tabbed': {
                            templateUrl: '/app/external/fuse/cities/cities/cities-archive.html',
                            controller: 'CityController as vm'
                        },
                        'viewTabState@app.cities.tabbed': {
                            templateUrl: '/app/external/fuse/cities/states/states-archive.html',
                            controller: 'StateController as vm'
                        },
                        'viewTabCountry@app.cities.tabbed': {
                            templateUrl: '/app/external/fuse/cities/countrys/countrys-archive.html',
                            controller: 'CountryController as vm'
                        }
                    }
                });

                //            O menu pode ser adicionado manualmente
                //            msNavigationServiceProvider.saveItem('cidade', {
                //              title: 'CITIES.MENU',
                //              icon: 'icon-city',
                //              state: 'app.cities.tabbed',
                //              weight: 15
                //            });
    }
})();

(function() {
  'use strict';

  angular
    .module('rapi.fuse.cities')
    .factory('Estado', estadoService);


  /** @ngInject */
  function estadoService($mdDialog, w3Resource) {

    var urlApi  = '/rapi/fuse/states';

    var service = {
      dialog : {
        create: showCreateDialog,
        edit  : showDialog
      }
    };

    return w3Resource.extend(urlApi, service);

    // ///////////////////////////////

    // DIALOGS
    /** archive: array com a lista de itens */
    function showCreateDialog( archive, ev){
      return showDialog(null, archive, ev);
    }

    /** Abre um Dialog para cadastr/edição de um item
     * row: objeto item que está sendo editado
     *  archive: array com a lista de itens
     */
    function showDialog(row, archive, ev){

      return $mdDialog.show({
        controller: 'StatesDialogController',
        controllerAs: 'vm',
        templateUrl: '/app/external/fuse/cities/states/states-dialog.html',
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          'row': row,
          'archive': archive
        }

      });

    }

  }

})();

(function () {
    'use strict';

    angular
            .module('rapi.fuse.cities')
            .controller('StateController', StateController);

    /** @ngInject */
    function StateController(Estado, w3Utils, $translate) {
        var vm = this;

        // Data
        vm.archive = [];
        vm.loading = false;
        vm.pagination = {};
        vm.paises = [];
        vm.params = {
            'paginate': 10,
            'sort': 'state_name', //EX: nome,-created_at
            'q' : null,
            'include' : 'country'
        };

        // Methods
        vm.showCreate    = showCreate;
        vm.showEdit      = showEdit;
        vm.confirmDelete = confirmDelete;
        vm.search        = search;
        vm.setPage       = setPage;

        activate();

        //-----------------------

        function activate() {
            vm.loading = true;
            vm.archive = null;

            Estado.search(vm.params).then(function (result) {
                vm.loading = false;
                vm.archive = result;
                vm.pagination = Estado.pagination;
            });

        }

        function setPage(p)
        {
            Estado.setPage(p);
            activate();
        }

        function search()
        {
            Estado.setPage(1);
            activate();
        }


        /**
         * Open new item dialog
         *
         * @param ev
         */
        function showCreate(ev) {
            Estado.dialog.create(vm.archive, ev);
        }

        function showEdit(row, ev) {
            Estado.dialog.edit(row, vm.archive, ev);
        }

       function confirmDelete(item, $index, $event) {

            //TRANSLATE: Você realmente quer apagar este item?
            w3Utils.confirmDelete($translate.instant('CITIES.MSG_CONFIRM_DELETE_STATE'), item.state_name, $event)
                    .then(function () {
                        Estado.remove(item.id).then(function () {
                            vm.archive.splice($index, 1);
                        });
                    });

        }

    }


})();

(function() {
  'use strict';

  angular
    .module('rapi.fuse.cities')
    .controller('StatesDialogController', StatesDialogController);

  /** @ngInject */
  function StatesDialogController($mdDialog, Estado, row, archive, Pais) {

    var vm = this;

    //Data
    vm.isNew = true;
    vm.row = angular.copy(row);
    vm.title = null;
    vm.countries = [];

    //Methods
    vm.closeDialog = closeDialog;
    vm.update = update;
    vm.save = save;

    activate();
    //-----------------------------------

    function activate() {
      archive = archive || [];
      loadCountries();
      if (vm.row) {
        vm.isNew = false;
      }
    }

    function update() {
      Estado.update(row.id, vm.row).then(function(result) {
        if (result) {
          angular.extend(row, result);
          closeDialog(row);
        }
      });
    }

    function save() {
      Estado.save(vm.row).then(function(result) {
        if (result) {
          archive.push(result);
          closeDialog(result);
        }
      });
    }

    function closeDialog(params) {
      $mdDialog.hide(params);
    }


    function loadCountries() {

      Pais.all().then(function(result) {
        vm.countries = result;
      });
    }

  }


})();

(function() {
  'use strict';

  angular
    .module('rapi.fuse.cities')
    .factory('Pais', paisService);


  /** @ngInject */
  function paisService($mdDialog, w3Resource) {

    var urlApi  = '/rapi/fuse/countries';

    var service = {
      dialog : {
        create: showCreateDialog,
        edit  : showDialog
      }
    };

    return w3Resource.extend(urlApi, service);

    // ///////////////////////////////

    // DIALOGS
    /** archive: array com a lista de itens */
    function showCreateDialog( archive, ev){
      return showDialog(null, archive, ev);
    }

    /** Abre um Dialog para cadastr/edição de um item
     * row: objeto item que está sendo editado
     *  archive: array com a lista de itens
     */
    function showDialog(row, archive, ev){

      return $mdDialog.show({
        controller: 'CountryDialogController',
        controllerAs: 'vm',
        templateUrl: '/app/external/fuse/cities/countrys/countrys-dialog.html',
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          'row': row,
          'archive': archive
        }

      });

    }

  }

})();

(function () {
    'use strict';

    angular
            .module('rapi.fuse.cities')
            .controller('CountryController', CountryController);

    /** @ngInject */
    function CountryController(Pais, w3Utils, $translate) {
        var vm = this;

        // Data
        vm.archive = [];
        vm.loading = false;
        vm.pagination = {};
        vm.params = {
            'paginate': 10,
            'sort': 'country_name', //EX: nome,-created_at
            'q' : null
        };

        // Methods
        vm.showCreate    = showCreate;
        vm.showEdit      = showEdit;
        vm.confirmDelete = confirmDelete;
        vm.search        = search;
        vm.setPage       = setPage;

        activate();

        //-----------------------

        function activate() {
            vm.loading = true;
            vm.archive = null;

            Pais.search(vm.params).then(function (result) {
                vm.loading = false;
                vm.archive = result;
                vm.pagination = Pais.pagination;
                // console.log(vm.archive);
            });

        }

        function setPage(p)
        {
            Pais.setPage(p);
            activate();
        }

        function search()
        {
            Pais.setPage(1);
            activate();
        }

        /**
         * Open new item dialog
         *
         * @param ev
         */
        function showCreate(ev) {
            Pais.dialog.create(vm.archive, ev);
        }

        function showEdit(row, ev) {
            Pais.dialog.edit(row, vm.archive, ev);
        }

       function confirmDelete(item, $index, $event) {

            //TRANSLATE: Você realmente quer apagar este item?
            w3Utils.confirmDelete($translate.instant('CITIES.MSG_CONFIRM_DELETE_COUNTRY'), item.country_name, $event)
                    .then(function () {
                        Pais.remove(item.id).then(function () {
                            vm.archive.splice($index, 1);
                        });
                    });

        }

    }



})();

(function() {
  'use strict';

  angular
    .module('rapi.fuse.cities')
    .controller('CountryDialogController', CountryDialogController);

  /** @ngInject */
  function CountryDialogController($mdDialog, Pais, row, archive) {

    var vm = this;

    //Data
    vm.isNew = true;
    vm.row   = angular.copy(row);
    vm.title = null;

    //Methods
    vm.closeDialog = closeDialog;
    vm.update = update;
    vm.save = save;

    activate();
    //-----------------------------------

    function activate() {
      archive = archive || [];

        if (vm.row) {
            vm.isNew = false;
        }
    }

    function update() {
      Pais.update(row.id, vm.row).then(function(result) {
        if (result) {
          angular.extend(row, result);
          closeDialog(row);
        }
      });
    }

    function save() {
      Pais.save(vm.row).then(function(result) {
        if (result) {
          archive.push(result);
          closeDialog(result);
        }
      });
    }

    function closeDialog(params) {
      $mdDialog.hide(params);
    }

  }


})();

(function () {
    'use strict';

    angular
        .module('rapi.fuse.acl.test', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {

        // State
        $stateProvider
            .state('app.acl_test', {
                url: '/acl-test',
                checkSessionRequest: true,
                views: {
                    'content@app': {
                        templateUrl: '/app/external/fuse/acl/test/test-acl.html',
                        controller: 'AclTestController as vm'
                    }
                }
            });

        msNavigationServiceProvider.saveItem('testes_acl', {
            title: 'Testes acl',
            icon: 'icon-account-multiple',
            state: 'app.acl_test',
            weight: 99
        });

    }
})();



(function () {
    'use strict';

    angular
            .module('rapi.fuse.acl.test')
            .controller('AclTestController', AclTestController);

    /** @ngInject */
    function AclTestController($http, w3Utils)
    {
        var vm = this;

        //DATA
        vm.row = {};
        vm.roles = [];
        vm.permisisons = [];

        activate();
        //METHODS
        function activate()
        {
            loadMe() ;
            loadPermisisons() ;
            loadRoles();
        }
        
        function loadMe() 
        {
            $http.get(w3Utils.urlApi('/rapi/guardian/me/acl')).then(function (result) {
                vm.row = result.data.data;
            });
        }
        
        function loadRoles() 
        {
            $http.get(w3Utils.urlApi('/rapi/guardian/acl/roles')).then(function (result) {
                vm.roles = result.data.data;
            });
        }
        
        function loadPermisisons() 
        {
            $http.get(w3Utils.urlApi('/rapi/guardian/acl/permissions')).then(function (result) {
                vm.permisisons = result.data.data;
            });
        }

    }


})();

(function () {
    'use strict';

    angular
            .module('rapi.fuse.cities')
            .factory('City', cidadeService);


    /** @ngInject */
    function cidadeService($mdDialog, w3Resource, $http, w3Utils) {

        var urlApi = '/rapi/fuse/cities';

        var service = {
            searchCEP: searchCEP,
            dialog: {
                create: showCreateDialog,
                edit: showDialog
            }
        };

        return w3Resource.extend(urlApi, service);

        // ///////////////////////////////

        // DIALOGS
        /** archive: array com a lista de itens */
        function showCreateDialog(archive, ev, data) {
            return showDialog(data, archive, ev);
        }

        /** Abre um Dialog para cadastr/edição de um item
         * row: objeto item que está sendo editado
         *  archive: array com a lista de itens
         */
        function showDialog(row, archive, ev) {

            return $mdDialog.show({
                controller: 'CityDialogController',
                controllerAs: 'vm',
                templateUrl: '/app/external/fuse/cities/cities/cities-dialog.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    'row': row,
                    'archive': archive
                }

            });

        }

        function searchCEP(cep) {

            var data = {
                params: {
                    cep: cep,
                    include: 'city.state.country'
                }
            };

            return $http.get(w3Utils.urlApi(urlApi + "/cep"), data).then(function (result) {
                return result.data.data;
            });
        }
    }

})();

(function () {
    'use strict';

    angular
            .module('rapi.fuse.cities')
            .controller('CityController', CityController);

    /** @ngInject */
    function CityController(City, w3Utils, $translate) {
        var vm = this;

        // Data
        vm.archive = [];
        vm.loading = false;
        vm.pagination = {};
        vm.params = {
            'paginate': 10,
            'sort': 'city_name', //EX: nome,-created_at
            'q' : null,
            'include' : 'state.country'
        };

        // Methods
        vm.showCreate    = showCreate;
        vm.showEdit      = showEdit;
        vm.confirmDelete = confirmDelete;
        vm.search        = search;
        vm.setPage       = setPage;

        activate();

        //-----------------------

        function activate() {            
            vm.loading = true;
            vm.archive = null;

            City.search(vm.params).then(function (result) {
                vm.loading = false;
                vm.archive = result;
                vm.pagination = City.pagination;
            });

        }

        function setPage(p)
        {
            City.setPage(p);
            activate();
        }

        function search()
        {
            City.setPage(1);
            activate();
        }

        /**
         * Open new item dialog
         *
         * @param ev
         */
        function showCreate(ev) {
            City.dialog.create(vm.archive, ev);
        }

        function showEdit(row, ev) {
            City.dialog.edit(row, vm.archive, ev);
        }

       function confirmDelete(item, $index, $event) {

            //TRANSLATE: Você realmente quer apagar este item?
            w3Utils.confirmDelete($translate.instant('CITIES.MSG_CONFIRM_DELETE_CITY'), item.city_name, $event)
                    .then(function () {
                        City.remove(item.id).then(function () {
                            vm.archive.splice($index, 1);
                        });
                    });

        }

    }


})();

(function() {
  'use strict';

  angular
    .module('rapi.fuse.cities')
    .controller('CityDialogController', CityDialogController);

  /** @ngInject */
  function CityDialogController($mdDialog, City,Estado, row, archive, Pais) {

    var vm = this;

    //Data
    vm.isNew = true;
    vm.row   = angular.copy(row);
    vm.title = null;
    vm.states = [];
    vm.countrys = [];

    //Methods
    vm.closeDialog = closeDialog;
    vm.update = update;
    vm.save = save;
    vm.loadCountry = loadCountry;
    vm.loadState = loadState;

    activate();
    //-----------------------------------

    function activate() {
      archive = archive || [];
        if (vm.row && vm.row.id) {
            vm.isNew = false;
        }
        if(!vm.isNew){
          vm.row.country_id = vm.row.state.country_id;
          loadCountry();
          loadState(vm.row.country_id);
        }
    }

    function update() {
      City.update(row.id, vm.row).then(function(result) {
        if (result) {
          angular.extend(row, result);

          closeDialog(row);
        }
      });
    }

    function save() {
      vm.row.include='state.country';
      City.save(vm.row).then(function(result) {
        if (result) {
          archive.push(result);
          closeDialog(result);
        }
      });
    }

    function closeDialog(params) {
      $mdDialog.hide(params);
    }

    function loadState(country_id)
    {

      Estado.search({'country_id':country_id}).then(function (result) {
                vm.states = result;
            });
    }
    function loadCountry()
    {
        var params = {
            page:null,
            paginate:null,
            sort:'country_name'
        }
      Pais.search(params).then(function (result) {
                vm.countrys = result;
            });
    }

  }


})();

(function ()
{
    'use strict';

    angular
            .module('rapi.fuse.acl.role', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        var permission = 'guardian.acl.manage';
        // State
        $stateProvider
                .state('app.role', {
                    url: '/Roles',
                    views: {
                        'content@app': {
                            templateUrl: '/app/external/fuse/acl/role/role-archive.html',
                            controller: 'RoleController as vm'
                        }
                    },
                    needPermissions: permission
                })
                .state('app.role.new', {
                    url: '/novo',
                    checkSessionRequest: true, views: {
                        'content@app': {
                            templateUrl: '/app/external/fuse/acl/role/role-form.html',
                            controller: 'RoleFormController as vm'
                        }
                    },
                    needPermissions: permission
                })
                .state('app.role.show', {
                    url: '/{id}',
                    checkSessionRequest: true, views: {
                        'content@app': {
                            templateUrl: '/app/external/fuse/acl/role/role-show.html',
                            controller: 'RoleShowController as vm'
                        }
                    },
                    needPermissions: permission
                })
                .state('app.role.edit', {
                    url: '/{id}/editar',
                    checkSessionRequest: true, views: {
                        'content@app': {
                            templateUrl: '/app/external/fuse/acl/role/role-form.html',
                            controller: 'RoleFormController as vm'
                        }
                    },
                    needPermissions: permission
                });

//                msNavigationServiceProvider.saveItem('role', {
//                    title: 'ROLE.MENU',
//                    icon: 'icon-bank',
//                    state: 'app.role',
//                    weight: 10
//                });

    }
})();

(function () {
    'use strict';

    angular
            .module('rapi.fuse.acl.role')
            .factory('Role', RoleService);


    /** @ngInject */
    function RoleService(w3Resource, $http, w3Utils) {

        var urlApi = '/rapi/guardian/acl/roles';

        var service = {
            find: find
        };

        return w3Resource.extend(urlApi, service);

        //----------------------------------

        function find(id, params)
        {
            var data = {
                params: params
            };

            return $http.get(w3Utils.urlApi(urlApi + '/{id}', {id: id}), data).then(function (result) {
                return result.data.data;
            });
        }
        
    }
})();

(function () {
  'use strict';

  angular
  .module('rapi.fuse.acl.role')
  .controller('RoleController', RoleController)
  .controller('RoleFormController', RoleFormController)
  .controller('RoleShowController', RoleShowController);

  /** @ngInject */
  function RoleController(Role, w3Utils, $translate, $mdDialog) {
    var vm = this;

    // Data
    vm.archive = [];

    vm.pagination = {};
    vm.params = {};
    var defaultParams = {
      'paginate': 10,
      'sort': 'name', //EX: nome,-created_at
      'q': null,
      'onlyTrashed': null,
      'withTrashed': null
    };

    // Methods
    vm.confirmDelete = confirmDelete;
    vm.search = search;
    vm.setPage = setPage;
    vm.getAllItens = getAllItens;
    vm.getTrasehdItens = getTrasehdItens;
    vm.getOnlyActiveItens = getOnlyActiveItens;
    vm.clearFilter = clearFilter;

    activate();

    //-----------------------

    function activate()
    {

      vm.params = angular.copy(defaultParams);
      search();
    }

    function setPage(p)
    {
      Role.setPage(p);
      activate();
    }

    function search()
    {
      if (vm.params.q) {
        vm.params.withTrashed = 1;
      }

      Role.search(vm.params).then(function (result) {

        vm.archive = result;
        vm.pagination = Role.pagination;
      });
    }

    function clearFilter()
    {
      vm.searchActive = false;

      vm.params = angular.copy(defaultParams);
      search();
    }

    function confirmDelete(item, $index, $event)
    {
      w3Utils.confirmDelete($translate.instant('ROLE.TITLE_CONFIRM_DELETE'), $translate.instant('ROLE.MSG_CONFIRM_DELETE') + item.name + '?', $event)
      .then(function () {
        Role.remove(item.id).then(function () {
          vm.archive.splice($index, 1);
        });
      });
    }

    function getAllItens()
    {
      vm.params.onlyTrashed = null;
      vm.params.withTrashed = 1;
      search();
    }

    function getTrasehdItens()
    {
      vm.params.onlyTrashed = 1;
      vm.params.withTrashed = null;
      search();
    }

    function getOnlyActiveItens()
    {
      vm.params.onlyTrashed = null;
      vm.params.withTrashed = null;
      search();
    }
  }

  /** @ngInject */
  function RoleFormController(Role, Permission, w3Utils, $translate, $stateParams, $state, $mdDialog) {

    var vm = this;
    var ID;

    //Data
    vm.isNew = false;
    vm.row = {};
    vm.permissions = [];
    vm.permissions_group = [];
    vm.checkedPermissions = [];
    vm.params = {
      'onlyTrashed': null,
      'withTrashed': 1,
      'include': 'permissions'
    };

    //Methods
    vm.save = save;
    vm.confirmDelete = confirmDelete;
    vm.goArchive = goArchive;
    vm.toggleAll = toggleAll;
    vm.isGroupChecked = isGroupChecked;


    activate();
    //-------------------

    function activate()
    {
      if ($stateParams.id) {
        loadResource($stateParams.id);
      } else {
        vm.isNew = true;
        loadAllDependencies(false);
      }
    }

    function loadResource(id)
    {
      Role.find(id, vm.params).then(function (result) {
        vm.row = result;
        enableEdit(result.id);
        loadAllDependencies(true);
      });
    }

    function loadAllDependencies(check) {
      Permission.all().then(function(result){
        vm.permissions = result;
        if (check) {
          checkItens(vm.permissions, vm.row.permissions.data);
        }
        groupPermissions(vm.permissions);
      });
    }

    function groupPermissions(permissions) {
      var groups = [];

      angular.forEach(permissions, function (permission) {
        if(groups.indexOf(permission.group) == -1) {
          this.push(permission.group);
          vm.permissions_group.push({
              'group': permission.group
            });
        }
      }, groups);
    }

    function permissonsGroupLenght(groupName){
      var length = 0;
      angular.forEach(vm.permissions, function (permission) {
        if(permission.group == groupName) {
          length = length + 1;
        }
      });

      return length;
    }

    function permissonsGroupCheckedLenght(groupName){
      var length = 0;
      angular.forEach(vm.permissions, function (permission) {
        if(permission.group == groupName && permission.checked) {
          length = length + 1;
        }
      });

      return length;
    }

    function uncheckPermissonsGroup(group){
      var length = 0;
      angular.forEach(vm.permissions, function (permission) {
        if(permission.group == group) {
          permission.checked = false;
        }
      });
      return length;
    }

    function checkPermissonsGroup(groupName){
      var length = 0;
      angular.forEach(vm.permissions, function (permission) {
        if(permission.group == groupName) {
          permission.checked = true;
        }
      });
      return length;
    }

    function isGroupChecked(permissionGroup) {
      return (permissonsGroupLenght(permissionGroup.group)  === permissonsGroupCheckedLenght(permissionGroup.group));
    }

    function toggleAll(permissionGroup) {
      if (isGroupChecked(permissionGroup)) {
        uncheckPermissonsGroup(permissionGroup.group);
      } else {
        checkPermissonsGroup(permissionGroup.group)
      }
    };

    function enableEdit(id) {
      vm.isNew = false;
      ID = id;
    }

    function getIdsChecked(data)
    {
      var ids = [];

      angular.forEach(data, function (item) {
        if(item.checked)
        this.push(item.id);
      }, ids);

      return ids;
    }

    function getIds(data)
    {
      var ids = [];

      angular.forEach(data, function (item) {
        this.push(item.id);
      }, ids);

      return ids;
    }

    function checkItens(list, data)
    {
      var ids = getIds(data);

      angular.forEach(list, function (item) {
        item.checked = (ids.indexOf(item.id) !==  -1);
      });
    }

    function save()
    {
      vm.row.permissions =  getIdsChecked(vm.permissions);
      if (vm.isNew) {
        create();
      } else {
        update();
      }
    }

    function create()
    {
      Role.save(vm.row).then(function (result) {
        $state.go('app.role.edit', {id: result.id});
      });
    }

    function update()
    {
      Role.update(ID, vm.row).then(function (result) {
        if (result) {
          angular.extend(vm.row, result);
        }
      });
    }


    function confirmDelete($event)
    {
      w3Utils.confirmDelete($translate.instant('ROLE.TITLE_CONFIRM_DELETE'), $translate.instant('ROLE.MSG_CONFIRM_DELETE') + vm.row.name + '?', $event)
      .then(function () {

        Role.remove(ID).then(goArchive);
      });
    }

    function goArchive()
    {
      $state.go('app.role');
    }
  }

  /** @ngInject */
  function RoleShowController(Role, $stateParams, $state) {

    var vm = this;

    //Data
    vm.row = {};
    vm.params = {
      'onlyTrashed': null,
      'withTrashed': 1,
      'include': 'group_permissions'
    };

    //Methods
    vm.goArchive = goArchive;

    activate();
    //-------------------

    function activate()
    {
      if ($stateParams.id) {
        loadResource($stateParams.id);
      }
    }

    function loadResource(id)
    {
      Role.find(id, vm.params).then(function (result) {
        vm.row = result;
      });
    }

    function goArchive()
    {
      $state.go('app.role');
    }

  }


})();

(function () {
    'use strict';

    angular
            .module('rapi.fuse.acl.role')
            .factory('Permission', PermissionService);


    /** @ngInject */
    function PermissionService(w3Resource) {

        var urlApi = '/rapi/guardian/acl/permissions';

        var service = {
            find: null,
            save: null,
            update: null,
            remove: null
        };

        return w3Resource.extend(urlApi, service);
        //----------------------------------
    }
})();

(function () {
    'use strict';

    angular
        .module('commons.conta_bancaria', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('xsession.conta_bancaria', {
                url: '/conta_bancarias',
                views: {
                    'content@app': {
                        templateUrl: '/app/external/conta_bancaria/conta_bancaria-archive.html',
                        controller: 'ContaBancariaController as vm'
                    }
                }
            })
            .state('xsession.contas', {
                url: '/contas',
                views: {
                    'content@app': {
                        templateUrl: '/app/external/conta_bancaria/conta_bancaria-archive.html',
                        controller: 'ContaBancariaController as vm'
                    }
                }
            })
            .state('xsession.contas.show', {
                url: '/{id}',
                views: {
                    'content@app': {
                        templateUrl: '/app/external/conta_bancaria/show_conta/show_conta.html',
                        controller: 'ShowContaBancariaController as vm'
                    }
                }
            });

        // msNavigationServiceProvider.saveItem('conta_bancaria', {
        //   title: 'CONTA_BANCARIA.MENU',
        //   icon: 'icon-tile-four',
        //   state: 'xsession.conta_bancaria',
        //   weight: 30
        // });

    }
})();

(function () {
    'use strict';

    angular
        .module('commons.conta_bancaria')
        .controller('DetailPaymentDialogController', DetailPaymentDialogController);

    /** @ngInject */
    function DetailPaymentDialogController($mdDialog, ContaBancaria, id) {

        var vm = this;

        //Data
        vm.row = {};

        //Methods
        vm.cancel = cancel;

        activate();

        //-----------------------------------

        function activate() {
            if(id){
                // vm.row = data;
            }else{
                ContaBancaria.find(id, '').then(function (result) {
                    vm.row = result;
                });
            }
            console.log('ROW', vm.row);
        }



        function cancel() {
            $mdDialog.cancel();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('rapi.fuse.acl', [])
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, RfAcl) {

        $rootScope.$on('w3Auth:onChangeProfile', function () {
            RfAcl.refreshAclStorange();
        });

        $rootScope.$on('XSession:changed', function () {
            RfAcl.refreshAclStorange();
        });


        RfAcl.setupMenuNav();
    }

})();

(function ()
{
    'use strict';

    angular
            .module('rapi.fuse.acl')
            .directive('rfAclShowCam', aclShowCamDirective);

    // Source code adapted from stackoverflow: <https://stackoverflow.com/a/24065378>
    function aclShowCamDirective(ngIfDirective, RfAcl) {
        var ngIf = ngIfDirective[0];

        return {
            transclude: ngIf.transclude,
            priority: ngIf.priority,
            terminal: ngIf.terminal,
            restrict: ngIf.restrict,
              scope: {
                rfAclShowCam: "@rfAclShowCam"
            },
            link: function ($scope, $element, $attr) {                                    

                $attr.ngIf = function () 
                {
                    return RfAcl.hasPerms($scope.rfAclShowCam);;
                };
                
                ngIf.link.apply(ngIf, arguments);
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
            .module('rapi.fuse.acl')
            .directive('rfAclHideCam', aclHideCamDirective);

    // Source code adapted from stackoverflow: <https://stackoverflow.com/a/24065378>
    function aclHideCamDirective(ngIfDirective, RfAcl) {
        var ngIf = ngIfDirective[0];

        return {
            transclude: ngIf.transclude,
            priority: ngIf.priority,
            terminal: ngIf.terminal,
            restrict: ngIf.restrict,
              scope: {
                rfAclHideCam: "@rfAclHideCam"
            },
            link: function ($scope, $element, $attr) {                            

                $attr.ngIf = function () 
                {
                    return ! RfAcl.hasPerms($scope.rfAclHideCam);
                };
                
                ngIf.link.apply(ngIf, arguments);
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('commons.conta_bancaria')
        .controller('ContaBancariaShowDialogController', ContaBancariaDialogController);

    /** @ngInject */
    function ContaBancariaDialogController($mdDialog, ContaBancaria, data, id) {

        var vm = this;

        //Data
        vm.row = {};

        //Methods
        vm.cancel = cancel;

        activate();

        //-----------------------------------

        function activate() {
            if(data){
                vm.row = data;
            }else{
                ContaBancaria.find(id, '').then(function (result) {
                    vm.row = result;
                });
            }
            console.log('ROW', vm.row)
        }



        function cancel() {
            $mdDialog.cancel();
        }
    }
})();

(function ()
{
    'use strict';

    angular
            .module('rapi.fuse.acl')
            .directive('rfAclShowRole', aclShowCamDirective);

    // Source code adapted from stackoverflow: <https://stackoverflow.com/a/24065378>
    function aclShowCamDirective(ngIfDirective, RfAcl) {
        var ngIf = ngIfDirective[0];

        return {
            transclude: ngIf.transclude,
            priority: ngIf.priority,
            terminal: ngIf.terminal,
            scope: {
                rfAclShowRole: "@rfAclShowRole"
            },
            restrict: ngIf.restrict,
            link: function ($scope, $element, $attr) {
                            
                $attr.ngIf = function () 
                {
                    return RfAcl.hasRole($scope.rfAclShowRole);
                };
                
                ngIf.link.apply(ngIf, arguments);
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
            .module('rapi.fuse.acl')
            .directive('rfAclHideRole', aclHideCamDirective);

    // Source code adapted from stackoverflow: <https://stackoverflow.com/a/24065378>
    function aclHideCamDirective(ngIfDirective, RfAcl) {
        var ngIf = ngIfDirective[0];

        return {
            transclude: ngIf.transclude,
            priority: ngIf.priority,
            terminal: ngIf.terminal,
            scope: {
                rfAclHideRole: "@rfAclHideRole"
            },
            restrict: ngIf.restrict,
            link: function ($scope, $element, $attr) {                                    

                $attr.ngIf = function () 
                {
                    return ! RfAcl.hasRole($scope.rfAclHideRole);
                };
                
                ngIf.link.apply(ngIf, arguments);
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('commons.conta_bancaria')
        .controller('ContaBancariaDialogController', ContaBancariaDialogController);

    /** @ngInject */
    function ContaBancariaDialogController($mdDialog, ContaBancaria, data) {

        var vm = this;

        //Data
        vm.isNew = true;
        vm.row = {};
        vm.title = null;
        vm.bancos = [];
        vm.docType = 'CPF';
        vm.vendedor = {};
        vm.lockTipo = false;

        //Methods
        vm.cancel = cancel;
        vm.update = update;
        vm.save = save;

        activate();

        //-----------------------------------

        function activate() {

            if (data.conta || data.id) {
                vm.isNew = false;
                vm.row = angular.copy(data);
                if (vm.row.entity_type === 'otica') {
                    vm.row.tipo = 'PAGSEGURO';
                    vm.lockTipo = true;
                }
            }
        }

        function update() {
            ContaBancaria.xUpdate(vm.row.id, vm.row).then(function (result) {
                if (result) {
                    closeDialog(result);
                }
            });
        }

        function save() {
            ContaBancaria.save(vm.row, 'banco').then(function (result) {
                if (result) {
                    closeDialog(result);
                }
            });
        }


        function cancel() {
            $mdDialog.cancel();
        }

        function closeDialog(params) {
            vm.row.banco = _.filter(vm.bancos, getBanco)[0];
            $mdDialog.hide(angular.copy(vm.row));

            function getBanco(item) {
                return item.id === vm.row.banco_id;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('commons.conta_bancaria')
        .controller('CreateAppSessionDialogController', CreateAppSessionDialogController);

    /** @ngInject */
    function CreateAppSessionDialogController($mdDialog, ContaBancaria, id) {

        var vm = this;
        vm.loading = true;

        //Methods
        vm.cancel = cancel;

        activate();

        //-----------------------------------

        function activate() {
            if(id){
                ContaBancaria.authPersonate(id).then(function (result) {
                    if(result){
                        localStorage.setItem('app_access_token', result.access_token);
                        localStorage.setItem('app_x-otica', result.otica.id);
                        localStorage.setItem('app_x-conta', result.conta.id);

                        setTimeout(function (){
                            vm.loading = false;
                            window.open(document.location.origin + '/premio');
                        }, 2000);

                    }
                });
            }
        }



        function cancel() {
            $mdDialog.cancel();
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('commons.conta_bancaria')
    .component('contaBancariaCard', {
      templateUrl: '/app/external/conta_bancaria/component/conta-bancaria-card/conta-bancaria-card.template.html',
      controller: contaBancariaController,
      controllerAs: 'vm',
      bindings: {
        conta: '<conta',
        select: '@select'
      },
      transclude: {
        'actionMenu': '?actionMenu'
      }
    });

  // <conta-bancaria-card></conta-bancaria-card>
  /** @ngInject */
  function contaBancariaController() {
    var vm = this;
    
    vm.entitySubLabel = '';
    vm.$onInit = onInit;

    function onInit() {
        vm.entitySubLabel = checkTipoConta();
    }
    
    function checkTipoConta() {
        switch (vm.conta.entity_sub) {
            case 'gerente':
                return 'Gerente';
            case 'vendedor':
                return 'Vendedor';

        }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('commons.pedido')
    .controller('PedidoDialogSendRequest', PedidoDialogSendRequest);

  /** @ngInject */
  function PedidoDialogSendRequest(Pedido, PedidoInfo, $mdDialog, request) {
    var vm = this;

    vm.labs = [];
    vm.messageValues = {};

    vm.cancel = cancel;
    vm.close = close;
    vm.isBoxNeeded = isBoxNeeded;
    vm.isCodeNeeded = isCodeNeeded;
    vm.isInfoNeeded = isInfoNeeded;
    vm.isLabsNeeded = isLabsNeeded;
    vm.isToDeliver = isToDeliver;
    vm.isToEnd = isToEnd;
    vm.isToProduce = isToProduce;
    vm.isToSend = isToSend;
    vm.sendRequest = sendRequest;

    activate();

    function activate() {
      console.log('request', request);
      vm.request = request;
      setMessageValues();
      if (isLabsNeeded()) {
        loadLabs();
      }
    }

    function loadLabs() {
      PedidoInfo.allLabs().then(loadLabsSucess);

      function loadLabsSucess(response) {
        vm.labs = response;
      }
    }

    function setMessageValues() {
      vm.messageValues.id = vm.request.id;
      vm.messageValues.person = vm.request.person;
      vm.messageValues.person_prefix = vm.request.person_prefix;
    }

    function isToSend() {
      return vm.request.type == 'send';
    }

    function isInfoNeeded() {
      return isBoxNeeded() || isLabsNeeded() || isCodeNeeded();
    }

    function isToProduce() {
      return vm.request.type == 'produce';

    }

    function isToDeliver() {
      return vm.request.type == 'deliver';
    }

    function isToEnd() {
      return vm.request.type == 'end';
    }

    function isBoxNeeded() {
      return vm.request.status == "AGUARDANDO_POLO";
    }

    function isLabsNeeded() {
      return vm.request.status == "AGUARDANDO_ADMIN";
    }

    function isCodeNeeded() {
      return vm.request.status == "ENVIO_ADMIN" || vm.request.status == "ENVIO_POLO";
    }


    function sendRequest() {
      // console.log('sending', vm.request);
      var data = {
        'id': vm.request.id
      }
      switch (vm.request.status) {
        case 'RASCUNHO':
          Pedido.sendRequestFromOticaToPolo(data.id).then(sendRequestSucess);
          break;

        case 'AGUARDANDO_POLO':
          data.box = vm.request.box;
          Pedido.sendRequestFromPoloToAdmin(data.id, data).then(sendRequestSucess);
          break;

        case 'AGUARDANDO_ADMIN':
          data.laboratorio_id = vm.request.lab.id;
          Pedido.sendRequestFromAdminToLab(data.id, data).then(sendRequestSucess);
          break;

        case 'AGUARDANDO_LAB':
          Pedido.startLensProduction(data.id).then(sendRequestSucess);
          break;

        case 'EXECUTANDO_LAB':
          Pedido.sendRequestFromLabToAdmin(data.id).then(sendRequestSucess);
          break;

        case 'ENVIO_ADMIN':
          data.cod_rastreamento = vm.request.cod_rastreamento;
          // data.vl_fabricacao = vm.request.vl_fabricacao;
          Pedido.sendRequestFromAdminToPolo(data.id, data).then(sendRequestSucess);
          break;

        case 'ENVIO_POLO':
          data.cod_rastreamento = vm.request.cod_rastreamento;
          Pedido.sendRequestFromPoloToOtica(data.id, data).then(sendRequestSucess);
          break;

        case 'ENVIO_OTICA':
          Pedido.setRequestAsEnded(data.id).then(sendRequestSucess);
          break;
      }

      function sendRequestSucess(result) {
        var data = {
          'box': result.box,
          'cod_rastreamento': result.cod_rastreamento,
          'status_label': result.status_label,
          'status': result.status,
        }
        close(data);
      }
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function close(data) {
      $mdDialog.hide(data);
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('commons.pedido')
    .controller('PedidoDialogDeclineRequest', PedidoDialogDeclineRequest);

  /** @ngInject */
  function PedidoDialogDeclineRequest(Pedido, $mdDialog, request) {
    var vm = this;

    vm.labs = [];
    vm.messageValues = {};

    vm.cancel = cancel;
    vm.close = close;
    vm.declineRequest = declineRequest;

    activate();

    function activate() {
      vm.request = request;
      console.log('** request 2 --', vm.request)
      vm.messageValues.id = vm.request.id;
    }

    function declineRequest() {
      var data = {
        'obs_cancelamento': vm.request.obs_cancelamento
      };

      switch (request.status) {
        case 'RASCUNHO':
          data.person = 'otica';
          Pedido.cancel(vm.request.id, data).then(declineRequestSucess);
          break;
        case 'AGUARDANDO_POLO':
          data.person = 'polo';
          Pedido.cancel(vm.request.id, data).then(declineRequestSucess);
          break;
        case 'AGUARDANDO_ADMIN':
          data.person = 'admin';
          Pedido.cancel(vm.request.id, data).then(declineRequestSucess);
          break;
        case 'AGUARDANDO_LAB':
          data.person = 'lab';
          Pedido.cancel(vm.request.id, data).then(declineRequestSucess);
          break;
      }

      function declineRequestSucess(result) {
        var data = {
          'status_label': result.status_label,
          'status': result.status,
        }

        close(data);
      }
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function close(data) {
      $mdDialog.hide(data);
    }
  }

})();

(function ()
{
    'use strict';

    angular
            .module('rapi.w3')
            .factory('w3Utils', w3Utils);

    /** @ngInject */
    function w3Utils($document, $mdDialog, $state, w3Config)
    {

        var configs = {
            baseUrl: 'http://localhost:8000',
            env: 'localhost'
        };

        var service = {
            getUrl: getUrl,
            urlApi: urlApi,
            urlApiInclude: urlApiInclude,
            getLocale: getLocale,
            alert: alert,
            confirmDelete: confirmDelete,
            confirm: confirm,
            openPopUp: openPopUp,
            makeUrlApp: makeUrlApp,
            getIds : getIds,
            getIdsJoin : getIdsJoin
        };

        activate();
        return service;

        //////////

        function activate()
        {
            angular.extend(configs, w3Config.get('host'));
        }

        function getBaseUrl()
        {
            return configs.baseUrl;
        }

        /**
         * ex url: /marcas/{id}/action/{action}
         * cria-se um objeto {id:5, action: 'delete'}
         * resultado: http://localhost:8000/api/v1/marcas/5/action/delete
         *
         * Se passar um integer no lugar do obejto ele procura automaticamente o {id}
         * ex url: /marcas/{id}/teste
         * cria-se um id 5
         * resultado: http://localhost:8000/api/v1/marcas/5/teste
         */
        function urlApi(url, params)
        {
            url = configs.baseUrlApi + url;

            if (angular.isObject(params)) {
                angular.forEach(params, function (v, k) {
                    url = url.replace('{' + k + '}', v);
                });
            } else if (params)
            {
                url = url.replace('{id}', params);
            }

            return getUrl(url);
        }

        /**
         *  apenas adciona ?include ao final da url para evitar de ter que ficar criando toda aquele array data{params: {include: .. } }
         */
        function urlApiInclude(url, params, include)
        {
            url = urlApi(url, params);

            if (include) {
                url += "?include=" + include;
            }

            return url;
        }

        function getUrl(url)
        {
            url = url || '';
            return getBaseUrl() + url;
        }

        function getLocale()
        {
            return 'pt-br';
            //return 'es';//pt-br';
        }

        function alert(title, message, labelBtn)
        {
            labelBtn = labelBtn || 'OK';

            var dialog = $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title(title)
                    .ariaLabel(title)
                    .parent(angular.element($document.body))
                    .ok(labelBtn);

            if (message)
                dialog.textContent(message);

            return $mdDialog.show(dialog);
        }


        function confirmDelete(title, message, ev)
        {

            var templateModal = [
                '<md-dialog aria-label="Excluir conta" class="dialog-md mv-modal-default">',
                '<md-toolbar class="md-warn">',
                '<div class="md-toolbar-tools">',
                '<h2>{{title}}</h2>',
                '    <span flex></span>',
                '    <md-button class="md-icon-button" ng-click="cancel()" aria-label="fechar dialog">',
                '<i class="ion ion-close-round" style="color:#fff"></i>',
                '</md-button>',
                '</div>',
                '</md-toolbar>',
                '<md-dialog-content style="max-width:800px;max-height:810px; ">',
                '   <div>',
                '       <h3 ng-bind-html="message"></h3>',
                '   </div>',
                '</md-dialog-content>',
                '<md-dialog-actions>',
                '   <span flex></span>',
                '   <md-button ng-click="cancel()" translate="COMMON.BTN_CANCEL">Cancelar</md-button>',
                '   <span flex="5"></span>',
                '   <md-button ng-click="excluir($event)" class="md-raised md-warn" translate="COMMON.BTN_EXCLUIR"> Excluir</md-button>',
                '</md-dialog-actions>',
                '</md-dialog>'
            ].join('');

            function ModalConfirmeDeleteCtlr($scope, $mdDialog, title, message)
            {

                $scope.title = title || "Confirmação de exclusão";
                $scope.message = (message === null) ? "Realmente deseja excluir esse registro?" : message;

                $scope.cancel = cancel;
                $scope.excluir = excluir;

                //----------Functions------------

                function cancel() {
                    $mdDialog.cancel();
                }

                function excluir() {
                    $mdDialog.hide(true);
                }

            }

            return $mdDialog.show({
                controller: ModalConfirmeDeleteCtlr,
                template: templateModal,
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                resolve: {
                    title: function () {
                        return title;
                    },
                    message: function () {
                        return message;
                    }
                }
            });

        }


        function confirm(title, message, ev)
        {

            var templateModal = [
                '<md-dialog aria-label="Confirmação" class="dialog-md mv-modal-default">',
                '<md-toolbar class="md-accent">',
                '<div class="md-toolbar-tools">',
                '<h2>{{title}}</h2>',
                '    <span flex></span>',
                '    <md-button class="md-icon-button" ng-click="cancel()" aria-label="fechar dialog">',
                '<i class="ion ion-close-round" style="color:#fff"></i>',
                '</md-button>',
                '</div>',
                '</md-toolbar>',
                '<md-dialog-content style="max-width:800px;max-height:810px; ">',
                '   <div>',
                '       <h3 ng-bind-html="message"></h3>',
                '   </div>',
                '</md-dialog-content>',
                '<md-dialog-actions>',
                '   <span flex></span>',
                '   <md-button ng-click="cancel()" translate="COMMON.BTN_CANCEL">Cancelar</md-button>',
                '   <span flex="5"></span>',
                '   <md-button ng-click="confirmar($event)" class="md-raised md-accent" translate="COMMON.BTN_CONFIRM">Confirmar</md-button>',
                '</md-dialog-actions>',
                '</md-dialog>'
            ].join('');

            function ModalConfirmeCtlr($scope, $mdDialog, title, message)
            {

                $scope.title = title || "Confirmação";
                $scope.message = (message === null) ? "Deseja executar esta ação?" : message;

                $scope.cancel = cancel;
                $scope.confirmar = confirmar;

                //----------Functions------------

                function cancel() {
                    $mdDialog.cancel();
                }

                function confirmar() {
                    $mdDialog.hide(true);
                }

            }

            return $mdDialog.show({
                controller: ModalConfirmeCtlr,
                template: templateModal,
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                resolve: {
                    title: function () {
                        return title;
                    },
                    message: function () {
                        return message;
                    }
                }
            });

        }

        function openPopUp(stateOrName, params, w, h)
        {
            var url = $state.href(stateOrName, params);
            var options = [];

            w = w || 740;
            h = h || 600;


            options.push('height=' + h);
            options.push('width=' + w);

            return window.open(url, "webapp", options.join(','));
        }

        function makeUrlApp(path)
        {
            var configHost = w3Config.get('host');
           

            if (configHost.env === 'local') {
                return [configHost.appUrl, path].join('/');
            }

            return [configHost.appUrl, configHost.baseModule, path].join('/');
        }
        
         /*
         * Responsável por pegar os is dos chips e retornar em uma string separapor |
         */
        function getIds(colection)
        {
            if (!angular.isArray(colection))
                return null;

            return colection.map(function (row) {
                return row.id;
            });
        }
        
         /*
         * Responsável por pegar os is dos chips e retornar em uma string separapor |
         */
        function getIdsJoin(colection)
        {
            if (!angular.isArray(colection))
                return null;

            return getIds(colection).join('|');
        }

        
        /**
         * //mytodo criar um service so para manipular array e objetos o fuse ja tem alguns recursos
         * @param {type} obj
         * @returns {undefined}
         */
//        function cleanAttributes(obj)
//        {
//            for (var i in obj) {
//                if (test[i] === null || test[i] === undefined) {
//                    delete test[i];
//                }
//            }
//        }

    
    }
}());

(function() {
  'use strict';

/**
$log.info( w3Local.set('tdd', 1234) === w3Local.set('tdd', 1234) );
$log.info( w3Local.set('tdd', 1234) === w3Local.set('tdd2', 1234) );
$log.info( w3Local.get('ts', 1234) === 1234 );
w3Local.set('ts', {nome:'valmir'})
$log.info( w3Local.get('ts').nome === 'valmir' );
*/

  angular
    .module('rapi.w3')
    .service('w3Local', local)
    .service('w3Session', session);

  function storange(drive) {

    /* jshint validthis: true */
    var vm = this;
    vm.drive = drive;
    vm.set = set;
    vm.get = get;
    vm.unset = unset;
    vm.reset = reset;
    
    //Mytodo create set namespace e unsetNamespace

    function set(key, value) {
      value = angular.toJson(value);
      this.drive.setItem(key, value);
    }

    function get(key, defaul) {

      var item = this.drive.getItem(key);

      if (!item || item === 'null') {
        return defaul;
      }

      try {
        return angular.fromJson(item);
      } catch (e) {
        return defaul;
      }

    }

    function unset(key) {
      this.drive.removeItem(key);
    }

    function reset() {
      this.drive.clear();
    }

  }

  function local() {
    return new storange(window.localStorage);
  }

  function session() {
    return new storange(window.sessionStorage);
  }



})();

(function () {
    'use strict';

    angular
            .module('rapi.w3')
            .service('w3Resource', w3Resource);

    /** @ngInject */
    function w3Resource($http, w3Utils) {

        this.make = function (urlApi, presenter) {
            return resourceModelo($http, w3Utils, urlApi, presenter);
        };

        this.extend = function (urlApi, service, presenter) {
            var resource = this.make(urlApi, presenter);
            angular.extend(resource, service);
            return resource;
        };

    }

    function resourceModelo($http, w3Utils, urlApi, presenter) {

        function Service() {
            this.page = 1;
            this.perPage = 15;
            this.name = 'w3Resource';
            this.url = urlApi;
            this.pagination = null;
            this.transformerRequest = null;
            this.transformerResponse = null;
        }


        /** retorna os primeiros 15 items itens da rota + includes */
        Service.prototype.get = function (includes) {
            return this.search({
                'include': includes,
                'paginate': this.perPage
            });
        };

        /** retorna todos os itens da rota + includes */
        Service.prototype.all = function (includes) {
            return this.search({
                'include': includes,
                'take': -1
            });
        };

        /**
         * Registra a pagina
         * @param int newPage
         */
        Service.prototype.setPage = function (newPage) {
            this.page = newPage;
        };

        /** retorna os itens da rota  filtrados por params*/
        Service.prototype.search = function (params) {

            var vm, data;

            vm = this;

            var dataParams = (presenter)? presenter.params(params) : params;
            dataParams.page = this.page;

            data = {
                w3Reload: vm.name + '.search',
                params: dataParams
            };

            return $http.get(w3Utils.urlApi(this.url), data).then(function (result) {
                vm.pagination = (result.data.meta) ? result.data.meta : null;
                return (presenter)? presenter.collection(result.data.data) : result.data.data;
            });
        };

        /**
         * Busca um registro pelo ID
         * @param id integer codifo indentificador
         * @param includeEmbed string
         * @return $q
         * */
        Service.prototype.find = function (id, includeEmbed) {

            var data = {
                w3Reload: this.name + '.find',
                params: {
                    'include': includeEmbed
                }
            };

            return $http.get(w3Utils.urlApi(this.url + '/{id}', {
                id: id
            }), data).then(function (result) {
                return (presenter)? presenter.item(result.data.data) : result.data.data;
            });

        };

        /** salva data */
        Service.prototype.save = function (data) {

            var config = {
                'w3Reload': this.name + '.save'
            };

            var dataRequest = (presenter)? presenter.request(data) : data;

            return $http.post(w3Utils.urlApi(this.url), dataRequest, config).then(
                    function (result) {

                        if (result.status === 201) {
                            var transformer = (presenter)? presenter.item(result.data.data) : result.data.data;
                            angular.extend(data, transformer);
                            return data;
                        }

                        return false;
                    });
        };

        /** edita informações do idem id */
        Service.prototype.update = function (id, data) {

            var config = {
                'w3Reload': this.name + '.update'
            };

            var dataRequest = (presenter)? presenter.request(data) : data;

            return $http.put(w3Utils.urlApi(this.url + '/{id}', {
                id: id
            }), dataRequest, config).then(function (result) {

                if (result.data.status === 'success') {
                    var transformer = (presenter)? presenter.item(result.data.data) : result.data.data;
                    angular.extend(data, transformer);
                    return data;
                }

                return false;
            });
        };


        Service.prototype.remove = function (id) {

            var config = {
                'w3Reload': this.name + '.remove'
            };

            return $http.delete(w3Utils.urlApi(this.url + '/{id}', {
                id: id
            }), config).then(function (result) {
                return (result.data.status === 'success') ? true : false;
            });
        };

        return new Service();
    }



})();


/***
 * //mytodo implemets  w3Presenter in w3resource
 */
//function modeloResouce2(w3Date, w3Presenter, w3Resource) {
//
//        var Presenter = w3Presenter.make(
//                transformerResponse,
//                transformerRequest
//                );
//
//        var service = {
//            otherMethd: otherMethd,
//        };
//
//        return w3Resource.extend(service, Presenter);
//
//        function transformerResponse(response) {
//            response.nome = response.nome.toUpperCase();
//            response.data_nasc = w3Date.enToObj(response.data_nasc);
//            return response;
//        }
//
//        function transformerRequest(request) {
//            request.data_nasc = w3Date.toFormatEn(request.data_nasc);
//            return request;
//        }
//
//        function otherMethd() {
//            return $http.get(w3Utils.urlApi('/painel/me'), data).then(function (result) {
//                return Presenter.item(result.data.data);
//            });
//        }
//
//    }
//
//    function modeloResouce3(w3Date, w3Presenter, w3Resource) {
//
//        var Presenter = w3Presenter.make(
//                transformerResponse,
//                transformerRequest
//                );
//
//        return w3Resource.get(Presenter);
//
//        function transformerResponse(response) {
//            response.nome = response.nome.toUpperCase();
//            response.data_nasc = w3Date.enToObj(response.data_nasc);
//            return response;
//        }
//
//        function transformerRequest(request) {
//            request.data_nasc = w3Date.toFormatEn(request.data_nasc);
//            return request;
//        }
//
//    }

(function () {
    'use strict';

    angular
            .module('rapi.w3')
            .service('w3Presenter', makeService);

    /** @ngInject */
    function makeService() {

        this.make = function (response, request, params) {
            return new Service(response, request, params);
        };

    }

    function Service(response, request, params) {
        this.transformerRequest = request;
        this.transformerResponse = response;
        this.transformerParams = params;
    }

    Service.prototype.setTransformerRequest = function (func) {
        this.transformerRequest = func;
    };

    Service.prototype.setTransformerResponseRequest = function (func) {
        this.transformerResponse = func;
    };
    
    Service.prototype.setTransformerParamsRequest = function (func) {
        this.transformerParams = func;
    };

    Service.prototype.collection = function (results) {
        var presenter = this.transformerResponse;    
        var vm = this;
        return results.map(function (result, index) {
            return vm.presenter(result, presenter, index);
        });
    };
    
    Service.prototype.item = function (result) {
        return this.presenter(result, this.transformerResponse);
    };
    
    Service.prototype.request = function (result) {
        return this.presenter(result, this.transformerRequest);
    };
    
    Service.prototype.params = function (result) {
        return this.presenter(result, this.transformerParams);
    };
    
    Service.prototype.presenter = function(result, presenter, index){
        
        if(angular.isFunction(presenter) === false){
            return result;
        }
        
        var data = angular.copy(result);
        return presenter(data, index);  
    };


})();

/***
 * Modelo de uso
 * 
 var Presenter = w3Presenter.make(
        function (result)
        {
            console.log(222, result);
            result.nome = 2;
            return result;
        },
        function (result)
        {
            console.log(222, result);
            result.ok = 2;
            return result;
        }
);

//service

function save(data) {
    var newData = Presenter.request(data);

    return $http.post(w3Utils.urlApi(route), newData).then(function (result) {
        return (result.status === 201) ? Presenter.item(result.data.data) : false;
    });
}

function search(params) {

    var data = {
        params: params
    };

    return $http.get(w3Utils.urlApi(route), data).then(function (result) {
        return Presenter.collection(result.data.data);
    });

}

 */
(function () {

    'use strict';

    angular.module('rapi.w3')
            .service('w3JWT', w3JWTService);

    function w3JWTService() {

        this.urlBase64Decode = function (str) {
            var output = str.replace(/-/g, '+').replace(/_/g, '/');
            switch (output.length % 4) {
                case 0:
                {
                    break;
                }
                case 2:
                {
                    output += '==';
                    break;
                }
                case 3:
                {
                    output += '=';
                    break;
                }
                default:
                {
                    throw 'Illegal base64url string!';
                }
            }
            return decodeURIComponent(escape(window.atob(output))); //polifyll https://github.com/davidchambers/Base64.js
        };


        this.decodeToken = function (token) {
            var parts = token.split('.');

            if (parts.length !== 3) {
                throw new Error('JWT must have 3 parts');
            }

            var decoded = this.urlBase64Decode(parts[1]);
            if (!decoded) {
                throw new Error('Cannot decode the token');
            }

            return JSON.parse(decoded);
        };

        this.getTokenExpirationDate = function (token) {
            var decoded;
            decoded = this.decodeToken(token);

            if (typeof decoded.exp === "undefined") {
                return null;
            }

            var d = new Date(0); // The 0 here is the key, which sets the date to the epoch
            d.setUTCSeconds(decoded.exp);

            return d;
        };

        this.isTokenExpired = function (token, offsetSeconds) {
            var d = this.getTokenExpirationDate(token);
            offsetSeconds = offsetSeconds || 0;
            if (d === null) {
                return false;
            }

            // Token expired?
            return !(d.valueOf() > (new Date().valueOf() + (offsetSeconds * 1000)));
        };
    }
    

}());

/* global NaN */

(function () {
    'use strict';

    angular
            .module('rapi.w3')
            .factory('w3Date', dateService);

    //helperService.$inject = [];
    //Mytodo remover o service $w3Date q so ta com um methodo extraxdate
    //Mytodo remover directive input-date ver se ainda ha necessidade de uso
    //Mytodo ver a impotese de transformar isso em $w3Date criar um padrão para service

    /** @ngInject */
    function dateService()
    {

        var service = {
            toFormatEn: toFormatEn,
            enToObj: enToObj,
            subDays: subDays,
            subMonths: subMonths,
            subMonthsInteval: subMonthsInteval,
            subYears: subYears,
            subYearsInteval: subYearsInteval,
            diffDays: diffDays,
            dateToPt: dateToPt,
            ptToDate: ptToDate,
            enToDate: enToObj,
            enToPt: enToPt,
            ptToEn: ptToEn,
            dateToEn: dateToEn
        }; 

        return service;
        ////////////////////////////

        /**
         * Transforma tanto date como datetime no formato yyyy-MM-dd HH:mm:ss to Date
         * @param {string} dt
         * @returns {undefined|Date}
         */
        function enToObj(dt)
        {
            if (!dt || angular.isString(dt) === false)
                return;

            var objDate, bits;

            bits = dt.split(/\D/);

            if (bits.length === 3) {
                objDate = new Date(bits[0], --bits[1], bits[2]);
            } else {
                objDate = new Date(bits[0], --bits[1], bits[2], bits[3], bits[4]);
            }

            return objDate;

//            if (!dt)
//                return new Date();
//            //var hora = dt.substr(11);
//
//            if (angular.isString(dt) && dt !== "") {
//                dt = dt.substr(0, 10).split('-');
//            }
//
//            //mytodo melhorar essa parte de conveter hora junto
//            // if(hora){
//            //     hora = hora.split(':');
//            //     return new Date(dt[0], (dt[1]-1), dt[2], hora[0], hora[1], hora[2]);
//            // }
//            return new Date(dt[0], (dt[1] - 1), dt[2]);
        }

        function dateToEn(date)
        {
            return date ? moment(date).format('YYYY-MM-DD') : '';
//            var m = moment(date, 'DD-MM-YYYY', true);
//            return m.isValid() ? m.toDate() : new Date(NaN);
        }

        /**
         * Tranforma um objeto Date para uma string date/datetime
         * @param {Date} dt
         * @param {boolean} full
         * @returns {string}
         */
        function toFormatEn(dt, full)
        {
            if (!dt) {
                return;
            }
            
            var format = (full === true) ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
            return moment(dt).format(format);

//            var format = (full === true) ? 'yyyy-MM-dd HH:mm:ss' : 'yyyy-MM-dd';
//
//            if (angular.isDate(dt) === false) {
//                dt = Date.parse(dt);
//            }
//            dt = $filter('date')(dt, format);
//            return dt;
        }

        function subDays(objDate, nDays)
        {
            return new Date(
                    objDate.getFullYear(),
                    objDate.getMonth(),
                    objDate.getDate() - nDays
                    );
        }

        function subMonths(objDate, nMonths)
        {
            return new Date(
                    objDate.getFullYear(),
                    objDate.getMonth() - nMonths,
                    objDate.getDate()
                    );
        }

        function subMonthsInteval(objDate, nMonths)
        {
            var m = objDate.getMonth() - nMonths;
            return [
                new Date(objDate.getFullYear(), m, 1),
                new Date(objDate.getFullYear(), m + 1, 0)
            ];
        }

        function subYears(objDate, nYears)
        {
            return new Date(
                    objDate.getFullYear() - nYears,
                    objDate.getMonth(),
                    objDate.getDate()
                    );
        }

        function subYearsInteval(objDate, nYears)
        {
            var y = objDate.getFullYear() - nYears;

            return [
                new Date(y, 0, 1),
                new Date(y, 12, 0)
            ];
        }

        function diffDays(date)
        {
            var date1 = new Date(date);
            var date2 = new Date();
            var timeDiff = Math.abs(date2.getTime() - date1.getTime());
            var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
            return diffDays;
        }

        /**
         * Transforma Objeto Date em string data PT
         * EX:  new Date => 25/08/2016
         * @param Date date
         * @returns string datapt
         */
        function dateToPt(date)
        {

            if(!angular.isDate(date)){
                return date;
            }

             return moment(date).format('DD/MM/YYYY');
//
//            var date1 = date;
//
//            if (!date1) {
//                return;
//            } else {
//
//                //return date ? '*' + moment(date).format('DD/MM/YYYY') : '';
//                //date1 = date1.addDays(1);
//                date1 = $filter('date')(date1, 'dd/MM/yyyy');
//                //date1 = date1.split("-").join("/");
//
//                return date1;
//            }

        }

        /**
         * Transforma string data PT  em Objeto Date
         * EX:  25/08/2016 => new Date
         * @param string input
         * @returns Date
         */
        function ptToDate(date)
        {
            var date1 = date;

            if (!date1) {
                return;
            } else {
                date1 = date1.split("/");
                date1 = new Date(date1[2], date1[1] - 1, date1[0]);

                return date1;
            }
        }

        /**
         * Transforma data EN em PT
         * EX: 2016-08-25 => 25/08/2016
         * @param string input
         * @returns string
         */
        function enToPt(input)
        {

            if (!input) {
                return;
            } else {
                var d = input.split("-");
                input = [d[2], d[1], d[0]].join('/');

                return input;
            }
        }

        /**
         * Transforma data PT em EN
         * EX: 25/08/2016 => 2016-08-25
         * @param string input
         * @returns string
         */
        function ptToEn(input)
        {

            if (!input) {
                return;
            } else {
                var d = input.split("/");
                input = [d[2], d[1], d[0]].join('-');

                return input;
            }
        }

    }


})();

(function () {
    'use strict';

    angular
            .module('rapi.w3')
            .factory('w3Auth', w3AuthService);

    /**
     * //ToDO
     *
     * $auth.signup(user, [options])
     * $auth.logiSocialite(name, [userData]) //redes sociais
     */

    /** @ngInject */
    function w3AuthService($http, $q, $rootScope, $log, w3Utils, w3Local, w3JWT)
    {
        var JWT;
        var service = {
            login: login,
            loginFromToken: loginFromToken,
            profile: profile,
            user: user,
            logout: logout,
            check: check,
            guest: guest,
            getToken: getToken,
            token: getTokenWhen,
            getPayload: getPayload,
            setToken: setToken
        };

        return service;
        ////////////////

        function login(credentials)
        {
            var deferred = $q.defer();

            var config = {
                skipAuthorization: true
            };



            $http.post(w3Utils.urlApi('/rapi/guardian/auth/login'), credentials, config).then(
                    function (result) {

                        if (result.data.status === 'success') {
                            _handlerOnSuccess(result.data.data);
                            deferred.resolve(result.data.data);
                        }

                        deferred.reject(result);

                    },
                    function (error) {
                        deferred.reject(error);
                    }
            );

            return deferred.promise;
        }

        function loginFromToken(token)
        {
            var deferred = $q.defer();

            $http({
                url: w3Utils.urlApi('/rapi/guardian/me'), //Profile
                skipAuthorization: true,
                method: 'GET',
                params: {
                    'include': 'user'
                },
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }).then(
                    function (result) {

                        if (result.data.data.user_id >= 1) {
                            _handlerOnSuccess(result.data.data);
                            deferred.resolve(result.data.data);
                        }

                        deferred.reject(result);

                    },
                    function (error) {
                        deferred.reject(error);
                    }
            );

            return deferred.promise;
        }

        function _handlerOnSuccess(result)
        {
            setToken(result.access_token);
            loadProfile();
        }

        function loadProfile() {
            $http.get(w3Utils.urlApi('/rapi/guardian/me')).then(
                function (result) {
                    if (result.status === 200) {
                        setProfile(result.data.data);
                        w3Local.set('rapi.auth.user', result.data.data);
                        $rootScope.$broadcast('w3Auth:loginSuccess', result.data);
                    }
                }
            );
        }

        function logout()
        {
            return $http.post(w3Utils.urlApi('/rapi/guardian/auth/logout')).then(function () {
                setToken(null);
                setProfile(null);
                w3Local.unset('rapi.auth.user');
                $rootScope.$emit('w3Auth:logout');
            });
        }

        function check()
        {
            var token = getJWT();

            if (!token) {//not token
                return false;
            }

            if (w3JWT.isTokenExpired(token)) {//token expired
                return false;
            }

            return true;
        }

        function guest()
        {
            return (check()) ? false : true;
        }

        function getToken()
        {
            var token = getJWT();

            if (token) {

                if (w3JWT.isTokenExpired(token)) {

                    return refreshToken(token);

                } else {
                    return token;
                }

            }
        }

        function getTokenWhen()
        {
            return $q.when(getToken());
        }

        function refreshToken(token)
        {
            return $http({
                url: w3Utils.urlApi('/rapi/guardian/auth/refresh'),
                skipAuthorization: true,
                method: 'POST',
                headers: {Authorization: 'Bearer ' + token}
            }).then(function (response) {
                $log.info('Refresh Token');
                setToken(response.data.data.access_token);
                return response.data.data.access_token;
            }, function (err) {
                setToken(null);
                $log.eror('RefreshToken:error', err);
                return false;
            });
        }

        function getJWT()
        {
            if (!JWT) {
                JWT = w3Local.get('rapi.auth.token');
            }

            return JWT;
        }

        function getPayload()
        {
            var token = getJWT();
            return w3JWT.decodeToken(token);
        }

        function setToken(token)
        {
            JWT = token;
            w3Local.set('rapi.auth.token', token);
            $log.debug('w3Auth.setToken', token);
        }

        function profile()
        {
            return w3Local.get('rapi.auth.profile');
        }

        function setProfile(profile)
        {
            w3Local.set('rapi.auth.profile', profile);
            $rootScope.$broadcast('w3Auth:onChangeProfile', profile);
        }

        function user()
        {
            return w3Local.get('rapi.auth.user');
        }

    }
})();

(function () {
    'use strict';

    angular
            .module('rapi.w3')
            .provider('w3HttpInterceptor', w3HttpInterceptor);


    function w3HttpInterceptor() {

        var toastr;

        //quando o token é enviado via URL e nao pelo header, ex: ?access_token
        this.urlParam = null;

        //nome da key que vai ser utilizada no header
        this.authHeader = 'Authorization';

        //prefix do valor to token passado no header
        this.authPrefix = 'Bearer ';

        //tokenGetter: w3Auth.getToken,
        //função que retorna o token
        this.tokenGetter = null;

        //Quando configurado sera inserido o token apenas nas request que iniciam com esse prefixo
        this.urlPrefix = 'api/v1';

        //Mescla os objeto com o request.header
        this.prependHeaders = null;// Ex: {'FOO':'bar'}

        var config = this;

        this.$get = ['$q', '$rootScope', '$log', '$injector',
            function ($q, $rootScope, $log, $injector) {

                $rootScope.w3Reload = {};

                return {
                    request: function (request) {

                        if (request.w3Reload) {
                            $rootScope.w3Reload[ request.w3Reload ] = true;
                        }

                        //Casa tenha paramentro na request dizendo para ingnorar Authorization, ele tmb não add
                        if (request.skipAuthorization) {
                            return request;
                        }

                        //Caso a URL não seja de api nem add o token
                        if (request.url.indexOf(config.urlPrefix) < 0) {
                            return request;
                        }

                        $rootScope.loadingProgress = true;

                        if (config.urlParam) {
                            request.params = request.params || {};
                            // Already has the token in the url itself
                            if (request.params[config.urlParam]) {
                                return request;
                            }
                        } else {
                            request.headers = request.headers || {};

                            if(angular.isObject(config.prependHeaders)){
                              request.headers = angular.extend(request.headers, config.prependHeaders);
                            }

                            // Already has an Authorization header
                            if (request.headers[config.authHeader]) {
                                return request;
                            }
                        }

                        //Resolve tokenGetter
                        //if(config.tokenGetter === null){
                        //  config.tokenGetter = $injector.get('w3Auth').getToken;
                        //}

                        var tokenPromise = $q.when($injector.invoke(config.tokenGetter, this, {
                            config: request
                        }));

                        return tokenPromise.then(function (token) {
                            if (token) {
                                if (config.urlParam) {
                                    request.params[config.urlParam] = token;
                                } else {
                                    request.headers[config.authHeader] = config.authPrefix + token;
                                }
                            }
                            return request;
                        });
                    },
                    'response': function (response) {
                        responseLoading(response);
                        responseMensage(response.data);
                        return response || $q.when(response);
                    },
                    'responseError': function (rejection) {

                        var msg;

                        responseLoading(rejection);

                        if (rejection.status === 400) {
                            //Erro de validacao
                            responseMessageValidation(rejection.data);
                        } else if (rejection.status === 403) {
                            //Usuario não possui essa permissão CAM/ROLE
                            msg = (rejection.data.error && rejection.data.error.message) ? rejection.data.error.message : 'Seu usuário não possui acesso!';
                            responseWarn(msg);
                            $rootScope.$emit('w3HttpInterceptor:permissionRequired', rejection);
                        } else if (rejection.status === 404) {
                            //Não encontrado
                            $rootScope.$emit('w3HttpInterceptor:notFound', rejection);
                            responseMessageNotFound(rejection.data);
                        } else if (rejection.status === 401) {
                            //User não autorizado | User não logado
                            msg = (rejection.data.error && rejection.data.message) ? rejection.data.message : 'Favor efetuar login!';
                            responseWarn(msg);
                            checkLoginRequired(rejection);
                        } else if (rejection.status === -1) {
                        //    request canceled
                        } else if (rejection.status) {
                            //alert(angular.toJson(rejection))
                            $log.error(rejection);

                            if (rejection.data && rejection.data.error && rejection.data.error.message)
                                responseError(rejection.data.error.message);

                        }

                        return $q.reject(rejection);
                    }
                };

                function checkLoginRequired(rejection)
                {
                    var codes = ['token_not_provided', 'UNAUTHORIZED'];
                    var responseCode = (rejection.data.error && rejection.data.error.code) ? rejection.data.error.code : null;

                    console.warn('HTTP INTERCEPTOR 401', rejection);

                    if(codes.indexOf(responseCode) !== false){
                        $rootScope.$emit('w3HttpInterceptor:loginRequired', rejection);
                    }
                }

                //-----------------------------------------
                /**
                 * Verifica o retorno da requisição e alta os status de loadingProgress
                 * @param response is response|rejection
                 */
                function responseLoading(response)
                {
                    if (response.config && 'w3Reload' in response.config) {
                        delete $rootScope.w3Reload[ response.config.w3Reload ];
                    }

                    //Caso a URL seja de uma api ele para reload
                    if (response.config && response.config.url.indexOf(config.urlPrefix) !== -1) {
                        $rootScope.loadingProgress = false;
                    }
                }

                function getToaster() {
                    if (!toastr) {
                        toastr = $injector.get("toastr");
                    }
                    return toastr;
                }

                function responseError(message) {
                    getToaster().error(message);
                }

                function responseInfo(message) {
                    getToaster().info(message);
                }

                function responseWarn(message) {
                    getToaster().warning(message);
                }

                function responseMensage(data) {

                    if (data.message) {

                        var type = (data.status === 'error' || data.status === 'success') ? data.status : 'note';
                        var error = null;

                        if (data.errors) {
                            error = '<ul>';
                            angular.forEach(data.errors, function (item) {
                                error += '<li>' + item + '</li>';
                            });
                            error += '</ul>';
                        }

                        if (type === 'success') {
                            getToaster().success(error, data.message);
                        } else if (type === 'error') {
                            getToaster().error(error, data.message);
                        } else {
                            getToaster().info(error, data.message);
                        }

                    }


                }

                function responseMessageNotFound(data) {
                    if (data.status === "error" && data.error.message) {
                        $log.info(data.error.message);
                        getToaster().error(data.error.message);
                    }
                }

                function responseMessageValidation(data) {

                    if (!data.error)
                        return false;

                    //var type = (data.status === 'error' || data.status === 'success') ? data.status : 'note';
                    var error = null;

                    if (data.error.validation) {
                        error = '<ul>';
                        angular.forEach(data.error.validation, function (msg) {
                            error += '<li>' + msg + '</li>';
                        });

                        error += '</ul>';
                    }

                    getToaster().error(error, data.message);

                }

            }];


    }

})();

//! moment.js locale configuration
//! locale : brazilian portuguese (pt-br)
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var pt_br = moment.defineLocale('pt-br', {
        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : '%s atrás',
            s : 'poucos segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        ordinalParse: /\d{1,2}º/,
        ordinal : '%dº'
    });

    return pt_br;

}));

/* eslint-disable */
(function($){$.fn.priceFormat=function(options){var defaults={prefix:'US$ ',suffix:'',centsSeparator:'.',thousandsSeparator:',',limit:false,centsLimit:2,clearPrefix:false,clearSufix:false,allowNegative:false,insertPlusSign:false};var options=$.extend(defaults,options);return this.each(function(){var obj=$(this);var is_number=/[0-9]/;var prefix=options.prefix;var suffix=options.suffix;var centsSeparator=options.centsSeparator;var thousandsSeparator=options.thousandsSeparator;var limit=options.limit;var centsLimit=options.centsLimit;var clearPrefix=options.clearPrefix;var clearSuffix=options.clearSuffix;var allowNegative=options.allowNegative;var insertPlusSign=options.insertPlusSign;if(insertPlusSign)allowNegative=true;function to_numbers(str){var formatted='';for(var i=0;i<(str.length);i++){char_=str.charAt(i);if(formatted.length==0&&char_==0)char_=false;if(char_&&char_.match(is_number)){if(limit){if(formatted.length<limit)formatted=formatted+char_}else{formatted=formatted+char_}}}return formatted}function fill_with_zeroes(str){while(str.length<(centsLimit+1))str='0'+str;return str}function price_format(str){var formatted=fill_with_zeroes(to_numbers(str));var thousandsFormatted='';var thousandsCount=0;if(centsLimit==0){centsSeparator="";centsVal=""}var centsVal=formatted.substr(formatted.length-centsLimit,centsLimit);var integerVal=formatted.substr(0,formatted.length-centsLimit);formatted=(centsLimit==0)?integerVal:integerVal+centsSeparator+centsVal;if(thousandsSeparator||$.trim(thousandsSeparator)!=""){for(var j=integerVal.length;j>0;j--){char_=integerVal.substr(j-1,1);thousandsCount++;if(thousandsCount%3==0)char_=thousandsSeparator+char_;thousandsFormatted=char_+thousandsFormatted}if(thousandsFormatted.substr(0,1)==thousandsSeparator)thousandsFormatted=thousandsFormatted.substring(1,thousandsFormatted.length);formatted=(centsLimit==0)?thousandsFormatted:thousandsFormatted+centsSeparator+centsVal}if(allowNegative&&(integerVal!=0||centsVal!=0)){if(str.indexOf('-')!=-1&&str.indexOf('+')<str.indexOf('-')){formatted='-'+formatted}else{if(!insertPlusSign)formatted=''+formatted;else formatted='+'+formatted}}if(prefix)formatted=prefix+formatted;if(suffix)formatted=formatted+suffix;return formatted}function key_check(e){var code=(e.keyCode?e.keyCode:e.which);var typed=String.fromCharCode(code);var functional=false;var str=obj.val();var newValue=price_format(str+typed);if((code>=48&&code<=57)||(code>=96&&code<=105))functional=true;if(code==8)functional=true;if(code==9)functional=true;if(code==13)functional=true;if(code==46)functional=true;if(code==37)functional=true;if(code==39)functional=true;if(allowNegative&&(code==189||code==109))functional=true;if(insertPlusSign&&(code==187||code==107))functional=true;if(!functional){e.preventDefault();e.stopPropagation();if(str!=newValue)obj.val(newValue)}}function price_it(){var str=obj.val();var price=price_format(str);if(str!=price)obj.val(price)}function add_prefix(){var val=obj.val();obj.val(prefix+val)}function add_suffix(){var val=obj.val();obj.val(val+suffix)}function clear_prefix(){if($.trim(prefix)!=''&&clearPrefix){var array=obj.val().split(prefix);obj.val(array[1])}}function clear_suffix(){if($.trim(suffix)!=''&&clearSuffix){var array=obj.val().split(suffix);obj.val(array[0])}}$(this).bind('keydown.price_format',key_check);$(this).bind('keyup.price_format',price_it);$(this).bind('focusout.price_format',price_it);if(clearPrefix){$(this).bind('focusout.price_format',function(){clear_prefix()});$(this).bind('focusin.price_format',function(){add_prefix()})}if(clearSuffix){$(this).bind('focusout.price_format',function(){clear_suffix()});$(this).bind('focusin.price_format',function(){add_suffix()})}if($(this).val().length>0){price_it();clear_prefix();clear_suffix()}})};$.fn.unpriceFormat=function(){return $(this).unbind(".price_format")};$.fn.unmask=function(){var field=$(this).val();var result="";for(var f in field){if(!isNaN(field[f])||field[f]=="-")result+=field[f]}return result}})(jQuery);
/* eslint-enable */

'use strict';
angular.module("ngLocale", [], ["$provide", function($provide) {
var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
$provide.value("$locale", {
  "DATETIME_FORMATS": {
    "AMPMS": [
      "AM",
      "PM"
    ],
    "DAY": [
      "domingo",
      "segunda-feira",
      "ter\u00e7a-feira",
      "quarta-feira",
      "quinta-feira",
      "sexta-feira",
      "s\u00e1bado"
    ],
    "ERANAMES": [
      "Antes de Cristo",
      "Ano do Senhor"
    ],
    "ERAS": [
      "a.C.",
      "d.C."
    ],
    "FIRSTDAYOFWEEK": 6,
    "MONTH": [
      "janeiro",
      "fevereiro",
      "mar\u00e7o",
      "abril",
      "maio",
      "junho",
      "julho",
      "agosto",
      "setembro",
      "outubro",
      "novembro",
      "dezembro"
    ],
    "SHORTDAY": [
      "dom",
      "seg",
      "ter",
      "qua",
      "qui",
      "sex",
      "s\u00e1b"
    ],
    "SHORTMONTH": [
      "jan",
      "fev",
      "mar",
      "abr",
      "mai",
      "jun",
      "jul",
      "ago",
      "set",
      "out",
      "nov",
      "dez"
    ],
    "STANDALONEMONTH": [
      "janeiro",
      "fevereiro",
      "mar\u00e7o",
      "abril",
      "maio",
      "junho",
      "julho",
      "agosto",
      "setembro",
      "outubro",
      "novembro",
      "dezembro"
    ],
    "WEEKENDRANGE": [
      5,
      6
    ],
    "fullDate": "EEEE, d 'de' MMMM 'de' y",
    "longDate": "d 'de' MMMM 'de' y",
    "medium": "d 'de' MMM 'de' y HH:mm:ss",
    "mediumDate": "d 'de' MMM 'de' y",
    "mediumTime": "HH:mm:ss",
    "short": "dd/MM/yy HH:mm",
    "shortDate": "dd/MM/yy",
    "shortTime": "HH:mm"
  },
  "NUMBER_FORMATS": {
    "CURRENCY_SYM": "R$",
    "DECIMAL_SEP": ",",
    "GROUP_SEP": ".",
    "PATTERNS": [
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 3,
        "minFrac": 0,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
      },
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "minInt": 1,
        "negPre": "-\u00a4",
        "negSuf": "",
        "posPre": "\u00a4",
        "posSuf": ""
      }
    ]
  },
  "id": "pt-br",
  "localeID": "pt_BR",
  "pluralCat": function(n) {  if (n >= 0 && n <= 2 && n != 2) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
});
}]);

(function () {
    'use strict';
    angular
            .module('rapi.w3')
            .filter('w3Moments', mommentsFilter)
            .filter('w3Nl2br', nl2brFilter)
            .filter('w3Date2Str', date2StrFilter)
            .filter('w3DatePt', datePtFilter)
            .filter('w3FromDatePt', fromDatePtFilter)
            .filter('w3OnlyDatePt', onlyDatePtFilter)
            .filter('w3DateMask', datemaskFilter)
            .filter('w3FileSize', fileSizeFilter)
            .filter('w3Paginate', w3PaginateService)
            .filter('w3groupBy', groupBy)
            .filter('w3Phone', phone)
            .filter('w3Cep', cep)
            .filter('w3Cpf', cpf)
            .filter('w3Rg', rg)
            .filter('w3Cnpj', cnpj);
    /**
     * Usage
     * var myFile = 5678;
     *
     * {{myText|rpFileSize}}
     *
     * Output
     * "5.54 Kb"
     *
     */
    function fileSizeFilter()
    {
        var units = [
            'bytes',
            'KB',
            'MB',
            'GB',
            'TB',
            'PB'
        ];
        return function (bytes, precision) {

            if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) {
                return '?';
            }

            var unit = 0;
            while (bytes >= 1000) {
                bytes /= 1000;
                unit++;
            }

            return bytes.toFixed(+precision) + ' ' + units[unit];
        };
    }



    /** @ngInject */
    function mommentsFilter(w3Utils)
    {
        moment.locale(w3Utils.getLocale());
        return function (input) {
            var v = input || '';
            if (v === '' || v === 'Invalid Date') {
                return '';
            }

            return moment(input).fromNow();
        };
    }

    /**
     * input: 2014-12-26 14:07:17
     * retorna: 26/12/2014 14:07
     */
    /** @ngInject */
    function datePtFilter() {
        return function (input) {
            input = input || '';

            if(angular.isDate(input)){
              input = input.toISOString();
            }

            if (angular.isString(input) === false || input === "0000-00-00 00:00:00" || input.length < 10)
                return;
            var str_date = input.substr(0, 10);
            var str_hora = input.substr(11, 5);
            input = str_date.split('-');
            return input[2] + '/' + input[1] + '/' + input[0] + " " + str_hora;
        };
    }

    /**
     * input: obj date
     * retorna: 26/12/2014
     */
    /** @ngInject */
    function fromDatePtFilter($filter) {
        return function (input) {

            if (!input) {
                return;
            } else {

                input = $filter('date')(input, 'dd/MM/yyyy');
                return input;
            }
        };
    }

    /**
     * input: 2014-12-26 14:07:17
     * retorna: 26/12/2014 14:07
     */
    /** @ngInject */
    function onlyDatePtFilter()
    {
        return function (input) {
            input = input || '';
            if (angular.isDate(input)) {
                input = input.toString();
            } else if (input === "0000-00-00 00:00:00" || input.length < 10) {
                return;
            }

            var str_date = input.substr(0, 10);
            input = str_date.split('-');
            return input[2] + '/' + input[1] + '/' + input[0];
        };
    }

    /** @ngInject */
    function date2StrFilter(w3Date)
    {
        return function (input) {
            if (angular.isDate(input)) {
                return w3Date.dateToPt(input);
            }
        };
    }

    /** @ngInject */
    function datemaskFilter($log)
    {
        //mytodo delete este filter in 30 dias => 20/09/2016
        var func = datePtFilter();
        return function (input) {
            $log.warn('Filter:w3DateMask is depecreted use w3DatePt');
            return func(input);
        };
    }

    function nl2brFilter()
    {
        return function (data) {
            if (!data)
                return data;
            return data.replace(/\n\r?/g, '<br />');
        };
    }


    /**
     * Use: {{vm.pagination|w3Paginate:'produtos'}}
     * @returns 'Exibindo 1 à 10 produtos de 100.'
     */
    /** @ngInject */
    function w3PaginateService($translate)
    {

        return function (pagination, label) {

            if (!angular.isObject(pagination))
                return;
            var start, end;
            label = label || 'itens';
            start = ((pagination.current_page - 1) * pagination.per_page) + 1;
            end = start + (+pagination.per_page)  - 1;
            //"FILTER_PAGINATE" : "Exibindo {{start}} à {{end}} itens de {{total}}."
            var str = $translate.instant('RAPI.FILTER_PAGINATE', {'start': start, 'end': end, 'total': pagination.total});
            return str;
        };
    }

    /*
     * Ordena uma lista por um parâmetro
     */
    /** @ngInject */
    function groupBy($parse)
    {
        return _.memoize(
                function (items, field) {
                    var getter = $parse(field);
                    return _.groupBy(items, function (item) {
                        return getter(item);
                    });
                }
        );
    }

    /**
     * input: 4535411523
     * retorna: (45) 3541-1523
     */
    /** @ngInject */
    function phone() {
        return function (input) {
            var str = input + '';
            str = str.replace(/\D/g, '');
            if (str.length === 11) {
                str = str.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
            } else {
                str = str.replace(/^(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
            }
            return str;
        };
    }


    /**
     * input: 85875000
     * retorna: 85.875-000
     */
    /** @ngInject */
    function cep() {
        return function (input) {
            var str = input + '';
            str = str.replace(/\D/g, '');
            str = str.replace(/^(\d{2})(\d{3})(\d)/, "$1.$2-$3");
            return str;
        };
    }


    /**
     * input: 11573175536
     * retorna: 115.731.755-36
     */
    /** @ngInject */
    function cpf() {
        return function (input) {
            var str = input + '';
            str = str.replace(/\D/g, '');
            str = str.replace(/(\d{3})(\d)/, "$1.$2");
            str = str.replace(/(\d{3})(\d)/, "$1.$2");
            str = str.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
            return str;
        };
    }

    /**
     * input: 11573175536
     * retorna: 115.731.755-36
     */
    /** @ngInject */
    function rg() {
        return function (input) {
            var str = input + '';
            str = str.replace(/\D/g, '');
            str = str.replace(/(\d{2})(\d)/, "$1.$2");
            str = str.replace(/(\d{3})(\d)/, "$1.$2");
            str = str.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
            return str;
        };
    }


    /**
     * input: 52376524000185
     * retorna: 52.376.524/0001-85
     */
    /** @ngInject */
    function cnpj() {
        return function (input) {
            var str = input + '';
            str = str.replace(/\D/g, '');
            str = str.replace(/^(\d{2})(\d)/, '$1.$2');
            str = str.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
            str = str.replace(/\.(\d{3})(\d)/, '.$1/$2');
            str = str.replace(/(\d{4})(\d)/, '$1-$2');
            return str;
        };
    }

})();

(function ()
{
    'use strict';

    angular
            .module('rapi.w3')
            .directive('w3Enter', w3EnterDirective);

    /** @ngInject */
    function w3EnterDirective() {

        return function (scope, element, attrs) {
            element.bind("keydown", function (event) {

                if (event.which === 13) {
                    scope.$apply(function () {
                        scope.$eval(attrs.w3Enter);
                    });

                    event.preventDefault();
                }
            });
        };

    }

})();

(function () {
    'use strict';

    angular
            .module('rapi.w3')
            .directive('w3Money', w3MoneyDirective);

    /**
     * use <input w3-money ng-model='vm.quantidade' /> default currency
     * use <input w3-money="[number|currency]" ng-model='vm.price' />
     * @ngInject */
    function w3MoneyDirective($filter) {

        return {
            require: '?ngModel',
            link: function (scope, elem, attrs, ctrl) {
                if (!ctrl)
                    return;

                var format = attrs.w3Money || 'currency';

                ctrl.$formatters.unshift(function () {

                    return $filter(format)(ctrl.$modelValue);
                });

                ctrl.$parsers.unshift(function () {//viewValue

                    if (format === 'number') {

                        elem.priceFormat({
                            allowNegative: true,
                            centsLimit: 0,
                            prefix: '',
                            centsSeparator: ',',
                            thousandsSeparator: '.'
                        });

                    } else {

                        elem.priceFormat({
                            allowNegative: true,
                            prefix: '',
                            centsSeparator: ',',
                            thousandsSeparator: '.'
                        });

                    }
                    return parseFloat(elem[0].value.replace(/\./g, '').replace(',', '.')) || 0;
                });
            }
        };
    }

})();

(function () {
    'use strict';

    angular
            .module('rapi.w3')
            .directive('w3Currency', w3CurrencyDirective);

    /**
     * use <input w3-currency ng-model='vm.quantidade' limit="2" prefix="" /> default currency
     * prefix is optional />
     * @ngInject */
    function w3CurrencyDirective($filter) {

        return {
            require: '?ngModel',
            scope: {
                limit: '=limit',
                prefix: '=prefix'
            },
            link: function (scope, elem, attrs, ctrl) {
                
                var limite = scope.limit ? scope.limit : '2';
                var prefixo = scope.prefix ? scope.prefix : ''; // exemple: R$, USD
                
                if (!ctrl)
                    return;
                
                var format = attrs.w3Money || 'currency';

                ctrl.$formatters.unshift(function () {

                    return $filter(format)(ctrl.$modelValue, prefixo, limite);
                });

                ctrl.$parsers.unshift(function () {//viewValue

                        elem.priceFormat({
                            allowNegative: true,
                            centsLimit: limite,
                            prefix: prefixo,
                            centsSeparator: ',',
                            thousandsSeparator: '.'
                        });
                    
                    return parseFloat(elem[0].value.replace(/\./g, '').replace(',', '.')) || 0;
                });
            }
        };
    }

})();

(function() {
    'use strict';

angular
    .module('rapi.w3')

    .directive('w3Autolinker', autoLinkerDiretive)
    .filter('w3Autolinker', autoLinkerFilter);

    autoLinkerDiretive.$inject = ['$timeout'];

    function autoLinkerDiretive($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                $timeout(function() {
                    var eleHtml = element.html();

                    if (eleHtml === '') {
                        return false;
                    }

                    var text = Autolinker.link(eleHtml, {
                        className: 'autolinker',
                        newWindow: false
                    });

                    text = text.replace(/\n\r?/g, '<br />');

                    element.html(text);

                    var autolinks = element[0].getElementsByClassName('autolinker');

                    for (var i = 0; i < autolinks.length; i++) {
                        angular.element(autolinks[i]).bind('click', function(e) {
                            var href = e.target.href;

                            if (href) {
                                //window.open(href, '_system');
                                window.open(href, '_blank');
                            }

                            e.preventDefault();
                            return false;
                        });
                    }
                }, 0);
            }
        }
    }

    function autoLinkerFilter() {

        return function(input) {

            input = input || '';

            if (input === '') return false;

            var text = Autolinker.link(input, {
                className: 'autolinker',
                newWindow: false
            });

            text = text.replace(/\n\r?/g, '<br />');

            return text;

            //var autolinks = element[0].getElementsByClassName('autolinker');
            //
            //for (var i = 0; i < autolinks.length; i++) {
            //    angular.element(autolinks[i]).bind('click', function(e) {
            //        var href = e.target.href;
            //        console.log('autolinkClick, href: ' + href);
            //
            //        if (href) {
            //            //window.open(href, '_system');
            //            window.open(href, '_blank');
            //        }
            //
            //        e.preventDefault();
            //        return false;
            //    });
            //}
        }
    }

})();

(function ()
{
    'use strict';

    angular
            .module('rapi.w3')
            .directive('w3PageTable', w3PageTableDirective)
            .directive('w3OrderTable', w3OrderTableDirective);


    /** @ngInject */
    function w3PageTableDirective()
    {
        return {
            restrict: 'E',
            scope: {
                pagination: '=w3Pagination',
                setPage: '&w3SetPage'
            },
            template: [
                '{{pagination|w3Paginate}}',
                '<md-button ng-click="prevpage()" ng-disabled="page <= 1">',
                '   <md-icon md-font-icon="icon-chevron-left" class="icon s26"></md-icon>',
                '    {{\'RAPI.PAGINATE_PREV\'|translate}}',
                '</md-button>',
                '<md-button ng-click="nextpage()" ng-disabled="page >= pagination.last_page">',
                '   <span translate="RAPI.PAGINATE_NEXT"> Próximo </span>',
                '    <md-icon md-font-icon="icon-chevron-right" class="icon s26"></md-icon>',
                '</md-button>'].join(''),
            link: function (scope)
            {
                scope.nextpage = nextpage;
                scope.prevpage = prevpage;
                scope.page     = scope.pagination.current_page || 1;

                function setPage(p) {
                    console.log('set page', scope.pagination)

                    if (p < 1 || p > scope.pagination.last_page)
                        return;

                    scope.$evalAsync(function ()
                    {
                        scope.page = p;
                        scope.setPage({'$page':p});
                    });
                }

                function prevpage() {
                    setPage(scope.pagination.current_page - 1);
                }

                function nextpage() {
                    setPage(scope.pagination.current_page + 1);
                }
            }
        };
    }

    /** @ngInject */
    function w3OrderTableDirective()
    {
        return {
            restrict: 'A',
            scope: {
                params: '=w3OrderTable',
                onChange: '&w3Change'
            },
            link: function (scope, iElement)
            {

                activate();

                function getOrder()
                {
                    var sort = [];

                    iElement.find('thead>tr>th').each(function (k, el) {
                        var $el = angular.element(el),
                                key = $el.data('order');

                        if ($el.hasClass('sorting_desc')) {
                            sort.push("-" + key);
                        } else if ($el.hasClass('sorting_asc')) {
                            sort.push(key);
                        }


                    });

                    return sort.join(',');
                }

                /**
                 * Toggle Order
                 */
                function toggleOrder()
                {
                    var $el = $(this);

                    if ($el.hasClass('sorting_desc')) {
                        $el.removeClass('sorting_desc');
                    } else if ($el.hasClass('sorting_asc')) {
                        $el.removeClass('sorting_asc');
                        $el.addClass('sorting_desc');
                    } else {
                        $el.addClass('sorting_asc');
                        $el.removeClass('sorting_desc');
                    }

                    scope.$evalAsync(function ()
                    {
                        scope.params.sort = getOrder();
                        scope.onChange();
                    });

                }

                function activate()
                {
                    var sort = scope.params.sort.split(',') || [];

                    iElement.find('thead>tr>th').each(function (k, el) {
                        var $el = angular.element(el),
                                key = $el.data('order');

                        if ($el.data('order')) {
                            $el.addClass('sorting');
                            $el.on('click', toggleOrder);
                        }

                        if (sort.indexOf(key) >= 0) {
                            $el.addClass('sorting_asc');
                        } else if (sort.indexOf("-" + key) >= 0) {
                            $el.addClass('sorting_desc');
                        }
                    });
                }

            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: '/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function () {
  'use strict';

  angular
    .module('commons.minha_conta', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('xsession.minha-conta', {
        url: '/minha-conta',
        views: {
          'content@app': {
            templateUrl: '/app/external/minha-conta/minha-conta.html',
            controller: 'MinhaContaController as vm'
          }
        }
      })
      .state('xsession.conta_detail', {
        url: '/minha-conta/detalhes/:id',
        views: {
          'content@app': {
            templateUrl: '/app/external/minha-conta/conta-detail/conta-detail.html',
            controller: 'ContaDetailController as vm'
          }
        }
      });

    // msNavigationServiceProvider.saveItem('conta', {
    //   title: 'Minha conta',
    //   icon: 'icon-percent',
    //   state: 'xsession.minha-conta',
    //   weight: 30
    // });

  }
})();

(function () {
    'use strict';

    angular
        .module('commons.minha_conta')
        .controller('ContaDetailController', ContaDetailController);

    /** @ngInject */
    function ContaDetailController($stateParams, ContaBancaria, $mdDialog) {
        var vm = this;
        var defaultParams = {
            total: 1,
            include: 'deposito',
            take: -1
        };

        vm.conta = {};
        vm.extrato = [];
        vm.cupomState = 'no-bank';
        vm.cupomCode = '';
        vm.cupom = {};
        vm.params = {};
        vm.extratoTotals = {};

        //methods
        vm.showEditConta = showEditConta;
        vm.resgatarCupom = resgatarCupom;
        vm.clearCupom = clearCupom;
        vm.clearSearchExtrato = clearSearchExtrato;
        vm.searchExtrato = searchExtrato;

        activate();

        //------------------
        function activate() {
            vm.params = angular.copy(defaultParams);
            loadConta();

        }

        function loadConta() {
            ContaBancaria.findWithDetail($stateParams.id, {})
                .then(function (result) {
                    vm.conta = result;
                    checkConfs();
                    searchExtrato();
                })
        }


        function checkConfs() {
            var confirm = $mdDialog.confirm()
                .title('Configurar conta')
                .textContent('Nós percebemos que você ainda não configurou sua conta, deseja configurar agora?')
                .ariaLabel('Configurar conta')
                .ok('Configurar agora')
                .cancel('Deixar para depois');

            if (vm.conta.tipo !== 'PENDENTE') {
                vm.cupomState = 'init';
            } else {
                vm.cupomState = 'no-bank';

                $mdDialog.show(confirm).then(function () {
                    showEditConta(null)
                });
            }

        }


        function showEditConta(ev) {
            ContaBancaria.dialog.edit(vm.conta, [], ev)
                .then(function (result) {
                    if (!result) return;

                    loadConta();
                })
        }

        function searchExtrato() {
            formatFilterData();
            ContaBancaria.getDebitos(vm.conta.id, vm.params).then(function (result) {
                vm.extrato = result.data;
                vm.extratoTotals = result.total;
            })
        }

        function formatData(date) {
            var month = date.getUTCMonth() + 1; //months from 1-12
            var day = date.getUTCDate();
            var year = date.getUTCFullYear();

            if (month < 10) {
                month = '0' + month;
            }

            if (day < 10) {
                day = '0' + day;
            }

            return year + "-" + month + "-" + day;
        }

        function formatFilterData() {
            if (vm.params.dt_column != null) {
                if (vm.params.dt_obj_start != null) {
                    vm.params.dt_start = formatData(vm.params.dt_obj_start);
                }

                if (vm.params.dt_obj_end != null) {
                    vm.params.dt_end = formatData(vm.params.dt_obj_end);
                }
            }
        }

        function clearSearchExtrato() {
            vm.params = angular.copy(defaultParams);
            searchExtrato();
        }

        function resgatarCupom() {
            ContaBancaria.resgatarCupom(vm.cupomCode, vm.conta.id).then(function (result) {
                vm.cupom = result;
                vm.cupomState = 'success';
            })
        }

        function clearCupom() {
            vm.cupomState = 'init';
            vm.cupomCode = '';
            vm.cupom = {};
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('rapi.fuse.xsession', [])
        .config(config)
        .run(run);

    /** @ngInject */
    function config($httpProvider, $urlRouterProvider, $stateProvider, xSessionProvider) {
        $urlRouterProvider.otherwise('/session/home');
        $httpProvider.interceptors.push('XSessionInterceptor');

        //////X SESSION
        $stateProvider.state('xsession', {
            url: '/x/{XID}',
            abstract: true,
            parent: 'app',
            requiredXSession: true,
            params: {
                XID: {
                    value: xSessionProvider.getDefaultID()
                }
            },
            views: {
                'toolbar@app': {
                    templateUrl: '/app/external/fuse/xsession/toolbar.html',
                    controller: 'ToolbarController as vm'
                }
            }
        });

        // State
        $stateProvider
            .state('app.xsession', {
                url: '/session',
                ignoreAuthAccessModule: true,
                views: {
                    'content@app': {
                        templateUrl: '/app/external/fuse/xsession/list-sessions.html',
                        controller: 'XSessionController as vm'
                    }
                }
            })
            .state('app.xsession_home', {
                url: '/session/home',
                ignoreAuthAccessModule: true,
                views: {
                    'content@app': {
                        controller: 'XSessionHomeController as vm'
                    }
                }
            });

    }

    /** @ngInject */
    function run($rootScope, $log, $state, xSession) {

        $rootScope.$on('XSession:undefined', function () {
            $state.go('app.xsession');
        });

        //xSession.setDefaultID()

        $rootScope.$on('$stateChangeStart',
            function (event, toState, toParams, fromState, fromParams) {

                if ((toState.checkSessionRequest || toState.name.indexOf('xsession') === 0) && xSession.guest()) {
                    $rootScope.loadingProgress = false;

                    if (toParams.XID > 0) {
                        xSession.setModel({id: toParams.XID, name: ''});
                        return;
                    }

                    event.preventDefault();
                    $log.warn('$checkSessionRequest->', toState.name);
                    $state.go('app.xsession');
                }

            });
    }

})();

(function() {
    'use strict';

    angular
        .module('rapi.fuse.xsession')
        .factory('XSessionInterceptor', xSessionInterceptor);


    /** @ngInject */
    function xSessionInterceptor(xSession) {

        var urlPrefix = 'api/v1';

        var service = {
            request: customRequest
        };

        return service;
        //------------------------------

        /**
         * Custom HTTP on Request do something on success
         */
        function customRequest(request)
        {
            //Caso a URL não seja de api nem add UNIDADE ID
            if (request.url.indexOf(urlPrefix) < 0) {
                //console.log('XSessionInterceptor:ignoreURL:', request.url);
                return request;
            }

            var key = xSession.getConfig('keyHeader');
            var prependHeaders = xSession.getConfig('prependHeaders');

            request.headers = request.headers || {};
            request.headers[key] = xSession.ID();

            if(angular.isObject(prependHeaders)){
              request.headers = angular.extend(request.headers, prependHeaders);
            }

            console.log('XSessionInterceptor:request', 'HEADER-KEY:' + key + '->', request.headers[key], request.url);

            return request;
        }

    }

})();

(function () {
    'use strict';

    angular
            .module('rapi.fuse.xsession')
            .provider('xSession', xSessionProvider);


    /** @ngInject */
    function xSessionProvider() {

        var self = this;
        var HAS_SESSION = false;

        var CONFIG = {
            home: 'app.xsession',
            keyHeader: 'X-SESSION',
            nameToolbar: 'App',
            keyStorange: 'session',
            labels: {
                title: 'Olá,',
                content: 'Nós percebemos que você têm acesso a mais de uma unidade, com qual delas deseja trabalhar agora?',
                title_empty_state : 'Você não tem acesso a nenhuma loja e/ou unidade.',
                content_empty_state: 'Entre em contato com o seu gerente para solicitar a permissão de acesso.'
            },
            queryModel: null,
            //Mescla os objeto com o request.header Ex: {'FOO':'bar'}
            prependHeaders : null
        };

        this.setDefaultID = function (ID)
        {
            window.sessionStorage.setItem(CONFIG['keyStorangeID'], ID);
        };

        this.getDefaultID = function ()
        {
            return window.sessionStorage.getItem(CONFIG['keyStorangeID']);
        };

        this.configure = function (config)
        {
            CONFIG = angular.extend(CONFIG, config);
            CONFIG['keyStorange'] = CONFIG['keyHeader'].replace('-', '_').toLowerCase();
            CONFIG['keyStorangeID'] = CONFIG['keyStorange'] + '_id';
//            console.log(CONFIG);
        };

        this.setQueryModel = function (query)
        {
            CONFIG['queryModel'] = query;
        };

        this.$get = XSession;

        /** @ngInject */
        function XSession($injector, $log, $rootScope, w3Session) {

            var service = {
                setDefaultID: self.setDefaultID,
                ID: getID,
                getModel: getModel,
                setModel: setModel,
                unsetModel: unsetModel,
                guest: guest,
                check: check,
                stateHome: getNameStateHome,
                searchModel: searchModel,
                labels: labels,
                getConfig: getConfig,
                setConfig: setConfig,
                mergeConfig: mergeConfig
            };

            activate();
            return service;

            //------------------------------
            function activate()
            {
                HAS_SESSION = (getID()) ? true : false;
                updateRootScope();
            }

            function updateRootScope()
            {
                $rootScope.currentXSession = getModel();
                $rootScope.nameToolbar = getConfig('nameToolbar');
            }

            function getConfig(key)
            {
                return (key) ? CONFIG[key] : CONFIG;
            }
            
            function setConfig(key, value)
            {
                return CONFIG[key] = value;
            }
            
            function mergeConfig(key, value)
            {
                var oldValue = getConfig(key) || {};
                var v2 = angular.extend(oldValue, value);
                setConfig(key, v2);
            }

            function getNameStateHome()
            {
                return CONFIG['home'];
            }

            function check()
            {
                return (HAS_SESSION === true);
            }

            function guest()
            {
                return !check();
            }

            function getID()
            {
                var model = getModel();
                return (model) ? model.id : null;
            }

            function getModel()
            {
                var model = w3Session.get(CONFIG['keyStorange']);

                if (!model) {
                    $log.error('XSession:getModel -> Undefined X-SESSION');
                    $rootScope.$broadcast('XSession:undefined');
                    return false;
                }

                return model;
            }

            function unsetModel()
            {
                var model = {id: 0, name: 'Não informado'};
                setModel(model);
            }

            function setModel(model)
            {
                var _model = {
                    id: model.id,
                    name: model.name
                };

//                console.log('XSession:setModel -> ', _model);

                w3Session.set(CONFIG['keyStorange'], _model);
                self.setDefaultID(_model.id);
                onChangeModel(_model);
            }

            function onChangeModel(model)
            {
                activate();
                $rootScope.$broadcast('XSession:changed', model);
            }

            function searchModel()
            {
                if (CONFIG['queryModel']) {
                    return  $injector.invoke(CONFIG['queryModel']);
                } else {
                    console.error('xSession: queryModel não definido');
                }
            }

            function labels()
            {
                return CONFIG['labels'];
            }

        }


    }

})();

(function () {
    'use strict';

    angular
            .module('rapi.fuse.xsession')
            .controller('XSessionHomeController', xSessionHomeController)
            .controller('XSessionController', xSessionController);

    /** @ngInject */
    function xSessionHomeController($state, xSession) {

        var name = xSession.stateHome();

        $state.go(name);

    }

    /** @ngInject */
    function xSessionController($state, xSession, toastr) {

        var vm = this;

        // Data
        vm.archive = [];
        vm.searchTerm = '';
        vm.labels = xSession.labels();
        vm.pageLoaded = false;

        // Methods
        vm.selectModel = selectModel;
        vm.searchFilter = searchFilter;

        activate();

        //-----------------------

        function activate()
        {
            xSession.unsetModel();
            loadModels();
        }

        function selectModel(model)
        {
            xSession.setModel(model);
            $state.go(xSession.stateHome(), {'XID': xSession.ID()});
        }

        function loadModels()
        {
            xSession.searchModel().then(function (result) {
                if (result.length === 1) {
                    selectModel(result[0]);
                } else {
                  vm.archive = result;
                  vm.pageLoaded = true;
                  if (result.length){
                    toastr.info('Favor selecionar uma sessão para continuar!');
                  } else {
                    toastr.error('Você não possui acesso a nenhuma unidade!');
                  }
                }
            });
        }

        function searchFilter(model) {
            if (!vm.searchTerm) {
                return true;
            };

            var term = vm.searchTerm.toLowerCase();
            return (model.name && model.name.toLowerCase().includes(term)) ||
                (model.description && model.description.toLowerCase().includes(term));
        };

    }



})();

(function () {
    'use strict';

    angular
            .module('rapi.fuse.user')
            .factory('RfUser', UserService);


    /** @ngInject */
    function UserService(w3Resource, w3Presenter, w3Date, $http, w3Utils) {

        var urlApi = '/rapi/guardian/users';
        var presenter = w3Presenter.make(responsePresenter, requestPresenter);

        var service = {
            querySearch: querySearch,
            disable: disable,
            restore: restore,
            getShared: getShared,
            removeShared: removeShared,
            saveShared: saveShared,
            find: find
        };

        return w3Resource.extend(urlApi, service, presenter);

        //----------------------------------

        function requestPresenter(data)
        {

            if (data.birthday) {
                data.birthday = w3Date.dateToEn(data.birthday);
            }


            return data;
        }

        function responsePresenter(data)
        {
            if (data.birthday) {
                data.birthday = w3Date.enToObj(data.birthday);
            }
            
            
            return data;
        }

        function find(id, params)
        {
            var data = {
                params: params
            };

            return $http.get(w3Utils.urlApi(urlApi + '/{id}', {id: id}), data).then(function (result) {
                return result.data.data;
            });
        }


        function disable(id)
        {
            return $http.put(w3Utils.urlApi(urlApi + '/{id}/disable', id)).then(function (result) {
                return (result.data.status === 'success') ? result.data.data : false;
            });
        }

        function restore(id)
        {
            return $http.put(w3Utils.urlApi(urlApi + '/{id}/restore', id)).then(function (result) {
                return (result.data.status === 'success') ? result.data.data : false;
            });
        }

        function getShared(data)
        {
            return $http.get(w3Utils.urlApi('/rapi/guardian/shared'), data).then(function (result) {
                return result.data.data;
            });
        }

        function saveShared(data)
        {
            return $http.post(w3Utils.urlApi('/rapi/guardian/shared'), data).then(function (result) {
                return result.data.data;
            });
        }

        function removeShared(id)
        {
            return $http.delete(w3Utils.urlApi('/rapi/guardian/shared/{id}', {id: id})).then(function (result) {
                return result.data.data;
            });
        }

        function querySearch(query)
        {
            var params = {
                q: query,
                take: 10
            };

            return this.search(params);
        }

    }

})();

(function () {
    'use strict';

    angular
            .module('rapi.fuse.user')
            .controller('UserController', UserController)
            .controller('UserFormController', UserFormController)
            .controller('UserShowController', UserShowController);

    /** @ngInject */
    function UserController(RfUser, w3Utils, $translate, $mdDialog) {
        var vm = this;

        // Data
        vm.archive = [];

        vm.pagination = {};
        vm.params = {};
        var defaultParams = {
            'paginate': 10,
            'sort': 'email', //EX: nome,-created_at
            'q': null,
            'include': 'city',
            'onlyTrashed': null,
            'withTrashed': null
        };

        // Methods
        vm.confirmDelete = confirmDelete;
        vm.search = search;
        vm.setPage = setPage;
        vm.getAllItens = getAllItens;
        vm.getTrasehdItens = getTrasehdItens;
        vm.getOnlyActiveItens = getOnlyActiveItens;
        vm.disableConfirm = disableConfirm;
        vm.restoreConfirm = restoreConfirm;
        vm.clearFilter = clearFilter;

        activate();

        //-----------------------

        function activate()
        {

            vm.params = angular.copy(defaultParams);
            search();
        }

        function setPage(p)
        {
            RfUser.setPage(p);
            activate();
        }

        function search()
        {
            if (vm.params.q) {
                vm.params.withTrashed = 1;
            }

            RfUser.search(vm.params).then(function (result) {

                vm.archive = result;
                vm.pagination = RfUser.pagination;
            });
        }

        function clearFilter()
        {
            vm.searchActive = false;

            vm.params = angular.copy(defaultParams);
            search();
        }

        function confirmDelete(item, $index, $event)
        {
            w3Utils.confirmDelete($translate.instant('USER.TITLE_CONFIRM_DELETE'), $translate.instant('USER.MSG_CONFIRM_DELETE') + item.name + '?', $event)
                    .then(function () {
                        RfUser.remove(item.id).then(function () {
                            vm.archive.splice($index, 1);
                        });
                    });
        }

        function getAllItens()
        {
            vm.params.onlyTrashed = null;
            vm.params.withTrashed = 1;
            search();
        }

        function getTrasehdItens()
        {
            vm.params.onlyTrashed = 1;
            vm.params.withTrashed = null;
            search();
        }

        function getOnlyActiveItens()
        {
            vm.params.onlyTrashed = null;
            vm.params.withTrashed = null;
            search();
        }

        function disableConfirm(ev, row)
        {
            var confirm = $mdDialog.confirm(ev)
                    .title($translate.instant('USER.DESATIVAR_USER'))
                    .textContent($translate.instant('USER.DESATIVAR_USER_MSG') + ' ' + row.name + '?')
                    .ariaLabel('Desativar User')
                    .targetEvent(ev)
                    .ok($translate.instant('USER.DESATIVAR'))
                    .cancel($translate.instant('USER.CANCELAR'));

            $mdDialog.show(confirm).then(function () {
                RfUser.disable(row.id).then(function (result) {
                    angular.extend(row, result);
                });
            });
        }

        function restoreConfirm(ev, row) {
            var confirm = $mdDialog.confirm(ev)
                    .title($translate.instant('USER.RESTAURAR_USER'))
                    .textContent($translate.instant('USER.RESTAURAR_USER_MSG') + ' ' + row.name + '?')
                    .ariaLabel('Restaurar User')
                    .targetEvent(ev)
                    .ok($translate.instant('USER.RESTAURAR'))
                    .cancel($translate.instant('USER.CANCELAR'));

            $mdDialog.show(confirm).then(function () {
                RfUser.restore(row.id).then(function (result) {
                    angular.extend(row, result);
                });
            });
        }

    }

    /** @ngInject */
    function UserFormController(RfUser,RfAcl, City, w3Utils, Role, w3Date, $translate, $stateParams, $state, $mdDialog) {

        var vm = this;
        var ID;

        //Data
        vm.isNew = false;
        vm.addressSearchByCep = true;
        vm.row = {};
        vm.params = {
            'onlyTrashed': null,
            'withTrashed': 1,
            'include': 'acl,city.state.country'
        };
        vm.disableEmail = false;

        vm.configUpload = {
            url: w3Utils.urlApi('/rapi/fuse/uploads'),
            params: {}
        };

        //Methods
        vm.save = save;
        vm.confirmDelete = confirmDelete;
        vm.goArchive = goArchive;
        vm.disableConfirm = disableConfirm;
        vm.restoreConfirm = restoreConfirm;
        vm.loadCityWithCEP = loadCityWithCEP;


        activate();
        //-------------------

        function loadCityWithCEP() {
          City.searchCEP(vm.row.postcode).then(function (result) {
              if (result.city) {
                  vm.row.city = result.city;
                  vm.row.city_id = result.city.id;
                  vm.row.district = result.bairro;
                  vm.row.street = result.logradouro;
              }
          });
        }

        function checDisableEmailInput(){
            if(RfAcl.hasPerms('guardian.user.create') || vm.isNew){
                vm.disableEmail = false;
            }else{
                vm.disableEmail = true;
            }
        }

        function activate()
        {
            if ($stateParams.id) {
                loadResource($stateParams.id);
            } else {
                vm.isNew = true;
                loadAllDependencies(false);
            }

            checDisableEmailInput()
        }

        function loadResource(id)
        {
            RfUser.find(id, vm.params).then(function (result) {
                vm.row = result;
                if (vm.row.birthday != null) {
                    vm.row.birthday = w3Date.enToObj(vm.row.birthday);
                }
                enableEdit(result.id);
                loadAllDependencies(true);
            });
        }

        function loadAllDependencies(check) {
            Role.all().then(function (result) {
                vm.roles = result;
                if (check) {
                    checkItens(vm.roles, vm.row.acl.roles);
                }
            });
        }

        function enableEdit(id) {
            vm.isNew = false;
            ID = id;
        }

        function getIdsChecked(data)
        {
            var ids = [];

            angular.forEach(data, function (item) {
                if (item.checked)
                    this.push(item.id);
            }, ids);

            return ids;
        }

        function getIds(data)
        {
            var ids = [];

            angular.forEach(data, function (item) {
                this.push(item.id);
            }, ids);

            return ids;
        }

        function checkItens(list, data)
        {
            var ids = getIds(data);

            angular.forEach(list, function (item) {
                item.checked = (ids.indexOf(item.id) !== -1);
            });
        }

        function save()
        {
            vm.row.roles = getIdsChecked(vm.roles);
            vm.row.include = vm.params.include;

            if (vm.isNew) {
                create();
            } else {
                update();
            }
        }

        function create()
        {
            RfUser.save(vm.row).then(function (result) {
                $state.go('app.user.edit', {id: result.id});
            });
        }

        function update()
        {
            RfUser.update(ID, vm.row).then(function (result) {
                if (result) {
                    angular.extend(vm.row, result);
                }
            });
        }


        function confirmDelete($event)
        {
            w3Utils.confirmDelete($translate.instant('USER.TITLE_CONFIRM_DELETE'), $translate.instant('USER.MSG_CONFIRM_DELETE') + vm.row.name + '?', $event)
                    .then(function () {

                        RfUser.remove(ID).then(goArchive);
                    });
        }

        function goArchive()
        {
            $state.go('app.user');
        }
        function disableConfirm(ev) {

            var confirm = $mdDialog.confirm(ev)
                    .title($translate.instant('USER.DESATIVAR_USER'))
                    .textContent($translate.instant('USER.DESATIVAR_USER_MSG') + ' ' + vm.row.name + '?')
                    .ariaLabel('Desativar User')
                    .targetEvent(ev)
                    .ok($translate.instant('USER.DESATIVAR'))
                    .cancel($translate.instant('USER.CANCELAR'));

            $mdDialog.show(confirm).then(function () {
                RfUser.disable(vm.row.id).then(function () {
                    loadResource($stateParams.id);
                });
            });

        }

        function restoreConfirm(ev) {
            var confirm = $mdDialog.confirm(ev)
                    .title($translate.instant('USER.RESTAURAR_USER'))
                    .textContent($translate.instant('USER.RESTAURAR_USER_MSG') + ' ' + vm.row.name + '?')
                    .ariaLabel('Restaurar User')
                    .targetEvent(ev)
                    .ok($translate.instant('USER.RESTAURAR'))
                    .cancel($translate.instant('USER.CANCELAR'));

            $mdDialog.show(confirm).then(function () {
                RfUser.restore(vm.row.id).then(function () {
                    loadResource($stateParams.id);
                });
            });
        }
    }

    /** @ngInject */
    function UserShowController(RfUser, $stateParams, $state) {

        var vm = this;

        //Data
        vm.row = {};
        vm.AclPermissionsGroup = [];
        vm.params = {
            'onlyTrashed': null,
            'withTrashed': 1,
            'include': 'acl'
        };


        //Methods
        vm.goArchive = goArchive;

        activate();
        //-------------------

        function activate()
        {
            if ($stateParams.id) {
                loadResource($stateParams.id);
            }
        }

        function loadResource(id)
        {
            RfUser.find(id, vm.params).then(function (result) {
                vm.row = result;
                groupPermissions(vm.row.acl.permissions);
            });
        }

        function goArchive()
        {
            $state.go('app.user');
        }

        function groupPermissions(permissions) {
            var groups = [];

            angular.forEach(permissions, function (permission) {
                if (groups.indexOf(permission.group) == -1) {
                    this.push(permission.group);
                    vm.AclPermissionsGroup.push({
                        'group': permission.group
                    });
                }
            }, groups);
        }

    }


})();

(function () {
    'use strict';

    angular
            .module('rapi.fuse.user')
            .directive('rfUserList', UserList)
            .controller('rfUserListController', rfUserListController);

    /**
     * USAGE:
     * <rf-user-list table-id="" table-type="" permissions=""></rf-user-list>
     * table-id = id merchant
     * table-type = BraPay\\Merchant\\Merchant
     * @constructor
     */
    function UserList() {
        return {
            restrict: 'E',
            scope: {
                permissions: "=permissions",
                table_id: "=tableId",
                table_type: "=tableType",
                url_callback: "=urlCallback"
            },
            controller: 'rfUserListController as vm',
            templateUrl: '/app/external/fuse/user/rf-user-list.tmpl.html'
        };
    }

    /** @ngInject */
    function rfUserListController(RfUser, $mdDialog, $scope) {

        var vm = this;

        // Data
        vm.users = [];
        vm.row = {};

        // Methods
        vm.removeShared = removeShared;
        vm.openNewUser = openNewUser;
        vm.deleteUser = deleteUser;

        activate();

        /////////////////////////////////////////////
        $scope.$watch('[table_id,table_type]', loadUsers);

        function activate()
        {
            loadUsers();
        }

        function loadUsers() {            

            if (!$scope.table_id || ! $scope.table_type)
                return;

            var data = {
                params: {
                    'include': 'user',
                    'sort': 'user_id',
                    'table_id': $scope.table_id,
                    'table_type': $scope.table_type
                }
            };

            RfUser.getShared(data).then(function (result) {
                vm.users = result;
            });
        }


        function removeShared(row, ind, ev)
        {
            var confirm = $mdDialog.confirm(ev)
                    .title('Revogar acesso')
                    .textContent('Deseja realmente revogar o acesso do usuário ' + row.user.name + ' ?. Ao fazer isso este usuário não poderá mais acessar o sistema.')
                    .ariaLabel('Revogar acesso')
                    .targetEvent(ev)
                    .ok('Revogar acesso')
                    .cancel('Cancelar');

            $mdDialog.show(confirm).then(function () {
                RfUser.removeShared(row.id).then(function (result) {
                    vm.users.splice(ind, 1);
                });
            });
        }


        function deleteUser(row, ind, ev)
        {
            var confirm = $mdDialog.confirm(ev)
                    .title('Excluir usuário')
                    .textContent('Deseja realmente excluir o usuário ' + row.user.name + ' ?. Ao fazer isso este usuário não poderá mais acessar o sistema.')
                    .ariaLabel('Excluir usuário')
                    .targetEvent(ev)
                    .ok('Excluir usuário')
                    .cancel('Cancelar');

            $mdDialog.show(confirm).then(function () {
                RfUser.remove(row.id).then(function (result) {
                    vm.users.splice(ind, 1);
                });
            });
        }

        function openNewUser(ev)
        {

            return $mdDialog.show({
                controller: 'NewUserDialogController',
                controllerAs: 'vm',
                templateUrl: '/app/external/fuse/user/dialogs/new-user.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    'row': vm.row,
                    'permisisons': $scope.permissions,
                    'table_id': $scope.table_id,
                    'table_type': $scope.table_type,
                    'url_callback': $scope.url_callback,
                }

            }).then(function (result) {
                if (result) {
                    vm.users.push(result);
                }
            });
        }
    }

})();

(function () {
    'use strict';

    angular
            .module('rapi.fuse.report')
            .factory('RfReport', ReportService)
            .factory('Report', ReportService);//mytodo deprected remove


    /** @ngInject */
    function ReportService(w3Config, w3Auth, w3Date) {

        var service = {
            newQuery: newQueryBuilder
        };

        return service;
        //==============================
        function newQueryBuilder() {
            return new Report(w3Date, w3Config.getConfigHost().baseUrl, w3Auth);
        }
    }

    function Report(w3Date, baseUrl, w3Auth)
    {
        this.w3Date = w3Date;
        this.baseUrl = baseUrl;
        this.token = null;
        this.requiredCols = ['report'];
        this.onCols = [];
        this.onMultiplesValue = [];
        this.$invalid = true;

        this.params = {
            'format': 'html', //html/pdf/csv/xls
            'ouput': 'view', //view/download/email/print
            'report': null
        };

        this.autoToken = function()
        {
            var self = this;
            return w3Auth.token().then(function(tk){
                self.token = tk;
            });
        };

    }

    Report.prototype.validate = function () {
        var self = this;
        var invalid = false;

        this.requiredCols.map(function (req) {
            if (!self.check(req)) {
                invalid = true;
            }
        });

        this.$invalid = invalid;
        return invalid;
    };

    Report.prototype.setOnMultiplesValues = function (cols)
    {
        this.onMultiplesValue = cols;
        return this;
    };

    Report.prototype.isMulti = function (cols)
    {
        if (this.onMultiplesValue.indexOf(cols) === -1) {
            return 1;
        }
    };

    Report.prototype.setOnColumns = function (cols)
    {
        this.onCols = cols;
        this.validate();
        return this;
    };

    Report.prototype.setRequiredColumns = function (cols)
    {
        this.requiredCols = cols;
        this.requiredCols.push('report');
        this.validate();
        return this;
    };

    Report.prototype.off = function (col)
    {
        return !this.on(col);
    };

    Report.prototype.on = function (col)
    {
        return (this.onCols.indexOf(col) !== -1);
    };

    Report.prototype.check = function (key)
    {
        return (this.params[key]) ? true : false;
    };

    Report.prototype.required = function (col)
    {
        return (this.requiredCols.indexOf(col) !== -1);
    };

    Report.prototype.setReport = function (repo)
    {
        this.setParam('report', repo);
        return this;
    };

    Report.prototype.setFormat = function (format)
    {
        this.setParam('format', format);
        return this;
    };

    Report.prototype.setOutput = function (out)
    {
        this.setParam('ouput', out);
        return this;
    };

    Report.prototype.setDate = function (key, date)
    {
        this.setParam(key, this.w3Date.toFormatEn(date));
        return this;
    };

    Report.prototype.setParam = function (key, value)
    {
        this.params[key] = value;
        this.validate();
        return this;
    };

    Report.prototype.setParams = function (params)
    {
        delete params['page'];
        delete params['take'];
        delete params['paginate'];
        
        this.params = angular.extend(this.params, params);
        console.log('RfReport:setParams', this.params);
        return this;
    };

    Report.prototype.setBetweenDate = function ($dtParams)
    {
        this.setParam('dt_column', $dtParams.dt_column);
        this.setDate('dt_start', $dtParams.dt_start);
        this.setDate('dt_end', $dtParams.dt_end);
        return this;
    };

    Report.prototype.pluck = function (key, colection)
    {
        var selecteds;
        if (!angular.isArray(colection))
            return null;

        selecteds = colection.map(function (row) {
            return row.id;
        }).join("|");

        this.setParam(key, selecteds);
    };

    /**
     * use para arrays simples formados por strings ou números ex: ['pendente']
     * @param {type} key
     * @param {type} colection
     * @returns {unresolved}
     */
    Report.prototype.simplPluck = function (key, colection)
    {
        var selecteds;
        if (!angular.isArray(colection))
            return null;

        selecteds = colection.map(function (row) {
            return row;
        }).join("|");

        this.setParam(key, selecteds);
    };

    Report.prototype.url = function ()
    {
        var params = this.params;
        params.token = this.token;
        var q = $.param(params);

        var url = this.baseUrl + "/rapi/report/render";
        return url + "?" + q;
    };

    Report.prototype.open = function ()
    {
        //console.log('OPEN', this.params, this.url());
        var self = this;

        this.autoToken().then(function(){
            window.open(self.url());
        });
        //window.open(url, "relatoriossifra", "height=800,width=1000");
    };

    Report.prototype.sendReport = function (format, output)
    {
        output = output || 'view';
        this.setFormat(format);
        this.setOutput(output);
        this.open();
    };

    Report.prototype.transformChip = function (chip)
    {
        if (angular.isObject(chip)) {
            return chip;
        }
        return {
            name: chip
        };
    };


})();

(function () {
  'use strict';

  angular
      .module('rapi.fuse.profile', ['ngFileUpload']);

})();

(function () {
  'use strict';

  angular
      .module('rapi.fuse.profile')
      .factory('RfMe', RfMeFactory);

  /** @ngInject */
  function RfMeFactory($http, w3Utils) {
    var urlApi = '/rapi/guardian/me';

    var service = {
      show: show,
      update: update
    };

    return service;

    function show(include) {
      var url = w3Utils.urlApi(urlApi);
      var data = {
        params: {
          include: include
        }
      };

      return $http.get(url, data).then(onLoadSuccess);

      function onLoadSuccess(result) {
        return result.data.data;
      }
    }

    function update(data) {
      // var id = {
      //   id: data.id
      // };
      var config = {
        w3Reload: 'w3Resource.update'
      };
      var url = w3Utils.urlApi(urlApi);
      var dataCopied = angular.copy(data);

      return $http.put(url, dataCopied, config).then(onUodateSuccess);

      function onUodateSuccess(result) {
        if (result.data.status === 'success') {
          return result.data.data;
        }
      }
    }
  }

})();

(function () {
  'use strict';

  angular
      .module('rapi.fuse.profile')
      .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider
        .state('app.profile', {
          url: '/perfil',
          views: {
            'content@app': {
              templateUrl: '/app/external/fuse/profile/profile-show.html',
              controller: 'ProfileShowController as vm'
            }
          }
        })
        .state('app.profile.update', {
          url: '/editar',
          views: {
            'content@app': {
              templateUrl: '/app/external/fuse/profile/profile-form.html',
              controller: 'ProfileFormController as vm'
            }
          }
        });


    msNavigationServiceProvider.saveItem('profile', {
      title: 'PROFILE.MENU',
      icon: 'icon-account',
      state: 'app.profile',
      weight: 90
    });

  }
})();

(function () {
  'use strict';

  angular
      .module('rapi.fuse.profile')
      .controller('ProfileShowController', ProfileShowController);

  /** @ngInject */
  function ProfileShowController(RfMe) {
    var vm = this;

    /* Data */
    vm.profile = {};
    vm.today = null;
    vm.isBirthday = false;


    /* Public functions */

    activate();

    function activate() {

      loadProfile();
    }

    function loadProfile() {
      var includes = 'roles,city.state.country';

      RfMe.show(includes).then(onLoadSuccess);

      function onLoadSuccess(result) {
        verifyBirthday(result);
        vm.profile = formatData(result);
        console.log(vm.profile)
      }

      function formatData(profile) {
        profile = formatSex(profile);
        profile = formatAddress(profile);
        return profile;
      }
    }

    function formatSex(profile) {
      if (profile.sex === 'male') {
        profile.sexLabel = 'Masculino';
      } else if (profile.sex === 'female') {
        profile.sexLabel = 'Feminino';
      }
      return profile;
    }

    function formatAddress(profile) {
      profile.address_street = '';
      profile.address_city = '';

      if (profile.street) {
        profile.address_street += 'R. ' + profile.street;
        if (profile.number) {
          profile.address_street += ', ' + profile.number;
        }
        if (profile.district) {
          profile.address_street += ' - ' + profile.district;
        }
      }

      if (profile.city) {
        profile.address_city += profile.city.city_name;
        if (profile.city.state) {
          profile.address_city += ' - ' + profile.city.state.state_code;
        }
        if (profile.postcode) {
          profile.address_city += ', ' + profile.postcode.slice(0,5) + '-' + profile.postcode.slice(5);
        }
        if (profile.city.state && profile.city.state.country){
          profile.address_city += ', ' + profile.city.state.country.country_name;
        }
      }


      return profile;
    }


    function verifyBirthday(profile) {
      var timeFormat = 'YYYY-MM-DD';
      var birthday;
      var today;

      if (profile.birthday) {
        today = moment(new Date()).format(timeFormat);
        birthday = moment(new Date(profile.birthday)).format(timeFormat);
        if (today === birthday) {
          vm.isBirthday = true;
        }
      }
    }

  }
})();

(function () {
  'use strict';

  angular
      .module('rapi.fuse.profile')
      .controller('ProfileFormController', ProfileFormController);

  /** @ngInject */
  function ProfileFormController($rootScope,
                                 RfMe,
                                 City,
                                 w3Utils,
                                 w3Config,
                                 w3Local) {
    var vm = this;

    /* Data */
    vm.profile = {};
    vm.uploadConfig = {};
    vm.pageLoaded = false;
    vm.sampleProfile = false;


    /* Public functions */
    vm.onSaveResource = onSaveResource;
    vm.onCepBlur = onCepBlur;


    /* Iniciation and configuration */
    activate();

    function activate() {
      loadProfile();
      setUploadConfiguration();
      vm.sampleProfile = w3Config.get('sample_profile');
    }

    function setUploadConfiguration() {
      vm.uploadConfig = {
        url: w3Utils.urlApi('/rapi/fuse/uploads'),
        params: {
          'gallery': 'profiles'
        }
      };
    }


    /* Action response */
    function onCepBlur() {
      loadCityWithCEP();
    }

    function onSaveResource() {
      updateProfile();
    }


    /* Service calls */
    function loadProfile() {
      var includes = 'city.state.country';

      RfMe.show(includes).then(onLoadSuccess);

      function onLoadSuccess(result) {
        vm.profile = formatData(result);
        vm.pageLoaded = true;
      }

      function formatData(profile) {
        if (profile.birthday) {
          profile.birthdayObject = new Date(profile.birthday);
        }
        return profile;
      }
    }

    function updateProfile() {
      var data = formatData(angular.copy(vm.profile));

      RfMe.update(data).then(onUpdateSuccess);

      function onUpdateSuccess(result) {
        angular.extend(vm.profile, result);
        updateLocalStorage(result);
        $rootScope.$broadcast('profileUpdated', result);
      }

      function formatData(profile) {
        var timeFormat = 'YYYY-MM-DD';

        if (profile.birthdayObject) {
          profile.birthday = moment(profile.birthdayObject).format(timeFormat);
          delete profile.birthdayObject;
        }
        return profile;
      }
    }

    function updateLocalStorage(user) {
      var storedUser = w3Local.get('rapi.auth.profile');
      angular.extend(storedUser, user);
      w3Local.set('rapi.auth.profile', storedUser);
    }


    function loadCityWithCEP() {
      var include = {
        include: 'city.state.country'
      };

      City.searchCEP(vm.profile.postcode, include).then(onSearchSuccess);

      function onSearchSuccess(result) {
        if (result.city) {
          vm.profile.city = result.city;
          vm.profile.city_id = result.city.id;
          vm.profile.district = result.bairro;
          vm.profile.street = result.logradouro;
          vm.profile.number = '';
          vm.profile.complement = '';
        }
      }
    }

  }
})();

(function () {
    'use strict';

    angular
            .module('rapi.fuse.metas', []);

        
})();
/* global _ */

(function () {
    'use strict';

    angular
            .module('rapi.fuse.metas')
            .factory('MetaHelper', MetaHelperFactory)
            .factory('MetaLoadHelper', MetaLoadHelperFactory);


    /** @ngInject */
    function MetaHelperFactory($filter, Meta)
    {
        function Config(ownerType, ownerId, metas)
        {
            metas = metas || [];
            this.ownerType = ownerType;
            this.ownerId = ownerId;
            this.metas = this.transforms(metas);
        }

        Config.prototype.search = function (params)
        {
            return $filter('filter')(this.metas, params) || [];
        };

        Config.prototype.filterByType = function (type)
        {
            return this.search({'$metaType': type});
        };

        Config.prototype.filterByKey = function (key)
        {
            return this.search({'$metaKey': key});
        };

        Config.prototype.transforms = function (values)
        {
            var self = this;

            return _.map(values, function (d) {
                return self.item(d);
            });
        };

        Config.prototype.item = function (meta)
        {
            return new MagicMeta(meta, this);
        };

        Config.prototype.first = function (key)
        {
            var result = this.filterByKey(key);
            return result.length ? result[0] : null;
        };

        /**
         * Igual ao this.fisrt porém se ele nao encontrar
         * ele cria um obj <MagicMeta> temporario
         */
        Config.prototype.fetch = function (key, type, value)
        {
            var result = this.filterByKey(key);

            if (result.length) {
                return result[0];
            }

            //Se ele nao encontrar vai criar um meta sem ID temporario
            return this.new(key, type, value);
        };

        Config.prototype.new = function (key, type, value)
        {
            var meta = {
                meta_key: key,
                meta_value: value || null,
                meta_type: type || key
            };

            return this.item(meta);
        };

        /**
         * Salva uma meta ja transformada em <MagicMeta>
         *
         * @param {MagicMeta} magicMeta
         * @returns {promisse}
         */
        Config.prototype.save = function (magicMeta)
        {
            var promisse;

            if (magicMeta.$metaId) {
                promisse = this.update(magicMeta.$metaId, magicMeta.$toModel());
            } else {
                promisse = this.create(magicMeta.$metaKey, magicMeta.$getValue(), magicMeta.$metaType);
            }

            return promisse;
        };

        Config.prototype.update = function (id, data)
        {
            return Meta.update(id, data);
        };

        Config.prototype.create = function (key, value, type)
        {
            var self = this;

            var obj = {
                'meta_key': key,
                'meta_value': value,
                'meta_type': type || null,
                'owner_type': this.ownerType,
                'owner_id': this.ownerId
            };

            return Meta.save(obj).then(function (result) {
                self.metas.push(self.item(result));
                return result;
            });
        };

        Config.prototype.add = function (key, value, type)
        {
            var self = this;

            return this.create(key, value, type).then(function (result) {
                return self.item(result);
            });
        };

        Config.prototype.remove = function (id)
        {
            var self = this;

            return Meta.remove(id).then(function () {

                angular.forEach(self.metas, function (v, i) {
                    if (v.$metaId === id) {
                        self.metas.splice(i, 1);
                    }
                });

            });
        };

        /**
         * Deleta todas Metas com a valor da KEY
         *
         * @param string key
         * @returns void
         */
        Config.prototype.removeByKey = function (key)
        {
            var self = this;
            var results = this.filterByKey(key);

            angular.forEach(results, function (meta) {
                self.remove(meta.$metaId);
            });
        };

        Config.prototype.toCollection = function (key, data)
        {
            var collection = function (key, data, $meta) {                
                this.$array = data;
                this.$add = function (item) {
                    var self = this;
                    
                    return $meta.add(key, item).then(function (result) {
                        self.$array.push(result);
                    });
                };
                this.$remove = function (item, index) {
                    var self = this;

                    item.$remove().then(function () {
                        if (angular.isUndefined(index) === false)
                            self.$array.splice(index, 1);
                    });
                };
            };

            return new collection(key, data, this);
        };

        /**
         *
         * @param {type} meta
         * @param {type} helper
         * @returns {meta_helper.factoryL#3.MetaHelperFactory.MagicMeta}
         *
         * ========================================================================
         */
        function MagicMeta(meta, helper)
        {
            this.$helper = helper;
            this.$array = [];

            this.$metaId = null;
            this.$metaKey = null;
            this.$metaType = null;
            this.$metaValue = null;

            this.$extend(meta);

            return this;
        }

        MagicMeta.prototype = {
            $extend: function (meta)
            {
                this.$metaId = meta.id;
                this.$metaKey = meta.meta_key;
                this.$metaType = meta.meta_type;
                this.$metaValue = meta.meta_value;

                if (!meta.meta_value) {
                    this.$metaValue = {};
                } else if (angular.isArray(this.$metaValue)) {
                    this.$toArray();
                } else {
                    this.$toObject();
                }

            },
            $save: function ()
            {
                var self = this;

                return this.$helper.save(self).then(function (result) {
                    self.$extend(result);
                });
            },
            $remove: function ()
            {
                return this.$helper.remove(this.$metaId);
            },
            $toObject: function ()
            {
                for (var name in this.$metaValue) {
                    this[name] = this.$metaValue[name];
                }
                return this;
            },
            $toArray: function ()
            {
                var self = this;
                this.$array = [];

                angular.forEach(this.$metaValue, function (item) {
                    self.$push(item);
                });
                return this;
            },
            $push: function (item)
            {
                //this.$array.push(item);
                var i = this.$array.push();
                this.$array[i] = MagicArray.call(item, i, this);
                return this;
            },
            $add: function(item)
            {
                this.$push(item).$save();
            },
            $toModel: function ()
            {
                var model = {
                    id: this.$metaId,
                    meta_key: this.$metaKey,
                    meta_value: this.$getValue(),
                    meta_type: this.$metaType
                };


                return model;
            },
            $getValue: function ()
            {
                var data = {};

                if (this.$array.length) {
                    data = this.$array;
                } else {

                    for (var name in this) {
                        if (name.substr('0', 1) !== '$')
                            data[name] = this[name];
                    }

                }


                return data;
                //return this.$array.length ? this.$array : this.$metaValue;
            }
        };

        /**
         * @param {array} data
         * @param {MagicMeta} magiMeta
         * @returns {undefined}
         */
        function MagicArray($index, magiMeta)
        {
            this.$removeData = function () {
                magiMeta.$array.splice($index, 1);
                magiMeta.$save();
            };

            this.$save = function () {
                magiMeta.$save();
            };

            this.$saveData = function (data) {
                magiMeta.$array[$index] = data;
                magiMeta.$save();
            };

            this.$updateData = function (data) {
                magiMeta.$array[$index] = angular.extend(magiMeta.$array[$index], data);
                magiMeta.$save();
            };

            return this;
        }



//        MagicMeta.prototype.$save =  function()
//        {
//            this.helper.updateOrCreate(this.$meta_key, this, this.$meta_type);
//        };
//
//        MagicMeta.prototype.getData =  function()
//        {
//            var result = {};
//
//            angular.forEach(function(){
//
//            });
//        };

        function construct(ownerType, ownerId, metas)
        {
            return new Config(ownerType, ownerId, metas);
        }



        return construct;
    }

    /** @ngInject */
    function MetaLoadHelperFactory(Meta, MetaHelper)
    {

        function construct(ownerType, ownerId)
        {
            var data = {
                owner_id: ownerId,
                owner_type: ownerType
            };

            return Meta.search(data).then(function (metas) {
                return new MetaHelper(ownerType, ownerId, metas);
            });
        }

        return construct;

    }

})();

(function () {
    'use strict';

    angular
            .module('rapi.fuse.metas')
            .factory('Meta', MetaService);


    /** @ngInject */
    function MetaService(w3Resource) {

        var urlApi = '/rapi/fuse/metas';
//        var Presenter = w3Presenter.make(null, requestPresenter);

        return w3Resource.make(urlApi);
        //return w3Resource.make(urlApi, Presenter);
        //return w3Resource.extend(urlApi, service);

        //----------------------------------

    }

})();

(function() {
  'use strict';

  angular
    .module('rapi.fuse.logs')
    .factory('Log', LogService);


  /** @ngInject */
  function LogService(w3Resource) {

    var urlApi  = '/rapi/fuse/activities/all';

    var service = {
    };

    return w3Resource.extend(urlApi, service);

    // ///////////////////////////////


  }

})();

(function () {
    'use strict';

    angular
            .module('rapi.fuse.logs')
            .controller('LogsController', LogsController);

    /** @ngInject */
    function LogsController( $mdDialog, Log) {
        var vm = this;

        // Data
        vm.archive = [];
        vm.loading = false;
        vm.pagination = {};
        vm.params = {
            'paginate': 10,
            'sort': 'created_at', //EX: nome,-created_at
            'q': null,
            'include' : 'causer'
        };

        // Methods
        vm.showDetail = showDetail;
        vm.search = search;
        vm.setPage = setPage;

        activate();

        //-----------------------

        function activate() {
            vm.loading = true;
            vm.archive = null;

            Log.search(vm.params).then(function (result) {
                vm.loading = false;
                vm.archive = result;
                vm.pagination = Log.pagination;
            });

        }

        function setPage(p)
        {
            Log.setPage(p);
            activate();
        }

        function search()
        {
            Log.setPage(1);
            activate();
        }



        function showDetail(row, ev) {
            $mdDialog.show({
                controller: 'logsDialogController',
                controllerAs: 'vm',
                templateUrl: '/app/external/fuse/logs/dialogs/logs-dialog.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    'row': row
                }

            });
        }


    }


})();

(function ()
{
    'use strict';

    angular
        .module('rapi.fuse.layouts')
        .controller('LayoutsController', LayoutsController);

  /** @ngInject */
  function LayoutsController($scope, $rootScope, w3Config)
  {
     var vm = this;
      // Data

      //////////
      // Data
      // vm.bg_auth = w3Config.get('bg_auth');
      // vm.logo = w3Config.get('logo');
      // vm.sigla = w3Config.get('sigla');
      // vm.title_project = w3Config.get('title_project');
       vm.openMenu = w3Config.get('menuOpenFrom');

      // Remove the splash screen
      $scope.$on('$viewContentAnimationEnded', function (event)
      {
          if ( event.targetScope.$id === $scope.$id )
          {
              $rootScope.$broadcast('msSplashScreen::remove');
          }
      });
  }


})();

(function () {
    'use strict';

    angular
            .module('rapi.fuse.auth')
            .factory('RfPassword', AuthService);

    /** @ngInject */
    function AuthService($http, w3Config, w3Utils) {

        var urlApi = '/rapi/guardian/auth/password';

        var service = {
            remind: remind,
            reset: reset,
            makeUrlReset: makeUrlReset
        };

        return service;

        //----------------------------------
        function remind(data)
        {
            var config = {
                w3Reload: 'rfpassord.remind'
            };

            if(!data.url_callback) {
                data.url_callback = makeUrlReset();
            } else if(data.welcome){
              data.url_callback += '?welcome=1';
            }

            return $http.post(w3Utils.urlApi(urlApi + '/remind'), data, config)
                    .then(remindComplete);

            function remindComplete(result) {
                return (result.data.status === 'success') ? result.data.data : false;
            }
        }

        function reset(data)
        {
            return $http.post(w3Utils.urlApi(urlApi + '/reset'), data)
                    .then(resetComplete);

            function resetComplete(result) {
                return (result.data.status === 'success') ? result.data.data : false;
            }
        }

        function makeUrlReset()
        {
            var configHost = w3Config.get('host');

            var url;

            if (configHost.env === 'local') {
                url = [configHost.appUrl, '#!/auth/reset/token'].join('/');
            } else {
                url = [configHost.appUrl, configHost.baseModule, '#!/auth/reset/token'].join('/');
            }

            return url;
        }


    }

})();

(function () {
    'use strict';

    angular
            .module('rapi.fuse.auth')
            .controller('AuthController', authController)
            .controller('LogoutController', logoutController)
            .controller('LoginTokenController', loginTokenController);

    /** @ngInject */
    function authController($scope, $rootScope) {

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event) {
            if (event.targetScope.$id === $scope.$id) {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });

    }

    /** @ngInject */
    function loginTokenController($stateParams, $state, w3Auth, w3Config) {

        var token = $stateParams.access_token;

        w3Auth.loginFromToken(token).then(function () {
            $state.go(w3Config.get('auth').routeSuccess);
        });

    }

    /** @ngInject */
    function logoutController($state, w3Auth) {

        w3Auth.logout().then(function () {
            $state.go('auth.login');
        });

    }


})();

(function () {
  'use strict';

  angular
      .module('rapi.fuse.auth')
      .factory('RfAuthValidation', AuthValidationService);

  /** @ngInject */
  function AuthValidationService($window, w3Config, w3Local, w3Auth, $state, toastr, $timeout) {
    return {
      logout: logout,
      navigateToHome: navigateToHome,
      hasAccessToModule: hasAccessToModule,
      noAccessToModuleNotification: noAccessToModuleNotification
    };

    function logout() {
      $window.localStorage.clear();
      $window.sessionStorage.clear();
      // w3Auth.logout().then(onSuccess);

      // function onSuccess() {
      //   navigateToHome();
      // }
    }

    function navigateToHome() {
      $timeout(navigateToRoot, 4000 );

      // var home = document.location.origin;
      // if (!(home.includes('192.168') || home.includes('localhost') || home.includes('0.0.0.0'))) {
      //   $window.open(document.location.origin, '_self');
      // } else {
      //   $state.go('auth.login');
      // }

      function navigateToRoot() {
        // console.log('navigation to root at', document.location.origin);
        $window.open(document.location.origin, '_self');
      }
    }

    function hasAccessToModule(permissions) {
      var userPermissions = permissions ? permissions: w3Local.get('loggedUserPermissions');
      var accessModulePermission = w3Config.get('access_permission_to_module');

      return !accessModulePermission || _.includes(userPermissions, accessModulePermission);
    }

    function noAccessToModuleNotification() {
      var module = w3Config.getConfigHost().baseModule;
      toastr.error('Acesso negado. Você não possui permisão para acessar o modulo ' + _.upperCase(module) + '!');
    }


  }

})();

(function () {
    'use strict';

    angular
            .module('rapi.fuse.cities')
            .controller('TabsController', TabsController);

    /** @ngInject */
    function TabsController(City, Estado, Pais,  $window) {
        var vm = this;

        // Data
        vm.selected_create = 'city';
      
        // Methods
        vm.setCreate = setCreate;
        vm.showCreate = showCreate;

        //-----------------------


        function setCreate(ob){
            vm.selected_create = ob;
        }

        function showCreate(ev)
        {

            switch(vm.selected_create) {
                case 'city':
                showCreateCity(ev);
                    break;
                case 'state':
                showCreateState(ev);
                    break;
                case 'country':
                showCreateCountry(ev);
                    break;
                default:
                showCreateCity(ev);
            }
        }

        function showCreateCity(ev)
        {
            City.dialog.create([], ev).then(function(result){
                if(result){
                    $window.location.reload();
                }
            })
        }

        function showCreateState(ev)
        {
            Estado.dialog.create([], ev).then(function(){
                if(result){
                    $window.location.reload();
                }
            })
        }

        function showCreateCountry(ev)
        {
            Pais.dialog.create([], ev).then(function(){
                if(result){
                    $window.location.reload();
                }
            })
        }
    }


})();

(function () {
    'use strict';


    angular
        .module('rapi.fuse.acl')
        .factory('RfAcl', AclFactory);

    /** @ngInject */
    function AclFactory($http, $log, w3Utils, w3Local, RfAuthValidation, msNavigationService, $state, w3Config, $timeout, $rootScope) {

        var urlApi = '/rapi/guardian';
        var navigation;
        var deletedNavigation = [];

        var service = {
            refreshAclStorange: refreshAclStorange,
            getCachedRoles: getCachedRoles,
            getCachedPermmissions: getCachedPermmissions,
            hasPerms: hasPerms,
            hasRole: hasRole,
            setupMenuNav: setupMenuNav
        };

        return service;

        // ///////////////////////////////
        function refreshAclStorange() {
            $log.info('Refresh ACL');

            if (w3Local.get('rapi.auth.token')){
              getLoggedUserACL().then(getLoggedUserACLComplete);
            }

            function getLoggedUserACLComplete(data) {
                if (RfAuthValidation.hasAccessToModule(data.permissions.map(getName))) {
                    $state.go(w3Config.get('auth').routeSuccess);

                    var roles = getACLNames(data.roles);
                    var permissions = getACLNames(data.permissions);
                    var acl = {
                        roles: roles,
                        permissions: permissions
                    };

                    w3Local.set('loggedUserRoles', roles);
                    w3Local.set('loggedUserPermissions', permissions);
                    $rootScope.$broadcast('FuseACL:onChangeACL', acl);

                } else {
                    RfAuthValidation.noAccessToModuleNotification();
                    RfAuthValidation.logout();
                    RfAuthValidation.navigateToHome();
                }
            }

            function getName(item) {
                return item.name;
            }

            $timeout(_filterNavigation, 2000);
        }

        function getLoggedUserACL() {
            return $http.get(w3Utils.urlApi(urlApi + '/me/acl'))
                .then(function (result) {
                    return result.data.data;
                });
        }

        function getCachedRoles() {
            return w3Local.get('loggedUserRoles', []);
        }

        function getCachedPermmissions() {
            return w3Local.get('loggedUserPermissions', []);
        }

        /**
         * @param string|array  collections name roles
         * @return bool
         */
        function hasRole(roles) {

            if (angular.isString(roles)) {
                roles = roles.split("|");
            }

            var loggedUserRoles = getCachedRoles();
            var userHasRole = false;

            for (var i = 0; i < roles.length; i++) {
                if (loggedUserRoles.indexOf(roles[i]) !== -1) {
                    userHasRole = true;
                    break;
                }
            }

            return userHasRole;
        }

        function hasPerms(permissions) {
            if (angular.isString(permissions)) {
                permissions = [permissions];
            }

            var loggedUserPermissions = getCachedPermmissions();
            var userHasPermission = false;

            if (!loggedUserPermissions){
                return false;
            }

            for (var i = 0; i < permissions.length; i++) {                
                if (loggedUserPermissions.indexOf(permissions[i]) !== -1) {
                    userHasPermission = true;
                    break;
                }
            }

            // var check = _.intersection(permissions, userHasPermission).length > 0;
            // $log.debug(loggedUserPermissions, 'check ->', permissions, userHasPermission);
            return userHasPermission;
        }

        function getACLNames(aclList) {
            var aclNameList = [];

            angular.forEach(aclList, function (item) {
                this.push(item.name.replace(/ /g, ''));
            }, aclNameList);

            return aclNameList;
        }

        function setupMenuNav() {
          $timeout(onTimeout, 1000);
            function onTimeout() {
                if(!navigation){
                  loadAllNavigations();
                }

              _filterNavigation();
            }
        }

        function restoreNavigation() {
          $log.debug('====================');
          $log.debug('RESTORE NAVIGATION MENU ITENS');
          deletedNavigation.forEach(restore);

          function restore(item) {
            $log.debug('Restoring ', item.title, ' to navigation');
            msNavigationService.saveItem(item._path, item);
          }

          msNavigationService.sort();
          loadAllNavigations();
          deletedNavigation = [];
        }

        function loadAllNavigations() {
          navigation = msNavigationService.getFlatNavigation();
        }

        function printAllNavigations() {
          $log.debug('====================');
          $log.debug('NAVIGATION MENU ITENS');
          navigation.forEach(log);

          function log(item, index) {
            $log.debug(index + '. ', item._id);
            $log.debug('\tTitle', item.title);
            $log.debug('\tPath ', item._path);
          }
        }

        function printUserPermissions() {
            $log.debug('====================');
            $log.debug('USER PERMISSIONS');
            $log.debug(getCachedPermmissions());
        }

        function _filterNavigation() {
            // $log.debug('FILTER NAVIGATION');

            var filterRemoveMenu = function (m) {

                //$log.debug('CHECK', m);
                if (!m.needRoles && !m.needPermissions) {
                    return false;
                }

                if (m.needRoles && hasRole(m.needRoles) === true) {
                    return false;
                }

                if (m.needPermissions && hasPerms(m.needPermissions) === true) {
                    return false;
                }

                $log.debug('Removing ', m.title, ' from navigation');
                deletedNavigation.push(m);
                msNavigationService.deleteItem(m._path);
                return true;
            };

            restoreNavigation();
            printUserPermissions();
            printAllNavigations();


            $log.debug('====================');
            $log.debug('REMOVE NAVIGATION MENU ITENS');

            navigation.map(function (m) {
                    if (m.children.length)
                        m.children.map(filterRemoveMenu);
                    if (filterRemoveMenu(m))
                        return;

                });
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('commons.conta_bancaria')
    .controller('ShowContaBancariaController', ShowContaBancariaController);

  /** @ngInject */
  function ShowContaBancariaController(ContaBancaria, w3Utils, w3Config, $translate, $stateParams) {
    var vm = this;

    // Data
    vm.row = {};
    vm.archivePagos = [];
    vm.archivePendentes = [];
    vm.loading = false;
    vm.pagination = {};
    vm.params = {
      'paginate': 10,
      'sort': 'nome', //EX: nome,-created_at
      'q': null
    };
    vm.totals = {};
    vm.isUserAdmin = false;

    // Methods
    vm.showCreate = showCreate;
    vm.showEdit = showEdit;
    vm.confirmDelete = confirmDelete;
    vm.search = search;
    vm.setPage = setPage;
    vm.showDetailsConta = showDetailsConta;
    vm.openDetailPayment = openDetailPayment;
    vm.createAppSession = createAppSession;


    activate();

    //-----------------------

    function activate() {
      if ($stateParams.id) {
        loadResource($stateParams.id);
      }

      vm.isUserAdmin = w3Config.get('module') === 'admin';
    }

    function loadDepositos(id) {
      vm.loading = true;
      vm.archive = null;

      ContaBancaria.searchContasAPagar({
        conta_id: id,
        total: 1,
        status: 'pago|pendente'
      }).then(function (result) {

        vm.loading = false;

        setArchiveByStatus(result.data)
        console.log('RESULT', result.total.total);
        vm.totals = result.total.merged;
      });
    }

    function setArchiveByStatus(data) {
      vm.archivePagos = [];
      vm.archivePendentes = [];

      data.map(function (item) {
        if(!!item._pago){
          vm.archivePagos.push(item);
        }else{
          vm.archivePendentes.push(item);
        }
      });
    }

    function loadResource(id) {
      ContaBancaria.find(id, '').then(function(result) {
        vm.row = result;
        loadDepositos(id);
      });
    }

    function setPage(p) {
      ContaBancaria.setPage(p);
      activate();
    }

    function search() {
      ContaBancaria.setPage(1);
      activate();
    }


    /**
     * Open new item dialog
     *
     * @param ev
     */
    function showCreate(ev) {
      ContaBancaria.dialog.create(vm.archive, ev);
    }

    function showEdit(row, ev) {
      ContaBancaria.dialog.edit(row, vm.archive, ev);
    }

    function showDetailsConta(data, id) {
      ContaBancaria.dialog.show(data, id);
    }

    function confirmDelete(item, $index, $event) {

      //TRANSLATE: Você realmente quer apagar este item?
      w3Utils.confirmDelete($translate.instant('CONTA_BANCARIA.MSG_CONFIRM_DELETE'), item.nome, $event)
        .then(function () {
          ContaBancaria.remove(item.id).then(function () {
            vm.archive.splice($index, 1);

          });
        });

    }

    function  openDetailPayment(ev){
      ContaBancaria.dialog.showDetailsPayment(12)
          .then(function (){
            console.log('CLOSE');
          });
    }

    function createAppSession(){
      ContaBancaria.dialog.createAppSession($stateParams.id)
          .then(function (){
            console.log('CLOSE');
          });
    }
  }


})();

(function ()
{
  'use strict';

  angular
    .module('main.xsession-lab', []);

})();

(function () {
  'use strict';

  angular
    .module('main.xsession-lab')
    .factory('xSessionLab', xSessionLabService);

  /** @ngInject */
  function xSessionLabService($http, w3Utils, w3Presenter) {
    var urlApi           = '/laboratorios';
    var sessionPresenter = w3Presenter.make(sessionResponsePresenter);

    var service = {
      listSessions : listSessions
    };

    return service;

    function sessionResponsePresenter(data) {
      return {
        'id'  : data.id,
        'name': data.nome
        // 'description': data.trade_name
      };
    }

    function listSessions() {
      return $http.get(w3Utils.urlApi(urlApi)).then(listSessionsSeucess);

      function listSessionsSeucess(result) {
        return sessionPresenter.collection(result.data.data);
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('commons.pedido')
    .factory('Pedido', PedidoService);

  /** @ngInject */
  function PedidoService(PedidoConstant, w3Resource, w3Utils, $http, $log, $mdDialog) {

    var urlApi = '/pedidos';

    var service = {
      cancel: cancel,
      disable: disable,
      getAllrequestStatus: getAllrequestStatus,
      getFrameModel: getFrameModel,
      getRequestStatus: getRequestStatus,
      getSellers: getSellers,
      printDetails: printDetails,
      printPackingLabel: printPackingLabel,
      printPvcCarc: printPvcCarc,
      printSelelrAwardLabel: printSelelrAwardLabel,
      printServiceOrder: printServiceOrder,
      restore: restore,
      sendRequestFromAdminToLab: sendRequestFromAdminToLab,
      sendRequestFromAdminToPolo: sendRequestFromAdminToPolo,
      sendRequestFromLabToAdmin: sendRequestFromLabToAdmin,
      sendRequestFromOticaToPolo: sendRequestFromOticaToPolo,
      sendRequestFromPoloToAdmin: sendRequestFromPoloToAdmin,
      sendRequestFromPoloToOtica: sendRequestFromPoloToOtica,
      setRequestAsEnded: setRequestAsEnded,
      startLensProduction: startLensProduction,
      showDetailDialog: showDetailDialog,
      allGressiveItens: allGressiveItens,
      gressiveItensByProduct: gressiveItensByProduct,
      changeVlsPedido: changeVlsPedido,
      showCancelDialog: showCancelDialog,
      validateVoucher: validateVoucher,
      desvincularVoucher: desvincularVoucher,
    };

    return w3Resource.extend(urlApi, service);

    //----------------------------------

    function getSellers(otica_id) {
      var data = {
        params: {
          include: 'user',
          permission: 'otica_vendedor|otica_gerente|otica_admin',
          table_id: otica_id
        }
      };
      console.log('data', data);

      return $http.get(w3Utils.urlApi('/rapi/guardian/shared'), data).then(getSellersSucess);

      function getSellersSucess(response) {
        return response.data.data;
      }
    }

    function allGressiveItens() {
      var data = {
        params: {
          take: -1
        }
      };

      return $http.get(w3Utils.urlApi('/items'), data).then(function (response) {
        return response.data.data;
      });
    }

    function gressiveItensByProduct(productId) {
      return $http.get(w3Utils.urlApi('/items/produto/'+productId)).then(function (response) {
        return response.data.data;
      });
    }

    function printDetails(id, data) {
      var url = w3Utils.urlApi(urlApi + '/{id}/print', id)
      return $http.put(url, data).then(printSucess);

      function printSucess(result) {
        return (result.data.status === 'success') ? result.data.data : false;
      }
    }

    function printPvcCarc(id, data) {
      return $http.put(w3Utils.urlApi(urlApi + '/{id}/print', id), data).then(cancelSucess);

      function cancelSucess(result) {
        return (result.data.status === 'success') ? result.data.data : false;
      }
    }

    function printPackingLabel(id, data) {
      return $http.put(w3Utils.urlApi(urlApi + '/{id}/print', id), data).then(cancelSucess);

      function cancelSucess(result) {
        return (result.data.status === 'success') ? result.data.data : false;
      }
    }

    function printSelelrAwardLabel(id, data) {
      return $http.put(w3Utils.urlApi(urlApi + '/{id}/print', id), data).then(cancelSucess);

      function cancelSucess(result) {
        return (result.data.status === 'success') ? result.data.data : false;
      }
    }

    function printServiceOrder(id, data) {
      return $http.put(w3Utils.urlApi(urlApi + '/{id}/print', id), data).then(cancelSucess);

      function cancelSucess(result) {
        return (result.data.status === 'success') ? result.data.data : false;
      }
    }

    function disable(id) {
      return $http.put(w3Utils.urlApi(urlApi + '/{id}/disable', id)).then(disableSucess);

      function disableSucess(result) {
        return (result.data.status === 'success') ? result.data.data : false;
      }
    }

    function restore(id) {
      return $http.put(w3Utils.urlApi(urlApi + '/{id}/restore', id)).then(restoreSucess);

      function restoreSucess(result) {
        return (result.data.status === 'success') ? result.data.data : false;
      }
    }

    function updateStatus(id, data) {
      if (!id) {
        console.log('Sem ID para atualizar status do pedido', id, data);
        return {
          then: function (response, reject) {
            return reject('Sem ID para atualizar status do pedido');
          }
        };
      }

      return $http.put(w3Utils.urlApi(urlApi + '/{id}/status', id), data).then(updateStatusSucess);

      function updateStatusSucess(result) {
        return (result.data.status === 'success') ? result.data.data : false;
      }
    }

    function cancel(id, data) {
      return updateStatus(id, data);
    }

    function sendRequestFromLabToAdmin(id) {
      var data = {
        "status": "ENVIO_ADMIN"
      };
      return updateStatus(id, data);
    }

    function sendRequestFromOticaToPolo(id) {
      var data = {
        "status": "AGUARDANDO_POLO"
      };
      return updateStatus(id, data);
    }

    function setRequestAsEnded(id) {
      var data = {
        "status": "FINALIZADO"
      };
      return updateStatus(id, data);
    }

    function sendRequestFromPoloToAdmin(id, data) {
      data.status = 'AGUARDANDO_ADMIN';
      return updateStatus(id, data);
    }

    function sendRequestFromPoloToOtica(id, data) {
      data.status = "ENVIO_OTICA";
      return updateStatus(id, data);
    }

    function sendRequestFromAdminToLab(id, data) {
      data.status = 'AGUARDANDO_LAB';
      return updateStatus(id, data);
    }

    function sendRequestFromAdminToPolo(id, data) {
      data.status = "ENVIO_POLO";
      return updateStatus(id, data);
    }

    // function acceptRequestFromOtica(id) {
    //   var data = {
    //     "status": "RASCUNHO"
    //   };
    //   return updateStatus(id, data);
    // }
    //
    // function acceptRequestFromAdmin(id) {
    //   var data = {
    //     "status": "RASCUNHO"
    //   };
    //   return updateStatus(id, data);
    // }
    //
    // function acceptRequestFromPolo(id) {
    //   var data = {
    //     "status": "RASCUNHO"
    //   };
    //   return updateStatus(id, data);
    // }

    function startLensProduction(id) {
      var data = {
        "status": "EXECUTANDO_LAB"
      };
      return updateStatus(id, data);
    }

    // function finishLensProduction(id) {
    //   var data = {
    //     "status": "RASCUNHO"
    //   };
    //   return updateStatus(id, data);
    // }

    function getAllrequestStatus() {
      return PedidoConstant.REQUEST_STATUS;
    }

    function getRequestStatus(id) {
      return PedidoConstant.REQUEST_STATUS.filter(function(el) {
        return el.id == id;
      })[0];
    }

    function getFrameModel(id) {
      return {
        'id': id,
        'img_src': 'https://services.pololentes.com.br/img/tipo_armacao/' + id + '.png'
      }
    }

    function showDetailDialog(productId, tipo, ev)
    {
      return $mdDialog.show({
        controller: 'DetailItemDialog',
        controllerAs: 'vm',
        templateUrl: '/app/external/pedido/dialog/detail-item-dialog/detail-item-dialog.html',
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          'productId': productId,
          'tipo': tipo
        }
      });

    }

    function showCancelDialog(person, pedido, ev)
    {
      return $mdDialog.show({
        controller: 'CancelarPedidoDialog',
        controllerAs: 'vm',
        templateUrl: '/app/external/pedido/dialog/cancelar-pedido/cancelar-pedido-dialog.html',
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          'person': person,
          'pedido': pedido
        }
      });

    }

    function changeVlsPedido(id, data) {
      return $http.put(w3Utils.urlApi(urlApi + '/{id}/valor-manual', id), data).then(cancelSucess);

      function cancelSucess(result) {
        return (result.data.status === 'success') ? result.data.data : false;
      }
    }

    function validateVoucher(row) {
      return $http.post(w3Utils.urlApi(urlApi + '/voucher-validator'), row).then(function (result){
        return (result.data.status === 'success') ? result.data : false;
      }, function (error){
        return error.data;
      });
    }

    function desvincularVoucher(id) {
      return $http.put(w3Utils.urlApi(urlApi + '/{id}/voucher-des-use', id)).then(function (result){
        return (result.data.status === 'success') ? result.data : false;
      }, function (error){
        return error.data;
      });
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('commons.pedido')
    .constant('PedidoConstant', {
      REQUEST_STATUS: [{
          'id': 'RASCUNHO',
          'label': 'Rascunho'
        },
        {
          'id': 'CANCELADO_POLO|CANCELADO_OTICA|CANCELADO_ADMIN|CANCELADO_LABORATORIO',
          'label': 'Cancelado'
        },
        {
          'id': 'ENVIO_ADMIN',
          'label': 'Enviado para Webmaster'
        },
        {
          'id': 'AGUARDANDO_POLO',
          'label': 'Aguardando Polo'
        },
        {
          'id': 'FINALIZADO',
          'label': 'Finalizado'
        },
        {
          'id': 'AGUARDANDO_ADMIN',
          'label': 'Aguardando Webmaster'
        },
        {
          'id': 'ENVIO_OTICA',
          'label': 'Enviado para Ótica'
        },
        {
          'id': 'AGUARDANDO_LAB',
          'label': 'Aguardando Laboratório'
        },
        {
          'id': 'ENVIO_POLO',
          'label': 'Enviado para Polo'
        },
        {
          'id': 'EXECUTANDO_LAB',
          'label': 'Produzindo o produto'
        }
      ],
      REQUEST_STATUS_OTICA: [{
          'id': 'RASCUNHO',
          'label': 'Rascunho'
        },
        {
          'id': 'CANCELADO_POLO|CANCELADO_OTICA|CANCELADO_ADMIN|CANCELADO_LABORATORIO',
          'label': 'Cancelado'
        },
        {
          'id': 'AGUARDANDO_LAB|AGUARDANDO_ADMIN|AGUARDANDO_POLO',
          'label': 'Processando'
        },
        {
          'id': 'EXECUTANDO_LAB',
          'label': 'Em fabricação'
        },
        {
          'id': 'ENVIO_ADMIN|ENVIO_POLO',
          'label': 'Fabricado'
        },
        {
          'id': 'ENVIO_OTICA',
          'label': 'Enviado para Ótica'
        },
        {
          'id': 'FINALIZADO',
          'label': 'Finalizado'
        }
      ],
      REQUEST_STATUS_POLO: [{
          'id': 'AGUARDANDO_LAB',
          'label': 'Aguardando fabricação'
        },
        {
          'id': 'CANCELADO_POLO|CANCELADO_OTICA|CANCELADO_ADMIN|CANCELADO_LABORATORIO',
          'label': 'Cancelado'
        },
        {
          'id': 'EXECUTANDO_LAB',
          'label': 'Em fabricação'
        },
        {
          'id': 'ENVIO_ADMIN',
          'label': 'Fabricado'
        },
        {
          'id': 'AGUARDANDO_POLO',
          'label': 'Aguardando aprovação'
        },
        {
          'id': 'FINALIZADO',
          'label': 'Finalizado'
        },
        {
          'id': 'AGUARDANDO_ADMIN',
          'label': 'Aguardando Webmaster'
        },
        {
          'id': 'ENVIO_OTICA',
          'label': 'Enviado para Ótica'
        },
        {
          'id': 'ENVIO_POLO',
          'label': 'Webmaster enviou para Polo'
        },
      ],
      EYEGLASS_FRAME_MATERIAL: [{
          'id': 'PLASTICO_ACETATO',
          'label': 'Plastico / Acetato'
        },
        {
          'id': 'NYLON',
          'label': 'Nylon'
        },
        {
          'id': 'METAL',
          'label': 'Metal'
        },
        {
          'id': 'PARAFUSO',
          'label': 'Parafuso'
        }
      ],
      EYEGLASS_FRAME_TYPE: [
          {
            'id': 1,
            'img_src': 'https://services.pololentes.com.br/img/tipo_armacao/1.png'
          },
        {
          'id': 2,
          'img_src': 'https://services.pololentes.com.br/img/tipo_armacao/2.png'
        },
        {
          'id': 3,
          'img_src': 'https://services.pololentes.com.br/img/tipo_armacao/3.png'
        },
        {
          'id': 4,
          'img_src': 'https://services.pololentes.com.br/img/tipo_armacao/4.png'
        },
        {
          'id': 5,
          'img_src': 'https://services.pololentes.com.br/img/tipo_armacao/5.png'
        },
        {
          'id': 6,
          'img_src': 'https://services.pololentes.com.br/img/tipo_armacao/6.png'
        },
        {
          'id': 7,
          'img_src': 'https://services.pololentes.com.br/img/tipo_armacao/7.png'
        },
        {
          'id': 8,
          'img_src': 'https://services.pololentes.com.br/img/tipo_armacao/8.png'
        },
        {
          'id': 9,
          'img_src': 'https://services.pololentes.com.br/img/tipo_armacao/9.png'
        },
        {
          'id': 10,
          'img_src': 'https://services.pololentes.com.br/img/tipo_armacao/10.png'
        },
        {
          'id': 11,
          'img_src': 'https://services.pololentes.com.br/img/tipo_armacao/11.png'
        },
        {
          'id': 12,
          'img_src': 'https://services.pololentes.com.br/img/tipo_armacao/12.png'
        },
        {
          'id': 13,
          'img_src': 'https://services.pololentes.com.br/img/tipo_armacao/13.png'
        },
        {
          'id': 14,
          'img_src': 'https://services.pololentes.com.br/img/tipo_armacao/14.png'
        },
      ],
      PRIS_VERTICAL_BASE_TYPE: [
        'Superior',
        'Inferior'
      ],
      PRIS_HORIZONTAL_BASE_TYPE: [
        'Nasal',
        'Temp'
      ],
      PRESCRIPTION_TYPE: [{
          'id': 'DE',
          'label': 'Both eyes',
          'translate': 'PEDIDO.FORM.PRODUTO.RB_LENS_FOR_BOTH_EYES'
        },
        {
          'id': 'E',
          'label': 'Left eyes',
          'translate': 'PEDIDO.FORM.PRODUTO.RB_LENS_FOR_LEFT_EYE'
        },
        {
          'id': 'D',
          'label': 'Right eyes',
          'translate': 'PEDIDO.FORM.PRODUTO.RB_LENS_FOR_RIGTH_EYE'
        }
      ]
    });

})();

(function() {
  'use strict';

  angular
    .module('commons.pedido')
    .controller('PedidoSelectOtica', PedidoSelectOtica);

  /** @ngInject */
  function PedidoSelectOtica($state, PedidoInfo, w3Session) {
    var vm = this;

    // Data - Arrays
    vm.myResourceList = [];

    // Data - Objects
    vm.resourceDefaultParams = {};

    vm.select = select;

    activate();

    // Functions - Configuration, page setup and data load
    function activate() {
      if (w3Session.get('x_otica_id')) {
        select(w3Session.get('x_otica_id'))
      } else {
        setDefaultParams();
        loadResource(vm.resourceDefaultParams);
      }
    }


    function setDefaultParams() {
      vm.resourceDefaultParams = {
        admin_aprovou: true,
        include: ',city.state.country,'
      };
    }

    function select(otica_id) {
      var data = {
        otica_id: otica_id
      }

      $state.go('xsession.pedido.new', data);
    }

    // Functions - Service calls
    function loadResource(params) {
      PedidoInfo.allOtica(params).then(sucess);

      function sucess(result) {
        console.log('result', result);
        vm.myResourceList = setAddress(result);
      }
    }

    function setAddress(list) {
      return list.map(format);

      function format(item) {
        item.cityAddress = '';
        item.streetAddress = '';

        if (item.city) {
          item.cityAddress += item.city.city_name;
          if (item.city.state) {
            item.cityAddress += ' (' + item.city.state.state_code + ')'
            if (item.city.state.country) {
              item.cityAddress += ', ' + item.city.state.country.country_name;
            }
          }
        }

        if (item.rua) {
          item.streetAddress += item.rua;
          if (item.numero) {
            item.streetAddress += ', ' + item.numero;
          }
        }

        if (item.bairro) {
          item.streetAddress += ', ' + item.bairro;
        }

        return item;
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('commons.pedido')
    .factory('PedidoNavigation', PedidoNavigationService);

  /** @ngInject */
  function PedidoNavigationService(Pedido) {
    var id = -1;

    var service = {
      get: get,
      set: set,
    }

    return service;

    function set(new_id) {
      id = new_id;
    }

    function get() {
      return id;
    }

    // var requestIDs = [];
    // var activeIndex = -1;
    //
    //
    // var service =  {
    //   getActive      : getActive,
    //   getNavInfo     : getNavInfo,
    //   isFirstRequest : isFirstRequest,
    //   isLastRequest  : isLastRequest,
    //   set            : set,
    //   find : find,
    // }
    //
    // return service;
    //
    // function set(ids, idx) {
    //   requestIDs = ids;
    //   activeIndex = idx;
    // }
    //
    // function getActive() {
    //   return find(requestIDs[activeIndex].id);
    // }
    //
    // function getNavInfo() {
    //   return {
    //     'index' : activeIndex + 1,
    //     'total' : requestIDs.length
    //   }
    // }
    //
    // function find(id) {
    //   Pedido.find(id).then(findSucess);
    //
    //   function findSucess(response) {
    //     return response;
    //   }
    // }
    //
    // function isLastRequest() {
    //   return activeIndex >= (requestIDs.length -1);
    // }
    //
    // function isFirstRequest() {
    //   return activeIndex <= 0;
    // }
    //
    // function goToNextRequest() {
    //   if (!isLastRequest()) {
    //     activeIndex += 1;
    //     return getActive();
    //   }
    // }
    //
    // function goToPreviousRequest() {
    //   if (!isFirstRequest()) {
    //     activeIndex -= 1;
    //     return getActive();
    //   }
    // }

  };

})();

(function() {
  'use strict';

  angular
    .module('commons.pedido')
    .factory('PedidoInfo', PedidoinfoService);

  /** @ngInject */
  function PedidoinfoService(w3Utils, $http, $log) {
    var urlApiCores = '/cores';
    var urlApiFormaPagamento = '/forma-pagamentos';
    var urlApiGrupos = '/grupos';
    var urlApiLaboratórios = '/laboratorios';
    var urlApiMaterial = '/materiais';
    var urlApiOtica = '/oticas';
    var urlApiPolo = '/polos';
    var urlApiProduto = '/produtos';
    var urlApiTecnologia = '/tecnologias';
    var urlApiTratamento = '/tratamentos';
    var urlApiAdicionais = '/items/adicionais';

    var service = {
      allCor: allCor,
      allGrupos: allGrupos,
      allLabs: allLabs,
      allMaterial: allMaterial,
      allOtica: allOtica,
      allPolo: allPolo,
      allTecologia: allTecologia,
      allTratamento: allTratamento,
      findFormaPagamento: findFormaPagamento,
      findMaterial: findMaterial,
      findOtica: findOtica,
      findProduto: findProduto,
      findTratamento: findTratamento,
      searchProduto: searchProduto,
      getAdditionals: getAdditionals,
    };

    return service;

    // ----------------------------------------------------------
    // OTICAS
    function findOtica(id, params) {
      var data = {
        params: {
          'include': params
        }
      };

      return $http.get(w3Utils.urlApi(urlApiOtica + '/{id}', {
        id: id
      }), data).then(findOticaSucess);

      function findOticaSucess(result) {
        return result.data.data;;
      }
    }

    function allOtica(params) {
      var data = {
        params: params
      }
      return $http.get(w3Utils.urlApi(urlApiOtica), data).then(allOticaSucess);

      function allOticaSucess(result) {
        return result.data.data;;
      }
    }

    // ----------------------------------------------------------
    // LABS

    function allLabs() {
      return $http.get(w3Utils.urlApi(urlApiLaboratórios)).then(allLabsSucess);

      function allLabsSucess(result) {
        return result.data.data;;
      }
    }

    // ----------------------------------------------------------
    // POLOS
    function allPolo() {
      return $http.get(w3Utils.urlApi(urlApiPolo)).then(allPoloSucess);

      function allPoloSucess(result) {
        return result.data.data;;
      }
    }

    // ----------------------------------------------------------
    // GRUPOS
    function allGrupos() {
      return $http.get(w3Utils.urlApi(urlApiGrupos)).then(allGruposSucess);

      function allGruposSucess(result) {
        return result.data.data;;
      }
    }

    allGrupos

    // ----------------------------------------------------------
    // MATERIAIS
    function findMaterial(id, params) {
      var data = {
        params: {
          'include': params
        }
      };

      return $http.get(w3Utils.urlApi(urlApiMaterial + '/{id}', {
        id: id
      }), data).then(findMaterialSucess);

      function findMaterialSucess(result) {
        return result.data.data;;
      }
    }

    function allMaterial() {
      return $http.get(w3Utils.urlApi(urlApiMaterial)).then(allMaterialSucess);

      function allMaterialSucess(result) {
        return result.data.data;;
      }
    }



    // ----------------------------------------------------------
    // PRODUTOS
    function findProduto(id, includeEmbed) {
      var data = {
        params: {
          'include': includeEmbed
        }
      };

      return $http.get(w3Utils.urlApi(urlApiProduto + '/{id}', {
        id: id
      }), data).then(findProdutoSucess);

      function findProdutoSucess(result) {
        return result.data.data;;
      }
    }

    function searchProduto(params) {
      var data;

      data = {
        params: params
      };

      return $http.get(w3Utils.urlApi(urlApiProduto), data).then(searchProdutoSucess);

      function searchProdutoSucess(result) {
        return result.data.data;
      }
    }

    // ----------------------------------------------------------
    // TRATAMENTOS
    function findTratamento(id, includeEmbed) {
      var data = {
        params: {
          'include': includeEmbed
        }
      };

      return $http.get(w3Utils.urlApi(urlApiTratamento + '/{id}', {
        id: id
      }), data).then(findTratamentoSucess);

      function findTratamentoSucess(result) {
        return result.data.data;;
      }
    }

    function allTratamento() {
      return $http.get(w3Utils.urlApi(urlApiTratamento)).then(allTratamentoSucess);

      function allTratamentoSucess(result) {
        return result.data.data;;
      }
    }

    // ----------------------------------------------------------
    // FORMA PAGAMENTO
    function findFormaPagamento(id, includeEmbed) {
      var data = {
        params: {
          'include': includeEmbed
        }
      };

      return $http.get(w3Utils.urlApi(urlApiFormaPagamento + '/{id}', {
        id: id
      }), data).then(findFormaPagamentoSucess);

      function findFormaPagamentoSucess(result) {
        return result.data.data;;
      }
    }

    // ----------------------------------------------------------
    // TECNOLOGIA
    function allTecologia() {
      return $http.get(w3Utils.urlApi(urlApiTecnologia)).then(allTecologiaSucess);

      function allTecologiaSucess(result) {
        return result.data.data;;
      }
    }

    // ----------------------------------------------------------
    // CORES
    function allCor() {
      return $http.get(w3Utils.urlApi(urlApiCores)).then(allCorSucess);

      function allCorSucess(result) {
        return result.data.data;;
      }
    }
    // ----------------------------------------------------------
    // ADICIONAIS
    function getAdditionals() {
      return $http.get(w3Utils.urlApi(urlApiAdicionais)).then(additionalSucess);

      function additionalSucess(result) {
        return result.data.data;
      }
    }

  }

})();

(function () {
  'use strict';

  angular
      .module('commons.pedido')
      .controller('PedidoFormController', PedidoFormController);

  /** @ngInject */
  function PedidoFormController(Pedido,
                                PedidoInfo,
                                PedidoConstant,
                                PedidoNavigation,
                                w3Utils,
                                w3Config,
                                w3Local,
                                w3Session,
                                $translate,
                                $stateParams,
                                $state,
                                $scope,
                                $anchorScroll,
                                $location,
                                toastr,
                                $mdDialog) {
    var vm = this;
    var ID;

    //Data
    vm.isNew = false;
    vm.formStage = 1;
    vm.row = {
      espec_tipo: 'DE',
      medidas: {
        diametro: 0
      },
      espec_od: {},
      espec_oe: {},
      adicionais: []
    };
    vm.productFilter = {};
    vm.tratamento = {};
    vm.material = {};
    vm.itrackline = {};

    vm.searchMaterial = '';
    vm.filterActive = false;

    vm.isLeftEyeEditable = false;
    vm.isRequestEditable = false;
    vm.isRightEyeEditable = false;
    vm.isOtica = false;
    vm.isOticaAprovada = null;

    vm.watchOticaRequest = null;

    vm.produtos = [];
    vm.grupos = [];
    vm.cores = [];
    vm.tecnologias = [];
    vm.adicaoValues = [];
    vm.esfericos = [];
    vm.cilindros = [];
    vm.eixos = [];
    // vm.tratamentos = [];
    vm.materiais = [];
    vm.prish_base = [];
    vm.prisv_base = [];
    vm.frameTypes = [];
    vm.frameModels = [];
    vm.searchMateriais = [];
    vm.selectedMaterials = [];
    vm.selectedTratamentos = [];
    vm.formasPagamento = [];
    vm.gressives = [];
    vm.additionals = [];
    vm.additionalsSelected = [];

    vm.precoProduto = 0;
    vm.totalRef= 0;
    vm.decontoPoncentagem = 0;
    vm.acrescimoPoncentagem = 0;

    vm.missingData = [];
    vm.tentouEnviarParaPolo = false;

    vm.productSelected = false;

    vm.params = {
      'onlyTrashed': null,
      'withTrashed': 1
    };

    vm.codigoVoucher = '';
    vm.voucherErrorMsg = '';
    vm.voucherInfo = '';

    vm.optionsTratamento = [];
    vm.codes = [];
    vm.enableItracklineCode = false;
    vm.configUpload = {
      url: w3Utils.urlApi('/rapi/fuse/uploads'),
      params: {}
    };

    //Methods
    vm.save = save;
    vm.cancelConfirm = cancelConfirm;
    vm.goArchive = goArchive;
    vm.produtosFromGrupo = produtosFromGrupo;
    vm.startRequestWithProduct = startRequestWithProduct;
    vm.confirmSend = confirmSend;
    vm.loadProdutos = loadProdutos;
    vm.clearFilter = clearFilter;
    vm.toogleFilter = toogleFilter;
    vm.startFilter = startFilter;
    vm.select = select;
    vm.advaceStage = advaceStage;
    vm.showDetail = showDetail;
    vm.showDetailITrackLine = showDetailITrackLine;
    vm.validateVoucher = validateVoucher;

    // Disable, show, hide and if conditions
    vm.isRequestDisabled = isRequestDisabled;
    vm.isRequestActive = isRequestActive;
    vm.isPrescriptionValid = isPrescriptionValid;
    vm.getMissingData = getMissingData;
    vm.editableStates = editableStates;

    vm.makeParcelaLabel = makeParcelaLabel;

    vm.clearVoucherCode = clearVoucherCode;
    vm.removeVoucher = removeVoucher;
    vm.enableRemoveVoucher = enableRemoveVoucher;
    vm.removeRemoteFile = removeRemoteFile;

    vm.isAdditionalSelected = isAdditionalSelected;
    vm.toggleAdditional = toggleAdditional;
    vm.hasCorteRemoto = hasCorteRemoto;


    activate();

    //-------------------

    $scope.$on('changeProductTotals', function(event, data) {
      vm.precoProduto = data.preco;
      vm.row.produto._ref = data.ref;

      if(vm.row.produto.tipo === 'GRESSIVE'){
        vm.row.item_longe_id = data.ids.item_longe_id;
        vm.row.item_interm_id = data.ids.item_interm_id;
        vm.row.item_perto_id = data.ids.item_perto_id;

        vm.row.itemLonge = data.itemLonge;
        vm.row.itemInterm = data.itemInterm;
        vm.row.itemPerto = data.itemPerto;
      }

      calculateTotalValue();
    });

    function activate() {
      console.log('teste controllers')
      verifyIfOticaAprovadaSN();
    }

    function startPageConfiguration(newValue, oldValue) {
      if (newValue !== oldValue) {
        vm.watchOticaRequest();
        if (vm.isOticaAprovada) {
          if ($stateParams.id) {
            loadResource($stateParams.id);
          } else {
            vm.isNew = true;
            vm.isRequestEditable = true;
            vm.isRightEyeEditable = true;
            vm.isLeftEyeEditable = true;
            loadAllDependencies();
          }
          setWatches();
          setUser();

        }
      }
    }

    function setStage() {
      if (vm.row.material_armacao || vm.row.tipo_armacao) {
        vm.formStage = 5;
      } else if (!_.isEmpty(_.omit(vm.row.medidas, ['diametro']))) {
        vm.formStage = 4;
      } else if (!_.isEmpty(vm.row.espec_od) || !_.isEmpty(vm.row.espec_oe)) {
        vm.formStage = 3;
      } else if (vm.row.material_id || vm.row.tratamento_id || vm.row.forma_pagamento_id) {
        vm.formStage = 2;
      } else {
        vm.formStage = 1;
      }
      scrollToNextDiv();
    }

    function verifyIfOticaAprovadaSN() {
      loadOtica();
      vm.watchOticaRequest = $scope.$watch('vm.isOticaAprovada', startPageConfiguration);
    }

    function setUser() {
      vm.isOtica = w3Config.get('module') === 'optical_shop';
    }

    function setTratamentos(){
      vm.optionsTratamento = [];
      vm.codes = [];

      if( !vm.row.produto.tratamentos || vm.row.produto.tratamentos.length === 0 ){
        return;
      }

      for (var i = 0; i < vm.row.produto.tratamentos.length; i++) {
        if (vm.row.produto.tratamentos[i].is_itrack === true) {
          vm.codes.push(vm.row.produto.tratamentos[i]);
        }else{
          vm.optionsTratamento.push(vm.row.produto.tratamentos[i]);
        }
      }

      if(!vm.isNew && vm.row.tratamento_id){
        vm.tratamento = getSelected(vm.optionsTratamento, vm.row.tratamento_id);
      }
      if(!vm.isNew && vm.row.itrack_id){
        vm.enableItracklineCode = true;
        vm.itrackline = getSelected(vm.codes, vm.row.itrack_id);
      }
    }

    function confirmSend() {
      const data = angular.copy(vm.row);

      if(!data.material && data.material_id && vm.row.produto.materiais.length){
        data.material = vm.row.produto.materiais.find(function (mat) {
          return +mat.id === +data.material_id;
        });
      }
      if(!data.tratamento && data.tratamento_id && vm.row.produto.tratamentos.length){
        data.tratamento = vm.row.produto.tratamentos.find(function (mat) {
          return +mat.id === +data.tratamento_id;
        })
      }

      if(!vm.enableItracklineCode){
        data.itrack_id = null;
        data.itrack_code = '';
      }

      if (vm.additionalsSelected.length > 0) {
        data.adicionais = angular.copy(vm.additionalsSelected);
      } else {
        data.adicionais = null;
      }

      if(!vm.hasCorteRemoto()){
        data.file_corte_remoto_src = null;
        data.file_corte_remoto = null;
        vm.row.file_corte_remoto_src = null;
        vm.row.file_corte_remoto = null;
      }

      var dialog = {
        controller: 'PedidoDialogSendRequestOtica',
        controllerAs: 'vm',
        templateUrl: '/app/external/pedido/dialog/pedido-dialog-send-request-otica/pedido-dialog-send-request-otica.html',
        clickOutsideToClose: true,
        locals: {
          'request': data
        }
      };

      $mdDialog.show(dialog).then(onConfirm);


      function onConfirm() {
        vm.tentouEnviarParaPolo = true;
        if (isRequestValidToSend()) {
          sendRequestToPolo();
        } else {
          toastr.error(
              'Para enviar o pedido para a Polo, todas as informações no formulário devem ser preenchidas.',
              'Dados invalidos!')
        }
      }
    }

    function getMissingData() {
      isRequestValidToSend();
    }

    function isRequestValidToSend() {
      var missing = [];

      var info_geral = {
        name: 'Informações gerais',
        data: []
      };
      var produto = {
        name: 'Informações do produto',
        data: []
      };
      var prescricao_dir = {
        name: 'Prescrição da lente direita',
        data: []
      };
      var prescricao_esq = {
        name: 'Prescrição da lente esquerda',
        data: []
      };
      var medidas = {
        name: 'Medidas da lente',
        data: []
      };
      var armacao = {
        name: 'Armação da lente',
        data: []
      };

      if (!vm.row.nro_os) {
        info_geral.data.push('Número da OS');
      }


      if (!vm.row.cliente) {
        info_geral.data.push('Nome do cliente');
      }


      if (!vm.row.material_armacao) {
        armacao.data.push('Material da armação');
      }


      if (!vm.row.tipo_armacao) {
        armacao.data.push('Modelo da armação');
      }


      // if (!vm.row.forma_pagamento_id) {
      //   produto.data.push('Forma de pagamento');
      // }

      if (!vm.row.material_id) {
        produto.data.push('Material das lentes');
      }

      if (!vm.row.tratamento_id) {
        produto.data.push('Tratamento das lentes');
      }

      if (!vm.row.espec_tipo && vm.isOtica) {
        produto.data.push('Informar quantas lentes deseja. (para os dois olhos, olho direito ou olho esquerdo)');
      }
      // if (vm.row.espec_tipo === 'D' || vm.row.espec_tipo === 'DE' || !vm.row.espec_tipo) {
      //   prescricao_dir.data = validarEspecificaoLente(vm.row.espec_od);
      // }
      //
      // if (vm.row.espec_tipo === 'E' || vm.row.espec_tipo === 'DE' || !vm.row.espec_tipo) {
      //   prescricao_esq.data = validarEspecificaoLente(vm.row.espec_oe);
      // }

      medidas.data = validarMedidasLente(vm.row.medidas);


      if (vm.row.produto.tipo === 'GRESSIVE' && !vm.row.altura_v_progressivo) {
        medidas.data.push('Altura. Versão do corredor progressivo.');
      }

      if (vm.row.produto.tipo === 'GRESSIVE' && !vm.row.item_perto_id) {
        produto.data.push('Produto Hybrid. Configuração: Perto.');
      }

      if (vm.row.produto.tipo === 'GRESSIVE' && !vm.row.item_interm_id) {
        produto.data.push('Produto Hybrid. Configuração: Intermediário.');
      }

      if (vm.row.produto.tipo === 'GRESSIVE' && !vm.row.item_longe_id) {
        produto.data.push('Produto Hybrid. Configuração: Longe.');
      }

      if (info_geral.data.length) {
        missing.push(info_geral);
      }

      if (produto.data.length) {
        missing.push(produto);
      }

      if (prescricao_dir.data.length) {
        missing.push(prescricao_dir);
      }

      // if (prescricao_esq.data.length) {
      //   missing.push(prescricao_esq);
      // }


      if (medidas.data.length) {
        missing.push(medidas);
      }

      if (armacao.data.length) {
        missing.push(armacao);
      }

      vm.missingData = missing;

      return missing.length === 0;
    }

    function validarMedidasLente(medidas) {
      var array = [];
      if (medidas.largura === undefined || medidas.largura === null) {
        array.push('Largura da lente');
      }

      if (medidas.altura === undefined || medidas.altura === null) {
        array.push('Altura da lente');
      }

      if (medidas.ponte === undefined || medidas.ponte === null) {
        array.push('Ponte da lente');
      }

      if (medidas.diagonal === undefined || medidas.diagonal === null) {
        array.push('Diagonal da lente');
      }

      if (medidas.od_altura_pupilar === undefined || medidas.od_altura_pupilar === null) {
        array.push('Altura pupilar da lente direita');
      }

      if (medidas.oe_altura_pupilar === undefined || medidas.oe_altura_pupilar === null) {
        array.push('Altura pupilar da lente esquerda');
      }

      if (medidas.od_dnp === undefined || medidas.od_dnp === null) {
        array.push('DNP da lente direita');
      }

      if (medidas.oe_dnp === undefined || medidas.oe_dnp === null) {
        array.push('DNP da lente esquerda');
      }

      if (medidas.diametro === undefined) {
        array.push('Diâmetro');
      }

      return array;
    }

    function validarEspecificaoLente(espc) {
      var array = [];

      if(!espc){
        array.push('Especificações incompletas');
      } else{
        if (espc.cil === undefined || espc.cil === null) {
          array.push('Cil da lente ');
        }

        if (espc.eixo === undefined || espc.eixo === null) {
          array.push('Eixo da lente ');
        }

        if (espc.adicao === undefined || espc.adicao === null) {
          array.push('Adição da lente ');
        }

        if (espc.esferico === undefined || espc.esferico === null) {
          array.push('Esferico da lente ');
        }

        if (espc.prish === undefined || espc.prish === null) {
          array.push('Pris horizontal da lente ');
        }

        if (espc.prish_base === undefined || espc.prish_base === null) {
          array.push('Pris horizontal base da lente ');
        }

        if (espc.prisv === undefined || espc.prisv === null) {
          array.push('Pris vertical da lente ');
        }

        if (espc.prisv_base === undefined || espc.prisv_base === null) {
          array.push('Pris vertical base da lente ');
        }
      }

      return array;
    }

    function setWatches() {
      $scope.$watchCollection('vm.row.tratamento_id', updateTratamento);
      $scope.$watchCollection('vm.enableItracklineCode', updateEnableTratamento);
      $scope.$watchCollection('vm.row.itrack_id', updateITrackLine);
      $scope.$watchCollection('vm.row.material_id', updateMaterial);
      $scope.$watchCollection('vm.row.forma_pagamento_id', updatePagamento);
      $scope.$watchCollection('vm.row.espec_tipo', updateEspec);
      $scope.$watchCollection('vm.row.medidas.largura', updateDiameter);
      $scope.$watchCollection('vm.row.medidas.ponte', updateDiameter);
      $scope.$watchCollection('vm.row.medidas.diagonal', updateDiameter);
      $scope.$watchCollection('vm.row.medidas.od_dnp', updateDiameter);
      $scope.$watchCollection('vm.row.medidas.oe_dnp', updateDiameter);
    }

    function updateDiameter(newValue, oldValue) {
      var dnp = 0;
      var diameter = 2;
      if (newValue !== oldValue) {
        if (vm.row.medidas.largura) {
          diameter += vm.row.medidas.largura
        }

        if (vm.row.medidas.ponte) {
          diameter += vm.row.medidas.ponte
        }

        if (vm.row.medidas.diagonal) {
          diameter += vm.row.medidas.diagonal
        }

        if (vm.row.medidas.od_dnp && vm.row.medidas.oe_dnp) {
          if (vm.row.medidas.od_dnp < vm.row.medidas.oe_dnp) {
            dnp = vm.row.medidas.od_dnp;
          } else {
            dnp = vm.row.medidas.oe_dnp;
          }
          diameter -= dnp * 2;
        }
        vm.row.medidas.diametro = diameter;
      }
    }

    function updateEspec(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue === 'D') {
          vm.isLeftEyeEditable = false;
          vm.isRightEyeEditable = true;
        } else if (newValue === 'E') {
          vm.isRightEyeEditable = false;
          vm.isLeftEyeEditable = true;
        } else {
          vm.isRightEyeEditable = true;
          vm.isLeftEyeEditable = true;
        }

        if (oldValue && !newValue ||
            !oldValue && newValue ||
            newValue && oldValue && newValue.length !== oldValue.length) {
          calculateTotalValue();
        }
      }
    }

    function updatePagamento(newValue, oldValue) {
      if (newValue !== oldValue) {
        calculateTotalValue();
      }
    }

    function updateTratamento(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          vm.tratamento = getSelected(vm.row.produto.tratamentos, newValue);
        } else {
          vm.tratamento = {}
        }
        calculateTotalValue();
      }
    }




    function updateEnableTratamento(newValue, oldValue) {
      if (!newValue) {
        vm.row.itrack_id = null;
        vm.itrackline = null;
      }
    }

    function updateITrackLine(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          vm.itrackline = getSelected(vm.codes, newValue);
          if(vm.itrackline){
            vm.row.itrack = vm.itrackline;
          }
        } else {
          vm.itrackline = null;
          vm.row.itrack = null;
        }
        calculateTotalValue();
      }
    }

    function updateMaterial(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          vm.material = getSelected(vm.row.produto.materiais, newValue);
        } else {
          vm.material = {};
        }
        calculateTotalValue();
      }
    }

    function getSelected(list, id) {
      var data = {
        id: id
      };
      return _.filter(list, data)[0];
    }

    function advaceStage() {
      vm.formStage += 1;
      scrollToNextDiv();
    }

    function scrollToNextDiv() {
      var newHash = 'anchor' + vm.formStage;
      if ($location.hash() !== newHash) {
        $location.hash('anchor' + vm.formStage);
      } else {
        $anchorScroll();
        // TO ADD SMOOTH SCROLL
        // http://jsfiddle.net/brettdewoody/y65G5/
      }
    }

    function isRequestActive() {
      return !vm.row.deleted_at != null && !vm.isNew;
    }

    function isRequestDisabled() {
      return vm.row.deleted_at != null && !vm.isNew;
    }

    function setMeasureValues() {
      setAdicaoValues();
      setCilindrosValues();
      setEixosValues();
      setEsfericosValues();
    }

    function setEsfericosValues() {
      var i = vm.row.produto.esferico_min;
      while (i <= vm.row.produto.esferico_max) {
        vm.esfericos.push(i);
        i += 0.25;
      }
    }

    function setEixosValues() {
      var i = 0;
      while (i <= vm.row.produto.eixo) {
        vm.eixos.push(i);
        i += 1;
      }
    }

    function setCilindrosValues() {
      var i = vm.row.produto.cil_min;
      while (i <= vm.row.produto.cil_max) {
        vm.cilindros.push(i);
        i += 0.25;
      }
    }

    function setAdicaoValues() {
      var i = vm.row.produto.adicao_min;
      while (i <= vm.row.produto.adicao_max) {
        vm.adicaoValues.push(i);
        i += 0.25;
      }
    }

    // Product catalog

    function clearFilter() {
      vm.productFilter = {};
      vm.searchMateriais = [];
    }

    function toogleFilter() {
      vm.filterActive = !vm.filterActive;
    }

    function startFilter() {
      loadProdutos();
    }

    function produtosFromGrupo(grupoID) {
     return vm.produtos.filter(function (produto) {
        return (produto.grupo_id === grupoID && produto.tipo === 'NORMAL')
      })
    }

    function startDiscount() {
      if (vm.row.vl_desconto == null) {
        vm.row.vl_desconto = 0;
      }
    }

    function startRequest() {

      setMeasureValues();
      startDiscount();
    }


    // Loads
    function loadResource(id) {

      Pedido.find(id,  'venda,produto.materiais,produto.tratamentos,produto.cor,itemLonge,itemInterm,itemPerto,voucher,itrack,').then(findRequestSucess);
      enableEdit(vm.row.id);


      function findRequestSucess(response) {

        if (editableStates(response.status)) {
          vm.row = response;

          setStage();
          startRequest();
          if(response.voucher){
            vm.voucherInfo = response.voucher;
          }
          calculateTotalValue();
          vm.isRequestEditable = !(vm.row.id == null || vm.row.id === 0) && editableStates(vm.row.status);
          vm.isRightEyeEditable = vm.row.espec_tipo !== 'E';
          vm.isLeftEyeEditable = vm.row.espec_tipo !== 'D';

          startRequestWithProduct(vm.row.produto_id);


          if(vm.row.produto && vm.row.produto.tipo === 'GRESSIVE'){

            var dataItens = {
              intermediario: response.itemInterm? response.itemInterm : null,
              longe: response.itemLonge? response.itemLonge : null,
              perto: response.itemPerto? response.itemPerto : null,
            };
            vm.defaulItensGressive = dataItens;
          }
        } else {
          PedidoNavigation.set(response.id);
          var data = {
            id: response.id,
            status: 'todos'
          };

          $state.go('xsession.pedido.show', data);
        }

        if(vm.row.adicionais){
          setAditionalByRow()
        }
        loadAllDependencies();
      }
    }

    function setAditionalByRow() {
      vm.additionalsSelected = [];

      if (Array.isArray(vm.row.adicionais)) {
        vm.row.adicionais.forEach(function(adicionalSalvo) {
          var existente = vm.additionals.find(function(a) {
            return a.codigo === adicionalSalvo.codigo;
          });

          if (existente) {
            vm.additionalsSelected.push(existente);
          }
        });
      }
    }

    function loadAllDependencies() {
      loadConstants();



      if (vm.isNew) {
        loadCores();
        loadProdutos();
        loadGrupos();
        // loadTecnologias();
        loadMateriais();
      }

    }

    function loadConstants() {
      vm.frameModels = PedidoConstant.EYEGLASS_FRAME_TYPE;
      vm.frameTypes = PedidoConstant.EYEGLASS_FRAME_MATERIAL;
      vm.prish_base = PedidoConstant.PRIS_HORIZONTAL_BASE_TYPE;
      vm.prisv_base = PedidoConstant.PRIS_VERTICAL_BASE_TYPE;
      vm.prescription_type = PedidoConstant.PRESCRIPTION_TYPE;
    }

    function loadProdutos() {
      vm.productFilter.include = 'grupo,materiais,tratamentos,cor';

      if (vm.searchMateriais.length) {
        vm.productFilter.materiais = '';
        angular.forEach(vm.searchMateriais, function (materialID) {
          vm.productFilter.materiais = vm.productFilter.materiais + materialID + '|';
        });
      }

      PedidoInfo.searchProduto(vm.productFilter).then(function (result) {
        vm.produtos = result;
        vm.gressives = result.filter(function (prod) {
          return prod.tipo === 'GRESSIVE';
        })
      });
    }

    function loadOtica() {
      // var params = {
      //   'include': ',formasPagamento,'
      // };
      var id = 0;

      if ($stateParams.otica_id) {
        id = $stateParams.otica_id;
      } else {
        id = w3Session.get('x_otica_id');
      }

      PedidoInfo.findOtica(id, 'formasPagamento,').then(LoadoticaSucess);

      function LoadoticaSucess(response) {

        if(response.formasPagamento){
          vm.formasPagamento = response.formasPagamento.map(mapPayments);
        }
        vm.row.otica_id = response.id;
        loadAdditionalOtica();
        vm.isOticaAprovada = response.admin_aprovou;
      }

      function mapPayments(item) {
        item.quantidadeParcelas = item.parcelas.split(',').length;
        item.parcelasLabel = '( ' + item.parcelas.split(',').join(' / ') + ' )';
        return item;
      }
    }

    function loadAdditionalOtica(){
      PedidoInfo.getAdditionals()
          .then(function (additionals) {
            console.log('aditionals', additionals);
            vm.additionals = additionals;
          });
    }

    function loadProduto(id) {
      var params = {
        'include': ',materiais,tratamentos,cor,'
      };

      PedidoInfo.findProduto(id, params).then(function (result) {
        vm.row.produto = result;
        // vm.row.tecnologia = vm.row.produto.tecnologia;
        // vm.row.tecnologia_id = vm.row.tecnologia.id;
        vm.row.cor_id = vm.row.produto.cor_id;

        setTratamentos();

        if(!vm.isNew && vm.row.material_id){
          vm.material = vm.row.produto.materiais.find(function (mat) {
            return mat.id === vm.row.material_id;
          })
        }

        if(result.tipo === 'GRESSIVE'){
          vm.row.produto_id = result.id;
        }
        else{
          $scope.$emit('changeProductTotals', {codigo: result.id, preco: result.preco, ref: result.comissao});
        }

        setMeasureValues();
        calculateTotalValue();

      });
    }

    function loadCores() {
      PedidoInfo.allCor().then(function (result) {
        vm.cores = result;
      });
    }

    function loadGrupos() {
      PedidoInfo.allGrupos().then(function (result) {
        vm.grupos = result;
        angular.forEach(vm.grupos, function (grupo) {
          grupo.show = "true";
        });
      });
    }

    // function loadTecnologias() {
    //   PedidoInfo.allTecologia().then(function (result) {
    //     vm.tecnologias = result;
    //   });
    // }

    function loadMateriais() {
      PedidoInfo.allMaterial().then(function (result) {
        vm.materiais = result;
      });
    }

    function startRequestWithProduct(produtoID) {
      vm.row.produto_id = produtoID;
      loadProduto(produtoID);
      vm.productSelected = true;
    }

    function calculateTotalValue() {
      var total = 0.0;
      var descontoObj = 0.0;
      var refTratamento = 0;
      var refMaterial = 0;
      var refProduto = 0;
      var subTotalRef = 0;
      var subAdittionals = 0;

      if(!vm.row.produto){return;}

      total = total + vm.precoProduto;
      refProduto = +vm.row.produto._ref;

      if (vm.tratamento && vm.tratamento.id) {
        total += +vm.tratamento.preco;
        refTratamento = +vm.tratamento._ref || 0;
      }

      if (vm.material && vm.material.id) {
        total += +vm.material.preco;
        refMaterial = +vm.material._ref || 0;
      }
      if (vm.itrackline && vm.itrackline.id) {
        total += +vm.itrackline.preco;
        refMaterial = +vm.itrackline._ref || 0;
      }

      if(vm.additionalsSelected.length > 0){
        subAdittionals = vm.additionalsSelected.reduce(function(total, item) {
          return total + item.valor;
        }, 0);
        total += +subAdittionals;
      }

      // CALCULE TOTALS
      subTotalRef = refTratamento + refMaterial + refProduto;
      if (vm.row.espec_tipo === 'E' || vm.row.espec_tipo === 'D') {
        total = total / 2;
        vm.totalRef = subTotalRef / 2;
      } else{
        vm.totalRef = subTotalRef;
      }



      if(vm.row.forma_pagamento_id){
        descontoObj = getDesconto(vm.row.forma_pagamento_id);
      }

      if(vm.voucherInfo){
        vm.decontoPoncentagem = +vm.voucherInfo.desconto_percent;
        vm.acrescimoPoncentagem = descontoObj.acrescimo;
        vm.row.vl_desconto = (total * vm.decontoPoncentagem / 100.00).toFixed(2);
        vm.row.vl_acrescimo = (total * vm.acrescimoPoncentagem / 100.00).toFixed(2);
      } else if (vm.row.forma_pagamento_id != null && !vm.row.codigo_voucher) {
        vm.decontoPoncentagem = descontoObj.desconto;
        vm.acrescimoPoncentagem = descontoObj.acrescimo;
        vm.row.vl_desconto = (total * vm.decontoPoncentagem / 100.00).toFixed(2);
        vm.row.vl_acrescimo = (total * vm.acrescimoPoncentagem / 100.00).toFixed(2);
      } else {
        vm.decontoPoncentagem = 0;
        vm.acrescimoPoncentagem = 0;
        vm.row.vl_desconto = 0.0;
        vm.row.vl_acrescimo = 0.0;
      }

     // SET TOTALS
      vm.row.vl_total_desconto = total - +vm.row.vl_desconto + +vm.row.vl_acrescimo;
      vm.row.vl_total = total;
    }

    function isPrescriptionValid() {
      var isValid = false;
      if (vm.row.espec_od && vm.row.espec_oe) {
        switch (vm.row.espec_tipo) {
          case 'D':
            isValid = isEyePrescriptionValid(vm.row.espec_od);
            break;
          case 'E':
            isValid = isEyePrescriptionValid(vm.row.espec_oe);
            break;
          case 'DE':
            isValid = isEyePrescriptionValid(vm.row.espec_oe) && isEyePrescriptionValid(vm.row.espec_od);
            break;
        }
      }

      return isValid;
    }

    function isEyePrescriptionValid(prescription) {
      var requiredKeys = [];
      // var requiredKeys = [
      //   'esferico',
      //   'cil',
      //   'eixo',
      //   'adicao',
      //   'prish',
      //   'prisv'];

      // if (prescription.prish) {
      //   requiredKeys.push('prish_base');
      // }
      //
      // if (prescription.prisv) {
      //   requiredKeys.push('prisv_base');
      // }

      return _.every(requiredKeys, _.partial(_.has, prescription));
    }

    // State change and Modifiers: save, edit, remove...

    function enableEdit(id) {
      vm.isNew = false;
      ID = id;
    }

    function sendRequestToPolo() {
      vm.row.sendToPolo = true;
      save();
    }

    function getDesconto(id) {
      var desconto = vm.formasPagamento.filter(discountFilter);
      if (desconto.length) {
        return desconto[0];
      } else {
        return null;
      }

      function discountFilter(el) {
        return el.id === id;
      }
    }

    function save() {
      var resource = {};
      vm.row.status = vm.row.status? vm.row.status : "RASCUNHO";
      if (vm.row.espec_tipo === 'E') {
        vm.row.espec_od = {}
      } else if (vm.row.espec_tipo === 'D') {
        vm.row.espec_oe = {}
      }
      angular.copy(vm.row, resource);

      if(!vm.enableItracklineCode){
        resource.itrack_id = null;
        resource.itrack_code = '';
        resource.itrack = {};
      }

      if (vm.additionalsSelected.length > 0) {
        resource.adicionais = angular.copy(vm.additionalsSelected);
        vm.row.adicionais = angular.copy(vm.additionalsSelected); // se quiser manter vm.row.adicionais atualizado também
      } else {
        vm.row.adicionais = null;
        resource.adicionais = null;
      }

      if(!vm.hasCorteRemoto()){
        resource.file_corte_remoto_src = null;
        resource.file_corte_remoto = null;
        vm.row.file_corte_remoto_src = null;
        vm.row.file_corte_remoto = null;
      }

      if (vm.isNew) {
        create(resource);
      } else {
        update(resource);
      }
    }

    function create(resource) {
      // mytodo: apagar esta parte depois q decidir com o valmir como vai ficar o tratamento da regra q exige q vl total seja 1
      if(resource.tipo === 'GRESSIVE' && resource.vl_total === 0){
        resource.vl_total= 1;
      }
      delete resource.produto;
      Pedido.save(resource).then(saveSucess);

      function saveSucess(result) {
        if (resource.sendToPolo) {
          Pedido.sendRequestFromOticaToPolo(result.id).then(updateStatusSucess);
        } else {
          updateStatusSucess(result);
        }
      }

    }

    function editableStates(status) {
      return status === 'RASCUNHO' || status === 'AGUARDANDO_POLO';
    }

    function updateStatusSucess(result) {
      var data = {
        id: result.id
      };
      if (w3Session.get('x_otica_id')) {
        if ( editableStates (result.status)) {
          if (vm.row.id === undefined) {
            $state.go('xsession.pedido.edit', data);
          }
        } else {
          PedidoNavigation.set(result.id);
          data.status = 'todos';
          $state.go('xsession.pedido.show', data);
        }
      } else if (w3Session.get('x_polo_id')) {
        $state.go('xsession.pedido');
      }
    }

    function update(resource) {
      Pedido.update(resource.id, resource).then(updateSucess);

      function updateSucess(result) {
        if (resource.sendToPolo) {
          Pedido.sendRequestFromOticaToPolo(result.id).then(updateStatusSucess);
        } else {
          updateStatusSucess(result);
        }
      }
    }

    function cancelConfirm(ev) {
      Pedido.showCancelDialog('OTICA', vm.row, ev).then(function (result) {
        if (result) {
          goArchive();
        }
      });
    }

    function goArchive() {
      $state.go('xsession.pedido');
    }

    function select() {
      PedidoNavigation.set(vm.row.id);
      $state.go('xsession.pedido.show');
    }

    function showDetail(id, tipo) {
      Pedido.showDetailDialog(id, tipo);
    }

    function showDetailITrackLine(id, tipo) {
      showDetail(vm.row.itrack_id, 'ITRACKLINE');
    }

    function makeValueParcela(formaPagamento) {
      var callc = +( ( vm.row.vl_total - (vm.row.vl_total * formaPagamento.desconto / 100.00)+(vm.row.vl_total * formaPagamento.acrescimo / 100.00)) /
          formaPagamento.quantidadeParcelas ).toFixed(2);
      return callc;
    }

    function makeParcelaLabel(formaPagamento) {
        var diff = formaPagamento.acrescimo - formaPagamento.desconto;
        var labelDiff = '- ' + formaPagamento.desconto || formaPagamento.acrescimo ? diff +'%' : '';

        return formaPagamento.quantidadeParcelas + ' x vezes de R$' + makeValueParcela(formaPagamento) + '(' + formaPagamento.parcelasLabel + ')' + labelDiff + '~' + formaPagamento.nome
    }

    function validateVoucher(){

      // vm.codigoVoucher = '';
      vm.voucherErrorMsg = '';
      // vm.voucherInfo;


      var inputr = {
        codigo: vm.codigoVoucher,
        produto_id: vm.row.produto.id
      }

      Pedido.validateVoucher(inputr).then(function (result){
        if(result.status === 'error'){
          vm.voucherErrorMsg = result.message;
          vm.voucherInfo = '';
          vm.row.codigo_voucher = ''
        } else {
          vm.voucherInfo = Object.assign(result.data, {label: result.message })
          vm.row.codigo_voucher = vm.voucherInfo.codigo;
        }

        calculateTotalValue();

      }, function (error){
        vm.voucherErrorMsg = error.message;
        vm.voucherInfo = '';
        vm.row.codigo_voucher = '';
      })
    }

    function clearVoucherCode(){
      vm.codigoVoucher = '';
      vm.voucherErrorMsg = '';
      vm.voucherInfo = '';
      vm.row.codigo_voucher = '';

      calculateTotalValue();
    }

    function removeVoucher(){
      if(vm.row.id){
        Pedido.desvincularVoucher(vm.row.id).then(function (result){
          console.log('removeVoucher', result)
        })
      }

      clearVoucherCode();
    }

    function enableRemoveVoucher (){
      return !vm.row.id || vm.row.status === 'RASCUNHO' || vm.row.status === 'AGUARDANDO_POLO';
    }

    function removeRemoteFile(){
      this.row.file_corte_remoto = '';
      this.row.file_corte_remoto_src = '';
    }


   function isAdditionalSelected(additional) {
      return vm.additionalsSelected.some(function(item) {
        return item.codigo === additional.codigo;
      });
    };

    function toggleAdditional(additional) {
      var index = vm.additionalsSelected.findIndex(function(item) {
        return item.codigo === additional.codigo;
      });

      if (index === -1) {
        vm.additionalsSelected.push(additional);
        calculateTotalValue();
      } else {
        vm.additionalsSelected.splice(index, 1);
        calculateTotalValue();
      }
    };


    function hasCorteRemoto() {
      return Array.isArray(vm.additionalsSelected) && vm.additionalsSelected.some(function(item) {
        return item.codigo === 'corte_remoto';
      });
    };

  }

})();

(function() {
  'use strict';

  angular
    .module('commons.pedido')
    .controller('PedidoByStatusController', PedidoByStatusController);

  /** @ngInject */
  function PedidoByStatusController(
    $filter,
    $scope,
    $state,
    $stateParams,
    Pedido,
    PedidoNavigation,
    w3Config) {
    var vm = this;

    // Data
    vm.activeRequestObj = {};
    vm.loaded = false;
    vm.stopWatchingStatus = null;
    // vm.haveRequest =
    vm.pagination = {};
    vm.navigationInfo = {
      'index': 0,
      'total': 0
    };

    vm.params = {};
    var defaultParams = {
      'paginate': 1,
      'include': 'venda,vendedor,material,tratamento,laboratorio.city.state,polo.city.state,otica.city.state,produto.cor,formaPagamento,itemLonge,itemInterm,itemPerto,voucher,itrack'
    };

    // Methods
    vm.goArchive = goArchive;
    vm.goToNextRequest = goToNextRequest;
    vm.goToPreviousRequest = goToPreviousRequest;
    vm.isFirstRequest = isFirstRequest;
    vm.isLastRequest = isLastRequest;
    vm.isListEmpty = isListEmpty;
    vm.isUserAdmin = isUserAdmin;
    vm.isUserOtica = isUserOtica;
    vm.isUserLab = isUserLab;
    vm.isUserPolo = isUserPolo;


    activate();

    //-----------------------

    function activate() {
      if ($stateParams.filter) {
        angular.extend(defaultParams, $stateParams.filter, defaultParams);
      }
      vm.params = angular.copy(defaultParams);
      search($stateParams.status);
    }

    function isUserOtica() {
      return w3Config.get('module') === 'optical_shop';
    }

    function isUserAdmin() {
      return w3Config.get('module') === 'admin';
    }

    function isUserPolo() {
      return w3Config.get('module') === 'polo';
    }

    function isUserLab() {
      return w3Config.get('module') === 'laboratory';
    }

    function isListEmpty() {
      return vm.pagination.total === 0;
    }

    function isLastRequest() {
      return vm.pagination.current_page >= (vm.pagination.total);
    }

    function isOnlyOneRequest() {
      return vm.pagination.total === 1;
    }

    function isFirstRequest() {
      return vm.pagination.current_page <= 1;
    }

    function setPage(p) {
      Pedido.setPage(p);
      activate();
    }

    function goArchive() {
      $state.go('xsession.pedido');
    }

    function goToNextRequest() {
      if (!isLastRequest()) {
        vm.stopWatchingStatus();
        setPage(vm.pagination.current_page + 1);
      }
    }

    function goToPreviousRequest() {
      if (!isFirstRequest()) {
        vm.stopWatchingStatus();
        setPage(vm.pagination.current_page - 1);
      }
    }

    function updateNavigationInfo() {
      vm.navigationInfo.index = vm.pagination.current_page;
      vm.navigationInfo.total = vm.pagination.total;
    }

    function setSelectedPage(list) {
      var id = PedidoNavigation.get();
      var idx = list.map(mapID).filter(isFinite)[0];
      console.log("setSelectedPage", {id: id, idx: idx, list: list});
      vm.loaded = true;

      if (idx) {
        setPage(idx + 1);
      } else {
        activate();
      }

      function mapID(item, index) {
        if (item.id == id) {
          return index;
        }
      }
    }

    function search(status) {
      var params = {};

      if (vm.loaded) {
        params = vm.params;
      } else{
        angular.copy($stateParams.filter, params);
        params.navigation = 1;
      }

      if (status !== null && status !== 'todos') {
        params.status = $filter('uppercase')(status);
      }

      console.log('search', status, params);

      Pedido.search(params).then(searchSuccess);

      function searchSuccess(response) {
        if (vm.loaded) {
          vm.pagination = Pedido.pagination;
          vm.activeRequestObj = formatRequest(response[0]);
          updateNavigationInfo();
          vm.stopWatchingStatus = $scope.$watch('vm.activeRequestObj.status', statusChanged);
        } else {
          setSelectedPage(response);
        }
      }

      function formatRequest(request) {
        // request.material_armacao_label = request.material_armacao.slice(0,1) + request.material_armacao.slice(1).toLowerCase();
        request.formaPagamento = formatPayments(request.formaPagamento);
        return request;
      }

      function formatPayments(item) {
        if(!item || !item.parcelas || !item.parcelas.length){
          return;
        }
        item.quantidadeParcelas = item.parcelas.split(',').length;
        item.parcelasLabel = '( ' + item.parcelas.split(',').join(' / ') + ' )';
        item.tipoLabel = item.tipo[0].toUpperCase() + item.tipo.slice(1).toLowerCase();
        return item;
      }
    }

    function callNextRequestOnStatusChange() {
      var page = vm.pagination.current_page;
      if (isLastRequest()) {
        page -= 1;
        setPage(page);
      } else {
        activate();
      }
    }

    function statusChanged(newValue, oldValue) {
      if (_.toLower(newValue) != _.toLower($stateParams.status) && newValue != oldValue && newValue != null && oldValue != null) {
        vm.stopWatchingStatus();
        if (!isOnlyOneRequest()) {
          callNextRequestOnStatusChange();
        } else {
          $state.go('xsession.pedido', {
            'status': _.toLower(oldValue)
          });
        }
      }
    }


  }

})();

(function () {
  'use strict';

  angular
      .module('commons.pedido')
      .controller('PedidoByStatusListController', PedidoByStatusListController);

  /** @ngInject */
  function PedidoByStatusListController($filter,
                                        $state,
                                        $stateParams,
                                        $mdDialog,
                                        Pedido,
                                        PedidoInfo,
                                        PedidoConstant,
                                        PedidoNavigation,
                                        NavigationDialog,
                                        w3Config,
                                        w3Session
                                        ) {
    var vm = this;

    vm.archive = [];
    vm.sellers = [];
    vm.searchSellerInput = '';
    vm.listPedido = {};
    vm.loaded = false;
    vm.oticas = [];
    vm.pagination = {};
    vm.params = {};
    vm.polos = [];
    vm.produtos = [];
    vm.selectedStatus = [];
    vm.status = [];
    var defaultParams = {
      'include': ',vendedor,material,tratamento,laboratorio,polo,otica,produto.cor,formaPagamento,itrack,',
      'paginate': 100,
      'sort': '-id'
    };

    // Methods
    vm.clearFilter = clearFilter;
    vm.isActived = isActived;
    vm.isAllRequests = isAllRequests;
    vm.isDisabled = isDisabled;
    vm.isUserAdmin = isUserAdmin;
    vm.isUserOtica = isUserOtica;
    vm.isUserPolo = isUserPolo;
    vm.isUserLab = isUserLab;
    vm.search = search;
    vm.select = select;
    vm.setPage = setPage;
    vm.startFilter = startFilter;
    vm.cancelConfirm = cancelConfirm;

    activate();

    //-----------------------

    function activate() {
      vm.params = angular.copy(defaultParams);
      search($stateParams.status);
      setRequestType();
      loadFilter();

      checkHasDialogNotification();
    }


    // myTodo: mensagem de notificação
    function checkHasDialogNotification(){

      // remember: sempre que a notificação mudar alterar essa variável
      var NOTIFICATION_KEY = 'viewedNotification-BannerTopo';

      if(w3Config.get('module') !== 'optical_shop' || w3Session.get(NOTIFICATION_KEY)){
        console.log('Not notification context');
        return;
      }

      NavigationDialog.findDialog().then(function(dialogData){
        if(dialogData){
          showDialogNotification(dialogData, NOTIFICATION_KEY);
        }
      
      }, function(){
        console.log('Not has notification');
        return;
      })
    }


    function showDialogNotification(data, NOTIFICATION_KEY){
      var dialog = {
        controller: 'NotificationDialog',
        controllerAs: 'vm',
        templateUrl: '/app/external/notification_dialog/notification_dialog.html',
        clickOutsideToClose: true,
        locals: {
          title: data.title,
          content: data.content
        }
      };

      $mdDialog.show(dialog).then(onConfirm);
      
      function onConfirm() {
        w3Session.set(NOTIFICATION_KEY, true);
      }
    }

    function formatData(date) {
      var month = date.getUTCMonth() + 1; //months from 1-12
      var day = date.getUTCDate();
      var year = date.getUTCFullYear();

      if (month < 10) {
        month = '0' + month;
      }

      if (day < 10) {
        day = '0' + day;
      }

      return year + "-" + month + "-" + day;
    }

    function formatFilterData() {
      if (vm.params.dt_column != null) {
        if (vm.params.dt_obj_start != null) {
          vm.params.dt_start = formatData(vm.params.dt_obj_start);
        }

        if (vm.params.dt_obj_end != null) {
          vm.params.dt_end = formatData(vm.params.dt_obj_end);
        }
      }

      if (vm.selectedStatus.length !== 0) {
        vm.params.status = _.join(vm.selectedStatus, '|');
      }
    }

    function startFilter() {
      formatFilterData();
      search($stateParams.status);
    }

    function isUserOtica() {
      return w3Config.get('module') === 'optical_shop';
    }

    function isUserAdmin() {
      return w3Config.get('module') === 'admin';
    }

    function isUserPolo() {
      return w3Config.get('module') === 'polo';
    }

    function isUserLab() {
      return w3Config.get('module') === 'laboratory';
    }

    function setRequestType() {
      switch ($stateParams.status) {
        case 'rascunho':
          vm.listPedido.type = "em Rascunho";
          vm.listPedido.description = "Pedidos ainda não enviados para a polo";
          break;
        case 'aguardando_polo':
          vm.listPedido.type = "Pendentes";
          vm.listPedido.description = "Pedidos requisitados pelas óticas e que ainda não foram aceitos";
          break;
        case 'aguardando_admin':
          vm.listPedido.type = "Pendentes";
          vm.listPedido.description = "Pedidos requisitados pelas polos e que ainda não foram aceitos";
          break;
        case 'aguardando_lab':
          vm.listPedido.type = "Pendentes";
          vm.listPedido.description = "Pedidos requisitados pelo admin e que ainda não foram aceitos";
          break;
        case 'executando_lab':
          vm.listPedido.type = "em Produção";
          vm.listPedido.description = "Pedidos aceitos e atualmente em fabricação ou aguardando serem entregues ao admin.";
          break;
        case 'envio_admin':
          vm.listPedido.type = "a Entregar";
          vm.listPedido.description = "Pedidos finalizados recebidos pelos laboratórios e ainda não entregues para a polo";
          break;
        case 'envio_polo':
          vm.listPedido.type = "a Entregar";
          vm.listPedido.description = "Pedidos finalizados recebidos pelo admin e ainda não entregues para a ótica";
          break;
        case 'envio_otica':
          vm.listPedido.type = "Recebidos";
          vm.listPedido.description = "Pedidos finalizados recebidos pela polo e ainda finalizados";
          break;
        default:
      }
    }

    function isAllRequests() {
      return $stateParams.status === 'todos' || $stateParams.status == null;
    }

    function loadFilter() {
      loadProdutos();
      laodSellers();
      if (isAllRequests()) {
        loadStatus();
      }
      if (isUserAdmin()) {
        loadPolos();
        loadOticas();
      }
    }

    function clearFilter() {
      vm.searchActive = false;
      vm.params = angular.copy(defaultParams);
      vm.searchSellerInput = '';
      search();
    }

    function laodSellers() {
      var otica_id = w3Session.get('x_otica_id');
      Pedido.getSellers(otica_id).then(loadSellersSucess);

      function loadSellersSucess(response) {
        vm.sellers = response;
      }
    }

    function loadStatus() {
      if (isUserAdmin()) {
        vm.status = PedidoConstant.REQUEST_STATUS;
      } else if (isUserOtica()) {
        vm.status = PedidoConstant.REQUEST_STATUS_OTICA;
      } else if (isUserPolo()) {
        vm.status = PedidoConstant.REQUEST_STATUS_POLO;
      }
    }

    function loadProdutos() {
      PedidoInfo.searchProduto().then(loadSucess);

      function loadSucess(response) {
        vm.produtos = response;
      }
    }

    function loadPolos() {
      PedidoInfo.allPolo().then(loadSucess);

      function loadSucess(response) {
        vm.polos = response;
      }
    }

    function loadOticas() {
      PedidoInfo.allOtica().then(loadSucess);

      function loadSucess(response) {
        vm.oticas = response;
      }
    }

    function select(id) {
      var data = {};
      var dataToPick = [
        'dt_end',
        'dt_start',
        'produto_id',
        'q',
        'status',
        'user_id'
      ];

      formatFilterData();
      data.filter = _.pick(vm.params, dataToPick);
      PedidoNavigation.set(id);
      $state.go('xsession.pedido.show', data);
    }

    function getIdx(id, list) {
      return list.filter(requestfilter)[0];

      function requestfilter(item, index) {
        item.index = index;
        return item.id === id;
      }
    }

    function isActived() {
      return !isRequestDeleted();
    }

    function isDisabled() {
      return isRequestDeleted();
    }

    function setPage(p) {
      Pedido.setPage(p);
      activate();
    }

    function search(status) {
      if (!vm.loaded && Pedido.pagination !== null) {
        vm.loaded = true;
        setPage(1);
      } else {
        vm.loaded = true;
        if (status !== null && status !== 'todos') {
          vm.params.status = $filter('uppercase')(status);
        }

        Pedido.search(vm.params).then(searchSucess);
      }

      function searchSucess(response) {
        vm.archive = response.map(mapRequests);
        vm.pagination = Pedido.pagination;
      }

      function mapRequests(item) {
        if (item.formaPagamento){
          item.formaPagamento = formatPayments(item.formaPagamento);
        }
        return item;
      }

      function formatPayments(item) {
        item.quantidadeParcelas = item.parcelas.split(',').length;
        item.parcelasLabel = '( ' + item.parcelas.split(',').join(' / ') + ' )';
        item.tipoLabel = item.tipo[0].toUpperCase() + item.tipo.slice(1).toLowerCase();
        return item;
      }
    }

    function cancelConfirm(ev, item) {
      Pedido.showCancelDialog('ADMIN', item, ev).then(function (result) {
        if (result) {
          activate();
        }
      });
    }
  }

})();

(function () {
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
            .module('rapi.w3')
            .run(runBlock);


    /** @ngInject */
    function runBlock($rootScope, w3Auth)
    {
        $rootScope.$on('w3HttpInterceptor:loginRequired', function () {
            w3Auth.setToken(null);
        });
    }

})();
(function () {
    'use strict';

    angular
            .module('rapi.w3')
            .config(w3Config);


    /** @ngInject */
    function w3Config($httpProvider, toastrConfig, w3HttpInterceptorProvider) {

        toastrConfig.allowHtml = true;


        $httpProvider.interceptors.push('w3HttpInterceptor');
        $httpProvider.defaults.useXDomain = true;
        $httpProvider.defaults.withCredentials = false;
        $httpProvider.defaults.headers.common['Content-Type'] = 'application/json';



        w3HttpInterceptorProvider.tokenGetter = ['w3Auth', function (w3Auth) {
                return w3Auth.getToken();
            }];

        //var host = w3ConfigProvider.getConfig('host');
        //console.log('W#@', host);
        //w3HttpInterceptorProvider.prependHeaders = host.headers;
    }


})();

//mytodo importar w3Config do rapi fuse
(function () {
    'use strict';

    angular
            .module('rapi.w3.config', [])
            .provider('w3Config', w3ConfigProvider);

    /** @ngInject */
    function w3ConfigProvider() {

        // Default configuration
        var w3Configuration = {
            'welcome': 'Bem vindo ao Demo Rapi Fuse',
            'welcome_text': "Texto de boas vindas explicando o que é o Demo Rapi Fuse",
            'bg_auth': '/assets/images/backgrounds/march.jpg',
            'logo': null,
            'sigla': 'M',
            'menuOpenFrom': 'gt-xs',
            'title_project': 'Title',
            'access_permission_to_module': null,
            'sample_profile': false,
            'host': {
                'baseUrl': '',
                'baseUrlApi': '/api/v1',
                'appUrl': null,
                'baseModule' : null,
                'env': 'local',                
                'headers' : {}
            },
            'layout': {
                //verticalNavigation, verticalNavigationFullwidthToolbar, verticalNavigationFullwidthToolbar2, horizontalNavigation, contentOnly, contentWithToolbar
                'theme': 'verticalNavigation'
            },
            'upload': {
                'token': null,
                'url': null,
                'params': {
                    //'owner_type': 'LDM\\Casal\\Casal',
                    //'owner_id': null,
                    'gallery': null
                }
            },
            'auth': {
                'routeSuccess': 'app.dashboard',
                'type': null,
                'onLoginRequired': function () {
                    window.location = '#!/auth/login';
                }
            },
            'rollbar':{
                'activeOnEnvironments': [],
                'token': null,
                'ignoredHttpCodes': [],
                'ignoredCodes': [],
                'ignoredMessages': [],
                'overrideIgnoredMessages' : false,
                'overrideIgnoredHttpCodes' : false,
                'overrideIgnoredCodes' : false
            }
        };

        // Methods
        this.config = config;
        this.getConfig = getConfig;
        this.configHost = configHost;
        this.configAuth = configAuth;
        this.configUpload = configUpload;
        this.configLayout = configLayout;

        //PLUGIN
        this.plugins = {};
        this.makePlugin = makePlugin;
        this.addPluginProvider = addPluginProvider;
        this.plugin = getPlugin;
        this.configPlugin = configPlugin;//@deprected
        this.addPlugin = addPlugin;//@deprected


        //----------------------------------

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            w3Configuration = angular.extend({}, w3Configuration, configuration);
        }

        function configHost(configValue)
        {
            angular.extend(w3Configuration.host, configValue);
        }

        function configAuth(configValue)
        {
            angular.extend(w3Configuration.auth, configValue);
        }

        function configLayout(configValue)
        {
            angular.extend(w3Configuration.layout, configValue);
        }

        function configUpload(configValue)
        {
            angular.extend(w3Configuration.upload, configValue);
        }

        /**
         * Returns a config value
         */
        function getConfig(configName, defaul)
        {

            if (angular.isUndefined(w3Configuration[configName])) {
                return defaul;
            }

            return w3Configuration[configName];
        }

        /*
         *  ============ PLUGINS  ===================
         */

        /**
         * @deprecated
         *
         * //mytodo in deprecated desativar addPlugin
         */
        function configPlugin(namePlugin, configValue)
        {
            angular.extend(w3Configuration[namePlugin], configValue);
            throw "configPlugin is deprecated use ..";
        }

        /**
         * @deprecated
         *
         * //mytodo in deprecated desativar addPlugin
         */
        function addPlugin(namePlugin, configValue)
        {
            w3Configuration[namePlugin] = configValue;
            throw "addPlugin is deprecated use addPluginProvider";
        }

        /**
         * Retorna uma instancia do PluginProvider
         *
         * @returns {w3-config_provider_L2.w3ConfigProvider.PluginProvider}
         */
        function makePlugin(name)
        {
            return new PluginProvider(name);
        }

        /**
         * Ativa o plugin no w3Config
         *
         * @param  PluginProvider
         */
        function addPluginProvider(fn)
        {
            var name = fn.getName();
            this.plugins[name] = fn;
        }

        /**
         * Retorna o plugin
         *
         * @param string name
         * @return PluginProvider
         */
        function getPlugin(name)
        {
            var pl = this.plugins[name];

            if (angular.isUndefined(pl)) {
                throw "Plugin não encontrado";
            }

            return pl;
        }

        /**
         * Func. contruturora de plugins
         */
        function PluginProvider(name)
        {
            this.name = name;
            this.vm = this;
            this.info = {
                tutorial: 'Plugin Sem tutorial'
            };
            this.getConfig = getConfig;
        }

        PluginProvider.prototype = {
            getName: function () {
                return this.name;
            },
            tutorial: function () {
                window.console.info(this.info.tutorial);
                return this.vm;
            },
            setTutotial: function (textTutorial) {
                this.info.tutorial = angular.isArray(textTutorial) ? textTutorial.join("\n") : textTutorial;
                return this.vm;
            }
        };



        /**
         * Service
         */
        this.$get = function () {

            var service = {
                get: getConfig,
                set: setConfig,
                setConfigHost: setConfigHost,
                getConfigHost: getConfigHost
            };

            return service;

            //////////

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue) {
                w3Configuration[configName] = configValue;
            }

            function setConfigHost(configValue) {
                angular.extend(w3Configuration.host, configValue);
            }

            function getConfigHost() {
                return w3Configuration.host;
            }

        };
    }


})();

/* global moment */

function strPad(value, length)
{
    length = length || 2;
    var pad = "000000";
    return (pad + value.toString()).slice(-length);
}

Date.prototype.addDays = function (days)
{
    this.setDate(this.getDate() + days);
    return this;
};

Date.prototype.addMinutes = function (min)
{
    min = min || 0;
    min = this.getMinutes() + min;
    this.setMinutes(min);
    return this;
};

Date.prototype.getFormatedTime = function ()
{
    return [
        strPad(this.getHours( )),
        strPad(this.getMinutes())
    ].join(':');
};


moment.fn.toDateBR = function () {
    return new Date(this.year(), this.month(), this.date(), this.hour(), this.minute(), this.second(), this.millisecond());
};


Array.prototype.sum = function (prop) {
    var total = 0;
    for (var i = 0, _len = this.length; i < _len; i++) {
        total += this[i][prop];
    }
    return total;
};

/**
 * Transform tring to slug
 * @param {string} 
 * @returns {slug}
 */
function slugify(text)
{
    return text.toString().toLowerCase()
            .replace(/\s+/g, '-')           // Replace spaces with -
            .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
            .replace(/\-\-+/g, '-')         // Replace multiple - with single -
            .replace(/^-+/, '')             // Trim - from start of text
            .replace(/-+$/, '');            // Trim - from end of text
}
(function () {
  'use strict';

  angular
    .module('commons.providers', [])
    .config(config);

  /** @ngInject */
  function config() {
  }
})();

(function () {
    'use strict';

    angular
            .module('commons.providers')
            .factory('Tratamento', TratamentoService);


    /** @ngInject */
    function TratamentoService(w3Resource, $http, w3Utils) {

        var urlApi = '/tratamentos';

        var service = {
            disable: disable,
            restore: restore,
            find: find
        };

        return w3Resource.extend(urlApi, service);

        //----------------------------------

        function find(id, params)
        {
            var data = {
                params: params
            };

            return $http.get(w3Utils.urlApi( urlApi + '/{id}', {id: id}), data).then(function (result) {
                return result.data.data;
            });
        }

        function disable(id)
        {
            return $http.put(w3Utils.urlApi(urlApi + '/{id}/disable', id)).then(function (result) {
                return (result.data.status === 'success') ? result.data.data : false;
            });
        }

        function restore(id)
        {
            return $http.put(w3Utils.urlApi( urlApi + '/{id}/restore', id)).then(function (result) {
                return (result.data.status === 'success') ? result.data.data : false;
            });
        }


    }

})();

(function () {
    'use strict';

    angular
            .module('commons.providers')
            .factory('Produto', ProdutoService);


    /** @ngInject */
    function ProdutoService(w3Resource, $http, w3Utils) {

        var urlApi = '/produtos';

        var service = {
            disable: disable,
            restore: restore,
            find: find
        };

        return w3Resource.extend(urlApi, service);

        //----------------------------------

        function find(id, params)
        {
            var data = {
                params: params
            };

            return $http.get(w3Utils.urlApi( urlApi + '/{id}', {id: id}), data).then(function (result) {
                return result.data.data;
            });
        };

        function disable(id)
        {
            return $http.put(w3Utils.urlApi(urlApi + '/{id}/disable', id)).then(function (result) {
                return (result.data.status === 'success') ? result.data.data : false;
            });
        }

        function restore(id)
        {
            return $http.put(w3Utils.urlApi( urlApi + '/{id}/restore', id)).then(function (result) {
                return (result.data.status === 'success') ? result.data.data : false;
            });
        }


    }

})();

(function() {
  'use strict';

  angular
    .module('commons.providers')
    .factory('Material', MaterialService);


  /** @ngInject */
  function MaterialService($mdDialog, w3Resource) {

    var urlApi  = '/materiais';

    var service = {};

    return w3Resource.extend(urlApi, service);

  }

})();

(function () {
    'use strict';

    angular
        .module('commons.providers')
        .factory('Impressora', ImpressoraService);


    /** @ngInject */
    function ImpressoraService($mdDialog, $http, w3Utils) {

        var service = {
            openConfigPrintDialog: openConfigPrintDialog,
            loadPrints: loadPrints,
            printTest: printTest,
            print: print,
            printByTemplate: printByTemplate
        };

        return service;

        // ///////////////////////////////

        // DIALOGS
        function openConfigPrintDialog(ev) {
            return $mdDialog.show({
                controller: 'ConfigurarImpressoraDialogController',
                controllerAs: 'vm',
                templateUrl: '/app/external/impressora/dialogs/configurar-impressora-dialog.html',
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }

        function loadPrints(host) {
            var url = host + '/api/v1/printer';

            return $http.get(url, {timeout: 4000}).then(function (result) {
                return result.data;
            });
        }

        function getLinesByTemplate(host, template, pedido_id) {
            var url =  '/printer/template';

            return $http.post(w3Utils.urlApi(url), {template: template, pedido_id: pedido_id}).then(function (result) {
                return result.data.data.lines;
            });
        }

        function printTest(host, printName) {
            return getLinesByTemplate(host, 'test', null).then(function (lines) {
                return print(host, printName, lines, null);
            });
        }

        function printByTemplate(host, printName, template, pedidoId) {
            return getLinesByTemplate(host, template, pedidoId).then(function (lines) {
                return print(host, printName, lines, pedidoId);
            });
        }

        function print(host, printName, lines, pedidoId) {
            var url = host + '/api/v1/printer';

            return $http.post(url, {printName: printName, pedido_id: pedidoId, lines: lines}).then(function (result) {
                return result.data;
            });
        }
    }

})();

(function () {
    'use strict';

    angular
            .module('commons.providers')
            .factory('Gressive', GressiveService);


    /** @ngInject */
    function GressiveService(w3Resource, $http, w3Utils) {

        var urlApi = '/items';

        var service = {
            find: find
        };

        return w3Resource.extend(urlApi, service);

        //----------------------------------

        function find(id, params)
        {
            var data = {
                params: params
            };

            return $http.get(w3Utils.urlApi( urlApi + '/{id}', {id: id}), data).then(function (result) {
                return result.data.data;
            });
        };

    }

})();

(function ()
{
    'use strict';

    angular
        .module('commons.notification_dialog', []);
})();

(function() {
    'use strict';
  
    angular
      .module('commons.notification_dialog')
      .factory('NavigationDialog', NavigationDialogService);
  
    /** @ngInject */
    function NavigationDialogService(w3Utils, $http) {
        var service = {
            findDialog: findDialog,
          };
      
          return service;
      
          // ----------------------------------------------------------
          // OTICAS
          function findDialog() {
          
      
            return $http.get(w3Utils.urlApi('/banner/topo'), {}).then(findSucess);
      
            function findSucess(result) {
              return result.data.data;
            }
          }
    }

})();
(function () {
    'use strict';

    angular
        .module('commons.notification_dialog')
        .controller('NotificationDialog', NotificationDialog);

    /** @ngInject */
    function NotificationDialog($mdDialog, $sce, title, content) {
        var vm = this;
        vm.title = 'Aviso';
        vm.content = '';
       
        //Methods
        vm.closeDialog = closeDialog;

        activate();
        
        //-----------------------------------
        function activate() {
          vm.title = title;
          vm.content = trustedHtml(content);
        }

        function trustedHtml (plainText) {
            if(!plainText){
                return '<span>Sem mensagem a ser exibida.</span>';
            }
            return $sce.trustAsHtml(plainText);
      }

        function closeDialog() {
            $mdDialog.hide(); 
        }

    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function () {
    'use strict';

    angular
        .module('commons.minha_conta')
        .controller('MinhaContaController', MinhaContaController);

    /** @ngInject */
    function MinhaContaController(ContaBancaria, w3Local, w3Utils, $state, w3Config) {
        var vm = this;
        vm.userTipo = '';

        //data
        vm.state = 'init'; //  gerente_empty gerente_partial gerente_accounts vendedor_empty vendedor_accounts
        vm.conta = {};
        vm.modulo = '';

        //methods
        vm.verConta = verConta;
        vm.gerarConta = gerarConta;
        vm.selectConta = selectConta;
        // vm.showEditConta = showEditConta;
        // vm.confirmDeleteConta = confirmDeleteConta;

        activate();

        //-------------------
        function activate() {
            vm.modulo = w3Config.get('module');
            // _loadContas();
            _checkUserTipo();

            if ( vm.modulo === 'optical_shop' && vm.userTipo === 'gerente') {
                vm.state = 'escolher_conta';
            } else {
                verConta(vm.userTipo);
            }
        }

        function verConta(tipo) {
            if(!tipo && vm.modulo === 'optical_shop') return;

            var params = {
                entity_sub: tipo
            };

            ContaBancaria.findByType(params)
                .then(
                    function (result) {

                        vm.conta = result;

                        if (params.entity_sub === 'gerente' && !vm.conta) {
                            vm.state = 'empty_gerente';
                        } else if (params.entity_sub !== 'gerente' && !vm.conta) {
                            vm.state = 'empty_vendedor';
                        } else if (vm.conta && vm.conta.id) {
                            selectConta(vm.conta);
                        }
                    },
                    function (error) {
                        if (params.entity_sub === 'gerente' && error.status == 404) {
                            vm.state = 'empty_gerente';
                        } else if (params.entity_sub !== 'gerente' && error.status == 404) {
                            vm.state = 'empty_vendedor';
                        }
                    }
                )
        }

        function gerarConta(tipo) {
            ContaBancaria.create(tipo).then(function (result) {
                    selectConta(result);
                }
            )
        }

        function _checkUserTipo() {
            var roles = w3Local.get('loggedUserRoles');

            if (_checkIs(roles, 'otica_gerente')) {
                vm.userTipo = 'gerente';
            } else if (_checkIs(roles, 'otica_vendedor')) {
                vm.userTipo = 'vendedor';
            } else {
                vm.userTipo = '';
            }
            return vm.userTipo;
        }

        function _checkIs(roles, role) {
            return roles.find(function (value) {
                return value === role;
            })
        }

        // function _checkState() {
        // if(vm.userTipo === 'gerente' && !vm.contas.length){
        //   vm.state = 'gerente_empty';
        // }
        // else if(vm.userTipo === 'gerente' && vm.contas.length){
        //   vm.state = 'gerente_accounts';
        // }
        // else if(vm.userTipo === 'vendedor' && !vm.contas.length){
        //   vm.state = 'vendedor_empty';
        // }
        // else if(vm.userTipo === 'vendedor' && vm.contas.length){
        //   vm.state = 'vendedor_accounts';
        // }
        // }

        // conta methods
        function selectConta(conta) {
            $state.go('xsession.conta_detail', {id: conta.id})
        }

        //
        // function showEditConta(conta, ev) {
        //   ContaBancaria.dialog.edit(conta, vm.contas, ev)
        // }
        //
        // function confirmDeleteConta(item, ind, ev) {
        //   w3Utils.confirmDelete(
        //     'Remover conta',
        //     'Você realmente deseja remover a conta ' + item.favorecido + '?',
        //     ev)
        //     .then(function () {
        //       ContaBancaria.remove(item.id).then(function () {
        //         vm.row.contas.data.splice(ind, 1);
        //       });
        //     });
        // }
    }
})();

(function ()
{
  'use strict';

  angular
    .module('rapi.fuse')
    .filter('rfUnique', unique)
    .filter('rfCity', cityFilter);


  /** @ngInject */
  function unique()
  {
    return function(collection, keyname) {
      var output = [],
      keys = [];

      angular.forEach(collection, function(item) {
        var key = item[keyname];
        if(keys.indexOf(key) === -1) {
          keys.push(key);
          output.push(item);
        }
      });

      return output;
    };
  }

  /** @ngInject */
  function cityFilter()
  {
    return function(city) {
      var output = '';
      
      if( ! city) 
        return null;

      output += city.city_name;

      if(city.state) 
        output +=  ", " + city.state.state_name; 

      if(city.state && city.state.country) 
        output +=  " - " + city.state.country.country_name;

      return output;
    };
  }


})();

(function ()
{
    'use strict';

    angular
            .module('rapi.fuse')
            .config(config);

    /** @ngInject */
    function config($translateProvider)
    {
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });

        $translateProvider.preferredLanguage('pt-br');
        $translateProvider.useSanitizeValueStrategy('sanitizeParameters');
    }

})();

(function () {
    'use strict';

    angular
        .module('commons.conta_bancaria')
        .factory('ContaBancaria', conta_bancariaService);


    /** @ngInject */
    function conta_bancariaService($mdDialog, w3Resource, w3Utils, $http) {

        var urlApi = '/contas';

        var service = {
            create: create,
            find: find,
            searchContasAPagar: searchContasAPagar,
            findByType: findByType,
            findWithDetail: findWithDetail,
            resgatarCupom: resgatarCupom,
            getDebitos: getDebitos,
            xUpdate: xUpdate,
            loadDropdown: loadDropdown,
            loadGrouped: loadGrouped,
            loadAccountsV3: loadAccountsV3,
            authPersonate: authPersonate,
            dialog: {
                create: showCreateDialog,
                show: showDetailsDialog,
                edit: showDialog,
                showDetailsPayment: showDetailsPaymentDialog,
                createAppSession: createAppSessionDialog
            }
        };

        return w3Resource.extend(urlApi, service);

        //------------------

        function create(tipo) {
            var data = {
                entity_sub: tipo
            };

            return $http.post(w3Utils.urlApi( urlApi + '/create'), data)
                .then(function (result) {
                    return (result.data.status === 'success' || result.status === 200 || result.status === 201) ? result.data.data : false;
                });
        }

        function findByType(params) {
            var data = {
                params: params
            };

            return $http.get(w3Utils.urlApi( urlApi + '/find'), data)
                .then(function (result) {
                    return (result.status === 200) ? result.data.data : [];
                });
        }

        function find(id, include) {
            var data = {
                params: {
                    include: include
                }
            };

            return $http.get(w3Utils.urlApi( '/finan/contas/' + id), data)
                .then(function (result) {
                    return (result.status === 200) ? result.data.data : [];
                });
        }

        function searchContasAPagar(params) {
            var data = {
                params: params
            };

            return $http.get(w3Utils.urlApi('/finan/debitos'), data)
                .then(function (result) {
                    return (result.status === 200) ? result.data : [];
                });
        }

        function findWithDetail(id, params) {
            var data = {
                params: params
            };

            return $http.get(w3Utils.urlApi( urlApi  +'/' + id + '/detail'), data)
                .then(function (result) {
                    return (result.status === 200) ? result.data.data : [];
                });
        }

        function resgatarCupom(code, contaId) {
            var data = {
                codigo: code,
            };
            return $http.post(w3Utils.urlApi( urlApi + '/'+ contaId + '/cupons/resgatar'), data)
                .then(function (result) {
                    return (result.status === 200 || result.status === 201) ? result.data.data : [];
                });
        }

        function xUpdate(contaId, data) {

            return $http.put(w3Utils.urlApi( urlApi + '/'+ contaId + '/update'), data)
                .then(function (result) {
                    return (result.status === 200 || result.status === 201) ? result.data.data : [];
                });
        }
        function getDebitos(contaId, params) {
            var data = {
                params : params
            };
            return $http.get(w3Utils.urlApi( urlApi + '/'+ contaId + '/debitos'), data)
                .then(function (result) {
                    return (result.status === 200 || result.status === 201) ? result.data : [];
                });
        }

        function loadDropdown() {
            var data = {
                params : {}
            };
            return $http.get(w3Utils.urlApi('/finan/contas/dropdown'), data)
                .then(function (result) {
                    return (result.status === 200 || result.status === 201) ? result.data.data : [];
                });
        }

        function loadGrouped(params) {
            var data = {
                params : params
            };
            return $http.get(w3Utils.urlApi('/finan/contas/dropdown-v2'), data)
                .then(function (result) {

                    return (result.status === 200 || result.status === 201) ? result.data.data : [];
                });
        }
        function loadAccountsV3(params) {
            var data = {
                params : params
            };
            return $http.get(w3Utils.urlApi('/finan/contas/dropdown-v3'), data)
                .then(function (result) {
                    console.log('DDDD', result);
                    return (result.status === 200 || result.status === 201) ? result.data.data : [];
                });
        }

        function showCreateDialog(archive, ev, data) {
            return showDialog(data, archive, ev);
        }

        function showDialog(row, archive, ev) {
            return $mdDialog.show({
                controller: 'ContaBancariaDialogController',
                controllerAs: 'vm',
                templateUrl: '/app/external/conta_bancaria/dialogs/form/conta_bancaria-dialog.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    'data': row,
                    'archive': archive
                }

            });

        }
        function showDetailsDialog(data, id, ev) {
            return $mdDialog.show({
                controller: 'ContaBancariaShowDialogController',
                controllerAs: 'vm',
                templateUrl: '/app/external/conta_bancaria/dialogs/show/conta_bancaria-dialog.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    'data': data,
                    'id': id
                }

            });

        }
        function showDetailsPaymentDialog(id, ev) {
            return $mdDialog.show({
                controller: 'DetailPaymentDialogController',
                controllerAs: 'vm',
                templateUrl: '/app/external/conta_bancaria/dialogs/detail_payment/detail_payment-dialog.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    'id': id
                }

            });

        }
        function authPersonate(contaId) {
            var data = {
                conta_id: contaId,
            };
            return $http.post(w3Utils.urlApi( '/finan/contas/auth-personate'), data)
                .then(function (result) {
                    return (result.status === 200 || result.status === 201) ? result.data.data : [];
                });
        }

        function createAppSessionDialog(id, ev) {
            return $mdDialog.show({
                controller: 'CreateAppSessionDialogController',
                controllerAs: 'vm',
                templateUrl: '/app/external/conta_bancaria/dialogs/create_app_session/create_app_session-dialog.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    'id': id
                }
            });

        }
    }

})();

(function () {
  'use strict';

  angular
    .module('commons.conta_bancaria')
    .controller('ContaBancariaController', ContaBancariaController);

  /** @ngInject */
  function ContaBancariaController(ContaBancaria, w3Utils, $translate, Otica) {
    var vm = this;
    var defaultParams = {
      'take': -1,
      'entity_id': null,
      'entity_type': null,
      'sort': 'nome', //EX: nome,-created_at
      'q': null,
      'conta_id': null
    };

    // Data
    vm.archive = [];
    vm.oticas = [];
    vm.loading = false;
    vm.pagination = {};
    vm.params = angular.copy(defaultParams);
    vm.searchText = '';
    vm.selectedOtica = null;

    // Methodss
    vm.search = search;
    vm.setPage = setPage;
    vm.clearSearchTerm = clearSearchTerm;
    vm.clearFilter = clearFilter;
    vm.handleCloseSelecOtica = handleCloseSelecOtica;

    activate();

    //-----------------------

    function activate() {
      search(1);
      loadOticas();
    }

    function setPage(p) {
      ContaBancaria.setPage(p);
      search(p);
    }

    function search(p) {
      // ContaBancaria.setPage(p);
      // vm.params.page = p;
      vm.loading = true;
      vm.archive = null;

      ContaBancaria.loadAccountsV3(vm.params).then(function (result) {
        vm.loading = false;
        vm.archive = result;
        // vm.pagination = ContaBancaria.pagination;
      });
    }


    function loadOticas() {
      Otica.search({'take': -1}).then(loadSucess);

      function loadSucess(response) {
        vm.oticas = response;
      }
    }

    function clearSearchTerm (){
      vm.searchText = '';
    }

    function clearFilter (){
      vm.searchText = '';
      vm.params = angular.copy(defaultParams);
      vm.selectedOtica = null;
      vm.handleCloseSelecOtica();
      vm.search(1);
    }

    function handleCloseSelecOtica(){
      vm.clearSearchTerm();
      if(vm.selectedOtica){
        vm.params.entity_id = vm.selectedOtica.id;
        vm.params.entity_type = 'otica';
      }

    }
  }


})();

(function () {
    'use strict';

    angular
        .module('commons.config', ['rapi.w3.config'])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, w3ConfigProvider, toastrConfig) {

        // Conf toaster REF: https://libraries.io/bower/angular-toastr
        toastrConfig.positionClass = 'toast-bottom-right';
        toastrConfig.closeButton = true;

        //LOAD TRANSLATE
        $translatePartialLoaderProvider.addPart('assets/langs');

        var env = getConfENV();

        w3ConfigProvider.config({
            'welcome': 'Bem vindo',
            'welcome_text': 'No seu painel de gerenciamento você poderá cadastrar e gerenciar clientes e serviços do seu produto',
            // 'logo': 'assets/images/logos/logo.png',
            // 'logo_painel': 'assets/images/logos/logo.png',
            'logo': 'app/external/assets/images/logos/logo-polo-lentes-blue.png',
            'logo_painel': 'app/external/assets/images/logos/logo-polo-lentes-blue.png',
            'showLogo': true,
            'sigla': 'Polo Lentes ',
            'title_project': 'Polo Lentes | A melhor tecnologia em lentes aliada ao seu negócio',
            'bg_auth': 'assets/images/backgrounds/guarantee-bg.jpg',
            // 'credits_logo': 'assets/images/logos/logo-light.png',
            // 'credits_auth_logo': 'assets/images/logos/logo-light.png',
            'credits_logo': 'app/external/assets/images/logos/logo-dploy-white.png',
            'credits_auth_logo': 'app/external/assets/images/logos/logo-dploy.png',
            'credits_link': 'http://dploy.com.br',
            'versao': 'V2.4.25'
        });

        w3ConfigProvider.configHost({
            'baseUrl': env.url,
            'baseUrlApi': '/api/v1',
            'appUrl': env.appUrl,
            'baseModule': null,
            'env': env.name,
        });

        w3ConfigProvider.configUpload({
            'token': 'polo@rapi:1234$token'
        });

        function getConfENV() {
            var host = document.location.host;

            var env = {
                'url': '',
                'name': '',
                'appUrl': document.location.origin
            };

            var allowLocal = [
                'localhost:3000',
                'localhost:3002',
                'localhost:5000',
                '192.168.1.100:3000',
                '192.168.1.100:3002',
                'app.pololentes.local',
                '192.168.1.25:8080'
            ];

            if (allowLocal.includes(host)) {
                // env.url = 'http://192.168.1.14:8001';
                env.url = 'https://services.sandbox.pololentes.com.br';
                env.name = 'local';
            } else if (host === 'app.pololentes.com.br') {
                env.url = 'https://services.pololentes.com.br';
                env.name = 'production';
            } else if (host === 'app.sandbox.pololentes.com.br') {
                env.url = 'https://services.sandbox.pololentes.com.br';
                env.name = 'sandbox';
            } else {
                console.error('Nenhum host é valido!');
            }

            console.log('ENV ->', env);
            return env;
        }
    }
})();

// (function ()
// {
//   'use strict';
//
//   angular
//     .module('laboratory')
//     .run(runBlock);
//
//   /** @ngInject */
//   function runBlock($rootScope)
//   {
//
//   }
//
// })();

(function ()
{
  'use strict';

  /**
  * Main module of the Fuse
  */
  angular
    .module('laboratory', [
      // Fuse Core
      'app.core',

      'ngMask',
      // Fuse
      'rapi.fuse',
      'rapi.fuse.layouts',
      //LAYOUTS MODULES
      //'rapi.fuse.layouts.vert_nav',
      'rapi.fuse.layouts.vert_nav_complete',
      //'rapi.fuse.layouts.vert_nav_comp_toolbar',
      //'rapi.fuse.layouts.vert_nav_comp_toolbar2',
      //'rapi.fuse.layouts.vert_nav_toolbar',
      //'rapi.fuse.layouts.vert_nav_toolbar2',
      //'rapi.fuse.layouts.hor_nav_complete',
      //'rapi.fuse.layouts.content_toolbar',
      //'rapi.fuse.layouts.content',
      'rapi.fuse.cities',
      'rapi.fuse.report',
      'rapi.fuse.suporte',
      'rapi.fuse.profile',

      //COMMONS
      'commons.config',
      'commons.pedido',
      'commons.conta_bancaria',
      'commons.notification_dialog',
      'commons.minha_conta',
      'commons.providers',
      'index.config',

      // MAIN DOMAINS
      'main.xsession-lab',
    ]);
})();

(function ()
{
  'use strict';

  angular
    .module('laboratory')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider)
  {
      //$urlRouterProvider.otherwise('/pedidos/');
  }

})();

(function ()
{
  'use strict';

  angular
    .module('laboratory')
    .controller('IndexController', IndexController);

  /** @ngInject */
  function IndexController(fuseTheming)
  {
    var vm = this;

    // Data
    vm.themes = fuseTheming.themes;
  }
})();

// (function ()
// {
//   'use strict';
//
//   angular
//     .module('laboratory');
//     //.constant('Variables', {});
// })();

(function ()
{
    'use strict';

    angular
            .module('index.config', ['commons.config', 'rapi.fuse.xsession'])
            .config(config);

    /** @ngInject */
    function config(w3ConfigProvider, xSessionProvider)
    {
        w3ConfigProvider.config({
            'welcome': 'Bem vindo',
            'welcome_text': 'No seu painel de pedidos você gerenciar os pedidos recebidos',
            'title_project': 'Polo Lentes',
            'bg_auth': 'assets/images/backgrounds/auth-background-active.jpg',
            'module' : 'laboratory'
        });

        w3ConfigProvider.configAuth({
            'routeSuccess': 'xsession.pedido'
        });

        w3ConfigProvider.configHost({
            'baseModule' : 'laboratory'
        });


        xSessionProvider.setQueryModel(['xSessionLab', function (xSessionLab) {
          return xSessionLab.listSessions();
        }]);

        xSessionProvider.configure({
          home: 'xsession.pedido',
          keyHeader: 'X-LABORATORIO',
          nameToolbar: 'Laboratório',
          keyStorange: 'session.laboratorio',
          labels: {
            title: 'Olá,',
            content: 'Nós percebemos que você têm acesso a mais de uma unidade, com qual delas deseja trabalhar agora?',
            title_empty_state: 'Você não tem acesso a nenhum laboratório.',
            content_empty_state: 'Entre em contato com o seu gerente para solicitar a permissão de acesso.'
          }
          // prependHeaders: {
          //   'APP_ID': 'otica',
          //   'APP_SECRET': 'app.otica'
          // }
        });

    }

})();

(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
            .module('rapi.fuse.layouts.vert_nav_toolbar2', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {

        var path = '/app/external/fuse/layouts';

        // State definitions
        $stateProvider
                .state('app', {
                    abstract: true,
                    views: {
                        'main@': {
                            templateUrl: path + '/vert-nav-toolbar2/vert-nav-toolbar2.html',
                            controller: 'LayoutsController as vm'
                        },
                        'toolbar@app': {
                            templateUrl: path + '/partials/toolbar/toolbar-no-quick2.html',
                            controller: 'ToolbarController as vm'
                        },
                         'navigation@app': {
                            templateUrl:  path + '/partials/navigation/vertical-navigation2.html',
                            controller: 'NavigationController as vm'
                        }
                    }
                });

        msNavigationServiceProvider.saveItem('logout', {
            title: 'COMMON.SAIR',
            icon: 'icon-logout',
            state: 'auth.logout',
            weight: 999
        });

    }


})();

(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
            .module('rapi.fuse.layouts.vert_nav_toolbar', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {

        var path = '/app/external/fuse/layouts';

        // State definitions
        $stateProvider
                .state('app', {
                    abstract: true,
                    views: {
                        'main@': {
                            templateUrl: path + '/vert-nav-toolbar/vert-nav-toolbar.html',
                            controller: 'LayoutsController as vm'
                        },
                        'toolbar@app': {
                            templateUrl: path + '/partials/toolbar/toolbar-no-quick.html',
                            controller: 'ToolbarController as vm'
                        },
                         'navigation@app': {
                            templateUrl:  path + '/partials/navigation/vertical-navigation.html',
                            controller: 'NavigationController as vm'
                        }
                    }
                });

        msNavigationServiceProvider.saveItem('logout', {
            title: 'COMMON.SAIR',
            icon: 'icon-logout',
            state: 'auth.logout',
            weight: 999
        });

    }


})();

(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
            .module('rapi.fuse.layouts.vert_nav_complete', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {

        var path = '/app/external/fuse/layouts';

        // State definitions
        $stateProvider
                .state('app', {
                    abstract: true,
                    views: {
                        'main@': {
                            templateUrl: path + '/vert-nav-complete/vert-nav-complete.html',
                            controller: 'LayoutsController as vm'
                        },
                        'toolbar@app': {
                            templateUrl: path + '/partials/toolbar/toolbar.html',
                            controller: 'ToolbarController as vm'
                        },
                         'navigation@app': {
                            templateUrl:  path + '/partials/navigation/vertical-navigation.html',
                            controller: 'NavigationController as vm'
                        },
                        'quickPanel@app': {
                            templateUrl: path + '/partials/quickpanel/quickpanel.html',
                            controller: 'QuickPanelController as vm'
                        }
                    }
                });

        msNavigationServiceProvider.saveItem('logout', {
            title: 'COMMON.SAIR',
            icon: 'icon-logout',
            state: 'auth.logout',
            weight: 999
        });

    }


})();

(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
            .module('rapi.fuse.layouts.vert_nav_comp_toolbar2', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {

        var path = '/app/external/fuse/layouts';

        // State definitions
        $stateProvider
                .state('app', {
                    abstract: true,
                    views: {
                        'main@': {
                            templateUrl: path + '/vert-nav-comp-toolbar2/vert-nav-comp-toolbar2.html',
                            controller: 'LayoutsController as vm'
                        },
                        'toolbar@app': {
                            templateUrl: path + '/partials/toolbar/toolbar2.html',
                            controller: 'ToolbarController as vm'
                        },
                         'navigation@app': {
                            templateUrl:  path + '/partials/navigation/vertical-navigation2.html',
                            controller: 'NavigationController as vm'
                        },
                        'quickPanel@app': {
                            templateUrl: path + '/partials/quickpanel/quickpanel.html',
                            controller: 'QuickPanelController as vm'
                        }
                    }
                });

        msNavigationServiceProvider.saveItem('logout', {
            title: 'COMMON.SAIR',
            icon: 'icon-logout',
            state: 'auth.logout',
            weight: 999
        });

    }


})();

(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
            .module('rapi.fuse.layouts.vert_nav_comp_toolbar', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {

        var path = '/app/external/fuse/layouts';

        // State definitions
        $stateProvider
                .state('app', {
                    abstract: true,
                    views: {
                        'main@': {
                            templateUrl: path + '/vert-nav-comp-toolbar/vert-nav-comp-toolbar.html',
                            controller: 'LayoutsController as vm'
                        },
                        'toolbar@app': {
                            templateUrl: path + '/partials/toolbar/toolbar.html',
                            controller: 'ToolbarController as vm'
                        },
                         'navigation@app': {
                            templateUrl:  path + '/partials/navigation/vertical-navigation.html',
                            controller: 'NavigationController as vm'
                        },
                        'quickPanel@app': {
                            templateUrl: path + '/partials/quickpanel/quickpanel.html',
                            controller: 'QuickPanelController as vm'
                        }
                    }
                });

        msNavigationServiceProvider.saveItem('logout', {
            title: 'COMMON.SAIR',
            icon: 'icon-logout',
            state: 'auth.logout',
            weight: 999
        });

    }


})();

(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('rapi.fuse.layouts.vert_nav', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {

        var path = '/app/external/fuse/layouts';  

        // State definitions
        $stateProvider
                .state('app', {
                    abstract: true,
                    views: {
                        'main@': {
                            templateUrl: path + '/vert-nav/vert-nav.html',
                            controller: 'LayoutsController as vm'
                        },
                        'navigation@app': {
                            templateUrl:  path + '/partials/navigation/vertical-navigation.html',
                            controller: 'NavigationController as vm'
                        }
                    }
                });

 msNavigationServiceProvider.saveItem('logout', {
            title: 'COMMON.SAIR',
            icon: 'icon-logout',
            state: 'auth.logout',
            weight: 999
        });
   
    }


})();

(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
            .module('rapi.fuse.layouts.hor_nav_complete', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {

        var path = '/app/external/fuse/layouts';

        // State definitions
        $stateProvider
                .state('app', {
                    abstract: true,
                    views: {
                        'main@': {
                            templateUrl: path + '/hor-nav-complete/hor-nav-complete.html',
                            controller: 'LayoutsController as vm'
                        },
                        'toolbar@app': {
                            templateUrl: path + '/partials/toolbar/hor-toolbar.html',
                            controller: 'ToolbarController as vm'
                        },
                         'navigation@app': {
                            templateUrl:  path + '/partials/navigation/horizontal-navigation.html',
                            controller: 'NavigationController as vm'
                        },
                        'quickPanel@app': {
                            templateUrl: path + '/partials/quickpanel/quickpanel.html',
                            controller: 'QuickPanelController as vm'
                        }
                    }
                });

        msNavigationServiceProvider.saveItem('logout', {
            title: 'COMMON.SAIR',
            icon: 'icon-logout',
            state: 'auth.logout',
            weight: 999
        });

    }


})();

(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
            .module('rapi.fuse.layouts.content_toolbar', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {

        var path = '/app/external/fuse/layouts';

        // State definitions
        $stateProvider
                .state('app', {
                    abstract: true,
                    views: {
                        'main@': {
                            templateUrl: path + '/content-toolbar/content-toolbar.html',
                            controller: 'LayoutsController as vm'
                        },
                        'toolbar@app': {
                            templateUrl: path + '/partials/toolbar/hor-toolbar.html',
                            controller: 'ToolbarController as vm'
                        },
                         'navigation@app': {
                            templateUrl:  path + '/partials/navigation/horizontal-navigation.html',
                            controller: 'NavigationController as vm'
                        },
                        'quickPanel@app': {
                            templateUrl: path + '/partials/quickpanel/quickpanel.html',
                            controller: 'QuickPanelController as vm'
                        }
                    }
                });

        msNavigationServiceProvider.saveItem('logout', {
            title: 'COMMON.SAIR',
            icon: 'icon-logout',
            state: 'auth.logout',
            weight: 999
        });

    }


})();

(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
            .module('rapi.fuse.layouts.content', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {

        var path = '/app/external/fuse/layouts';

        // State definitions
        $stateProvider
                .state('app', {
                    abstract: true,
                    views: {
                        'main@': {
                            templateUrl: path + '/content/content.html',
                            controller: 'LayoutsController as vm'
                        },
                        'toolbar@app': {
                            templateUrl: path + '/partials/toolbar/hor-toolbar.html',
                            controller: 'ToolbarController as vm'
                        },
                         'navigation@app': {
                            templateUrl:  path + '/partials/navigation/horizontal-navigation.html',
                            controller: 'NavigationController as vm'
                        },
                        'quickPanel@app': {
                            templateUrl: path + '/partials/quickpanel/quickpanel.html',
                            controller: 'QuickPanelController as vm'
                        }
                    }
                });

        msNavigationServiceProvider.saveItem('logout', {
            title: 'COMMON.SAIR',
            icon: 'icon-logout',
            state: 'auth.logout',
            weight: 999
        });

    }


})();

(function ()
{
    'use strict';

    angular
            .module('rapi.fuse.suporte', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {

        // State
        $stateProvider
                .state('app.suporte', {
                    url: '/suporte',
                    views: {
                        'content@app': {
                            templateUrl: '/app/external/fuse/suporte/suporte.html'
                        }
                    }
                })
                ;
        msNavigationServiceProvider.saveItem('suporte', {
            title: 'Suporte do sistema',
            icon: 'icon-account-multiple',
            state: 'app.suporte',
            weight: 99
        });


    }
})();



angular.module("app.core").run(["$templateCache", function($templateCache) {$templateCache.put("/app/external/conta_bancaria/conta_bancaria-archive.html","<div id=\"gen-produto\" class=\"page-layout carded fullwidth single-scroll model-page\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" flex><div class=\"heading\"><div layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"white-text mob-100\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1 margin-top-16\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-bank\"></md-icon><span style=\"margin-left:10px\">Contas</span></div></div><div layout=\"row\" \nlayout-align=\"end center\" class=\"mob-100\"></div></div><div \nclass=\"search-boxes content-card animate-slide-down margin-bottom-16 padding-8 margin-top-16\" layout=\"column\"><div \nflex layout=\"row\" layout-align=\"center center\"><div flex layout=\"row\" class=\"search-item\"><md-input-container flex>\n<input flex ng-model=\"vm.params.q\" type=\"text\" placeholder=\"Buscar por nome, e-mail ou chave PIX.\">\n</md-input-container><md-input-container flex class=\"margin-right-5\"><label>Selecione uma ótica:</label><md-select \nng-model=\"vm.selectedOtica\" md-on-close=\"vm.handleCloseSelecOtica();\" md-container-class=\"selectdemoSelectHeader\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchText\" aria-label=\"Vegetable filter\" \ntype=\"search\" placeholder=\"Ex. nome\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation()\">\n<md-button class=\"md-icon-button md-primary\" aria-label=\"Settings\"><md-icon ng-click=\"vm.clearSearchTerm()\" \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option value=\"\">Todas</md-option><md-option \nng-value=\"otica\" ng-repeat=\"otica in vm.oticas | filter: vm.searchText\">#{{otica.id}} {{otica.nome}}</md-option>\n</md-select></md-input-container></div><md-button class=\"md-accent md-raised md-icon-button\" aria-label=\"buscar\" \nng-click=\"vm.search(1)\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip><span translate=\"PRODUTO.BUSCAR\">\nBuscar</span></md-tooltip></md-button><md-button class=\"md-icon-button mr-0 md-raised\" ng-click=\"vm.clearFilter()\" \naria-label=\"Clear filter\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip>Limpar filtros</md-tooltip>\n</md-button></div></div></div><div class=\"content-card margin-bottom-24\"><md-content class=\"content no-padding\" \nms-scroll><table class=\"dataTable row-border hover\" ms-responsive-table w3-change=\"vm.search(1)\"><thead><tr><th \nclass=\"secondary-text\" data-order=\"id\"><div class=\"table-header\"><span class=\"column-title\" translate=\"COMMON.ID\">ID\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Favorecido</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Forma de pagamento</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Grupo</span></div></th><th \nclass=\"secondary-text w-100\"><div class=\"table-header\"></div></th></tr></thead><tbody><tr class=\"tr-notfound\" \nng-show=\"vm.loading === false && vm.archive.length == 0\"><td colspan=\"10\"><span>Nenhum resultado encontrado</span></td>\n</tr><tr ng-repeat=\"item in vm.archive\" ui-sref=\"xsession.contas.show({id:item.id})\" class=\"hover-table\"><td>\n{{item.id}}</td><td class=\"rf-pointer\"><div layout=\"column\" layout-align=\"center start\"><span>{{item.nome}}</span> \n<small class=\"secondary-text\">{{item.email}}</small> <span class=\"secondary-text\">{{item.entity_sub}}</span></div></td>\n<td class=\"rf-pointer\">{{item.tipo_label}}</td><td class=\"rf-pointer\"><div layout=\"column\" layout-align=\"center start\">\n<span class=\"secondary-text\">{{item.entity_type}}</span> <span>{{item.entity_name}}</span></div></td><td class=\"w-100\">\n<md-button class=\"md-icon-button md-accent\" aria-label=\"Editar\" translate translate-attr-aria-label=\"COMMON.EDITAR\">\n<md-icon md-font-icon=\"icon-eye\" class=\"icon s28\"></md-icon>{{\'COMMON.VISUALIZAR\'|translate}}</md-button></td></tr>\n</tbody></table></md-content></div></div></div>");
$templateCache.put("/app/external/minha-conta/minha-conta.html","<div class=\"page-layout blank common-bg\"><div ng-if=\"vm.state === \'escolher_conta\'\" flex layout=\"column\" \nlayout-align=\"center center\"><h2 class=\"md-display-2\">Qual conta você quer acessar?</h2><div layout=\"row\" \nstyle=\"width: 600px\"><div flex=\"\" layout=\"column\" layout-align=\"center center\"><md-icon class=\"s80 md-teal-500-fg\" \nmd-font-icon=\"icon-account-key\"></md-icon><md-button ng-click=\"vm.verConta(\'gerente\')\" \nclass=\"md-raised md-teal-500-bg white-text\">Ver minha conta de gerente</md-button></div><md-divider></md-divider><div \nflex=\"\" layout=\"column\" layout-align=\"center center\"><md-icon class=\"s80 md-deep-purple-500-fg\" \nmd-font-icon=\"icon-account\"></md-icon><md-button ng-click=\"vm.verConta(\'vendedor\'); vm.userTipo = \'vendedor\';\" \nclass=\"md-raised md-deep-purple-500-bg white-text\">Ver minha conta de vendedor</md-button></div></div></div><div \nng-if=\"vm.state === \'empty_gerente\'\" flex layout=\"column\" layout-align=\"center center\"><md-card class=\"p-24\" \nstyle=\"width: 600px\" layout=\"column\" layout-align=\"center center\"><h2>Não encontramos nenhuma conta.</h2><p>\nVocê precisa criar uma conta</p><md-button ng-click=\"vm.gerarConta(\'gerente\')\" \nclass=\"md-raised md-green-400-bg white-text\">Criar minha conta de gerente</md-button></md-card></div><div \nng-if=\"vm.state === \'empty_vendedor\'\" flex layout=\"column\" layout-align=\"center center\"><md-card class=\"p-24\" \nstyle=\"width: 600px\" layout=\"column\" layout-align=\"center center\"><h2>Não encontramos nenhuma conta.</h2><p>\nVocê precisa criar uma conta</p><md-button ng-click=\"vm.gerarConta(vm.userTipo)\" \nclass=\"md-raised md-green-400-bg white-text\">Criar minha conta</md-button></md-card></div></div>");
$templateCache.put("/app/external/notification_dialog/notification_dialog.html","<md-dialog class=\"single-dialog font-size-14\" style=\"max-width: 800px; width: 100%\" aria-label=\"Dialog\" \ntranslate-attr-aria-label=\"MOTIVO.DIALOG.MANUTENCAO_DIALOG\"><md-toolbar class=\"md-dark\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-color: black\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Fechar\" translate translate-attr-aria-label=\"COMMON.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nstyle=\"width: 100%; font-size: 14px\"><ng-bind-html ng-bind-html=\"vm.content\">Problemas ao exibir a mensagem;\n</ng-bind-html></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><div layout=\"row\" \nlayout-align=\"end center\"><md-button type=\"button\" ng-click=\"vm.closeDialog()\" class=\"md-warn\" aria-label=\"Cancelar\">\n<span>Fechar</span></md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("/app/external/pedido/pedido-by-status-archive.html","<div id=\"gen-pedido\" class=\"page-layout carded fullwidth single-scroll model-page\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" flex><div class=\"heading\"><div layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"white-text mob-100\" layout=\"column\" \nlayout-align=\"start start\" flex=\"40\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon class=\"mr-8\" \nmd-font-icon=\"icon-cart\"></md-icon><span data-translate=\"PEDIDO.TITLE_ARCHIVE\" translate-values=\"vm.listPedido\"></span>\n</div><div class=\"product-count secondary-text\"><span data-translate=\"PEDIDO.TOTAL\" \ntranslate-values=\"{\'total\':vm.archive.length}\">Total de cadastros {vm.pagination.total}</span></div></div><div \nclass=\"white-text secondary-text\" layout=\"row\" layout-align=\"start start\" flex=\"40\"><span>{{vm.listPedido.description}}\n</span></div><div layout=\"row\" layout-align=\"end center\" class=\"mob-100\"><md-button \nng-click=\"vm.searchActive = !vm.searchActive\" class=\"md-icon-button\" aria-label=\"Search\" translate \ntranslate-attr-aria-label=\"buscar\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip><span \ndata-translate=\"PEDIDO.BUSCAR\">Buscar</span></md-tooltip></md-button><div ng-if=\"vm.isUserOtica()\"><md-button \nui-sref=\"xsession.pedido.new\" class=\"md-fab md-primary mr-0\" aria-label=\"adicionar novo\" translate \ntranslate-attr-aria-label=\"COMMON.ADICIONAR_NOVO\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div>\n</div><div ng-if=\"vm.searchActive\" class=\"search-boxes animate-slide-down\" layout=\"column\"><div flex layout=\"row\"><div \nlayout=\"column\" flex><div flex layout=\"row\" class=\"margin-top-10 margin-bottom-5\"><md-input-container flex \nclass=\"margin-0 margin-right-5\"><label data-translate=\"PEDIDO.FILTER.GENERAL\"></label><input ng-model=\"vm.params.q\" \nclass=\"md-body-1\" type=\"text\"></md-input-container><md-input-container flex \nclass=\"margin-0 margin-left-5 margin-right-5\" ng-if=\"vm.isUserOtica()\"><label data-translate=\"PEDIDO.FILTER.SELLER\">\n</label><md-select ng-model=\"vm.params.user_id\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"vm.searchSellerInput\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"Procure por um vendedor...\" class=\"demo-header-searchbox md-text md-body-1\"></md-select-header><md-option \nclass=\"md-body-1\" ng-repeat=\"seller in vm.sellers | filter:vm.searchSellerInput\" ng-value=\"seller.user_id\">\n{{seller.user.name}}</md-option></md-select></md-input-container><md-input-container flex \nclass=\"margin-0 margin-left-5 margin-right-5\"><label data-translate=\"PEDIDO.FILTER.PRODUCT\"></label><md-select \nng-model=\"vm.params.produto_id\"><md-option class=\"md-body-1\" ng-value=\"produto.id\" ng-repeat=\"produto in vm.produtos\">\n{{ vm.isUserLab() ? produto.nome_tecnico: produto.nome }}</md-option></md-select></md-input-container>\n<md-input-container ng-if=\"vm.isAllRequests() && !vm.isUserLab()\" flex class=\"margin-0 margin-left-5 margin-right-5\">\n<label data-translate=\"PEDIDO.FILTER.STATUS\"></label><md-select multiple=\"multiple\" ng-model=\"vm.selectedStatus\">\n<md-option class=\"md-body-1\" ng-value=\"status.id\" ng-repeat=\"status in vm.status\">{{ status.label }}</md-option>\n</md-select></md-input-container><md-input-container ng-if=\"vm.isUserAdmin()\" flex \nclass=\"margin-0 margin-left-5 margin-right-5\"><label data-translate=\"PEDIDO.FILTER.POLO\"></label><md-select \nng-model=\"vm.params.polo_id\"><md-option class=\"md-body-1\" ng-value=\"polo.id\" ng-repeat=\"polo in vm.polos\">\n{{ polo.nome }}</md-option></md-select></md-input-container></div><div flex layout=\"row\" class=\"margin-top-5\">\n<md-input-container flex class=\"margin-0 margin-right-5\"><label data-translate=\"PEDIDO.FILTER.DATE_TYPE\"></label>\n<md-select ng-model=\"vm.params.dt_column\"><md-option value=\"created_at\">Data de criação</md-option><md-option \nvalue=\"updated_at\">Data da última atualização</md-option><md-option value=\"deleted_at\">Data de desativação</md-option>\n</md-select></md-input-container><md-input-container flex class=\"margin-0 margin-right-5\"><label \ndata-translate=\"PEDIDO.FILTER.DATE_START\"></label><input ng-model=\"vm.params.dt_obj_start\" class=\"md-body-1\" \ntype=\"date\" ng-disabled=\"!vm.params.dt_column\"></md-input-container><md-input-container flex \nclass=\"margin-0 margin-right-5\"><label data-translate=\"PEDIDO.FILTER.DATE_END\"></label><input \nng-model=\"vm.params.dt_obj_end\" class=\"md-body-1\" type=\"date\" ng-disabled=\"!vm.params.dt_column\"></md-input-container>\n<md-input-container ng-if=\"vm.isUserAdmin() || vm.isUserPolo()\" flex class=\"margin-0 margin-left-5 margin-right-5\">\n<label data-translate=\"PEDIDO.FILTER.OTICA\"></label><md-select ng-model=\"vm.params.otica_id\"><md-option \nclass=\"md-body-1\" ng-value=\"otica.id\" ng-repeat=\"otica in vm.oticas\">{{ otica.nome }}</md-option></md-select>\n</md-input-container></div></div><div layout=\"column\" layout-align=\"space-around center\" layout-padding \nclass=\"padding-botton-10\"><md-button class=\"md-accent md-raised md-icon-button\" aria-label=\"buscar\" \nng-click=\"vm.startFilter()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip><span \ndata-translate=\"PEDIDO.BUSCAR\">Buscar</span></md-tooltip></md-button><md-button ng-show=\"vm.searchActive\" \nclass=\"md-icon-button mr-0 md-raised\" ng-click=\"vm.clearFilter()\" aria-label=\"Clear filter\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip>Limpar filtros</md-tooltip></md-button></div></div></div></div>\n<div class=\"content-card\"><md-content class=\"content no-padding\" ms-scroll><table class=\"dataTable row-border hover\" \nms-responsive-table w3-order-table=\"vm.params\" w3-change=\"vm.search()\"><thead><tr><th class=\"secondary-text\" \ndata-order=\"id\"><div class=\"table-header\" style=\"text-align: center\"><span class=\"column-title\" \ndata-translate=\"PEDIDO.TABLE.ID\">IDS</span></div></th><th class=\"secondary-text\" data-order=\"status\"><div \nclass=\"table-header\" layout=\"row\" layout-align=\"center center\"><span class=\"column-title\" \ndata-translate=\"PEDIDO.TABLE.STATUS\">Status</span></div></th><th class=\"secondary-text\" data-order=\"otica_id\" \nng-if=\"vm.isUserAdmin() || vm.isUserPolo()\"><div class=\"table-header\"><span class=\"column-title\" \ndata-translate=\"PEDIDO.TABLE.OTICA\">Otica</span></div></th><th class=\"secondary-text\" data-order=\"nro_os\" \nng-if=\"vm.isUserOtica()\"><div class=\"table-header\" style=\"text-align: center\"><span class=\"column-title\">Nro OS</span>\n</div></th><th class=\"secondary-text\" data-order=\"cliente\" ng-if=\"vm.isUserOtica()\"><div class=\"table-header\" \nstyle=\"text-align: center\"><span class=\"column-title\">Cliente</span></div></th><th class=\"secondary-text\" \nng-if=\"vm.isUserAdmin()\"><div class=\"table-header\"><span class=\"column-title\" data-translate=\"PEDIDO.TABLE.POLO\">Polo\n</span></div></th><th class=\"secondary-text\" ng-if=\"vm.isUserAdmin()\"><div class=\"table-header\" \nstyle=\"text-align: center\"><span class=\"column-title\">Laboratório</span></div></th><th class=\"secondary-text\" \nng-if=\"vm.isUserAdmin()\"><div class=\"table-header\"><span class=\"column-title\">Recursos</span></div></th><th \nclass=\"secondary-text\" ng-if=\"vm.isUserLab() || vm.isUserPolo() || vm.isUserOtica()\"><div class=\"table-header\" \nstyle=\"text-align: center\"><span class=\"column-title\">Produto</span></div></th><th class=\"secondary-text\" \nng-if=\"vm.isUserLab() || vm.isUserPolo() || vm.isUserOtica()\"><div class=\"table-header\" style=\"text-align: center\">\n<span class=\"column-title\">Tratamento</span></div></th><th class=\"secondary-text\" \nng-if=\"vm.isUserLab() || vm.isUserPolo() || vm.isUserOtica()\"><div class=\"table-header\" style=\"text-align: center\">\n<span class=\"column-title\">Material</span></div></th><th class=\"secondary-text\" \nng-if=\"vm.isUserAdmin() || vm.isUserPolo() || vm.isUserOtica()\"><div class=\"table-header\"><span class=\"column-title\">\nValor</span></div></th><th class=\"secondary-text\" style=\"width: 20px\" ng-if=\"vm.isUserAdmin() || vm.isUserPolo()\"><div \nclass=\"table-header\" style=\"text-align: center\"><span class=\"pedido-table-header\">Prêmio total do vendedor</span></div>\n</th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\" \ndata-translate=\"COMMON.ATUALIZADO_EM\">Atualizado em</span></div></th><th class=\"secondary-text w-60\"><div \nclass=\"table-header\" style=\"text-align: center\"></div></th></tr></thead><tbody><tr class=\"tr-notfound\" \nng-show=\" vm.archive.length == 0\"><td colspan=\"10\"><span data-translate=\"PEDIDO.SEM_RESULTADOS\">\nNenhum resultado encontrado</span></td></tr><tr ng-repeat=\"item in vm.archive\" class=\"hover-table\"><td \nng-click=\"vm.select(item.id)\" class=\"rf-pointer\" style=\"text-align: center\">{{item.id}}</td><td \nng-click=\"vm.select(item.id)\" class=\"rf-pointer\" style=\"text-align: center\"><div layout=\"row\" \nlayout-align=\"center center\"><pedido-label id=\"item.status\" label=\"item.status_label\"></pedido-label></div></td><td \nng-if=\"vm.isUserAdmin() || vm.isUserPolo()\"><div layout=\"column\"><span>{{item.otica.nome}} </span><span \nclass=\"md-caption\">{{\'OS \' }} {{item.nro_os}} </span><span class=\"md-caption\">{{\'Cliente \' }} {{item.cliente}}</span>\n</div></td><td ng-if=\"vm.isUserOtica()\" style=\"text-align: center\"><div layout=\"column\"><span>{{item.nro_os}}</span>\n</div></td><td ng-if=\"vm.isUserOtica()\" style=\"text-align: center\"><div layout=\"column\"><span>{{item.cliente}}</span>\n</div></td><td ng-if=\"vm.isUserAdmin()\"><div layout=\"column\"><span>{{item.polo.nome}} </span><span class=\"md-caption\" \nstyle=\"width: 50px\">{{\'Caixa \'}} {{item.box || \'a informar\'}}</span></div></td><td ng-if=\"vm.isUserAdmin()\" \nstyle=\"text-align: center\">{{item.laboratorio.nome || \'A selecionar\'}}</td><td ng-if=\"vm.isUserAdmin()\"><div \nlayout=\"column\"><div><md-icon ng-if=\"item.produto.tipo === \'GRESSIVE\'\" class=\"s24 m-0 amber-500-fg mr-4\" \nmd-font-icon=\"icon-crown\"></md-icon><span>{{item.produto.nome}}</span></div><span>{{item.material.nome}} </span><span>\n{{item.tratamento.nome}}</span> <span>{{item.itrack_code}}</span></div></td><td ng-if=\"vm.isUserPolo()\" \nlayout=\"column\"><span>{{item.produto.nome}} </span><span class=\"md-caption\" style=\"width: 50px\">\n{{\'Caixa \'}} {{item.box || \'a informar\'}}</span></td><td ng-if=\"vm.isUserOtica()\" style=\"text-align: center\"><md-icon \nng-if=\"item.produto.tipo === \'GRESSIVE\'\" class=\"s24 m-0 amber-500-fg mr-4\" md-font-icon=\"icon-crown\"></md-icon><span>\n{{item.produto.nome}}</span></td><td ng-if=\"vm.isUserLab()\" style=\"text-align: center\"><span>\n{{item._prod_nome_tec_snap}}</span></td><td ng-if=\"vm.isUserLab()\" style=\"text-align: center\"><div layout=\"column\">\n<span>{{item.tratamento.nome_tecnico}} </span><span>{{item.itrack_code}}</span></div></td><td \nng-if=\" vm.isUserPolo() || vm.isUserOtica()\" style=\"text-align: center\"><span>{{item.tratamento.nome}} </span><span \nng-if=\"item.itrack_id\">{{item.itrack_code}}</span></td><td ng-if=\" vm.isUserPolo() || vm.isUserOtica()\" \nstyle=\"text-align: center\"><span>{{item.material.nome}}</span></td><td ng-if=\"vm.isUserLab()\" \nstyle=\"text-align: center\"><span>{{item.material.nome_tecnico}}</span></td><td \nng-if=\"vm.isUserAdmin() || vm.isUserPolo() || vm.isUserOtica()\"><div layout=\"column\"><span>\n{{item.vl_final | currency: \'R$ \'}} </span><span class=\"md-caption\">{{item._form_pag.nome}} </span><span \nclass=\"md-caption\">{{item._form_pag.label_parcela}}</span></div></td><td ng-if=\"vm.isUserAdmin() || vm.isUserPolo()\" \nstyle=\"text-align: center\">{{ item.vl_comissao | currency: \'R$ \'}}</td><td show-gt-sm \nng-class=\"{\'pedido-table-body\': vm.isUserAdmin()}\"><div>{{item.updated_at|w3DatePt}}</div><div><small><span \nclass=\"column-title\" data-translate=\"COMMON.CRIADO_EM\">Criado em:</span> {{item.created_at|w3DatePt}}</small></div>\n</td><td class=\"w-60\" style=\"text-align: center\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"mais opções\" \ntranslate translate-attr-aria-label=\"COMMON.MAIS_OPCOES\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-click=\"$mdMenu.open()\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.select(item.id)\" class=\"md-accent\" aria-label=\"Editar\" translate \ntranslate-attr-aria-label=\"COMMON.EDITAR\"><md-icon md-font-icon=\"icon-eye\" class=\"icon s28\"></md-icon>\n{{\'COMMON.VISUALIZAR\'|translate}}</md-button></md-menu-item><md-menu-item rf-acl-show-role=\"vendedor|gerente|dono\">\n<md-button ui-sref=\"xsession.pedido.edit({id:item.id})\" class=\"md-accent\" aria-label=\"Editar\" translate \ntranslate-attr-aria-label=\"COMMON.EDITAR\"><md-icon md-font-icon=\"icon-border-color\" class=\"icon s28\"></md-icon>\n{{\'COMMON.EDITAR\'|translate}}</md-button></md-menu-item><md-divider ng-if=\"vm.isUserAdmin()\"></md-divider><md-menu-item\n ng-if=\"vm.isUserAdmin() && item.status !== \'CANCELADO_ADMIN\'  && item.status !== \'CANCELADO_OTICA\'\"><md-button \nng-click=\"vm.cancelConfirm($event, item)\" class=\"md-warn\" aria-label=\"Cancelar\" translate \ntranslate-attr-aria-label=\"PEDIDO.CANCELAR\"><md-icon md-font-icon=\"icon-cancel\" class=\"icon s26\"></md-icon>\n{{\'PEDIDO.CANCELAR\'|translate}}</md-button></md-menu-item><md-menu-item ng-if=\"false\"><md-button \nng-click=\"vm.confirmDelete(item, $index, $event)\" class=\"md-warn\" aria-label=\"Excluir\" translate \ntranslate-attr-aria-label=\"COMMON.EXCLUIR\"><md-icon md-font-icon=\"icon-delete\" class=\"icon s26\"></md-icon>\n{{\'COMMON.EXCLUIR\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody><tfoot><tr><td \ncolspan=\"10\"><div layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\" layout-align-xs=\"none none\"><div \nlayout=\"row\" layout-align=\"start center\"><span data-translate=\"COMMON.EXIBINDO\">Exibindo</span><md-input-container \nclass=\"m-0\" style=\"top: -2px;    padding: 0 8px\"><md-select aria-label=\"Itens por página\" translate \ntranslate-attr-aria-label=\"COMMON.ITENS_POR_PAGINA\" ng-change=\"vm.search()\" ng-model=\"vm.params.paginate\"><md-option \nng-repeat=\"pag in [10, 15, 20, 25, 30, 50, 100]\" value=\"{{pag}}\">{{pag}} <span data-translate=\"COMMON.ITENS\">itens\n</span></md-option></md-select></md-input-container><span data-translate=\"COMMON.POR_PAGINA\">por página</span></div>\n<div layout=\"row\" layout-align=\"end center\"><w3-page-table w3-pagination=\"vm.pagination\" \nw3-set-page=\"vm.setPage($page)\"></w3-page-table></div></div></td></tr></tfoot></table></md-content></div></div></div>");
$templateCache.put("/app/external/pedido/pedido-by-status-show.html","<div class=\"page-layout simple tabbed model-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout-gt-sm=\"row\" \nlayout-sm=\"column\" layout-xs=\"column\" layout-align-xs=\"space-between start\"><div layout=\"column\" flex-gt-sm><div \nclass=\"white-fg flex-mobile-xs\" layout=\"row\" layout-align=\"start center\" flex><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-button ng-click=\"vm.goArchive()\" class=\"goto-products-button md-icon-button ml-0-imp\" \naria-label=\"voltar\" translate><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button></div><div layout=\"row\" \nlayout-align=\"start center\"><div layout-xs=\"row\" layout-sm=\"row\" layout-gt-sm=\"column\" layout-align-sm=\"start center\" \nlayout-align-gt-sm=\"start start\"><div layout=\"row\" layout-align=\"start center\"><span class=\"md-display-1 white-fg\" \ntranslate=\"PEDIDO.LIST_BY_STATUS.PAGE_HEADER.TITLE\" translate-values=\"{\'id\' : vm.activeRequestObj.id}\"></span></div>\n<div><pedido-label id=\"vm.activeRequestObj.status\" label=\"vm.activeRequestObj.status_label\"></pedido-label><md-chips \nclass=\"order-chips\"><md-chip ng-if=\"vm.activeRequestObj.sotelo_ref\" class=\"md-primary-bg md-raised\">\nDilab online: {{ vm.activeRequestObj.sotelo_ref }}</md-chip></md-chips></div></div></div></div><div layout=\"column\" \nng-hide=\"vm.isListEmpty()\"><div class=\"h6 secondary-text\" layout=\"row\"><span flex=\"30\" \ntranslate=\"PEDIDO.LIST_BY_STATUS.PAGE_HEADER.CREATED_AT\"></span> <span>{{ vm.activeRequestObj.created_at | w3DatePt}}\n</span></div><div class=\"h6 secondary-text\" layout=\"row\"><span flex=\"30\" \ntranslate=\"PEDIDO.LIST_BY_STATUS.PAGE_HEADER.UPDATED_AT\"></span> <span>{{ vm.activeRequestObj.updated_at | w3DatePt}}\n</span></div></div></div><div layout=\"row\" flex-gt-sm layout-align=\"start end\"><div layout=\"column\"><div layout=\"row\" \nclass=\"h6 secondary-text\" ng-if=\"vm.isUserPolo()\"><span class=\"margin-right-10\">Nro caixa: </span><span>\n{{vm.activeRequestObj.box || \'Não informado\'}}</span></div><div layout=\"row\" class=\"h6 secondary-text\" \nng-if=\"vm.isUserPolo() || vm.isUserOtica() || vm.isUserAdmin()\"><span class=\"margin-right-10\">Código de rastreio: \n</span><span>{{vm.activeRequestObj.cod_rastreamento || \'Não informado\'}}</span></div></div></div><div layout-xs=\"row\" \nlayout-sm=\"row\" layout-gt-sm=\"column\" layout-align=\"space-between end\"><pedido-actions layout=\"row\" \nlayout-align=\"end center\" request=\"vm.activeRequestObj\"></pedido-actions><div layout=\"row\" layout-align=\"end center\">\n<div class=\"margin-right-15\"><span class=\"md-body-2\" translate=\"PEDIDO.LIST_BY_STATUS.PAGE_HEADER.REQUEST_INDEX_OF\" \ntranslate-values=\"vm.navigationInfo\"></span></div><md-button ng-disabled=\"vm.isFirstRequest()\" type=\"button\" \nng-click=\"vm.goToPreviousRequest()\" \nng-class=\"vm.isFirstRequest() ? \'md-fab md-raised md-grey-600-bg\' :\'md-fab md-raised md-indigo-500-bg\'\" \naria-label=\"editar\"><md-tooltip>{{\'PEDIDO.LIST_BY_STATUS.BUTTON_TOOLTIP.PREVIOUS\'|translate}}</md-tooltip><md-icon \nmd-font-icon=\"icon-skip-previous\" class=\"white-text\"></md-icon></md-button><md-button ng-disabled=\"vm.isLastRequest()\" \ntype=\"button\" ng-click=\"vm.goToNextRequest()\" \nng-class=\"vm.isLastRequest() ? \'md-fab md-raised md-grey-600-bg\' : \'md-fab md-raised md-indigo-500-bg\'\" \naria-label=\"editar\"><md-icon md-font-icon=\"icon-skip-next\" class=\"white-text\"></md-icon><md-tooltip>\n{{\'PEDIDO.LIST_BY_STATUS.BUTTON_TOOLTIP.NEXT\'|translate}}</md-tooltip></md-button></div></div></div><md-content \nlayout-margin><div ng-hide=\"vm.isListEmpty()\"><pedido-detalhes request=\"vm.activeRequestObj\"></pedido-detalhes></div>\n<div ng-show=\"vm.isListEmpty()\" layout=\"column\" layout-align=\"center center\" layout-margin><md-icon \nmd-font-icon=\"icon-alert-box\" ng-style=\"{\'color\': \'red\', \'font-size\': \'48px\', height: \'48px\'}\"></md-icon><h1 \nclass=\"md-title\" translate=\"PEDIDO.LIST_BY_STATUS.EMPTY_LIST.TITLE\"></h1><p class=\"md-body-1\" \ntranslate=\"PEDIDO.LIST_BY_STATUS.EMPTY_LIST.MESSAGE\"></p></div></md-content></div>");
$templateCache.put("/app/external/pedido/pedido-form.html","<form ng-submit=\"vm.save()\" novalidate name=\"requestForm\"><div id=\"gen-pedido\" \nclass=\"page-layout simple tabbed model-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\" layout-xs=\"column\" layout-align-xs=\"space-between start\"><div \nclass=\"white-fg flex-mobile-xs\" layout=\"row\" layout-align=\"start center\" flex><md-button ng-click=\"vm.goArchive()\" \nclass=\"goto-products-button md-icon-button\" aria-label=\"voltar\" translate \ntranslate-attr-aria-label=\"PEDIDO.VOLTAR_ARCHIVE\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"md-display-1 white-fg\"><span>{{ \'Pedido de OS nro #\' + vm.row.nro_os}}</span>\n</div><div ng-if=\"vm.isOticaAprovada\"><span ng-if=\"vm.isRequestActive()\" class=\"text-boxed md-accent-bg\" \ntranslate=\"PEDIDO.ATIVO\">Ativo</span> <span ng-if=\"vm.isRequestDisabled()\" class=\"text-boxed grey-500-bg\" \ntranslate=\"PEDIDO.INATIVO\">Inativo</span></div></div><div ng-if=\"vm.isNew || !vm.isOticaAprovada\" \nclass=\"md-display-1 white-fg\" translate=\"PEDIDO.FORM.TITLE_NEW\">Adicionar novo pedido</div><div \nclass=\"subtitle secondary-text\"><span ng-if=\"!vm.isNew && vm.isOticaAprovada\" class=\"h2\" \ntranslate=\"PEDIDO.FORM.TITLE_EDIT\">Editar pedido</span></div><md-chips class=\"order-chips\"><md-chip \nng-if=\"vm.row.sotelo_ref\" class=\"md-primary-bg md-raised\">Dilab online: {{ vm.row.sotelo_ref }}</md-chip></md-chips>\n</div></div></div><div class=\"flex-mobile-xs\" layout=\"row\" layout-align-xs=\"end end\"><div \nrf-acl-show-role=\"polo|admin\"><md-button type=\"button\" ng-if=\"vm.isRequestActive()\" \nng-click=\"vm.cancelConfirm($event)\" class=\"md-fab md-raised md-red-500-bg\" aria-label=\"Cancelar\"><md-icon \nmd-font-icon=\"icon-cancel\" class=\"white-text\"></md-icon><md-tooltip>Cancelar pedido</md-tooltip></md-button></div>\n<md-button type=\"button\" ng-if=\"!vm.isNew && vm.isOticaAprovada\" ng-click=\"vm.select()\" \nng-disabled=\"vm.isRequestDisabled()\" class=\"md-fab md-raised\" aria-label=\"ver\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"md-accent-fg\"></md-icon><md-tooltip>{{\'COMMON.VISUALIZAR\'|translate}}</md-tooltip></md-button></div></div><div \nclass=\"content\"><div ng-if=\"vm.isOticaAprovada\"><div ng-if=\"vm.isNew\" ng-hide=\"vm.productSelected\" \nclass=\"padding-left-20 padding-right-20\"><ng-include \nsrc=\"\'/app/external/pedido/includes/_pedido-form-product-catalog.html\'\"></ng-include></div><div \nng-show=\"vm.productSelected || !vm.isNew\"><ng-include \nsrc=\"\'/app/external/pedido/includes/_pedido-form-card-general-information.html\'\"></ng-include><ng-include \nsrc=\"\'/app/external/pedido/includes/_pedido-form-card-product.html\'\" ng-show=\"vm.formStage > 1\" id=\"anchor2\">\n</ng-include><ng-include src=\"\'/app/external/pedido/includes/_pedido-form-card-prescription.html\'\" \nng-show=\"vm.formStage > 2\" id=\"anchor3\"></ng-include><ng-include \nsrc=\"\'/app/external/pedido/includes/_pedido-form-card-measure.html\'\" ng-show=\"vm.formStage > 3\" id=\"anchor4\">\n</ng-include><ng-include src=\"\'/app/external/pedido/includes/_pedido-form-card-eyeglasses-frames.html\'\" \nng-show=\"vm.formStage > 4\" id=\"anchor5\"></ng-include><div flex layout=\"row\" class=\"full-width\"><ng-include flex \nflex-auto src=\"\'/app/external/pedido/includes/_pedido-form-card-observation.html\'\" ng-show=\"vm.formStage > 4\" \nid=\"anchor6\"></ng-include><ng-include ng-if=\"vm.hasCorteRemoto()\" flex flex-auto \nsrc=\"\'/app/external/pedido/includes/_pedido-form-card-remote-cut.html\'\" ng-show=\"vm.formStage > 4\"></ng-include></div>\n<ng-include src=\"\'/app/external/pedido/includes/_pedido-form-card-missing-data.html\'\" ng-if=\"vm.tentouEnviarParaPolo\">\n</ng-include><ng-include ng-if=\"!vm.row.id || vm.row.id && vm.editableStates(vm.row.status) \" \nsrc=\"\'/app/external/pedido/includes/_pedido-form-card-action.html\'\"></ng-include></div></div><div \nng-if=\"!vm.isOticaAprovada\"><div layout=\"column\" layout-align=\"center center\" class=\"margin-30\" flex><div \nlayout=\"column\" layout-align=\"center center\" class=\"margin-top-10\" flex><div class=\"padding-right-24\"><md-icon \naria-label=\"empty state icon\" md-font-icon=\"icon-home\" class=\"red-500-fg\" \nng-style=\"{\'font-size\': \'48px\', height: \'48px\'}\"></md-icon></div><span class=\"md-title red-500-fg\">\nA sua Ótica não possui permissão para criar um pedido!!! </span><span class=\"md-title yellow-800-fg\">\nPara poder abrir um novo pedido, é necessário que a sua Ótica seja aprovada. </span><span class=\"md-subhead\">\nCaso você tenha certeza de que a sua Ótica foi aprovada, entre em contato com o responsável.</span></div></div></div>\n</div></div></form>");
$templateCache.put("/app/external/pedido/pedido-select-otica.html","<div id=\"gen-pedido\" class=\"page-layout simple tabbed model-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\" layout-xs=\"column\" layout-align-xs=\"space-between start\"><div \nclass=\"white-fg flex-mobile-xs\" layout=\"row\" layout-align=\"start center\" flex><md-button ng-click=\"vm.goArchive()\" \nclass=\"goto-products-button md-icon-button\" aria-label=\"voltar\" translate \ntranslate-attr-aria-label=\"PEDIDO.VOLTAR_ARCHIVE\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"md-display-1 white-fg\" translate=\"PEDIDO.FORM.TITLE_NEW\">Adicionar novo pedido</div></div></div></div></div><div\n class=\"content margin-10\" ng-cloak><div ng-if=\"vm.myResourceList.length\"><div layout=\"row\" \nlayout-align=\"center center\"><span class=\"md-title\">Selecione uma ótica para iniciar o pedido</span></div><div \nlayout-wrap layout=\"row\"><div flex=\"50\" flex-xl=\"33\" ng-repeat=\"item in vm.myResourceList\"><md-card><md-card-title \nclass=\"padding-10\"><md-card-title-text layout=\"row\" layout-align=\"center center\"><span>{{::item.nome}}</span>\n</md-card-title-text></md-card-title><md-divider class=\"blue-300-bg\"></md-divider><md-card-content><div \nlayout=\"column\"><div layout=\"column\" layout-align=\"start start\"><md-subheader>Identificação</md-subheader><div \nlayout=\"row\" layout-fill><div class=\"margin-vertical-5\" layout=\"row\" flex><div layout=\"row\" class=\"md-body-1\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-alpha\" class=\"margin-right-5 teal-400-fg\"></md-icon><span \nng-if=\"item.cnpj\">{{::item.cnpj | w3Cnpj }} </span><span ng-if=\"!item.cnpj\">{{\'-- -- -- --\'}}</span></div></div><div \nclass=\"margin-vertical-5\" layout=\"row\" flex><div layout=\"row\" class=\"md-body-1\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-alphabetical\" class=\"margin-right-5 teal-500-fg\"></md-icon><span>\n{{::item.razao_social || \'-- -- -- --\'}}</span></div></div></div></div><div layout=\"row\"><div layout=\"column\" \nlayout-align=\"start start\" flex><md-subheader>Contato</md-subheader><div class=\"margin-vertical-5\" layout=\"row\"><div \nlayout=\"row\" class=\"md-body-1\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-mail-ru\" \nclass=\"margin-right-5 blue-400-fg\"></md-icon><span>{{::item.email || \'-- -- -- --\'}}</span></div></div><div \nclass=\"margin-vertical-5\" layout=\"row\"><div layout=\"row\" class=\"md-body-1\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-web\" class=\"margin-right-5 blue-300-fg\"></md-icon><span>{{::item.website || \'-- -- -- --\'}}</span>\n</div></div><div class=\"margin-vertical-5\" layout=\"row\"><div layout=\"row\" class=\"md-body-1\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-cellphone-iphone\" class=\"margin-right-5 black-500-fg\">\n</md-icon><span>{{::item.celular || \'-- -- -- --\' | w3Phone}}</span></div></div><div class=\"margin-vertical-5\" \nlayout=\"row\"><div layout=\"row\" class=\"md-body-1\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-phone\" \nclass=\"margin-right-5 black-500-fg\"></md-icon><span>{{::item.telefone || \'-- -- -- --\' | w3Phone}}</span></div></div>\n</div><div layout=\"column\" layout-align=\"start start\" flex><md-subheader>Endereço</md-subheader><div \nclass=\"margin-vertical-5\" layout=\"row\"><div layout=\"row\" class=\"md-body-1\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-city\" class=\"margin-right-5 green-400-fg\"></md-icon><span>{{::item.cityAddress || \'-- -- -- --\'}}\n</span></div></div><div class=\"margin-vertical-5\" layout=\"row\"><div layout=\"row\" class=\"md-body-1\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-road\" class=\"margin-right-5 black-500-fg\"></md-icon><span>\n{{::item.streetAddress || \'-- -- -- --\'}}</span></div></div><div class=\"margin-vertical-5\" layout=\"row\"><div \nlayout=\"row\" class=\"md-body-1\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-code-tags\" \nclass=\"margin-right-5 grey-500-fg\"></md-icon><span>{{::item.cep || \'-- -- -- --\' | w3Cep }}</span></div></div></div>\n</div></div></md-card-content><md-divider class=\"blue-300-bg\"></md-divider><md-card-action class=\"padding-10\" \nlayout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.select(item.id)\" \nclass=\"md-raised green-500-bg white-500-fg\">Selecionar</md-button></md-card-action></md-card></div></div></div><div \nng-if=\"!vm.myResourceList.length\"><div layout=\"column\" layout-align=\"center center\" class=\"margin-30\" flex><div \nlayout=\"column\" layout-align=\"center center\" class=\"margin-top-10\" flex><div class=\"padding-right-24\"><md-icon \naria-label=\"empty state icon\" md-font-icon=\"icon-home\" class=\"red-500-fg\" \nng-style=\"{\'font-size\': \'48px\', height: \'48px\'}\"></md-icon></div><span class=\"md-title red-500-fg\">\nVocê não possui nenhuma Ótica aprovada pelo Admin!!! </span><span class=\"md-title yellow-800-fg\">\nPara poder abrir um novo pedido, é necessário que exista uma Ótica cadastrada e aprovada pelo Admin. </span><span \nclass=\"md-subhead\">Caso você tenha certeza de que existe alguma Ótica aprovada, entre em contato com o Admin.</span>\n<br><span class=\"md-subhead\">\nCaso você não tenha cadastrado nenhuma Ótica ainda, clique no botão abaixo e inicie o cadastro. </span><span \nclass=\"md-subhead\">Após cadastrar, aguarde o admin avaliar o cadastro e aprovar a nova Ótica.</span><md-button \nclass=\"md-raised green-500-bg white-500-fg\" ui-sref=\"app.otica.new\">Cadastrar Ótica</md-button></div></div></div></div>\n</div>");
$templateCache.put("/app/external/conta_bancaria/show_conta/show_conta.html","<div id=\"show-conta\" class=\"carded fullwidth\" layout=\"column\"><div class=\"center\"><div \nclass=\"header md-accent-bg p-16\" layout=\"row\" layout-align=\"start center\" layout-xs=\"column\" \nlayout-align-xs=\"space-between start\"><div class=\"white-fg flex-mobile-xs\" layout=\"row\" layout-align=\"start center\" \nflex><md-button ui-sref=\"xsession.contas\" class=\"goto-products-button md-icon-button\" aria-label=\"voltar\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div flex layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"md-display-1 white-fg\">{{vm.row.title}}</div><div \nclass=\"md-display-1 white-fg\">Detalhes da conta:</div><div class=\"subtitle secondary-text\" layout=\"column\"><span \nclass=\"h2\">Favorecido: {{vm.row.favorecido}}</span> <span class=\"h2\">Tipo: {{vm.row.tipo}}</span></div></div><div>\n<md-button ng-if=\"vm.isUserAdmin\" ng-click=\"vm.createAppSession()\" class=\"md-icon-button md-primary\" \naria-label=\"Criar uma sessão no aplicativo\"><md-icon md-font-icon=\"icon-cellphone-settings\" class=\"icon s28\"></md-icon>\n</md-button><md-button ng-click=\"vm.showDetailsConta(vm.row, vm.row.id)\" class=\"md-icon-button md-primary\" \naria-label=\"Visualizar\" translate translate-attr-aria-label=\"COMMON.EDITAR\"><md-icon md-font-icon=\"icon-eye\" \nclass=\"icon s28\"></md-icon></md-button></div></div></div></div><div class=\"content-card\"><div class=\"content p-24\"><div\n class=\"center\" layout=\"row\"><div flex=\"25\" class=\"widget-group pr-24\" layout=\"column\"><ms-widget flippable=\"false\" \nlayout=\"column\" flex=\"100\" class=\"pl-0 pr-0\"><ms-widget-front class=\"md-grey-200-bg border\" \nlayout-align=\"center center\"><div class=\"pl-16 pr-8 pv-16\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"red-fg font-size-48 line-height-48 ng-binding\">{{vm.totals.A_RECEBER.valor | currency}}</div><div \nclass=\"h3 secondary-text font-weight-500 ng-binding\">Valores a pagar ({{vm.totals.A_RECEBER.count}})</div></div>\n</ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" class=\"pl-0 pr-0\">\n<ms-widget-front class=\"md-grey-200-bg border\" layout-align=\"center center\"><div class=\"pl-16 pr-8 pv-16\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"green-fg font-size-48 line-height-48 ng-binding\">\n{{vm.totals.RECEBIDO.valor | currency}}</div><div class=\"h3 secondary-text font-weight-500 ng-binding\">\nValores Pagos ({{vm.totals.RECEBIDO.count}})</div></div></ms-widget-front></ms-widget></div><div flex><div \nclass=\"md-display-2\">Valores a pagar</div><table class=\"simple\" ms-responsive-table><thead><tr><th>Data</th><th>\nDescrição</th><th>Pedido</th><th>Valor</th></tr></thead><tbody><tr ng-repeat=\"trans in vm.archivePendentes\"><td>\n{{trans.dt_vencimento|w3DatePt}}</td><td><small>{{trans.descricao}}</small></td><td>{{trans._pedido_codigo}}</td><td>\n{{trans.vl_pagamento | currency}}</td></tr><tr ng-if=\"!vm.archivePendentes.length\"><td colspan=\"10\"><span \nclass=\"font-size-20 secondary-text text-center\">Você não tem nenhum débito pendente no momento.</span></td></tr>\n</tbody></table><br><br><br><div class=\"md-display-2\">Valores pagos</div><table class=\"simple\" ms-responsive-table>\n<thead><tr><th>Data</th><th>Descrição</th><th>Pedido</th><th>Valor</th></tr></thead><tbody><tr \nng-repeat=\"trans in vm.archivePagos\"><td>{{trans.dt_vencimento|w3DatePt}}</td><td><small>{{trans.descricao}}</small>\n</td><td>{{trans._pedido_codigo}}</td><td>{{trans.vl_pagamento | currency}}</td></tr><tr \nng-if=\"!vm.archivePagos.length\"><td colspan=\"10\"><span class=\"font-size-20 secondary-text text-center\">\nNão foram encontrados débitos pagos para esta conta</span></td></tr></tbody></table></div></div></div></div></div>\n</div>");
$templateCache.put("/app/external/fuse-core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("/app/external/minha-conta/conta-detail/conta-detail.html","<div class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header h-120\" \nng-class=\"{\'md-accent-bg\': vm.conta.entity_sub === \'padrao\',\'md-teal-500-bg\': vm.conta.entity_sub === \'gerente\', \'md-deep-purple-500-bg\': vm.conta.entity_sub === \'vendedor\'}\">\n<div layout=\"row\"><div flex><span class=\"h2\">#{{vm.conta.id}} {{vm.conta.entity_sub | uppercase}}</span><p>\n{{vm.conta.tipo}}<br>Conta: {{vm.conta.conta}}</p></div><div><md-button ng-click=\"vm.showEditConta($event)\" \ntype=\"button\" class=\"md-fab md-raised md-accent\" aria-label=\"editar\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"white-text\"></md-icon><md-tooltip>{{\'COMMON.EDITAR\'|translate}}</md-tooltip></md-button></div></div></div><div \nclass=\"content\"><md-tabs md-dynamic-height><md-tab id=\"tab1\"><md-tab-label>Extrato</md-tab-label><md-tab-body><div \nclass=\"simple-table-container md-whiteframe-4dp\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget class=\"pr-0\" flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\"><ms-widget-front \nclass=\"p-16 pink-400-bg white-fg\"><div class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" md-font-icon=\"icon-alarm\"></md-icon><div class=\"h3\">\nÀ receber</div></div></div><div layout=\"column\" layout-align=\"space-between\" flex><div class=\"pb-24\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"h2\">{{vm.extratoTotals.merged.A_RECEBER.valor | currency}}</div></div><div \nclass=\"secondary-text\">{{vm.extratoTotals.merged.A_RECEBER.count}} transações</div></div></ms-widget-front></ms-widget>\n<ms-widget class=\"pr-0\" flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\"><ms-widget-front \nclass=\"p-16 teal-400-bg white-fg\"><div class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" md-font-icon=\"icon-alarm-check\"></md-icon><div \nclass=\"h3\">Recebido</div></div></div><div layout=\"column\" layout-align=\"space-between\" flex><div class=\"pb-24\" \nlayout=\"row\" layout-align=\"center center\"><div class=\"h2\">{{vm.extratoTotals.merged.RECEBIDO.valor | currency}}</div>\n</div><div class=\"secondary-text\">{{vm.extratoTotals.merged.RECEBIDO.count}} transações</div></div></ms-widget-front>\n</ms-widget><ms-widget class=\"pr-0\" flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\">\n<ms-widget-front class=\"pl-16 pr-16 pb-16 pt-8 blue-bg white-fg\"><div class=\"pb-24\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" \nmd-font-icon=\"icon-alarm\"></md-icon><div class=\"h3\">Total</div></div><md-button ng-click=\"flipWidget()\" \nstyle=\"position: relative;right: -12px\" aria-label=\"more\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-cursor-pointer\"></md-icon></md-button></div><div layout=\"column\" layout-align=\"space-between\" flex>\n<div class=\"pb-24\" layout=\"row\" layout-align=\"center center\"><div class=\"h2\">\n{{vm.extratoTotals.total.valor | currency}}</div></div><div class=\"secondary-text\">\n{{vm.extratoTotals.total.count}} transações</div></div></ms-widget-front><ms-widget-back \nclass=\"p-16 pr-32 pink-400-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div layout=\"column\"><span>Atrasados ({{vm.extratoTotals.status.ATRASADO.count}}): <b>\n{{vm.extratoTotals.status.ATRASADO.valor | currency}}</b></span> <span>\nCancelados ({{vm.extratoTotals.status.CANCELADO.count}}): <b>{{vm.extratoTotals.status.CANCELADO.valor | currency}}</b>\n</span> <span>Em pagamento ({{vm.extratoTotals.status.EM_PAGAMENTO.count}}): <b>\n{{vm.extratoTotals.status.EM_PAGAMENTO.valor | currency}}</b></span></div></ms-widget-back></ms-widget><div flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"40\" class=\"pl-8\"><h3 class=\"secondary-text mt-8 mb-0 font-weight-500\">Buscar</h3><div \nlayout=\"column\" flex><div flex layout=\"row\" class=\"margin-top-5\"><md-input-container flex \nclass=\"margin-0 margin-right-5\"><label data-translate=\"PEDIDO.FILTER.DATE_TYPE\"></label><md-select \nng-model=\"vm.params.dt_column\"><md-option value=\"dt_vencimento\">Vencimento</md-option><md-option value=\"updated_at\">\nAtualização</md-option></md-select></md-input-container><md-input-container flex class=\"margin-0 margin-right-5\"><label\n data-translate=\"PEDIDO.FILTER.DATE_START\"></label><input ng-model=\"vm.params.dt_obj_start\" class=\"md-body-1\" \ntype=\"date\" ng-disabled=\"!vm.params.dt_column\"></md-input-container><md-input-container flex \nclass=\"margin-0 margin-right-5\"><label data-translate=\"PEDIDO.FILTER.DATE_END\"></label><input \nng-model=\"vm.params.dt_obj_end\" class=\"md-body-1\" type=\"date\" ng-disabled=\"!vm.params.dt_column\"></md-input-container>\n</div><div flex layout=\"row\" layout-align=\"none start\" class=\"margin-top-10 margin-bottom-5\"><md-input-container flex \nclass=\"margin-0 margin-right-5\"><label>Pedido/ Código</label><input ng-model=\"vm.params.q\" class=\"md-body-1\" \ntype=\"text\"></md-input-container><md-input-container flex class=\"margin-0 margin-left-5 margin-right-5\"><label \ndata-translate=\"PEDIDO.FILTER.STATUS\"></label><md-select ng-model=\"vm.params.status\"><md-option class=\"md-body-1\" \nvalue=\"PAGO\">Pago</md-option><md-option class=\"md-body-1\" value=\"CANCELADO\">Cancelado</md-option><md-option \nclass=\"md-body-1\" value=\"EM_PAGAMENTO\">Em Pagamento</md-option><md-option class=\"md-body-1\" value=\"ATRASADO\">Atrasado\n</md-option><md-option class=\"md-body-1\" value=\"PENDENTE\">Pendente</md-option></md-select></md-input-container><div \nlayout=\"column\" layout-align=\"space-around center\" class=\"pl-8 pr-8 pv-0\" style=\"position: relative;top: -16px\">\n<md-button class=\"md-icon-button mr-0 mb-5 md-raised\" style=\"margin-right: 0; margin-bottom: 5px\" \nng-click=\"vm.clearSearchExtrato()\" aria-label=\"Clear filter\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon>\n<md-tooltip>Limpar filtros</md-tooltip></md-button><md-button class=\"md-accent md-raised md-icon-button\" \naria-label=\"buscar\" ng-click=\"vm.searchExtrato()\" style=\"margin-right: 0\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon><md-tooltip><span data-translate=\"PEDIDO.BUSCAR\">Buscar</span></md-tooltip></md-button></div></div></div>\n</div></div><br><br><table class=\"simple\" ms-responsive-table><thead><tr><th>Data Prevista</th><th>Pedido</th><th>\nDescrição</th><th>Status</th><th>Pagamento</th><th>Valor</th><th>Comprovante</th></tr></thead><tbody><tr \nng-repeat=\"trans in vm.extrato\"><td>{{trans.dt_vencimento|w3DatePt}}</td><td>{{trans.pedido_code}}</td><td><small \nclass=\"secondary-text\">{{trans.descricao}}</small></td><td><span class=\"text-boxed\" \nng-class=\"{\'teal-400-bg white-fg\': trans.status === \'PAGO\', \'pink-400-bg white-fg\': trans.status === \'EM_PAGAMENTO\', \'amber-400-bg\': trans.status === \'ATRASADO\', \'blue-bg white-fg\': trans.status === \'PENDENTE\' }\">\n{{trans.status}}</span></td><td><small>{{trans._pago ? trans.updated_at : \'\' |w3DatePt}}</small></td><td>\n{{trans.vl_pagamento | currency}}</td><td><md-button ng-if=\"trans._pago\" href=\"{{trans.deposito._link}}\" \nclass=\"md-icon-button md-accent\" aria-label=\"comprovante\" target=\"_blank\"><md-icon md-font-icon=\"icon-file-document\">\n</md-icon></md-button></td></tr><tr ng-if=\"!vm.extrato.length\"><td colspan=\"7\"><span \nclass=\"font-size-20 secondary-text text-center\">Sem transações no momento</span></td></tr></tbody></table></div>\n</md-tab-body></md-tab><md-tab id=\"tab2\"><md-tab-label>Resgatar cupons</md-tab-label><md-tab-body layout=\"row\" \nlayout-align=\"center center\"><md-card ng-if=\"vm.cupomState === \'no-bank\'\" class=\"p-24\" \nstyle=\"width: 600px; margin: 0 auto\" layout=\"column\" layout-align=\"center center\"><h1>Sem banco</h1><p>\nNós percebemos que você ainda não configurou a sua conta, dessa forma não pdoeremos solicitar o depósito do seu bônus.\n</p><p>Por favor configure corretamente a sua conta para que possamos consluir sua solicitação.</p><div \nng-click=\"vm.showEditConta($event)\" layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" \nclass=\"md-fab md-raised md-accent\" aria-label=\"editar\"><md-icon md-font-icon=\"icon-pencil\" class=\"white-text\">\n</md-icon><md-tooltip>{{\'COMMON.EDITAR\'|translate}}</md-tooltip></md-button><span>Configurar agora</span></div>\n</md-card><md-card ng-if=\"vm.cupomState === \'init\'\" class=\"p-24\" style=\"width: 700px; margin: 0 auto\" layout=\"row\"><div\n class=\"p-24\" layout=\"column\" layout-align=\"center center\"><md-icon class=\"s80 teal-500-fg\" \nmd-font-icon=\"icon-credit-card\"></md-icon></div><div layout=\"column\" layout-align=\"center center\"><h1>\nResgatar cupom de bônus</h1><p>\nAo receber um pedido nós enviamos junto um cupom para que você possa resgatar um bônus, informe abaixo o código do seu cupom para solicitar o recebimento do mesmo.\n</p><p>Nós solicitaremos o depósito do seu bônus na conta <b>{{vm.conta.conta}}</b></p><form name=\"resgatarForm\" \nng-submit=\"vm.resgatarCupom()\" novalidate><div layout=\"row\" layout-align=\"center center\"><md-input-container \nmd-no-float class=\"md-block\"><input ng-model=\"vm.cupomCode\" type=\"text\" placeholder=\"00000\"></md-input-container>\n<md-button type=\"submit\" ng-disabled=\"resgatarForm.$invalid || resgatarForm.$pristine\" class=\"md-fab\" \naria-label=\"resgatar\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></div></form></div></md-card><md-card \nng-if=\"vm.cupomState === \'success\'\" class=\"p-24\" style=\"width: 600px; margin: 0 auto\" layout=\"column\" \nlayout-align=\"center center\"><h1>Cupom de bônus resgatado</h1><md-icon class=\"green-500-fg s80\" \nmd-font-icon=\"icon-emoticon\"></md-icon><p>\nNós solicitamos o depósito do seu bônus, você será notificado quando o valor for depositado e você pode acompanhar o processo no seu extrato.\n</p><span class=\"font-size-20\">{{vm.cupom.descricao}}</span> <span class=\"font-size-20\">Valor do cupom: <b>\n{{vm.cupom.vl_comissao | currency}}</b></span> <span class=\"font-size-20\">Pedido: {{vm.cupom.pedido_id}}</span><br><br>\n<md-button ng-click=\"vm.clearCupom()\" class=\"md-button md-raised md-accent\">Concluir</md-button></md-card>\n</md-tab-body></md-tab><md-tab id=\"tab3\"><md-tab-label>Conta</md-tab-label><md-tab-body><div \nclass=\"simple-table-container md-whiteframe-4dp\"><div ng-if=\"vm.cupomState === \'no-bank\'\" \nclass=\"border-bottom p-24 m-16\" layout=\"row\" layout-align=\"center center\"><md-icon class=\"s80 amber-400-fg\" \nmd-font-icon=\"icon-alert\"></md-icon><div class=\"pl-24\" layout=\"column\" layout-align=\"center center\"><p>\nNós percebemos que você ainda não configurou a sua conta, dessa forma não pdoeremos solicitar o depósito do seu bônus. Por favor configure corretamente a sua conta para que possamos consluir sua solicitação.\n</p></div><div class=\"w-300\" ng-click=\"vm.showEditConta($event)\" layout=\"row\" layout-align=\"center center\"><md-button \ntype=\"button\" class=\"md-fab md-raised md-accent\" aria-label=\"editar\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"white-text\"></md-icon><md-tooltip>{{\'COMMON.EDITAR\'|translate}}</md-tooltip></md-button><span>Configurar agora\n</span></div></div><div class=\"font-size-20 p-24\"><span class=\"md-title secondary-text\">Conta</span><p>\nIdenficação: {{vm.conta.id}}<br>Banco: {{vm.conta.banco}}<br>Tipo: {{vm.conta.tipo | uppercase}}<br><span \nng-if=\"vm.conta.tipo !== \'PAGSEGURO\'\">Agência: {{vm.conta.agencia}}<br></span>Conta: {{vm.conta.conta}}<br>\nDescrição: {{vm.conta.descricao}}</p><span class=\"md-title secondary-text\">Favorecido</span><p>\nFavorecido: {{vm.conta.favorecido}}<br>CPF: {{vm.conta.cpf}}</p></div><div \nclass=\"border-top ph-24 pv-10 secondary-text\" layout=\"row\"><div flex>Conta criada: {{vm.conta.created_at|w3DatePt}}\n</div><div flex>Última edição: {{vm.conta.updated_at|w3DatePt}}</div></div></div></md-tab-body></md-tab></md-tabs>\n</div></div>");
$templateCache.put("/app/external/fuse/cities/tabbed.html","<div class=\"page-layout simple tabbed cities\" layout=\"column\" ng-controller=\"TabsController as vm\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-xs=\"column\" layout-align-xs=\"space-between start\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-city mr-8\"></md-icon><span \nng-if=\"vm.selected_create === \'city\'\" translate=\"CITIES.CIDADES\">Cidades</span> <span \nng-if=\"vm.selected_create === \'state\'\" translate=\"CITIES.STATES\">STATES</span> <span \nng-if=\"vm.selected_create === \'country\'\" translate=\"CITIES.COUNTRYS\">COUNTRYS</span></div></div><div layout=\"row\">\n<md-button ng-click=\"vm.showCreate($event)\" class=\"md-fab md-primary\" aria-label=\"Nova cidade\" translate \ntranslate-attr-aria-label=\"COMMON.ADICIONAR_NOVO\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip><span \nng-if=\"vm.selected_create === \'city\'\" translate=\"CITIES.NEW_CIDADES\">Cidades</span> <span \nng-if=\"vm.selected_create === \'state\'\" translate=\"CITIES.NEW_STATES\">STATES</span> <span \nng-if=\"vm.selected_create === \'country\'\" translate=\"CITIES.NEW_COUNTRYS\">COUNTRYS</span></md-tooltip></md-button></div>\n</div><div class=\"content\"><md-tabs md-dynamic-height><md-tab md-on-select=\"vm.setCreate(\'city\')\"><md-tab-label><span \ntranslate=\"CITIES.CIDADES\">Cidades</span></md-tab-label><md-tab-body><div \nclass=\"content fullpage-datatable md-background-bg\" ui-view=\"viewTabCity\"></div></md-tab-body></md-tab><md-tab \nmd-on-select=\"vm.setCreate(\'state\')\"><md-tab-label><span translate=\"CITIES.STATES\">Estados</span></md-tab-label>\n<md-tab-body><div class=\"content fullpage-datatable md-background-bg\" ui-view=\"viewTabState\"></div></md-tab-body>\n</md-tab><md-tab md-on-select=\"vm.setCreate(\'country\')\"><md-tab-label><span translate=\"CITIES.COUNTRYS\">Países</span>\n</md-tab-label><md-tab-body><div class=\"content fullpage-datatable md-background-bg\" ui-view=\"viewTabCountry\"></div>\n</md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("/app/external/fuse/logs/logs-archive.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" flex><div class=\"header h-100\"><span class=\"h2 white-fg\" translate=\"LOGS.TITLE\">Atividades</span></div>\n<div class=\"content-card\"><md-content class=\"content no-padding\" ms-scroll><table class=\"dataTable row-border hover\" \nms-responsive-table w3-order-table=\"vm.params\" w3-change=\"vm.search()\"><thead><tr><th class=\"secondary-text\" \ndata-order=\"created_at\"><div class=\"table-header\"><span class=\"column-title\" translate=\"COMMON.CRIADO_EM\">Criado em\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"LOGS.TABLE.DESCRICAO\">Descrição</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"LOGS.TABLE.USUARIO\">Usuário</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header text-right\"><span class=\"column-title\" translate=\"COMMON.OPCOES\">Opções</span></div></th></tr>\n</thead><tbody><tr class=\"tr-notfound\" ng-show=\"vm.loading === false && vm.archive.length == 0\"><td colspan=\"10\"><span \ntranslate=\"LOGS.SEM_RESULTADOS\">Nenhum resultado encontrado</span></td></tr><tr \nng-repeat=\"item in vm.archive|orderBy:\'nome\'\" class=\"hover-table\"><td>{{item.created_at|w3DatePt}}</td><td>\n{{item.description}}</td><td>{{item.causer.first_name}}</td><td class=\"text-right\"><md-button \nng-click=\"vm.showDetail(item, $event)\" class=\"md-icon-button md-accent\" aria-label=\"Editar\" translate \ntranslate-attr-aria-label=\"COMMON.EDITAR\"><md-icon md-font-icon=\"icon-eye\" class=\"icon s28\"></md-icon></md-button></td>\n</tr></tbody><tfoot><tr><td colspan=\"10\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><span translate=\"COMMON.EXIBINDO\">Exibindo</span><md-input-container class=\"m-0\" \nstyle=\"top: -2px;    padding: 0 8px\"><md-select aria-label=\"Itens por página\" translate \ntranslate-attr-aria-label=\"COMMON.ITENS_POR_PAGINA\" ng-change=\"vm.search()\" ng-model=\"vm.params.paginate\"><md-option \nng-repeat=\"pag in [10, 15, 20, 25, 30, 50, 100]\" value=\"{{pag}}\">{{pag}} <span translate=\"COMMON.ITENS\">itens</span>\n</md-option></md-select></md-input-container><span translate=\"COMMON.POR_PAGINA\">por página</span></div><div \nlayout=\"row\" layout-align=\"end center\"><w3-page-table w3-pagination=\"vm.pagination\" w3-set-page=\"vm.setPage($page)\">\n</w3-page-table></div></div></td></tr></tfoot></table></md-content></div></div></div>");
$templateCache.put("/app/external/fuse/logs/tabbed.html","<div class=\"page-layout simple tabbed cities\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-xs=\"column\" layout-align-xs=\"space-between start\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-city mr-8\"></md-icon><span translate=\"CITIES.CIDADES\">Cidades</span></div></div><div layout=\"row\" \nclass=\"flex-mobile-xs\"></div></div><div class=\"content\"><md-tabs md-dynamic-height><md-tab><md-tab-label><span \ntranslate=\"CITIES.CIDADES\">Cidades</span></md-tab-label><md-tab-body><div \nclass=\"content fullpage-datatable md-background-bg\" ui-view=\"viewTabCity\"></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"CITIES.STATES\">Estados</span></md-tab-label><md-tab-body><div \nclass=\"content fullpage-datatable md-background-bg\" ui-view=\"viewTabState\"></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"CITIES.COUNTRYS\">Países</span></md-tab-label><md-tab-body><div \nclass=\"content fullpage-datatable md-background-bg\" ui-view=\"viewTabCountry\"></div></md-tab-body></md-tab></md-tabs>\n</div></div>");
$templateCache.put("/app/external/fuse/profile/profile-form.html","<form name=\"profileForm\" novalidate><div class=\"page-layout simple tabbed\" layout=\"column\"><div \nclass=\"header md-accent-bg\"><div layout=\"column\" layout-fill><div ng-if=\"vm.profile.id\" style=\"height: 37px\"></div><div\n flex layout=\"row\" layout-align=\"start center\" layout-xs=\"column\" layout-align-xs=\"space-between start\"><div \nclass=\"white-fg flex-mobile-xs\" layout=\"row\" layout-align=\"start center\" flex><md-button ui-sref=\"app.profile\" \nclass=\"goto-products-button md-icon-button\" aria-label=\"voltar\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n</md-button><div layout=\"row\" layout-align=\"start center\"><div class=\"md-avatar avatar contact-avatar huge\" hide-xs>\n<rf-avatar rf-size=\"100\" rf-profile=\"vm.profile\" rf-only-text=\"false\"></rf-avatar></div><div layout=\"column\" \nlayout-align=\"start start\"><h1 class=\"md-display-2 margin-0\">Editar perfil</h1></div></div></div><div \nclass=\"padding-left-10\" layout=\"row\" layout-align-xs=\"end end\"><md-button class=\"md-fab md-raised white-500-fg\" \nng-click=\"vm.onSaveResource()\" aria-label=\"Salvar\"><md-icon md-font-icon=\"icon-content-save\" class=\"green-500-fg\">\n</md-icon><md-tooltip><span data-translate=\"COMMON.SALVAR\">Salvar</span></md-tooltip></md-button></div></div><div \nng-if=\"vm.profile.id\" style=\"height: 37px\" layout=\"row\" layout-align=\"end center\"><div layout=\"column\" \nlayout-align=\"center end\" class=\"md-caption secondary-text\"><div layout=\"row\"><span class=\"margin-right-4\">Criado em: \n</span><span>{{vm.profile.created_at | w3DatePt}}</span></div><div layout=\"row\"><span class=\"margin-right-4\">\nAtualizado em: </span><span>{{vm.profile.updated_at | w3DatePt}}</span></div></div></div></div></div><div \nng-if=\"vm.sampleProfile\" class=\"padding-vertical-10 padding-horizontal-50\"><md-card><fieldset style=\"border-width: 0\" \nclass=\"margin-0 padding-0\"><div class=\"padding-10 md-body-1 mt-24\"><div layout=\"row\"><md-input-container flex \nclass=\"md-block margin-vertical-0 margin-horizontal-5\"><label>Nome de perfil</label><input \nng-model=\"vm.profile.first_name\" type=\"text\" ng-required=\"true\" name=\"first_name\" title=\"Primeiro nome\"><div \nng-messages=\"profileForm.first_name.$error\"><div ng-message=\"required\"><span>Informação obrigatória</span></div></div>\n</md-input-container><md-input-container flex class=\"md-block margin-vertical-0 margin-horizontal-5\"><label>Email\n</label><input ng-model=\"vm.profile.email\" type=\"text\" name=\"email\" title=\"email\"></md-input-container></div><div flex \nclass=\"margin-vertical-20\"><div flex layout=\"row\"><md-input-container \nclass=\"md-block margin-bottom-0 margin-horizontal-5\"><label>Nova Senha</label><input ng-model=\"vm.profile.password\" \ntype=\"password\" name=\"password\" title=\"Senha\"></md-input-container><md-input-container \nclass=\"md-block margin-bottom-0 margin-horizontal-5\"><label>Confirme a Nova Senha</label><input \nng-model=\"vm.profile.password_confirmation\" type=\"password\" name=\"password_confimation\" title=\"Confirme a sua senha\">\n</md-input-container><div flex layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.onSaveResource()\" \nclass=\"md-raised md-accent\">Salvar</md-button></div></div></div></div></fieldset></md-card></div><div \nng-if=\"!vm.sampleProfile\" class=\"padding-vertical-10 padding-horizontal-50\"><div ng-if=\"vm.pageLoaded\"><div><md-card>\n<md-card-title><md-card-title-text><h3>Dados de Identificacao</h3></md-card-title-text></md-card-title>\n<md-card-content><div class=\"padding-10 md-body-1\"><fieldset style=\"border-width: 0\" class=\"margin-0 padding-0\"><div \nflex class=\"margin-vertical-20\" layout=\"row\"><div flex><md-input-container \nclass=\"md-block margin-vertical-0 margin-horizontal-5\"><label>Primeiro nome</label><input \nng-model=\"vm.profile.first_name\" type=\"text\" ng-required=\"true\" name=\"first_name\" title=\"Primeiro nome\"><div \nng-messages=\"profileForm.first_name.$error\"><div ng-message=\"required\"><span>Informação obrigatória</span></div></div>\n</md-input-container></div><div flex><md-input-container class=\"md-block margin-vertical-0 margin-horizontal-5\"><label>\nSobrenome</label><input ng-model=\"vm.profile.last_name\" type=\"text\" name=\"last_name\" title=\"Sobrenome\">\n</md-input-container></div></div><div flex class=\"margin-vertical-20\" layout=\"row\"><div flex><md-input-container \nclass=\"md-block margin-vertical-0 margin-horizontal-5\"><label>Aniversário</label><input \nng-model=\"vm.profile.birthdayObject\" type=\"date\" name=\"birthday\" title=\"Aniversário\"></md-input-container></div><div \nflex><md-input-container class=\"md-block margin-vertical-0 margin-horizontal-5\"><label>Cargo</label><input \nng-model=\"vm.profile.occupation\" type=\"text\" name=\"occupation\" title=\"Cargo\"></md-input-container></div><div flex>\n<md-input-container class=\"md-block margin-vertical-0 margin-horizontal-5\"><span class=\"secondary-text\">Sexo</span>\n<md-radio-group ng-model=\"vm.profile.sex\" layout=\"row\"><md-radio-button value=\"female\">Feminino</md-radio-button>\n<md-radio-button value=\"male\">Masculino</md-radio-button></md-radio-group></md-input-container></div></div><div flex \nclass=\"margin-vertical-20\" layout=\"row\"><div flex><md-input-container \nclass=\"md-block margin-vertical-0 margin-horizontal-5\"><label>Sobre</label><textarea ng-model=\"vm.profile.about\" \ntitle=\"Sobre\" rows=\"5\" max-rows=\"5\" md-maxlength=\"245\" maxlength=\"245\" name=\"about\">\n                          \n</textarea></md-input-container></div></div></fieldset></div></md-card-content></md-card><md-card><md-card-title>\n<md-card-title-text><h3>Dados de Contato</h3></md-card-title-text></md-card-title><md-card-content><div \nclass=\"padding-10 md-body-1\"><fieldset style=\"border-width: 0\" class=\"margin-0 padding-0\"><div flex \nclass=\"margin-vertical-20\" layout=\"row\"><div flex><md-input-container \nclass=\"md-block margin-vertical-0 margin-horizontal-5\"><label>Telefone</label><input ng-model=\"vm.profile.phone\" \ntype=\"text\" mask=\"{{$root.fmask.tel}}\" name=\"phone\" title=\"Telefone\"></md-input-container></div><div flex>\n<md-input-container class=\"md-block margin-vertical-0 margin-horizontal-5\"><label>Celular</label><input \nng-model=\"vm.profile.cellphone\" type=\"text\" mask=\"{{$root.fmask.cel}}\" name=\"cellphone\" title=\"Celular\">\n</md-input-container></div></div><div flex class=\"margin-vertical-20\" layout=\"row\"><div flex><md-input-container \nclass=\"md-block margin-vertical-0 margin-horizontal-5\"><label>Email</label><input ng-model=\"vm.profile.email\" \ntype=\"text\" name=\"email\" title=\"email\"></md-input-container></div><div flex><md-input-container \nclass=\"md-block margin-vertical-0 margin-horizontal-5\"><label>Skype</label><input ng-model=\"vm.profile.skype\" \ntype=\"text\" name=\"skype\" title=\"Skype\"></md-input-container></div></div></fieldset></div></md-card-content></md-card>\n<md-card><md-card-title><md-card-title-text><h3>Endereço</h3></md-card-title-text></md-card-title><md-card-content><div\n class=\"padding-10 md-body-1\"><fieldset style=\"border-width: 0\" class=\"margin-0 padding-0\"><div flex \nclass=\"margin-vertical-20\" layout=\"row\"><div flex><md-input-container \nclass=\"md-block margin-bottom-0 margin-horizontal-5\"><label>CEP</label><input ng-model=\"vm.profile.postcode\" \ntype=\"text\" mask=\"{{$root.fmask.cep}}\" ng-blur=\"vm.onCepBlur()\" name=\"postcode\" title=\"CEP\"></md-input-container></div>\n<div flex><div class=\"margin-horizontal-5\"><rf-input-city rf-city=\"vm.profile.city\" ng-model=\"vm.profile.city_id\" \nrf-open-create=\"true\" flex></rf-input-city><input ng-model=\"vm.profile.city_id\" type=\"hidden\"></div></div></div><div \nflex class=\"margin-vertical-20\"><div flex class=\"margin-vertical-20\" layout=\"row\"><div flex><md-input-container \nclass=\"md-block margin-vertical-0 margin-horizontal-5\"><label>Bairro</label><input ng-model=\"vm.profile.district\" \ntype=\"text\" name=\"district\" title=\"Bairro\"></md-input-container></div><div flex><md-input-container \nclass=\"md-block margin-vertical-0 margin-horizontal-5\"><label>Rua</label><input ng-model=\"vm.profile.street\" \ntype=\"text\" name=\"street\" title=\"Rua\"></md-input-container></div><div flex><md-input-container \nclass=\"md-block margin-vertical-0 margin-horizontal-5\"><label>Numero</label><input ng-model=\"vm.profile.number\" \ntype=\"text\" name=\"number\" title=\"Numero\"></md-input-container></div></div></div><div flex class=\"margin-vertical-20\" \nlayout=\"row\"><div flex><md-input-container class=\"md-block margin-vertical-0 margin-horizontal-5\"><label>Complemento\n</label><textarea ng-model=\"vm.profile.complement\" md-maxlength=\"245\" maxlength=\"245\" rows=\"5\" name=\"complement\" \ntitle=\"complemento\" minlength=\"10\" max-rows=\"5\">\n                          </textarea></md-input-container></div></div>\n</fieldset></div></md-card-content></md-card><md-card><md-card-title><md-card-title-text><h3>Avatar</h3>\n</md-card-title-text></md-card-title><md-card-content><fieldset style=\"border-width: 0\" class=\"margin-0 padding-0\"><div\n class=\"padding-10 md-body-1\"><div flex class=\"margin-vertical-20\"><w3-image-dialog path=\"vm.profile.thumb\" \npath-src=\"vm.profile.thumb_src\" size=\"thumb\" gallery=\"profiles\" title=\"Selecione a sua imagem de perfil\" \nconfig=\"vm.uploadConfig\"></w3-image-dialog></div></div></fieldset></md-card-content></md-card><md-card><md-card-title>\n<md-card-title-text><h3>Senha</h3></md-card-title-text></md-card-title><md-card-content><fieldset \nstyle=\"border-width: 0\" class=\"margin-0 padding-0\"><div class=\"padding-10 md-body-1\"><div flex \nclass=\"margin-vertical-20\"><div flex><md-input-container class=\"md-block margin-bottom-0 margin-horizontal-5\"><label>\nNova Senha</label><input ng-model=\"vm.profile.password\" type=\"password\" name=\"password\" title=\"Senha\">\n</md-input-container></div><div flex><md-input-container class=\"md-block margin-bottom-0 margin-horizontal-5\"><label>\nConfirme a Nova Senha</label><input ng-model=\"vm.profile.password_confirmation\" type=\"password\" \nname=\"password_confimation\" title=\"Confirme a sua senha\"></md-input-container></div></div></div></fieldset>\n</md-card-content></md-card><div class=\"padding-10\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-fab white-500-bg\" ng-click=\"vm.onSaveResource()\" aria-label=\"Salvar\"><md-icon \nmd-font-icon=\"icon-content-save\" class=\"green-500-fg\"></md-icon><md-tooltip><span data-translate=\"COMMON.SALVAR\">Salvar\n</span></md-tooltip></md-button></div></div></div></div><div ng-if=\"!vm.pageLoaded\"><div layout=\"column\" \nlayout-align=\" center center\" class=\"margin-30\"><div class=\"padding-10\"><h3 class=\"margin-0\">Buscando dados de perfil\n</h3></div><div class=\"padding-10\"><h4 class=\"margin-0\">Aguarde um momento</h4></div><div class=\"padding-10\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></div></div></div></form>");
$templateCache.put("/app/external/fuse/profile/profile-show.html","<div id=\"profile-page\" class=\"page-layout blank md-background-bg md-hue-2\" layout=\"row\" layout-align=\"center start\">\n<div class=\"md-whiteframe-5dp md-background-bg\" flex flex-gt-sm=\"60\"><div layout=\"column\" layout-gt-xs=\"row\" \nclass=\"pl-32 pv-16\"><div class=\"w-232\" layout=\"row\" layout-align=\"start end\"><rf-avatar rf-size=\"200\" \nrf-profile=\"vm.profile\" rf-only-text=\"false\"></rf-avatar><md-icon ng-if=\"vm.isBirthday\" \nclass=\"birthday s40 amber-500-fg\" md-font-icon=\"icon-cake\"></md-icon></div><div flex><div layout=\"row\" \nlayout-align=\"space-between start\"><h2 class=\"md-display-1 mb-8\">{{vm.profile.name}}</h2><md-menu><md-button \nclass=\"md-icon-button\" aria-label=\"mais opções\" translate translate-attr-aria-label=\"COMMON.MAIS_OPCOES\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button ui-sref=\"app.profile.update\" class=\"md-accent\" aria-label=\"Editar\" translate \ntranslate-attr-aria-label=\"COMMON.EDITAR\"><md-icon md-font-icon=\"icon-border-color\" class=\"icon s28\"></md-icon>\n{{\'COMMON.EDITAR\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></div><span class=\"font-size-18\">\n{{vm.profile.email}}</span><br><span ng-if=\"vm.profile.status\" class=\"font-size-18\">Usuário ativo</span><br><span \nclass=\"font-size-18\">Último login: {{vm.profile.last_activity_dt|w3DatePt}}</span></div></div><md-divider></md-divider>\n<div class=\"pl-32 pv-16\"><span class=\"font-size-18 secondary-text\">\nCadastro no sistema: {{vm.profile.created_at|w3DatePt}}</span><br><span class=\"font-size-18 secondary-text\"><span \nng-repeat=\"rol in vm.profile.roles.data\"><span class=\"padding-5 text-boxed blue-500-bg white-500-fg\">\n{{rol.display_name}}</span></span></span></div><md-divider></md-divider><div class=\"pl-32 pv-16 secondary-text\"><span \nclass=\"font-size-18\">Nome completo: {{vm.profile.name}}</span><br><div layout=\"row\"><span flex class=\"font-size-18\">\nData de nascimento: {{vm.profile.birthday|w3DatePt}}</span> <span flex class=\"font-size-18\">\nGenero: {{vm.profile.sexLabel || \'-- -- -- --\'}}</span></div></div><md-divider></md-divider><div \nclass=\"pl-32 pv-16 secondary-text\"><div layout=\"row\"><span class=\"font-size-18 padding-right-5\">Endereço:</span><div \nlayout=\"column\"><span flex class=\"font-size-18\">{{vm.profile.address_city || \'-- -- -- --\'}}</span> <span flex \nclass=\"font-size-18\">{{vm.profile.address_street || \'-- -- -- --\'}}</span></div></div></div><md-divider></md-divider>\n<div class=\"pl-32 pv-16 secondary-text\"><div layout=\"row\"><span flex class=\"font-size-18\" ng-if=\"vm.profile.phone\">\nTelefone: {{vm.profile.phone | w3Phone}} </span><span flex class=\"font-size-18\" ng-if=\"!vm.profile.phone\">\nTelefone: {{\'-- -- -- --\'}} </span><span flex class=\"font-size-18\" ng-if=\"vm.profile.cellphone\">\nCelular: {{vm.profile.cellphone|w3Phone}} </span><span flex class=\"font-size-18\" ng-if=\"!vm.profile.cellphone\">\nCelular: {{\'-- -- -- --\'}}</span></div><div layout=\"row\"><span flex class=\"font-size-18\">\nSkype: {{vm.profile.skype || \'-- -- -- --\'}}</span> <span flex class=\"font-size-18\">\nCargo: {{vm.profile.occupation|| \'-- -- -- --\'}}</span></div></div><md-divider></md-divider><div \nclass=\"pl-32 pv-16 secondary-text\"><span class=\"font-size-18\">Sobre</span><p class=\"font-size-18 padding-left-5\">\n{{vm.profile.about || \'Escreva mais sobre você =D\'}}</p></div></div></div>");
$templateCache.put("/app/external/fuse/suporte/suporte.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" flex><div class=\"header h-20\"></div><div class=\"content-card\"><md-content class=\"content\" \nstyle=\"padding-top: 8px\" ms-scroll><script type=\"text/javascript\" \nsrc=\"https://s3.amazonaws.com/assets.freshdesk.com/widget/freshwidget.js\"></script><style type=\"text/css\" \nmedia=\"screen, projection\">@import url(https://s3.amazonaws.com/assets.freshdesk.com/widget/freshwidget.css);</style>\n<iframe title=\"Feedback Form\" class=\"freshwidget-embedded-form\" id=\"freshwidget-embedded-form\" \nsrc=\"https://valmirbarbosa.freshdesk.com/widgets/feedback_widget/new?&widgetType=embedded&formTitle=Suporte&submitTitle=Enviar+ticket&submitThanks=Ol%C3%A1%2C%0D%0ASua+solicita%C3%A7%C3%A3o+foi+recebida+e+ser%C3%A1+analisada+pela+nossa+equipe.%0D%0A%0D%0AN%C3%B3s+estaremos+entrando+em+contato+para+lhe+manter+informado.%0D%0A%0D%0AAtenciosamente&screenshot=no&searchArea=no\" \nscrolling=\"no\" height=\"450px\" width=\"100%\" frameborder=\"0\"></iframe><md-button target=\"_blank\" \nhref=\"http://suporte.valmirbarbosa.com.br/index.php?a=add&catid=12&s-name={{rapiProfile.name}}&s-email={{rapiProfile.email}}\">\nEnviar um novo chamado</md-button></md-content></div></div></div>");
$templateCache.put("/app/external/fuse/user/rf-user-list.tmpl.html","<div class=\"rf-comment\"><div class=\"section-content\"><div layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"md-title\">Usuários</span><md-button ng-click=\"vm.openNewUser()\" class=\"md-fab md-primary mr-0\" \naria-label=\"adicionar novo\" translate translate-attr-aria-label=\"COMMON.ADICIONAR_NOVO\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"mb-8 user-item\" ng-repeat=\"item in vm.users\"><div \nlayout=\"row\" flex class=\"md-whiteframe-1dp p-10\"><div class=\"w-70 mr-8\"><rf-avatar rf-size=\"60\" rf-profile=\"item.user\" \nrf-only-text=\"false\"></rf-avatar></div><div flex layout=\"row\"><div flex layout=\"column\"><strong>{{item.user.name}}\n<md-icon ng-if=\"item.is_owner\" class=\"amber-500-fg\" md-font-icon=\"icon-crown\"><md-tooltip>Usuário administrativo\n</md-tooltip></md-icon></strong><span>{{item.user.email}}</span> <small ng-if=\"item.user.last_activity_dt\" \nclass=\"secondary-text\">Último acesso: {{item.user.last_activity_dt|w3Moments}}</small> <span \nclass=\"light-blue-500-fg mt-8\"><md-icon class=\"light-blue-500-fg s16\" md-font-icon=\"icon-lock-outline\"></md-icon>\n{{item.permission}}</span></div><div layout=\"column\" layout-align=\"center center\"><md-button class=\"md-icon-button\" \nng-click=\"item.showBtn = !item.showBtn\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div>\n<div ng-show=\"item.showBtn\" layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"vm.removeShared(item, $index, $event)\" class=\"md-icon-button\" aria-label=\"Revogar acesso\"><md-icon \nclass=\"amber-500-fg\" md-font-icon=\"icon-account-remove\"></md-icon><md-tooltip>Revogar acesso</md-tooltip></md-button>\n<md-button ui-sref=\"app.user.edit({id:item.user_id})\" class=\"md-icon-button\" aria-label=\"Editar\"><md-icon \nclass=\"light-blue-500-fg\" md-font-icon=\"icon-border-color\"></md-icon><md-tooltip>Editar</md-tooltip></md-button>\n<md-button ng-click=\"vm.deleteUser(item, $index, $event)\" class=\"md-icon-button\" aria-label=\"Excluir\"><md-icon \nclass=\"red-600-fg\" md-font-icon=\"icon-trash\"></md-icon><md-tooltip>Excluir</md-tooltip></md-button></div></div></div>\n<div ng-if=\"!vm.users.length\" class=\"p-16\"><span>Nenhum usuário encontrado.</span></div></div></div>");
$templateCache.put("/app/external/fuse/user/user-archive.html","<div id=\"gen-user\" class=\"page-layout carded fullwidth single-scroll model-page\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" flex><div class=\"heading\"><div layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"white-text mob-100\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon class=\"mr-8\" \nmd-font-icon=\"icon-account\"></md-icon><span translate=\"USER.TITLE_ARCHIVE\">User</span></div><div \nclass=\"product-count secondary-text\"><span translate=\"USER.TOTAL\" translate-values=\"{\'total\':vm.pagination.total}\">\nTotal de cadastros {vm.pagination.total}</span></div></div><div layout=\"row\" layout-align=\"end center\" class=\"mob-100\">\n<md-button ng-click=\"vm.searchActive = !vm.searchActive\" class=\"md-icon-button\" aria-label=\"Search\" translate \ntranslate-attr-aria-label=\"buscar\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip><span \ntranslate=\"USER.BUSCAR\">Buscar</span></md-tooltip></md-button><md-button ui-sref=\"app.user.new\" \nclass=\"md-fab md-primary mr-0\" aria-label=\"adicionar novo\" translate translate-attr-aria-label=\"COMMON.ADICIONAR_NOVO\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div><div ng-if=\"vm.searchActive\" \nclass=\"search-boxes animate-slide-down\" layout=\"column\"><div class=\"mb-8\" flex flex-gt-xs=\"100\" layout=\"column\" \nlayout-gt-xs=\"row\"><div flex class=\"search-item md-whiteframe-3dp mr-8 md-background-bg\" layout=\"row\" \nlayout-align=\"start center\"><input flex ng-model=\"vm.params.q\" class=\"md-primary-fg\" type=\"text\" \nplaceholder=\"{{\'USER.BUSCAR\'|translate}}\"></div><div layout=\"row\" layout-align=\"end end\"><md-button \nclass=\"md-accent md-raised md-icon-button\" aria-label=\"buscar\" ng-click=\"vm.search()\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><md-tooltip><span translate=\"USER.BUSCAR\">Buscar</span></md-tooltip></md-button>\n<md-button ng-show=\"vm.searchActive\" class=\"md-icon-button mr-0 md-raised\" ng-click=\"vm.clearFilter()\" \naria-label=\"Clear filter\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip>Limpar filtros</md-tooltip>\n</md-button></div></div></div></div><div class=\"content-card\"><md-content class=\"content no-padding\" ms-scroll><table \nclass=\"dataTable row-border hover\" ms-responsive-table w3-order-table=\"vm.params\" w3-change=\"vm.search()\"><thead><tr>\n<th></th><th class=\"secondary-text\" data-order=\"name\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"USER.TABLE.NAME\">Nome</span></div></th><th class=\"secondary-text\" data-order=\"email\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"USER.TABLE.EMAIL\">Email</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"USER.SITUACAO\">Situação</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"COMMON.CRIADO_EM\">Criado em</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><md-menu>\n<md-button aria-label=\"more\" class=\"md-icon-button md-primary\" ng-click=\"$mdMenu.open()\"><i \nclass=\"icon icon-chevron-double-down s32\"></i></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.getAllItens()\" aria-label=\"Todos\">{{\'USER.TODOS\'|translate}}</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.getTrasehdItens()\" aria-label=\"Apenas os inativos\">{{\'USER.APENAS_INATIVOS\'|translate}}\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.getOnlyActiveItens()\" \naria-label=\"Apenas os ativos (padrão)\">{{\'USER.APENAS_ATIVOS\'|translate}}</md-button></md-menu-item></md-menu-content>\n</md-menu></div></th></tr></thead><tbody><tr class=\"tr-notfound\" ng-show=\" vm.archive.length == 0\"><td colspan=\"10\">\n<span translate=\"USER.SEM_RESULTADOS\">Nenhum resultado encontrado</span></td></tr><tr ng-repeat=\"item in vm.archive\" \nclass=\"hover-table\"><td ui-sref=\"app.user.edit({id:item.id})\" class=\"rf-pointer\"><rf-avatar rf-size=\"60\" \nrf-profile=\"item\" rf-only-text=\"false\"></rf-avatar></td><td ui-sref=\"app.user.edit({id:item.id})\" class=\"rf-pointer\">\n<b>#{{item.id}} - {{item.name}}</b></td><td>{{item.email}}</td><td><span ng-if=\"!item.deleted_at\" \nclass=\"text-boxed md-accent-bg\" translate=\"USER.ATIVO\">Ativo</span> <span ng-if=\"item.deleted_at\" \nclass=\"text-boxed grey-500-bg\" translate=\"USER.INATIVO\">Inativo</span></td><td><div>{{item.created_at|w3DatePt}}</div>\n</td><td><md-menu><md-button class=\"md-icon-button\" aria-label=\"mais opções\" translate \ntranslate-attr-aria-label=\"COMMON.MAIS_OPCOES\" ng-click=\"$mdMenu.open()\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ui-sref=\"app.user.show({id:item.id})\" \nclass=\"md-accent\" aria-label=\"Editar\" translate translate-attr-aria-label=\"COMMON.EDITAR\"><md-icon \nmd-font-icon=\"icon-eye\" class=\"icon s28\"></md-icon>{{\'COMMON.VISUALIZAR\'|translate}}</md-button></md-menu-item>\n<md-menu-item><md-button ui-sref=\"app.user.edit({id:item.id})\" class=\"md-accent\" aria-label=\"Editar\" translate \ntranslate-attr-aria-label=\"COMMON.EDITAR\"><md-icon md-font-icon=\"icon-border-color\" class=\"icon s28\"></md-icon>\n{{\'COMMON.EDITAR\'|translate}}</md-button></md-menu-item><md-menu-item ng-if=\"!item.deleted_at\"><md-button \nng-click=\"vm.disableConfirm($event, item)\" class=\"amber-600-fg\" aria-label=\"Desativar\" translate \ntranslate-attr-aria-label=\"COMMON.EXCLUIR\"><md-icon md-font-icon=\"icon-power\" class=\"icon s26 amber-600-fg\"></md-icon>\n{{\'USER.DESATIVAR\'|translate}}</md-button></md-menu-item><md-menu-item ng-if=\"item.deleted_at\"><md-button \nng-click=\"vm.restoreConfirm($event, item)\" class=\"md-accent\" aria-label=\"Restaurar\" translate \ntranslate-attr-aria-label=\"COMMON.EXCLUIR\"><md-icon md-font-icon=\"icon-replay\" class=\"icon s26 md-accent-fg\"></md-icon>\n{{\'USER.RESTAURAR\'|translate}}</md-button></md-menu-item><md-divider></md-divider><md-menu-item><md-button \nng-click=\"vm.confirmDelete(item, $index, $event)\" class=\"md-warn\" aria-label=\"Excluir\" translate \ntranslate-attr-aria-label=\"COMMON.EXCLUIR\"><md-icon md-font-icon=\"icon-delete\" class=\"icon s26\"></md-icon>\n{{\'COMMON.EXCLUIR\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody><tfoot><tr><td \ncolspan=\"10\"><div layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\" layout-align-xs=\"none none\"><div \nlayout=\"row\" layout-align=\"start center\"><span translate=\"COMMON.EXIBINDO\">Exibindo</span><md-input-container \nclass=\"m-0\" style=\"top: -2px;    padding: 0 8px\"><md-select aria-label=\"Itens por página\" translate \ntranslate-attr-aria-label=\"COMMON.ITENS_POR_PAGINA\" ng-change=\"vm.search()\" ng-model=\"vm.params.paginate\"><md-option \nng-repeat=\"pag in [10, 15, 20, 25, 30, 50, 100]\" value=\"{{pag}}\">{{pag}} <span translate=\"COMMON.ITENS\">itens</span>\n</md-option></md-select></md-input-container><span translate=\"COMMON.POR_PAGINA\">por página</span></div><div \nlayout=\"row\" layout-align=\"end center\"><w3-page-table w3-pagination=\"vm.pagination\" w3-set-page=\"vm.setPage($page)\">\n</w3-page-table></div></div></td></tr></tfoot></table></md-content></div></div></div>");
$templateCache.put("/app/external/fuse/user/user-form.html","<form ng-submit=\"vm.save()\" novalidate><div id=\"gen-user\" class=\"page-layout simple tabbed model-page\" layout=\"column\">\n<div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"start center\" layout-xs=\"column\" \nlayout-align-xs=\"space-between start\"><div class=\"white-fg flex-mobile-xs\" layout=\"row\" layout-align=\"start center\" \nflex><div layout=\"row\" layout-align=\"start center\"><div class=\"md-avatar avatar contact-avatar huge\" hide-xs><rf-avatar\n rf-size=\"90\" rf-profile=\"vm.row\" rf-only-text=\"false\"></rf-avatar></div><div layout=\"column\" \nlayout-align=\"start start\"><div layout=\"row\" layout-align=\"start center\"><div class=\"md-display-1 white-fg\">\n{{vm.row.name}}</div><span ng-if=\"!vm.row.deleted_at && !vm.isNew\" class=\"text-boxed md-accent-bg\" \ntranslate=\"USER.ATIVO\">Ativo</span> <span ng-if=\"vm.row.deleted_at && !vm.isNew\" class=\"text-boxed grey-500-bg\" \ntranslate=\"USER.INATIVO\">Inativo</span></div><div ng-if=\"vm.isNew\" class=\"md-display-1 white-fg\" \ntranslate=\"USER.FORM.TITLE_NEW\"></div><div class=\"subtitle secondary-text\"><span ng-if=\"!vm.isNew\" class=\"h2\" \ntranslate=\"USER.FORM.TITLE_EDIT\">Editar User</span></div></div></div></div><div class=\"flex-mobile-xs\" layout=\"row\" \nlayout-align-xs=\"end end\"><md-button type=\"button\" ng-if=\"!vm.isNew && !vm.row.deleted_at\" \nng-click=\"vm.disableConfirm($event)\" class=\"md-fab grey-50-bg md-amber-600-fg\" aria-label=\"Excluir\"><md-icon \nmd-font-icon=\"icon-power\" class=\"amber-600-fg\"></md-icon><md-tooltip>{{\'USER.DESATIVAR\'|translate}}</md-tooltip>\n</md-button><md-button type=\"button\" ng-if=\"!vm.isNew && vm.row.deleted_at\" ng-click=\"vm.restoreConfirm($event)\" \nclass=\"md-fab grey-50-bg md-accent\" aria-label=\"Excluir\"><md-icon md-font-icon=\"icon-replay\" class=\"md-accent-fg\">\n</md-icon><md-tooltip>{{\'USER.RESTAURAR\'|translate}}</md-tooltip></md-button><md-button type=\"button\" \nng-if=\"!vm.isNew\" ng-click=\"vm.confirmDelete($event)\" ng-disabled=\"!vm.isNew && vm.row.deleted_at\" \nclass=\"md-fab md-raised md-green-600-fg\" aria-label=\"Excluir\"><md-icon md-font-icon=\"icon-trash\" class=\"red-500-fg\">\n</md-icon><md-tooltip><span translate=\"COMMON.EXCLUIR\">Excluir</span></md-tooltip></md-button><md-button type=\"button\" \nng-if=\"!vm.isNew\" ui-sref=\"app.user.show({id:vm.row.id})\" ng-disabled=\"!vm.isNew && vm.row.deleted_at\" \nclass=\"md-fab md-raised\" aria-label=\"ver\"><md-icon md-font-icon=\"icon-eye\" class=\"md-accent-fg\"></md-icon><md-tooltip>\n{{\'COMMON.VISUALIZAR\'|translate}}</md-tooltip></md-button><md-button type=\"submit\" \nclass=\"md-fab md-raised md-green-600-fg\" ng-disabled=\"!vm.isNew && vm.row.deleted_at\" aria-label=\"Salvar\"><md-icon \nmd-font-icon=\"icon-content-save\" class=\"green-600-fg\"></md-icon><md-tooltip><span translate=\"COMMON.SALVAR\">Salvar\n</span></md-tooltip></md-button></div></div><div class=\"content\"><md-tabs md-dynamic-height><md-tab><md-tab-label><span\n translate=\"USER.FORM.PROFILE_INFORMATION\"></span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp p-16\"><div layout=\"row\"><div flex=\"75\"><div \nflex layout=\"row\"><md-input-container flex class=\"md-block\"><label translate=\"USER.FORM.FIRST_NAME\">vm.row.first_name\n</label><input ng-model=\"vm.row.first_name\" type=\"text\" ng-required=\"true\"></md-input-container><md-input-container \nflex class=\"md-block\"><label translate=\"USER.FORM.LAST_NAME\">vm.row.last_name</label><input \nng-model=\"vm.row.last_name\" type=\"text\"></md-input-container></div><div layout=\"row\"><md-input-container flex \nclass=\"md-block no-margin\"><h3 translate=\"USER.FORM.SEX\" class=\"md-subhead mt-0\"></h3><md-radio-group \nng-model=\"vm.row.sex\" layout=\"row\"><md-radio-button value=\"male\" class=\"md-body-1\">Masculino</md-radio-button>\n<md-radio-button value=\"female\" class=\"md-body-1\">Feminino</md-radio-button></md-radio-group></md-input-container>\n<md-input-container flex><label translate=\"USER.FORM.BIRTHDAY\"></label><input type=\"date\" ng-model=\"vm.row.birthday\">\n</md-input-container></div><div flex layout=\"row\"><md-input-container flex=\"50\" class=\"md-block\"><label \ntranslate=\"USER.FORM.EMAIL\">vm.row.email</label><input ng-model=\"vm.row.email\" type=\"email\" ng-required=\"true\" \nng-disabled=\"vm.disableEmail\"></md-input-container><md-input-container flex=\"25\" class=\"md-block\"><label \ntranslate=\"USER.FORM.PHONE\">vm.row.phone</label><input ng-model=\"vm.row.phone\" mask=\"{{$root.fmask.tel}}\" type=\"text\">\n</md-input-container><md-input-container flex=\"25\" class=\"md-block\"><label translate=\"USER.FORM.CELLPHONE\">\nvm.row.cellphone</label><input ng-model=\"vm.row.cellphone\" mask=\"{{$root.fmask.cel}}\" type=\"text\"></md-input-container>\n</div><md-input-container flex class=\"md-block\"><label translate=\"USER.FORM.SKYPE\"></label><input \nng-model=\"vm.row.skype\" type=\"text\"></md-input-container><md-input-container flex class=\"md-block\"><label \ntranslate=\"USER.FORM.OCCUPATION\"></label><input ng-model=\"vm.row.occupation\" type=\"text\"></md-input-container></div>\n<div flex=\"25\"><w3-image-dialog path=\"vm.row.thumb\" path-src=\"vm.row.thumb_src\" size=\"thumb\" gallery=\"profiles\" \ntitle=\"Selecione imagem de usuário\" config=\"vm.configUpload\"></w3-image-dialog></div></div><div class=\"md-actions\" \nlayout=\"row\" layout-align=\"end end\"><md-button type=\"submit\" class=\"md-fab grey-50-fg md-green-600-bg\" \naria-label=\"Salvar\"><md-icon md-font-icon=\"icon-content-save\" class=\"md-fab grey-50-fg\"></md-icon><md-tooltip><span \ntranslate=\"COMMON.SALVAR\">Salvar</span></md-tooltip></md-button></div></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"USER.FORM.ADDRESS_INFORMATION\"></span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp p-16\"><div layout=\"row\"><md-input-container \nflex=\"25\" class=\"md-block\"><label translate=\"USER.FORM.CEP\">vm.row.postcode</label><input ng-model=\"vm.row.postcode\" \ntype=\"text\" mask=\"{{$root.fmask.cep}}\" ng-blur=\"vm.loadCityWithCEP()\"></md-input-container><rf-input-city flex=\"75\" \nrf-required=\"false\" ng-model=\"vm.row.city_id\" rf-city=\"vm.row.city\" rf-open-create=\"true\" flex></rf-input-city></div>\n<div layout=\"row\"><md-input-container flex=\"75\" class=\"md-block\"><label translate=\"USER.FORM.STREET\">vm.row.street\n</label><input ng-model=\"vm.row.street\" type=\"text\"></md-input-container><md-input-container flex=\"25\" \nclass=\"md-block\"><label translate=\"USER.FORM.NUMBER\">vm.row.number</label><input ng-model=\"vm.row.number\" type=\"text\">\n</md-input-container></div><div layout=\"row\"><md-input-container flex class=\"md-block\"><label \ntranslate=\"USER.FORM.NEIGHBOURHOOD\">vm.row.district</label><input ng-model=\"vm.row.district\" type=\"text\">\n</md-input-container><md-input-container flex class=\"md-block\"><label translate=\"USER.FORM.COMPLEMENT\">\nvm.row.complement</label><input ng-model=\"vm.row.complement\" type=\"text\"></md-input-container></div><div \nclass=\"md-actions\" layout=\"row\" layout-align=\"end end\"><md-button type=\"submit\" \nclass=\"md-fab grey-50-fg md-green-600-bg\" aria-label=\"Salvar\"><md-icon md-font-icon=\"icon-content-save\" \nclass=\"md-fab grey-50-fg\"></md-icon><md-tooltip><span translate=\"COMMON.SALVAR\">Salvar</span></md-tooltip></md-button>\n</div></div></md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"USER.FORM.ACCESS_INFORMATION\"></span>\n</md-tab-label><md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp p-16\">\n<md-input-container class=\"md-block\"><label translate=\"USER.FORM.EMAIL\">vm.row.email</label><input \nng-model=\"vm.row.email\" ng-disabled=\"vm.row.id\" type=\"email\" ng-required=\"true\"></md-input-container><div layout=\"row\">\n<md-input-container flex class=\"md-block\"><label translate=\"USER.FORM.PASSWORD\">vm.row.password</label><input \nng-model=\"vm.row.password\" type=\"password\" ng-required=\"vm.isNew\"></md-input-container><md-input-container flex \nclass=\"md-block\"><label translate=\"USER.FORM.PASSWORD_CONFIRMATION\">vm.row.password_confirmation</label><input \nng-model=\"vm.row.password_confirmation\" type=\"password\" ng-required=\"vm.isNew\"></md-input-container></div><md-subheader\n class=\"md-no-sticky\">Níveis de acesso</md-subheader><div layout=\"row\" layout-wrap flex><div flex-xs=\"100\" \nflex-sm=\"50\" flex-md=\"33\" flex-lg=\"25\" flex-gt-lg=\"20\" ng-repeat=\"role in vm.roles\"><md-checkbox \nng-model=\"role.checked\">{{ role.display_name}}</md-checkbox></div></div><div class=\"md-actions\" layout=\"row\" \nlayout-align=\"end end\"><md-button type=\"submit\" class=\"md-fab grey-50-fg md-green-600-bg\" aria-label=\"Salvar\"><md-icon \nmd-font-icon=\"icon-content-save\" class=\"md-fab grey-50-fg\"></md-icon><md-tooltip><span translate=\"COMMON.SALVAR\">Salvar\n</span></md-tooltip></md-button></div></div></md-tab-body></md-tab></md-tabs></div></div></form>");
$templateCache.put("/app/external/fuse/user/user-show.html","<div class=\"page-layout carded fullwidth single-scroll model-page\" layout=\"row\"><div class=\"center\" flex><div \nclass=\"header h-100 pv-0-imp\"><div layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" \nlayout-align-xs=\"space-between start\"><div layout=\"row\" layout-align=\"start center\" flex><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"md-display-1\">{{\'USER.SHOW.SINGLE_TITLE\'|translate}}</div><span \nng-if=\"!vm.row.deleted_at\" class=\"text-boxed md-accent-bg\" translate=\"USER.ATIVO\">Ativo</span> <span \nng-if=\"vm.row.deleted_at\" class=\"text-boxed grey-500-bg\" translate=\"USER.INATIVO\">Inativo</span></div></div></div>\n</div><div layout=\"row\" layout-align=\"end end\" class=\"flex-mobile-xs\"><md-button type=\"button\" \nui-sref=\"app.user.edit({id:vm.row.id})\" class=\"md-fab md-raised md-accent\" aria-label=\"editar\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"white-text\"></md-icon><md-tooltip>{{\'COMMON.EDITAR\'|translate}}</md-tooltip>\n</md-button></div></div></div><div layout=\"row\"><div flex=\"25\" class=\"pr-8\"><div class=\"content-card\"><md-content \nclass=\"content\" ms-scroll><div class=\"top-bg md-accent-bg h-150\"></div><div class=\"h-150\" \nstyle=\"z-index: 3; position: relative\"><div layout=\"row\"><rf-avatar rf-size=\"90\" rf-profile=\"vm.row\" \nrf-only-text=\"false\"></rf-avatar><div flex class=\"pl-16\" layout=\"column\" layout-align=\"center center\"><b \nclass=\"font-size-20 white-fg\">{{vm.row.name}}</b></div></div></div><div layout=\"column\" class=\"secondary-text\"><b \nclass=\"secondary-text font-size-16\">Informações pessoais</b><div flex><span translate=\"USER.SHOW.SEX\"></span>\n: {{vm.row.sex === \'F\'?\'Feminino\' : \'Masculino\'}}</div><div flex><span translate=\"USER.SHOW.BIRTH_DATE\"></span>\n: {{vm.row.birthday|w3DatePt}}</div><md-divider class=\"mt-16 mb-16\"></md-divider><b \nclass=\"secondary-text font-size-16\">Contato</b><div flex><span translate=\"USER.SHOW.PHONE_HOME\"></span>\n: {{vm.row.phone | w3Phone}}</div><div flex><span translate=\"USER.SHOW.PHONE_CELL\"></span>\n: {{vm.row.cellphone | w3Phone}}</div><div flex><span translate=\"USER.SHOW.EMAIL\"></span>: {{vm.row.email}}</div>\n<md-divider class=\"mt-16 mb-16\"></md-divider><b class=\"secondary-text font-size-16\">Localização</b><div flex><span \ntranslate=\"USER.SHOW.CITY_ID\"></span>: {{vm.row.city.city_name}}</div><div flex><span translate=\"USER.SHOW.STREET\">\n</span>: {{vm.row.street}}</div><div flex><span translate=\"USER.SHOW.NUMBER\"></span>: {{vm.row.number}}</div><div flex \nng-if=\"vm.row.complement\"><span translate=\"USER.SHOW.COMPLEMENT\"></span>: {{vm.row.complement}}</div><div flex><span \ntranslate=\"USER.SHOW.DISTRICT\"></span>: {{vm.row.district}}</div><div flex><span translate=\"USER.SHOW.POSTAL_CODE\">\n</span>: {{vm.row.postcode | w3Cep}}</div></div></md-content></div></div><div flex=\"75\" class=\"pl-8\"><div \nclass=\"content-card\"><md-content class=\"content\" ms-scroll><div class=\"mb-16\"><span class=\"secondary-text md-headline\">\nInformações do sistema</span></div><div layout=\"row\"><small flex class=\"font-size-16 secondary-text\"><span \ntranslate=\"COMMON.CRIADO_EM\">Criado em:</span> {{vm.row.created_at|w3DatePt}}</small> <span flex \nclass=\"font-size-16 secondary-text\"><span translate=\"COMMON.ATUALIZADO_EM\">Atualizado em:</span>\n {{vm.row.updated_at|w3DatePt}}</span></div><md-divider class=\"mb-24 mt-24\"></md-divider><span \nclass=\"secondary-text md-headline\">Níneis de acesso</span><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"USER.SHOW.NAME\">Nome</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"USER.SHOW.DESCRIPTION\">Descrição</span></div></th></tr></thead><tbody><tr \nclass=\"tr-notfound animate-slide-right\" ng-show=\"vm.row.acl.roles.length === 0\"><td colspan=\"2\"><span \ntranslate=\"USER.SEM_RESULTADOS_ROLE\">Nenhum resultado encontrado</span></td></tr><tr \nng-repeat=\"item in vm.row.acl.roles\" class=\"hover-table font-size-12 animate-slide-right\"><td>{{item.display_name}}\n</td><td>{{item.description}}</td></tr></tbody></table><div ng-if=\"vm.limits\"><br><br><br><span \nclass=\"secondary-text md-headline mt-32\">Limites</span><br><span ng-if=\"vm.limits.limit\">Limite total: <b>\n{{vm.limits.limit|currency:\'USD \'}}</b></span> <span ng-if=\"vm.limits.used\">Limite usado: <b>\n{{vm.limits.used|currency:\'USD \'}}</b></span> <span ng-if=\"vm.limits.available\">Limite disponível <b>\n{{vm.limits.available|currency:\'USD \'}}</b></span> <span ng-if=\"!vm.limits.limit\" class=\"secondary-text text-center\">\nSem informações sobre o limite no momento.</span><md-divider class=\"mb-24 mt-24\"></md-divider></div><div \nng-if=\"vm.logs\"><br><br><br><span class=\"secondary-text md-headline\">Histórico</span><br><span \nclass=\"secondary-text text-center\">Sem informações no histórico no momento.</span><md-divider class=\"mb-24 mt-24\">\n</md-divider></div><br><br><br><span class=\"secondary-text md-headline\">Comentários</span><br><rf-comments-list \nconfig=\"vm.commetConfig\"></rf-comments-list></md-content></div></div></div></div></div>");
$templateCache.put("/app/external/fuse/xsession/list-sessions.html","<div ng-if=\"vm.pageLoaded\"><div class=\"p-24\" id=\"xsession-list-sessions\"><h2 class=\"md-display-1\" \nng-bind=\"vm.labels.title\"></h2><div layout=\"row\" layout-align=\"space-between center\" flex><p ng-if=\"vm.archive.length\" \nng-bind=\"vm.labels.content\"></p><div layout=\"row\" layout-align=\"end center\"><md-input-container \nclass=\"md-icon-left md-icon-right md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"vm.searchTerm\" placeholder=\"Buscar...\" ng-model-options=\"{ debounce: 300 }\"></md-input-container><md-button \nclass=\"md-icon-button\" ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'\" style=\"margin-bottom: 19px\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></div><div class=\"h-200\" layout=\"column\" \nlayout-align=\"center center\" ng-if=\"!vm.archive.length\"><h3 ng-bind=\"vm.labels.title_empty_state\"></h3><p \nng-bind=\"vm.labels.content_empty_state\"></p></div><div ng-if=\"vm.archive.length\"><div layout-wrap layout=\"row\" \nclass=\"ajust-row\"><div ng-repeat=\"model in vm.archive| filter:vm.searchFilter\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"33\" class=\"item-list\"><md-card flex ng-click=\"vm.selectModel(model)\" class=\"h-176\" \nng-class=\"{\'md-accent-bg md-hue-3\':  vm.active_session.nome == model.nome}\" style=\"width: 100%\"><md-card-title>\n<md-card-title-media><div class=\"md-media-xs card-media\"><md-icon md-font-icon=\"icon-home\" class=\"s70\"></md-icon></div>\n</md-card-title-media><md-card-title-text><span class=\"md-headline font-size-20\">{{model.name}}</span> <span \nclass=\"md-subhead\">{{model.description}}</span></md-card-title-text></md-card-title><md-card-actions><md-button \nclass=\"md-block md-accent md-raised\" ng-click=\"vm.selectModel(model)\" style=\"width:100%\">Selecionar</md-button>\n</md-card-actions></md-card></div></div></div></div></div><div ng-if=\"!vm.pageLoaded\" layout-fill><div layout=\"column\" \nlayout-align=\" center center\" class=\"margin-30\" layout-fill><div class=\"padding-10\"><h3 class=\"margin-0\">\nBuscando as suas sessões</h3></div><div class=\"padding-10\"><h4 class=\"margin-0\">Aguarde um momento...</h4></div><div \nclass=\"padding-10\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></div></div>");
$templateCache.put("/app/external/fuse/xsession/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button hide-{{vm.openMenu}}\" ng-click=\"vm.toggleSidenav(\'navigation\')\" \naria-label=\"Toggle navigation\" translate><md-icon md-font-icon=\"icon-menu\" aria-label=\"menu\" class=\"icon\"></md-icon>\n</md-button><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div><md-button ui-sref=\"app.xsession\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon icon-home\"></md-icon><md-tooltip><span \ntranslate=\"TOOLBAR.SELECIONE_UNIDADE\">Selecionar unidade</span></md-tooltip></md-button><div class=\"toolbar-separator\">\n</div><div class=\"p-8\">{{$root.nameToolbar}}: {{$root.currentXSession.name}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-button ng-if=\"vm.customIcon\" ng-click=\"vm.onClickIconCalendar()\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"{{ vm.customIcon }}\"></md-icon></md-button><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><rf-avatar rf-size=\"40\" rf-profile=\"rapiProfile\" rf-only-text=\"false\"></rf-avatar></div><span \nclass=\"username\" hide show-gt-sm>{{rapiProfile.name}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" \nhide-xs></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.profile\">\n<md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>Perfil</md-button></md-menu-item>\n<md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \naria-label=\"sair\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Sair</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("/app/external/pedido/dialog/pedido-dialog-decline-request.html","<md-dialog class=\"single-dialog dialog-600\" aria-label=\"Dialog\" \ntranslate-attr-aria-label=\"PEDIDO.DIALOG.DECLINE_REQUEST_DIALOG.DIALOG_TITLE\"><form name=\"dialogForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"PEDIDO.DIALOG.DECLINE_REQUEST_DIALOG.DIALOG_TITLE\"></span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\" aria-label=\"Fechar\" translate translate-attr-aria-label=\"COMMON.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\"><span \nclass=\"md-body-1\" translate=\"PEDIDO.DIALOG.DECLINE_REQUEST_DIALOG.DIALOG_MESSAGE\" translate-values=\"vm.messageValues\">\n</span><md-input-container flex class=\"margin-bottom-0\"><label class=\"md-body-2\" \ntranslate=\"PEDIDO.DIALOG.DECLINE_REQUEST_DIALOG.FIELD_LABEL.REASON\"></label><textarea class=\"md-body-1\" \nng-model=\"vm.request.obs_cancelamento\" md-maxlength=\"255\" rows=\"3\" ng-required=\"true\" md-select-on-focus></textarea>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><div layout=\"row\" \nlayout-align=\"end center\"><md-button type=\"button\" ng-click=\"vm.cancel()\" class=\"md-warn\" aria-label=\"Cancelar\" \ntranslate-attr-aria-label=\"COMMON.CANCELAR\"><span translate=\"COMMON.CANCELAR\">Cancelar</span></md-button><md-button \ntype=\"submit\" ng-click=\"vm.declineRequest()\" class=\"send-button md-accent md-raised\" ng-disabled=\"dialogForm.$invalid\" \naria-label=\"Adicionar\" translate-attr-aria-label=\"COMMON.SALVAR\"><span \ntranslate=\"PEDIDO.DIALOG.DECLINE_REQUEST_DIALOG.BTN_LABEL.SEND\"></span></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("/app/external/pedido/dialog/pedido-dialog-send-request.html","<md-dialog class=\"single-dialog dialog-600\" aria-label=\"Dialog\" \ntranslate-attr-aria-label=\"PEDIDO.DIALOG.SEND_REQUEST.DIALOG_TITLE\"><form name=\"dialogForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"PEDIDO.DIALOG.SEND_REQUEST.DIALOG_TITLE\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" \naria-label=\"Fechar\" translate translate-attr-aria-label=\"COMMON.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close s24\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\"><span ng-if=\"vm.isToSend()\" \nclass=\"md-body-1\" translate=\"PEDIDO.DIALOG.SEND_REQUEST.DIALOG_MESSAGE_SEND\" translate-values=\"vm.messageValues\">\n</span> <span ng-if=\"vm.isToEnd()\" class=\"md-body-1\" translate=\"PEDIDO.DIALOG.SEND_REQUEST.DIALOG_MESSAGE_END\" \ntranslate-values=\"vm.messageValues\"></span> <span ng-if=\"vm.isToDeliver()\" class=\"md-body-1\" \ntranslate=\"PEDIDO.DIALOG.SEND_REQUEST.DIALOG_MESSAGE_DELIVER\" translate-values=\"vm.messageValues\"></span> <span \nng-if=\"vm.isToProduce()\" class=\"md-body-1\" translate=\"PEDIDO.DIALOG.SEND_REQUEST.DIALOG_MESSAGE_PRODUCE\" \ntranslate-values=\"vm.messageValues\"></span> <span ng-if=\"vm.isInfoNeeded()\" class=\"md-body-1\" \ntranslate=\"PEDIDO.DIALOG.SEND_REQUEST.DIALOG_MESSAGE_NEED_INFO\"></span><md-input-container ng-if=\"vm.isBoxNeeded()\" \nflex class=\"margin-bottom-0\"><label translate=\"PEDIDO.DIALOG.SEND_REQUEST.FIELD_LABEL.BOX\"></label><input \nng-model=\"vm.request.box\" type=\"text\" ng-required=\"vm.isBoxNeeded()\"></md-input-container><md-input-container flex \nng-if=\"vm.isLabsNeeded()\"><label translate=\"PEDIDO.DIALOG.EDIT_LAB_DIALOG.FIELD_LABEL.LABS\"></label><md-select \nng-required=\"vm.isLabsNeeded()\" ng-model=\"vm.request.lab\"><md-option ng-repeat=\"lab in vm.labs\" ng-value=\"lab\"><span \nclass=\"md-body-1\">{{lab.nome}}</span></md-option></md-select></md-input-container><md-input-container flex \nclass=\"margin-bottom-0\" ng-if=\"vm.isCodeNeeded()\"><label translate=\"PEDIDO.DIALOG.EDIT_CODE_DIALOG.FIELD_LABEL.CODE\">\n</label><input ng-model=\"vm.request.cod_rastreamento\" type=\"text\" ng-required=\"vm.isCodeNeeded()\"></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><div layout=\"row\" \nlayout-align=\"end center\"><md-button type=\"button\" ng-click=\"vm.cancel()\" class=\"md-warn\" aria-label=\"Cancelar\" \ntranslate-attr-aria-label=\"COMMON.CANCELAR\"><span translate=\"COMMON.CANCELAR\">Cancelar</span></md-button><md-button \ntype=\"submit\" ng-click=\"vm.sendRequest()\" class=\"send-button md-accent md-raised\" ng-disabled=\"dialogForm.$invalid\" \naria-label=\"Adicionar\" translate-attr-aria-label=\"COMMON.SALVAR\"><span ng-if=\"vm.isToSend()\" \ntranslate=\"PEDIDO.DIALOG.SEND_REQUEST.BTN_LABEL.SEND\"></span> <span ng-if=\"vm.isToEnd()\" \ntranslate=\"PEDIDO.DIALOG.SEND_REQUEST.BTN_LABEL.END\"></span> <span ng-if=\"vm.isToDeliver()\" \ntranslate=\"PEDIDO.DIALOG.SEND_REQUEST.BTN_LABEL.DELIVER\"></span> <span ng-if=\"vm.isToProduce()\" \ntranslate=\"PEDIDO.DIALOG.SEND_REQUEST.BTN_LABEL.PRODUCE\"></span></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("/app/external/pedido/includes/_pedido-form-card-action.html","<md-card><md-card-actions class=\"padding-10\"><div layout=\"row\" layout-align=\"center center\"><md-button flex \ntype=\"submit\" class=\"md-blue-500-bg\" aria-label=\"Salvar\"><span class=\"white-text\">\n{{!vm.row.status || vm.row.status === \'RASCUNHO\'? \'Salvar como Rascunho \' : \'Salvar\'}}</span><md-icon \nmd-font-icon=\"icon-content-save\" class=\"md-fab grey-50-fg\"></md-icon></md-button><md-button flex \nng-if=\"!vm.row.status || vm.row.status === \'RASCUNHO\'\" class=\"md-accent md-raised md-green-500-bg\" \nng-click=\"vm.confirmSend()\" title=\"Para enviar o pedido para a Polo, você deve preencher todos os dados\"><span \nclass=\"white-text\" data-translate=\"PEDIDO.FORM.BTN_SEND_REQUEST_TO_POLO\"></span><md-icon md-font-icon=\"icon-send\" \nclass=\"md-fab grey-50-fg\"></md-icon></md-button></div></md-card-actions></md-card>");
$templateCache.put("/app/external/pedido/includes/_pedido-form-card-eyeglasses-frames.html","<md-card class=\"margin-top-15\"><md-toolbar class=\"md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"center center\"><h2 md-truncate translate=\"PEDIDO.FORM.PRODUTO.CARD_EYEGLASSES_FRAMES\"></h2></div>\n</md-toolbar><md-card-content class=\"card-eyeglasses-frames\"><div layout=\"row\" layout-wrap><div flex-xs=\"100\" \nflex-sm=\"50\" flex-md=\"33\" flex-gt-md=\"20\" layout=\"column\"><span class=\"secondary-text\">\n1. Escolha abaixo o material da armação</span><br><md-input-container \nclass=\"margin-left-15 margin-rigth-15 margin-top-5 margin-bottom-0\"><label class=\"md-body-1\" \ntranslate=\"PEDIDO.FORM.PRODUTO.SELECT_FRAME_TYPE\"></label><md-select class=\"md-body-1\" name=\"frameType\" \nng-required=\"true\" md-no-asterisk ng-disabled=\"!vm.isRequestEditable\" ng-model=\"vm.row.material_armacao\"><md-option \nng-value=\"frame.id\" ng-repeat=\"frame in vm.frameTypes\">{{ frame.label }}</md-option></md-select></md-input-container>\n<br><br><span class=\"secondary-text\">2. Em seguida escolha o modelo da armação clicando em uma das imagens</span></div>\n<md-radio-group name=\"frameModel\" ng-required=\"true\" md-no-asterisk ng-disabled=\"!vm.isRequestEditable\" \nng-model=\"vm.row.tipo_armacao\" flex-xs=\"30\" flex-sm=\"33\" flex-md=\"33\" flex-gt-md=\"20\" \nng-repeat=\"frameModel in vm.frameModels\" class=\"padding-right-15 padding-left-15\"><md-radio-button class=\"radio-frame\" \nvalue=\"{{frameModel.id}}\" aria-label=\"{{\'Eyeglasses frame \' + frameModel.id}}\"><img height=\"136\" style=\"height: 136px\" \nng-src=\"{{frameModel.img_src}}\"></md-radio-button></md-radio-group></div></md-card-content></md-card>");
$templateCache.put("/app/external/pedido/includes/_pedido-form-card-general-information.html","<md-card><md-toolbar class=\"md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"center center\"><h2 \nmd-truncate data-translate=\"PEDIDO.FORM.CARD_GENERAL_INFORMATION\"></h2></div></md-toolbar><md-card-content><div \nlayout=\"column\"><div flex layout=\"row\"><md-input-container flex \nclass=\"md-body-1 margin-horizontal-5 margin-top-15 margin-bottom-0\"><label class=\"md-body-1\" \ndata-translate=\"PEDIDO.FORM.NRO_OS\"></label><input class=\"md-body-1\" title=\"Número da ordem de serviço\" name=\"nro_os\" \nng-required=\"true\" md-no-asterisk ng-model=\"vm.row.nro_os\" type=\"text\" ng-disabled=\"!vm.isRequestEditable\">\n</md-input-container><md-input-container flex class=\"md-body-1 margin-horizontal-5 margin-top-15 margin-bottom-0\">\n<label class=\"md-body-1\" data-translate=\"PEDIDO.FORM.CLIENTE_NOME\"></label><input class=\"md-body-1\" \ntitle=\"Nome do cliente\" name=\"cliente\" ng-required=\"true\" md-no-asterisk ng-model=\"vm.row.cliente\" type=\"text\" \nng-disabled=\"!vm.isRequestEditable\"></md-input-container></div></div></md-card-content><md-card-actions \nng-show=\"vm.formStage == 1\" class=\"padding-10\" layout=\"row\"><md-button flex \nng-class=\"( requestForm.nro_os.$valid && requestForm.cliente.$valid ) ? \'md-raised blue-500-bg\' : \'md-raised grey-500-bg\'\" \nng-disabled=\"!( requestForm.nro_os.$valid && requestForm.cliente.$valid )\" aria-label=\"Continue\" \nng-click=\"vm.advaceStage()\"><span class=\"white-500-fg\">Continuar</span></md-button></md-card-actions></md-card>");
$templateCache.put("/app/external/pedido/includes/_pedido-form-card-lens-amount.html","<md-card><md-card-title style=\"border-style: solid; border-color: #336600; background-color: #669900\">\n<md-card-title-text layout=\"row\" layout-align=\"center center\"><span>Lentes</span></md-card-title-text></md-card-title>\n<md-card-content ng-cloak class=\"padding-top-16\"><md-content layout=\"column\" class=\"padding-0\" style=\"height: 519px\" \nms-scroll><div layout=\"column\" class=\"padding-10\" ng-hide=\"vm.row.espec_tipo\"><md-subheader class=\"md-no-sticky\" \ndata-translate=\"PEDIDO.FORM.PRODUTO.SUBHEADER_LENS_FOR_EYES\"></md-subheader><md-divider class=\"blue-300-bg\">\n</md-divider><md-radio-group ng-model=\"vm.row.espec_tipo\" layout=\"column\" ng-disabled=\"!vm.isRequestEditable\">\n<md-radio-button ng-repeat=\"type in vm.prescription_type\" value=\"{{type.id}}\" aria-label=\"{{type.label}}\" \nclass=\"padding-5\"><span class=\"md-body-1\" translate=\"{{type.translate}}\"></span></md-radio-button></md-radio-group>\n</div><div ng-show=\"vm.row.espec_tipo\" layout-fill layout=\"column\"><div layout=\"column\" layout-align=\"center center\" \nflex><p class=\"md-headline margin-bottom-0 margin-top-5\" style=\"text-align: center\" ng-if=\"vm.row.espec_tipo === \'DE\'\">\nLentes para ambos os olhos</p><p class=\"md-headline margin-bottom-0 margin-top-5\" style=\"text-align: center\" \nng-if=\"vm.row.espec_tipo === \'D\'\">Lente para o olho direito</p><p class=\"md-headline margin-bottom-0 margin-top-5\" \nstyle=\"text-align: center\" ng-if=\"vm.row.espec_tipo === \'E\'\">Lente para o olho esquerdo</p></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button ng-if=\"vm.isRequestEditable\" class=\"blue-500-bg\" \nng-click=\"vm.row.espec_tipo = null\"><span class=\"white-500-fg\">Selecionar outra lente</span></md-button></div></div>\n</md-content></md-card-content></md-card>");
$templateCache.put("/app/external/pedido/includes/_pedido-form-card-materials.html","<md-card><md-card-title style=\"border-style: solid; border-color: #660066; background-color: #9933ff\">\n<md-card-title-text layout=\"row\" layout-align=\"center center\"><span>Materiais</span></md-card-title-text>\n</md-card-title><md-card-content ng-cloak class=\"padding-top-16\"><md-content layout=\"column\" class=\"padding-0\" \nstyle=\"height: 519px\" ms-scroll><div ng-if=\"vm.row.produto.materiais.length\" flex><div ng-hide=\"vm.row.material_id\" \nclass=\"padding-10\"><md-subheader class=\"md-no-sticky\" translate=\"PEDIDO.FORM.SELECT_MATERIAL\"></md-subheader>\n<md-divider class=\"blue-300-bg\"></md-divider><md-radio-group ng-required=\"true\" ng-model=\"vm.row.material_id\" \nlayout=\"column\"><div layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"material in ::vm.row.produto.materiais\"><md-radio-button flex ng-disabled=\"!vm.isRequestEditable\" \nng-value=\"material.id\" class=\"padding-5\"><div layout=\"row\" layout-align=\"space-between center\"><pl-square-image \nsrc=\"material.thumb_src\" size=\"\'sm\'\"></pl-square-image><div flex layout=\"column\" class=\"pl-8\"><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ material.nome }}</p><div layout=\"row\" \nlayout-align=\"space-between center\"><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ material.preco | currency : \'R$ \' : 2 }}</p><small class=\"secondary-text\">REF:{{material._ref}}</small></div></div>\n</div></md-radio-button><md-button ng-click=\"vm.showDetail(material.id, \'MATERIAL\'); $event.stopPropagation();\" \nclass=\"md-icon-button\" aria-label=\"More\"><md-icon class=\"s24\" md-font-icon=\"icon-loupe\"></md-icon></md-button></div>\n</md-radio-group></div><div ng-show=\"vm.row.material_id\" layout-fill layout=\"column\"><div layout=\"column\" \nlayout-align=\"start center\" ng-repeat=\"material in ::vm.row.produto.materiais\" \nng-if=\"vm.row.material_id == material.id\" flex><pl-square-image src=\"material.thumb_src\" size=\"\'md\'\"></pl-square-image>\n<p class=\"md-headline margin-bottom-0 margin-top-5\">{{ material.nome }}</p><p \nclass=\"md-headline margin-bottom-0 margin-top-5\">{{ material.preco | currency : \'R$ \' : 2 }}</p><small \nclass=\"secondary-text\">REF:{{material._ref}}</small><md-button \nng-click=\"vm.showDetail(material.id, \'MATERIAL\'); $event.stopPropagation();\" class=\"md-icon-button\" aria-label=\"More\">\n<md-icon class=\"s24\" md-font-icon=\"icon-loupe\"></md-icon></md-button></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button ng-if=\"vm.isRequestEditable\" class=\"blue-500-bg\" \nng-click=\"vm.row.material_id = null\"><span class=\"white-500-fg\">Selecionar outro material</span></md-button></div>\n</div></div><div ng-if=\"!vm.row.produto.materiais.length\" flex><div layout=\"column\" layout-align=\"center center\" \nlayout-fill class=\"padding-10\" style=\"text-align: justify; text-justify: inter-word\"><div class=\"padding-right-24\">\n<md-icon aria-label=\"empty state icon\" md-font-icon=\"icon-cube-outline\" class=\"red-500-fg\" \nng-style=\"{\'font-size\': \'48px\', height: \'48px\'}\"></md-icon></div><span class=\"md-title red-400-fg\">\nEste produto não possui nenhum material </span><span class=\"md-subhead yellow-800-fg\">\nContate o responsavel pelo sistema e requisite a adição de materiais a estre produto</span></div></div></md-content>\n</md-card-content></md-card>");
$templateCache.put("/app/external/pedido/includes/_pedido-form-card-measure.html","<md-card class=\"margin-top-15\"><md-toolbar class=\"md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"center center\"><h2 md-truncate translate=\"PEDIDO.FORM.CARD_MEASURE\"></h2></div></md-toolbar>\n<md-card-content><div layout=\"row\" class=\"margin-top-10\"><div layout=\"column\" flex class=\"padding-10\"><div \nlayout=\"row\" layout-align=\"center center\" class=\"padding-10\" flex><img \nsrc=\"app/external/assets/images/eyeglass/medidaLente.png\" alt=\"Eyeglasses Frames\" style=\"height: 75%; width: 75%\">\n</div><div layout=\"row\"><div layout=\"column\" flex><md-input-container flex \nclass=\"md-body-1 margin-horizontal-5 margin-top-15 margin-bottom-0\"><label class=\"md-body-1\" \ntranslate=\"PEDIDO.FORM.PRODUTO.LENS_MEASURE_WEIGHT\"></label><input class=\"md-body-1\" name=\"weight\" ng-required=\"true\" \nmd-no-asterisk ng-disabled=\"!vm.isRequestEditable\" ng-model=\"vm.row.medidas.largura\" type=\"number\">\n</md-input-container><md-input-container flex class=\"md-body-1 margin-horizontal-5 margin-top-15 margin-bottom-0\">\n<label class=\"md-body-1\" translate=\"PEDIDO.FORM.PRODUTO.LENS_MEASURE_HEIGHT\"></label><input class=\"md-body-1\" \nname=\"height\" ng-required=\"true\" md-no-asterisk ng-disabled=\"!vm.isRequestEditable\" ng-model=\"vm.row.medidas.altura\" \ntype=\"number\"></md-input-container></div><div layout=\"column\" flex><md-input-container flex \nclass=\"md-body-1 margin-horizontal-5 margin-top-15 margin-bottom-0\"><label class=\"md-body-1\" \ntranslate=\"PEDIDO.FORM.PRODUTO.LENS_MEASURE_BRIDGE\"></label><input class=\"md-body-1\" name=\"bridge\" ng-required=\"true\" \nmd-no-asterisk ng-disabled=\"!vm.isRequestEditable\" ng-model=\"vm.row.medidas.ponte\" type=\"number\"></md-input-container>\n<md-input-container flex class=\"md-body-1 margin-horizontal-5 margin-top-15 margin-bottom-0\"><label class=\"md-body-1\" \ntranslate=\"PEDIDO.FORM.PRODUTO.LENS_MEASURE_DIAGONAL\"></label><input class=\"md-body-1\" name=\"diagonal\" \nng-required=\"true\" md-no-asterisk ng-disabled=\"!vm.isRequestEditable\" ng-model=\"vm.row.medidas.diagonal\" type=\"number\">\n</md-input-container></div></div></div><md-divider class=\"blue-300-bg\"></md-divider><div layout=\"column\" \nclass=\"padding-10\" flex><div layout=\"column\"><div layout=\"row\" layout-align=\"start center\"><md-subheader \nclass=\"md-no-sticky\" translate=\"PEDIDO.FORM.PRODUTO.LENS_MEASURE_PUPIL_HEIGHT\"></md-subheader><div><md-icon \nclass=\"margin-left-5 yellow-700-fg\" md-font-icon=\"icon-question-mark-circle\"><md-tooltip><span \ntranslate=\"PEDIDO.FORM.PRODUTO.LENS_MEASURE_PUPIL_HEIGHT_INFORMATION\" class=\"md-body-1\"></span></md-tooltip></md-icon>\n</div></div><md-divider class=\"blue-300-bg\"></md-divider><div layout=\"column\" class=\"margin-top-10\"><div layout=\"row\" \nlayout-align=\"center center\"><md-icon class=\"mr-8 blue-500-fg\" md-font-icon=\"icon-information-outline\"></md-icon><span \nflex translate=\"PEDIDO.FORM.PRODUTO.LENS_MEASURE_PUPIL_HEIGHT_LIMIT\" class=\"md-body-1\"></span></div><div layout=\"row\">\n<md-input-container flex class=\"md-body-1 margin-horizontal-5 margin-top-15 margin-bottom-0\"><label class=\"md-body-1\" \ntranslate=\"PEDIDO.FORM.PRODUTO.RIGTH\"></label><input class=\"md-body-1\" name=\"od_pupil_height\" ng-required=\"true\" \nmd-no-asterisk ng-disabled=\"!vm.isRequestEditable\" ng-model=\"vm.row.medidas.od_altura_pupilar\" type=\"number\">\n</md-input-container><md-input-container flex class=\"md-body-1 margin-horizontal-5 margin-top-15 margin-bottom-0\">\n<label class=\"md-body-1\" translate=\"PEDIDO.FORM.PRODUTO.LEFT\"></label><input class=\"md-body-1\" name=\"oe_pupil_height\" \nng-required=\"true\" md-no-asterisk ng-disabled=\"!vm.isRequestEditable\" ng-model=\"vm.row.medidas.oe_altura_pupilar\" \ntype=\"number\"></md-input-container></div></div></div><div layout=\"column\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.FORM.PRODUTO.LENS_MEASURE_DNP\"></md-subheader><md-divider class=\"blue-300-bg\"></md-divider><div \nlayout=\"row\"><md-input-container flex class=\"md-body-1 margin-horizontal-5 margin-top-15 margin-bottom-0\"><label \nclass=\"md-body-1\" translate=\"PEDIDO.FORM.PRODUTO.RIGTH\"></label><input class=\"md-body-1\" name=\"od_dnp\" \nng-required=\"true\" md-no-asterisk ng-disabled=\"!vm.isRequestEditable\" ng-model=\"vm.row.medidas.od_dnp\" type=\"number\">\n</md-input-container><md-input-container flex class=\"md-body-1 margin-horizontal-5 margin-top-15 margin-bottom-0\">\n<label class=\"md-body-1\" translate=\"PEDIDO.FORM.PRODUTO.LEFT\"></label><input class=\"md-body-1\" name=\"oe_dnp\" \nng-required=\"true\" md-no-asterisk ng-disabled=\"!vm.isRequestEditable\" ng-model=\"vm.row.medidas.oe_dnp\" type=\"number\">\n</md-input-container></div></div><div layout=\"column\"><div layout=\"row\" layout-align=\"start center\"><md-subheader \nclass=\"md-no-sticky\">Diâmetro</md-subheader><div><md-icon class=\"margin-left-5 yellow-700-fg\" \nmd-font-icon=\"icon-question-mark-circle\"><md-tooltip class=\"tooltip-multiline\">\nDiâmetro é automaticamente calculado pela seguinte formula.<br><br>(Ponte + Largura + Diagonal) - (DNP * 2) + (2)<br>\nO valor de DNP é o DNP de menor valor informado.<br>\nTodos os campos devem ser informados para o valor da diagonal ser válido.</md-tooltip></md-icon></div></div><md-divider\n class=\"blue-300-bg\"></md-divider><div layout=\"column\" class=\"margin-top-10\"><div layout=\"row\" \nlayout-align=\"center center\"><md-icon class=\"mr-8 blue-500-fg\" md-font-icon=\"icon-information-outline\"></md-icon><div \nclass=\"md-body-1\" layout=\"column\" flex><span>\nO valor do diâmetro deve ser menor ou igual ao diâmetro definido no produto. </span><span>\n{{\'Valor máximo permitido: \' + vm.row.produto.diametro}}</span></div></div><div layout=\"column\" \nclass=\"md-body-1 margin-top-10\"><span \nng-class=\"requestForm.weight.$valid && requestForm.bridge.$valid && requestForm.diagonal.$valid && requestForm.oe_dnp.$valid && requestForm.od_dnp.$valid && vm.row.medidas.diametro < vm.row.produto.diametro && vm.row.medidas.diametro > 0  ? \'green-500-fg\' : \'red-500-fg\'\">\n{{\'Valor calculado: \' + vm.row.medidas.diametro}}</span></div></div></div><div \nng-if=\"vm.row.produto.tipo === \'GRESSIVE\'\" layout=\"column\" class=\"margin-top-16\"><div layout=\"row\" \nlayout-align=\"start center\"><md-subheader class=\"fit-subheader\">Altura. Versão do corredor progressivo.</md-subheader>\n</div><md-divider class=\"blue-300-bg\"></md-divider><div layout=\"column\" class=\"margin-top-10\"><md-input-container \nclass=\"md-block margin-right-5\" flex><label>Selecione a altura</label><md-select name=\"altura_v_progressivo\" flex \nng-model=\"vm.row.altura_v_progressivo\"><md-option ng-value=\"item\" \nng-repeat=\"item in vm.row.produto._altura_v_progressivo\">{{item}}</md-option></md-select></md-input-container></div>\n</div></div></div></md-card-content><md-card-actions ng-show=\"vm.formStage == 4\" class=\"padding-10\" layout=\"row\">\n<md-button flex \nng-class=\"(vm.row.medidas.diametro < vm.row.produto.diametro && vm.row.medidas.diametro > 0 && requestForm.diagonal.$valid && requestForm.height.$valid && requestForm.weight.$valid && requestForm.bridge.$valid && requestForm.oe_dnp.$valid && requestForm.od_dnp.$valid && requestForm.od_pupil_height.$valid && requestForm.oe_pupil_height.$valid) ? \'md-raised green-500-bg\' : \'md-raised grey-500-bg\'\" \nng-disabled=\"!(vm.row.medidas.diametro < vm.row.produto.diametro && vm.row.medidas.diametro > 0 && requestForm.diagonal.$valid && requestForm.height.$valid && requestForm.weight.$valid && requestForm.bridge.$valid && requestForm.oe_dnp.$valid && requestForm.od_dnp.$valid && requestForm.od_pupil_height.$valid && requestForm.oe_pupil_height.$valid)\" \naria-label=\"Continue\" ng-click=\"vm.advaceStage()\"><span class=\"white-500-fg\">Continuar</span></md-button>\n</md-card-actions></md-card>");
$templateCache.put("/app/external/pedido/includes/_pedido-form-card-missing-data.html","<md-card><md-card-title style=\"border-style: solid; border-color: #663300; background-color: #cc9900\">\n<md-card-title-text layout=\"row\" layout-align=\"center center\"><span>Informações Requeridas</span></md-card-title-text>\n</md-card-title><md-card-content flex class=\"padding-top-16\"><md-content layout=\"column\" class=\"padding-20\" \nstyle=\"max-height: 450px\" ms-scroll><div ng-if=\"vm.missingData.length\"><div layout=\"row\"><span flex \nclass=\"md-body-1 padding-10\">Para enviar o pedido para a Polo, preencha as seguintes informações</span><md-button \nclass=\"md-raised\" ng-click=\"vm.getMissingData()\">Atualizar</md-button></div><div layout=\"column\" \nng-repeat=\"item in vm.missingData\"><md-subheader class=\"md-no-sticky\">{{item.name}}</md-subheader><md-divider \nclass=\"blue-300-bg\"></md-divider><div layout=\"column\" class=\"padding-10 md-body-1\"><div layout-wrap layout=\"row\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"padding-vertical-10\" ng-repeat=\"missing in item.data\" flex=\"25\"><span>\n{{missing}}</span></div></div></div></div></div><div ng-if=\"!vm.missingData.length\" class=\"padding-40\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"padding-right-24\"><md-icon aria-label=\"empty state icon\" \nmd-font-icon=\"icon-emoticon\" class=\"green-500-fg\" ng-style=\"::{\'font-size\': \'48px\', height: \'48px\'}\"></md-icon></div>\n<h1 class=\"green-500-fg\">Este pedido esta pronto para ser enviado para a Polo</h1></div></md-content></md-card-content>\n</md-card>");
$templateCache.put("/app/external/pedido/includes/_pedido-form-card-observation.html","<md-card class=\"margin-top-15\"><md-toolbar class=\"md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"center center\"><h2>Observação</h2></div></md-toolbar><md-card-content class=\"card-eyeglasses-frames\"><div\n layout=\"row\" layout-wrap><div flex layout=\"column\"><md-input-container class=\"md-block\"><label>Observações</label>\n<textarea ng-model=\"vm.row.observacao\" rows=\"5\" md-select-on-focus></textarea></md-input-container></div></div>\n</md-card-content></md-card>");
$templateCache.put("/app/external/pedido/includes/_pedido-form-card-prescription.html","<md-card class=\"margin-top-15\"><md-toolbar class=\"md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"center center\"><h2 md-truncate>Prescrição</h2></div></md-toolbar><md-card-content flex><div \nlayout=\"column\"><div layout-xs=\"column\" layout-sm=\"column\" layout-md=\"column\" layout-gt-md=\"row\"><div layout=\"column\" \nng-show=\"vm.isRightEyeEditable\" flex class=\"padding-5\"><md-subheader class=\"md-primary margin-bottom-5\" \ndata-translate=\"PEDIDO.FORM.PRODUTO.SUBHEADER_RIGHT_EYE\"></md-subheader><div layout=\"column\"><div layout=\"row\">\n<md-input-container flex class=\"md-body-1 margin-horizontal-5 margin-top-15 margin-bottom-0\"><label \ndata-translate=\"PEDIDO.FORM.PRODUTO.LENS_SPHERICAL\"></label><md-select name=\"od_esferico\" md-no-asterisk \nng-disabled=\"!vm.isRightEyeEditable\" ng-model=\"vm.row.espec_od.esferico\"><md-option ng-value=\"item\" \nng-repeat=\"item in vm.esfericos  track by $index\">{{item| currency:\' \'}}</md-option></md-select></md-input-container>\n<md-input-container flex class=\"md-body-1 margin-horizontal-5 margin-top-15 margin-bottom-0\"><label \ndata-translate=\"PEDIDO.FORM.PRODUTO.LENS_CIL\"></label><md-select ng-disabled=\"!vm.isRightEyeEditable\" \nng-model=\"vm.row.espec_od.cil\"><md-option ng-value=\"item\" ng-repeat=\"item in vm.cilindros  track by $index\">\n{{item| currency:\' \'}}</md-option></md-select></md-input-container><md-input-container flex \nclass=\"md-body-1 margin-horizontal-5 margin-top-15 margin-bottom-0\"><label \ndata-translate=\"PEDIDO.FORM.PRODUTO.LENS_AXIS\"></label><md-select ng-disabled=\"!vm.isRightEyeEditable\" \nng-model=\"vm.row.espec_od.eixo\"><md-option ng-value=\"item\" ng-repeat=\"item in vm.eixos  track by $index\">{{item}}\n</md-option></md-select></md-input-container><md-input-container flex \nclass=\"md-body-1 margin-horizontal-5 margin-top-15 margin-bottom-0\"><label \ndata-translate=\"PEDIDO.FORM.PRODUTO.LENS_ADDITION\"></label><md-select ng-disabled=\"!vm.isRightEyeEditable\" \nng-model=\"vm.row.espec_od.adicao\"><md-option ng-value=\"item\" ng-repeat=\"item in vm.adicaoValues  track by $index\">\n{{item| currency:\' \'}}</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container flex \nclass=\"md-body-1 margin-horizontal-5 margin-top-15 margin-bottom-0\"><label \ndata-translate=\"PEDIDO.FORM.PRODUTO.LENS_PRIS_H\"></label><input ng-disabled=\"!vm.isRightEyeEditable\" \nng-model=\"vm.row.espec_od.prish\" type=\"number\" step=\"0.25\"></md-input-container><md-input-container flex \nclass=\"md-body-1 margin-horizontal-5 margin-top-15 margin-bottom-0\"><label \ndata-translate=\"PEDIDO.FORM.PRODUTO.LENS_PRIS_H_BASE\"></label><md-select ng-model=\"vm.row.espec_od.prish_base\" \nng-disabled=\"!vm.isRightEyeEditable\"><md-option ng-value=\"pris_base\" ng-repeat=\"pris_base in vm.prish_base\">\n{{ pris_base }}</md-option></md-select></md-input-container><md-input-container flex \nclass=\"md-body-1 margin-horizontal-5 margin-top-15 margin-bottom-0\"><label \ndata-translate=\"PEDIDO.FORM.PRODUTO.LENS_PRIS_V\"></label><input ng-disabled=\"!vm.isRightEyeEditable\" \nng-model=\"vm.row.espec_od.prisv\" type=\"number\" step=\"0.25\"></md-input-container><md-input-container flex \nclass=\"md-body-1 margin-horizontal-5 margin-top-15 margin-bottom-0\"><label \ndata-translate=\"PEDIDO.FORM.PRODUTO.LENS_PRIS_V_BASE\"></label><md-select ng-model=\"vm.row.espec_od.prisv_base\" \nng-disabled=\"!vm.isRightEyeEditable\"><md-option ng-value=\"pris_base\" ng-repeat=\"pris_base in vm.prisv_base\">\n{{ pris_base }}</md-option></md-select></md-input-container></div></div></div><md-divider hide-xs hide-sm hide-md \nclass=\"blue-300-bg\" ng-show=\"vm.row.espec_tipo == \'DE\'\"></md-divider><div layout=\"column\" \nng-show=\"vm.isLeftEyeEditable\" flex class=\"padding-5\"><md-subheader class=\"md-primary margin-bottom-5\" \ndata-translate=\"PEDIDO.FORM.PRODUTO.SUBHEADER_LEFT_EYE\"></md-subheader><div layout=\"column\"><div layout=\"row\">\n<md-input-container flex class=\"md-body-1 margin-horizontal-5 margin-top-15 margin-bottom-0\"><label \ndata-translate=\"PEDIDO.FORM.PRODUTO.LENS_SPHERICAL\"></label><md-select name=\"oe_esferico\" md-no-asterisk \nng-disabled=\"!vm.isLeftEyeEditable\" ng-model=\"vm.row.espec_oe.esferico\"><md-option ng-value=\"item\" \nng-repeat=\"item in vm.esfericos  track by $index\">{{item| currency:\' \'}}</md-option></md-select></md-input-container>\n<md-input-container flex class=\"md-body-1 margin-horizontal-5 margin-top-15 margin-bottom-0\"><label \ndata-translate=\"PEDIDO.FORM.PRODUTO.LENS_CIL\"></label><md-select ng-disabled=\"!vm.isLeftEyeEditable\" \nng-model=\"vm.row.espec_oe.cil\"><md-option ng-value=\"item\" ng-repeat=\"item in vm.cilindros  track by $index\">\n{{item| currency:\' \'}}</md-option></md-select></md-input-container><md-input-container flex \nclass=\"md-body-1 margin-horizontal-5 margin-top-15 margin-bottom-0\"><label \ndata-translate=\"PEDIDO.FORM.PRODUTO.LENS_AXIS\"></label><md-select ng-disabled=\"!vm.isLeftEyeEditable\" \nng-model=\"vm.row.espec_oe.eixo\"><md-option ng-value=\"item\" ng-repeat=\"item in vm.eixos  track by $index\">{{item}}\n</md-option></md-select></md-input-container><md-input-container flex \nclass=\"md-body-1 margin-horizontal-5 margin-top-15 margin-bottom-0\"><label \ndata-translate=\"PEDIDO.FORM.PRODUTO.LENS_ADDITION\"></label><md-select ng-disabled=\"!vm.isLeftEyeEditable\" \nng-model=\"vm.row.espec_oe.adicao\"><md-option ng-value=\"item\" ng-repeat=\"item in vm.adicaoValues  track by $index\">\n{{item| currency:\' \'}}</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container flex \nclass=\"md-body-1 margin-horizontal-5 margin-top-15 margin-bottom-0\"><label \ndata-translate=\"PEDIDO.FORM.PRODUTO.LENS_PRIS_H\"></label><input ng-disabled=\"!vm.isLeftEyeEditable\" \nng-model=\"vm.row .espec_oe.prish\" type=\"number\" step=\"0.25\"></md-input-container><md-input-container flex \nclass=\"md-body-1 margin-horizontal-5 margin-top-15 margin-bottom-0\"><label \ndata-translate=\"PEDIDO.FORM.PRODUTO.LENS_PRIS_H_BASE\"></label><md-select ng-model=\"vm.row.espec_oe.prish_base\" \nng-disabled=\"!vm.isLeftEyeEditable\"><md-option ng-value=\"pris_base\" ng-repeat=\"pris_base in vm.prish_base\">\n{{ pris_base}}</md-option></md-select></md-input-container><md-input-container flex \nclass=\"md-body-1 margin-horizontal-5 margin-top-15 margin-bottom-0\"><label \ndata-translate=\"PEDIDO.FORM.PRODUTO.LENS_PRIS_V\"></label><input title=\"PRIS V\" ng-disabled=\"!vm.isLeftEyeEditable\" \nng-model=\"vm.row .espec_oe.prisv\" type=\"number\" step=\"0.25\"></md-input-container><md-input-container flex \nclass=\"md-body-1 margin-horizontal-5 margin-top-15 margin-bottom-0\"><label \ndata-translate=\"PEDIDO.FORM.PRODUTO.LENS_PRIS_V_BASE\"></label><md-select ng-model=\"vm.row.espec_oe.prisv_base\" \nng-disabled=\"!vm.isLeftEyeEditable\"><md-option ng-value=\"pris_base\" ng-repeat=\"pris_base in vm.prisv_base\">\n{{ pris_base }}</md-option></md-select></md-input-container></div></div></div></div></div></md-card-content>\n<md-card-actions class=\"padding-10\" layout=\"row\" ng-show=\"vm.formStage == 3\"><md-button flex aria-label=\"Continue\" \nng-click=\"vm.advaceStage()\" class=\"md-raised blue-500-bg\"><span class=\"white-500-fg\">Continuar</span></md-button>\n</md-card-actions></md-card>");
$templateCache.put("/app/external/pedido/includes/_pedido-form-card-product.html","<md-card class=\"margin-top-15\"><md-toolbar class=\"md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"center center\"><h2 md-truncate translate=\"PEDIDO.FORM.CARD_PRODUCTS\"></h2></div></md-toolbar>\n<md-card-content class=\"padding-top-0\"><div layout=\"column\"><div layout-wrap=\"\" layout=\"row\"><div flex-xs=\"100\" \nflex-sm=\"100\" flex-md=\"50\" flex-gt-md=\"25\"><product-card-switch ng-if=\"vm.row && vm.row.produto\" request=\"vm.row\" \ndefault-gressive-itens=\"vm.defaulItensGressive\"></product-card-switch><ng-include ng-if=\"vm.row.produto\" \nsrc=\"\'/app/external/pedido/includes/_pedido_form_product-additional-selector.html\'\"></ng-include></div><ng-include \nflex-xs=\"100\" flex-sm=\"100\" flex-md=\"50\" flex-gt-md=\"25\" \nsrc=\"\'/app/external/pedido/includes/_pedido-form-card-materials.html\'\"></ng-include><ng-include flex-xs=\"100\" \nflex-sm=\"100\" flex-md=\"50\" flex-gt-md=\"25\" src=\"\'/app/external/pedido/includes/_pedido-form-card-treatment.html\'\">\n</ng-include><ng-include flex-xs=\"100\" flex-sm=\"100\" flex-md=\"50\" flex-gt-md=\"25\" \nsrc=\"\'/app/external/pedido/includes/_pedido-form-card-lens-amount.html\'\"></ng-include></div><div layout=\"row\" flex>\n<ng-include src=\"\'/app/external/pedido/includes/_pedido-form-card-request-value.html\'\" flex></ng-include></div></div>\n</md-card-content><md-card-actions class=\"padding-10\" layout=\"row\" ng-show=\"vm.formStage == 2\"><md-button flex \naria-label=\"Continue\" ng-click=\"vm.advaceStage()\" \nng-class=\"vm.row.material_id && vm.row.tratamento_id && vm.row.forma_pagamento_id ? \'md-raised blue-500-bg\' : \'md-raised grey-500-bg\'\" \nng-disabled=\"!(vm.row.material_id && vm.row.tratamento_id && vm.row.forma_pagamento_id)\"><span class=\"white-500-fg\">\nContinuar</span></md-button></md-card-actions></md-card>");
$templateCache.put("/app/external/pedido/includes/_pedido-form-card-remote-cut.html","<md-card class=\"margin-top-15\"><md-toolbar class=\"md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"center center\"><h2>Corte remoto</h2></div></md-toolbar><md-card-content class=\"card-eyeglasses-frames\">\n<div flex layout=\"column\" flex layout-align=\"start center\"><span class=\"\">Selecione um arquivo de corte remoto.</span>\n<div><w3-button-upload class=\"md-accent-bg\" path=\"vm.row.file_corte_remoto\" path-src=\"vm.row.file_corte_remoto_src\" \ngallery=\"corte_remoto\" config=\"vm.configUpload\" title=\"Buscar arquivo de corte\"></w3-button-upload></div><a \nclass=\"rf-pointer document-miniature\" target=\"_blank\" disabled=\"!vm.row.file_corte_remoto_src\" \nng-href=\"{{vm.row.file_corte_remoto.src}}\"><small class=\"mb-8 mt-16\" ng-if=\"vm.row.file_corte_remoto\"><md-icon \nmd-font-icon=\"icon-paperclip\"></md-icon>( Arquivo de corte selecionado: {{vm.row.file_corte_remoto}} )</small><md-icon \nmd-font-icon=\"icon-cursor-pointer\" class=\"s60 icon-inv\"></md-icon></a><md-button ng-if=\"vm.row.file_corte_remoto\" \nng-click=\"vm.removeRemoteFile()\" type=\"button\" class=\"md-warn\" aria-label=\"Excluir\">Remover arquivo</md-button></div>\n</md-card-content></md-card>");
$templateCache.put("/app/external/pedido/includes/_pedido-form-card-request-value.html","<md-card><div layout-xs=\"column\" layout-sm=\"column\" layout-gt-sm=\"row\"><div><div class=\"padding-10 animate-slide-down\" \nlayout-fill layout=\"row\" layout-align=\"center center\" \nstyle=\"border-style: solid; border-color: #ff9900; background-color: #ffcc00\"><md-icon md-font-icon=\"icon-coin\" \nclass=\"white-500-fg\"></md-icon></div></div><md-card-content layout-fill><div layout-xs=\"column\" layout-sm=\"column\" \nlayout-gt-sm=\"row\" layout-fill><div layout=\"column\" flex class=\"padding-10\"><div layout=\"row\"><div layout=\"column\" \nflex class=\"margin-right-10\"><span class=\"md-display-2 secondary-text\">Item</span><md-divider class=\"blue-300-bg\">\n</md-divider></div><div layout=\"column\" flex class=\"margin-left-10\"><span class=\"md-display-2 secondary-text\">Valor\n</span><md-divider class=\"blue-300-bg\"></md-divider></div></div><div layout=\"column\"><div layout=\"row\" \nclass=\"md-headline\"><div layout=\"column\" flex class=\"margin-right-10\"><span>Produto</span></div><div layout=\"row\" flex \nlayout-align=\"end center\" class=\"margin-left-10 text-right\"><span \nng-if=\"vm.row.espec_tipo === \'DE\' || !vm.row.espec_tipo\" class=\"text-right\">\n{{ vm.precoProduto | currency : \'R$ \' : 2 }} </span><span \nng-if=\"vm.row.espec_tipo === \'E\' || vm.row.espec_tipo === \'D\'\" class=\"text-right\">\n{{ (+vm.precoProduto)/2 | currency : \'R$ \' : 2 }}</span></div></div><div layout=\"row\" class=\"md-headline\"><div \nlayout=\"column\" flex class=\"margin-right-10\"><span>Material</span></div><div layout=\"column\" flex \nclass=\"margin-left-10 text-right\"><span ng-if=\"vm.row.espec_tipo === \'DE\' || !vm.row.espec_tipo\">\n{{ vm.material.preco | currency : \'R$ \' : 2 }} </span><span \nng-if=\"vm.row.espec_tipo === \'E\' || vm.row.espec_tipo === \'D\'\">{{(+vm.material.preco / 2) | currency : \'R$ \' : 2 }}\n</span></div></div><div layout=\"row\" class=\"md-headline\"><div layout=\"column\" flex class=\"margin-right-10\"><span>\nTratamento</span></div><div layout=\"column\" flex class=\"margin-left-10 text-right\"><span \nng-if=\"vm.row.espec_tipo === \'DE\' || !vm.row.espec_tipo\">{{ vm.tratamento.preco | currency : \'R$ \' : 2 }} </span><span \nng-if=\"vm.row.espec_tipo === \'E\' || vm.row.espec_tipo === \'D\'\">{{(+vm.tratamento.preco/2) | currency : \'R$ \' : 2 }}\n</span></div></div><div ng-if=\"vm.itrackline\" layout=\"row\" class=\"md-headline\"><div layout=\"column\" flex \nclass=\"margin-right-10\"><span>iTRACK LINE</span></div><div layout=\"column\" flex class=\"margin-left-10 text-right\">\n<span>{{ vm.itrackline.preco | currency : \'R$ \' : 2 }}</span></div></div><div layout=\"column\" flex \nclass=\"secondary-text md-headline\"><small>Adicionais</small></div><div ng-repeat=\"aditional in vm.additionalsSelected\" \nlayout=\"row\"><div layout=\"column\" flex class=\"margin-right-10\"><span>{{aditional.descricao}}</span></div><div \nlayout=\"column\" flex class=\"margin-left-10 text-right\"><span>{{ aditional.valor | currency : \'R$ \' : 2 }}</span></div>\n</div></div></div><div layout=\"column\" flex class=\"padding-10\"><div ng-if=\"vm.row.produto.tipo === \'GRESSIVE\'\" \nclass=\"margin-bottom-30 padding-16\" layout=\"column\" style=\"border: 1px dashed #e9e9e9\"><span class=\"secondary-text\">\nCódigo de desconto</span><div ng-if=\"!vm.voucherInfo\" layout=\"row\" layout-align=\"end center\"><md-input-container \nclass=\"md-icon-float md-block\"><label>Código de desconto</label><md-icon md-font-icon=\"icon-receipt\"></md-icon><input \nng-model=\"vm.codigoVoucher\" type=\"text\"></md-input-container><md-button ng-click=\"vm.clearVoucherCode()\" \nclass=\"md-icon-button\" aria-label=\"More\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button><md-button \nng-disabled=\"!vm.codigoVoucher\" ng-click=\"vm.validateVoucher()\" class=\"md-raised md-primary margin-right-0\" \ntype=\"button\">Validar</md-button></div><div ng-if=\"vm.voucherErrorMsg\" class=\"red-300-bg padding-8\">\n{{vm.voucherErrorMsg}}</div><div ng-if=\"vm.voucherInfo\" class=\"voucher-ticket\" layout=\"row\" layout-align=\"end center\">\n<div class=\"ticket basic\" layout=\"column\" layout-align=\"center center\"><div class=\"text\"><div class=\"to\"><h3 \nclass=\"margin-bottom-0 margin-top-16 text-center\"><b>{{vm.voucherInfo.codigo}}</b></h3></div><p>\n{{vm.voucherInfo.label}}</p><h3 class=\"margin-bottom-0 margin-top-16 text-center\" ng-if=\"!vm.voucherInfo.label\">\n{{vm.voucherInfo.desconto_percent}}% OFF</h3></div></div><div class=\"ticket airline\"><div class=\"item1\" layout=\"row\">\n<div class=\"from\"><p class=\"margin-bottom-0 margin-top-0\">Voucher</p><h4 class=\"margin-bottom-8 margin-top-8\">\n{{vm.voucherInfo.titulo}}</h4></div></div><div class=\"item2\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"gate\"><p class=\"margin-bottom-0 margin-top-0\">Válido até: {{vm.voucherInfo.end_at|w3DatePt}}</p></div><md-button\n ng-if=\"vm.enableRemoveVoucher()\" ng-click=\"vm.removeVoucher()\" class=\"md-raised md-warn\" aria-label=\"More\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon>Remover</md-button></div></div></div></div><div class=\"margin-bottom-30\" \nlayout=\"row\"><md-input-container flex class=\"margin-top-5 margin-bottom-0\"><label class=\"md-body-1\" \ntranslate=\"PEDIDO.FORM.SELECT_FORMA_PAGAMENTO\"></label><md-select class=\"md-body-1\" \nng-disabled=\"!vm.isRequestEditable\" ng-model=\"vm.row.forma_pagamento_id\" ng-required=\"false\"><md-option \nng-value=\"{{formaPagamento.id}}\" ng-repeat=\"formaPagamento in vm.formasPagamento\">{{formaPagamento.nome}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\"><div layout=\"column\" flex class=\"margin-right-10\"><span>\nSubtotal</span></div><div layout=\"column\" flex class=\"margin-left-10 text-right\"><span>\n{{ vm.row.vl_total | currency : \'R$ \' : 2 }}</span></div></div><div layout=\"row\"><div layout=\"column\" flex \nclass=\"margin-right-10\"><span>Acréscimo</span></div><div layout=\"column\" flex class=\"margin-left-10 text-right\"><span>\n{{ vm.acrescimoPoncentagem ? \'(\' + vm.acrescimoPoncentagem + \'%)\' : \'\' }} {{ vm.row.vl_acrescimo | currency : \'R$ \' : 2 }}\n</span></div></div><div layout=\"row\"><div layout=\"column\" flex class=\"margin-right-10\"><span>Desconto</span></div><div \nlayout=\"column\" flex class=\"margin-left-10 text-right\"><span>\n{{ vm.decontoPoncentagem ? \'(\' + vm.decontoPoncentagem + \'%)\' : \'\' }} {{ vm.row.vl_desconto | currency : \'R$ \' : 2 }}\n</span></div></div><div layout=\"row\"><div layout=\"column\" flex class=\"margin-right-10\"><span>Total</span></div><div \nlayout=\"column\" flex class=\"margin-left-10 text-right\"><md-divider class=\"black-500-bg\"></md-divider><span>\n{{ vm.row.vl_total_desconto | currency : \'R$ \' : 2 }}</span></div></div><div layout=\"row\" layout-align=\"end end\"><span \nclass=\"secondary-text\">REF.: {{vm.totalRef}}</span></div></div></div></md-card-content></div></md-card>");
$templateCache.put("/app/external/pedido/includes/_pedido-form-card-requirement-one.html","");
$templateCache.put("/app/external/pedido/includes/_pedido-form-card-specifications.html","<md-card><md-card-title style=\"border-style: solid; border-color: #0066ff; background-color: #3399ff\">\n<md-card-title-text layout=\"row\" layout-align=\"center center\"><span>Projeto de Lente</span></md-card-title-text>\n</md-card-title><md-card-content class=\"padding-top-16\"><md-content layout=\"column\" class=\"padding-0\" \nstyle=\"height: 450px\" ms-scroll><div layout=\"column\" layout-fill><div layout=\"row\" layout-align=\"center center\" \nclass=\"padding-10\"><img class=\"width-144 height-144\" style=\"border-radius: 50%\" \nng-src=\"{{vm.row.produto.thumb_src || \'app/external/assets/images/product-catalog/product-group-default-img.jpg\'}}\">\n</div><div layout=\"column\" class=\"padding-10\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.FORM.SUBHEADER_LENS\"></md-subheader><md-divider class=\"blue-300-bg\"></md-divider><div layout=\"row\">\n<div class=\"padding-5\" layout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-sunglasses\" \nng-style=\"{\'color\': vm.row.produto.cor.codigo}\"></md-icon></div><div layout=\"column\" class=\"padding-5\"><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ vm.row.produto.nome }}</p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ vm.row.produto.preco | currency : \'R$ \' : 2 }}</p></div></div></div>\n</div></md-content></md-card-content></md-card>");
$templateCache.put("/app/external/pedido/includes/_pedido-form-card-treatment.html","<md-card><md-card-title style=\"border-style: solid; border-color: #339966; background-color: #00cc99\">\n<md-card-title-text layout=\"row\" layout-align=\"center center\"><span>Tratamentos</span></md-card-title-text>\n</md-card-title><md-card-content ng-cloak class=\"padding-top-16\"><md-content layout=\"column\" class=\"padding-0\" \nstyle=\"height: 519px\" ms-scroll><div ng-if=\"vm.optionsTratamento.length\" flex><div ng-hide=\"vm.row.tratamento_id\" \nclass=\"padding-10\"><md-subheader class=\"md-no-sticky\" translate=\"PEDIDO.FORM.SELECT_TRATAMENTO\"></md-subheader>\n<md-divider class=\"blue-300-bg\"></md-divider><md-radio-group ng-required=\"true\" ng-model=\"vm.row.tratamento_id\" \nlayout=\"column\"><div layout=\"row\" layout-align=\"space-between center\" ng-repeat=\"tratamento in ::vm.optionsTratamento\">\n<md-radio-button flex ng-disabled=\"!vm.isRequestEditable\" ng-value=\"tratamento.id\" class=\"padding-5\"><div layout=\"row\" \nlayout-align=\"space-between center\"><pl-square-image src=\"tratamento.thumb_src\" size=\"\'sm\'\"></pl-square-image><div \nflex class=\"pl-8\" layout=\"column\"><p class=\"md-body-1 margin-bottom-0 margin-top-5\">{{ tratamento.nome }}</p><div \nlayout=\"row\" layout-align=\"space-between center\"><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ tratamento.preco | currency : \'R$ \' : 2 }}</p><small class=\"secondary-text\">REF:{{tratamento._ref}}</small></div>\n</div></div></md-radio-button><md-button \nng-click=\"vm.showDetail(tratamento.id, \'TRATAMENTO\'); $event.stopPropagation();\" class=\"md-icon-button\" \naria-label=\"More\"><md-icon class=\"s24\" md-font-icon=\"icon-loupe\"></md-icon></md-button></div></md-radio-group></div>\n<div ng-show=\"vm.row.tratamento_id\" layout-fill layout=\"column\"><div layout=\"column\" layout-align=\"start center\" \nng-repeat=\"tratamento in ::vm.row.produto.tratamentos\" ng-if=\"vm.row.tratamento_id == tratamento.id\" flex>\n<pl-square-image src=\"tratamento.thumb_src\" size=\"\'md\'\"></pl-square-image><p \nclass=\"md-headline margin-bottom-0 margin-top-5\">{{ tratamento.nome }}</p><p \nclass=\"md-headline margin-bottom-0 margin-top-5\">{{ tratamento.preco | currency : \'R$ \' : 2 }}</p><small \nclass=\"secondary-text\">REF:{{tratamento._ref}}</small><md-button \nng-click=\"vm.showDetail(tratamento.id, \'TRATAMENTO\'); $event.stopPropagation();\" class=\"md-icon-button\" \naria-label=\"More\"><md-icon class=\"s24\" md-font-icon=\"icon-loupe\"></md-icon></md-button></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button ng-if=\"vm.isRequestEditable\" class=\"blue-500-bg\" \nng-click=\"vm.row.tratamento_id = null\"><span class=\"white-500-fg\">Selecionar outro tratamento</span></md-button></div>\n</div></div><div ng-if=\"!vm.optionsTratamento.length\" flex><div layout=\"column\" layout-align=\"center center\" \nlayout-fill class=\"padding-10\" style=\"text-align: justify; text-justify: inter-word\"><div class=\"padding-right-24\">\n<md-icon aria-label=\"empty state icon\" md-font-icon=\"icon-eye\" class=\"red-500-fg\" \nng-style=\"{\'font-size\': \'48px\', height: \'48px\'}\"></md-icon></div><span class=\"md-title red-400-fg\">\nEste produto não possui nenhum tratamento </span><span class=\"md-subhead yellow-800-fg\">\nContate o responsavel pelo sistema e requisite a adição de tratamentos a estre produto</span></div></div></md-content>\n</md-card-content></md-card>");
$templateCache.put("/app/external/pedido/includes/_pedido-form-product-catalog.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"center center\" flex><span \nclass=\"md-title\" translate=\"PEDIDO.FORM.H3_SELECT_LENS\"></span></div><md-button ng-hide=\"vm.filterActive\" \nclass=\"md-icon-button mr-0 md-raised\" ng-click=\"vm.toogleFilter()\" aria-label=\"Clear filter\"><md-icon \nmd-font-icon=\"icon-filter\"></md-icon><md-tooltip>Abrir filtros</md-tooltip></md-button><md-button \nng-show=\"vm.filterActive\" class=\"md-icon-button mr-0 md-raised\" ng-click=\"vm.toogleFilter()\" aria-label=\"Clear filter\">\n<md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip>Fechar filtros</md-tooltip></md-button></div><ng-include \nsrc=\"\'/app/external/pedido/includes/_pedido-form-product-filter.html\'\"></ng-include><ng-include \nsrc=\"\'/app/external/pedido/includes/_pedido-form-product-list-as-hoya.html\'\"></ng-include>");
$templateCache.put("/app/external/pedido/includes/_pedido-form-product-filter.html","<div layout=\"column\" ng-show=\"vm.filterActive\" class=\"animate-slide-down\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.FORM.SUBHEADER_FILTER\"></md-subheader><md-divider></md-divider><div layout=\"row\" \nclass=\"margin-top-5\"><md-input-container flex class=\"margin-left-15 margin-rigth-15\"><label \ntranslate=\"PEDIDO.FORM.SUBHEADER_COR\"></label><md-select ng-model=\"vm.productFilter.cor_id\"><md-option \nng-value=\"cor.id\" ng-repeat=\"cor in vm.cores\"><md-icon md-font-icon=\"icon-sunglasses\" ng-style=\"{\'color\': cor.codigo}\">\n</md-icon><span>{{ cor.nome }}</span></md-option></md-select></md-input-container><md-input-container flex \nclass=\"margin-left-15 margin-rigth-15\"><label translate=\"PEDIDO.FORM.GRUPO\"></label><md-select \nng-model=\"vm.productFilter.grupo_id\"><md-option ng-value=\"grupo.id\" ng-repeat=\"grupo in vm.grupos\">{{ grupo.nome }}\n</md-option></md-select></md-input-container><md-input-container flex class=\"margin-left-15 margin-rigth-15\"><label \ntranslate=\"PEDIDO.FORM.SUBHEADER_MATERIAIS\"></label><md-select ng-model=\"vm.searchMateriais\" multiple=\"true\"><md-option\n ng-value=\"material.id\" ng-repeat=\"material in vm.materiais\">{{ material.descricao }}</md-option></md-select>\n</md-input-container><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button mr-0 md-raised\" \nng-click=\"vm.clearFilter()\" aria-label=\"Clear filter\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip>\nLimpar filtros</md-tooltip></md-button><md-button ng-click=\"vm.startFilter()\" class=\"md-icon-button\" \naria-label=\"Search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div></div></div>");
$templateCache.put("/app/external/pedido/includes/_pedido-form-product-list-as-hoya.html","<div layout=\"row\" layout-wrap ng-hide=\"vm.produtos.length == 0\" class=\"catalog-product\"><div flex-xs=\"50\" flex-sm=\"50\" \nflex-gt-sm=\"33\" flex-gt-md=\"25\" ng-if=\"vm.gressives.length != 0\"><md-card class=\"gressive-card h-448\"><div \nlayout=\"column\"><img ng-src=\"app/external/assets/images/product-catalog/hybrid.jpg\" style=\"height: 144px\" \nalt=\"Group image\"><md-card-title class=\"p-12\"><md-card-title-text layout=\"row\" layout-align=\"center center\"><md-icon \nclass=\"s24 m-0 amber-500-fg\" md-font-icon=\"icon-crown\"></md-icon><span \nclass=\"md-headline font-size-14 font-weight-700 ml-8\">Produtos Hybrid</span></md-card-title-text></md-card-title>\n<md-divider></md-divider><md-card-content class=\"pt-o h-256 amber-200-bg\" ms-scroll=\"\" \nstyle=\"overflow: auto !important\"><span class=\"font-size-14\">Usufrua de todas as vantagens que apenas um <b>\nProduto Hybrid</b> pode oferecer.</span><md-list><md-list-item class=\"no-padding\" layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"produto in vm.gressives | orderBy : \'cor_id\'\"><div class=\"margin-right-15\">\n<md-icon md-font-icon=\"icon-sunglasses\" ng-style=\"{\'color\': produto.cor.codigo}\"></md-icon></div><div flex><span \nclass=\"md-body-1\" style=\"font-size: 11px\">{{produto.nome}}</span></div><div layout=\"row\" layout-align=\"end center\">\n<md-button ng-click=\"vm.startRequestWithProduct(produto.id)\" class=\"md-raised blue-500-bg white-500-fg\" \naria-label=\"select\" translate translate-attr-aria-label=\"PEDIDO.FORM.SELECT\"><span \ntranslate=\"PEDIDO.FORM.BTN_SELECT_PRODUCT\"></span></md-button></div></md-list-item></md-list></md-card-content></div>\n</md-card></div><div flex-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"33\" flex-gt-md=\"25\" ng-repeat=\"grupo in vm.grupos\" \nng-if=\"vm.produtosFromGrupo(grupo.id).length != 0\"><md-card class=\"h-448\" ng-if=\"grupo.nome !== \'gressive\'\"><div \nlayout=\"column\"><img \nng-src=\"{{grupo.thumb_src || \'app/external/assets/images/product-catalog/product-group-default-img.jpg\'}}\" \nstyle=\"height: 144px\" alt=\"Group image\"><md-card-title class=\"p-12\"><md-card-title-text layout=\"row\" \nlayout-align=\"center center\"><span class=\"md-headline font-size-14 font-weight-700\">{{grupo.nome}}</span>\n</md-card-title-text></md-card-title><md-divider></md-divider><md-card-content class=\"pt-o h-256\" ms-scroll=\"\" \nstyle=\"overflow: auto !important\"><md-list><md-list-item class=\"no-padding\" layout=\"row\" layout-align=\"start center\" \nng-repeat=\"produto in vm.produtosFromGrupo(grupo.id) | orderBy : \'cor_id\'\"><div class=\"margin-right-15\"><md-icon \nmd-font-icon=\"icon-sunglasses\" ng-style=\"{\'color\': produto.cor.codigo}\"></md-icon></div><div flex><span \nclass=\"md-body-1\" style=\"font-size: 11px\">{{produto.nome}}</span></div><div layout=\"row\" layout-align=\"end center\">\n<md-button ng-click=\"vm.startRequestWithProduct(produto.id)\" class=\"md-raised blue-500-bg white-500-fg\" \naria-label=\"select\" translate translate-attr-aria-label=\"PEDIDO.FORM.SELECT\"><span \ntranslate=\"PEDIDO.FORM.BTN_SELECT_PRODUCT\"></span></md-button></div></md-list-item></md-list></md-card-content></div>\n</md-card></div></div><div ng-show=\"vm.produtos.length == 0\" layout=\"column\" layout-align=\"center center\" \nlayout-margin><md-icon md-font-icon=\"icon-alert-box\" ng-style=\"{\'color\': \'red\', \'font-size\': \'48px\', height: \'48px\'}\">\n</md-icon><h1 class=\"md-display-3\" translate=\"PEDIDO.FORM.PRODUCT_CATALOG_FILTER_EMPTY_RESULT\"></h1></div>");
$templateCache.put("/app/external/pedido/includes/_pedido-show-details-card-eyeglasses-frame.html","<md-card><md-card-title><md-card-title-media><div class=\"md-media-sm card-media\" layout=\"row\" \nlayout-align=\"end center\"><md-icon md-font-icon=\"icon-glasses\" class=\"red-A700-fg\"></md-icon></div>\n</md-card-title-media><md-card-title-text layout=\"row\" layout-align=\"center center\"><span class=\"md-title\">\nModelo da armação</span></md-card-title-text><md-card-title-media><div class=\"md-media-sm card-media\" layout=\"row\" \nlayout-align=\"end center\"><md-icon md-font-icon=\"icon-glasses\" class=\"red-A700-fg\"></md-icon></div>\n</md-card-title-media></md-card-title><md-card-content><div \nng-if=\"!(request.material_armacao_label || request.tipo_armacao)\" class=\"padding-40\" style=\"text-align: center\" \nlayout=\"row\" layout-align=\"center center\" layout-fill><span class=\"md-body-2\">\nNão há dados do tipo e modelo da armação relacionados a este pedido</span></div><div layout=\"column\" \nng-if=\"request.material_armacao_label || request.tipo_armacao\"><div flex layout=\"row\" layout-margin><div flex \nlayout=\"column\" class=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.EYEGLASS_FRAME_TYPE\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.material_armacao_label }}</p></div><div flex layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.EYEGLASS_FRAME_MODEL\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider>\n<div><img style=\"height: 124px\" ng-if=\"vm.isRequestValid()\" ng-src=\"{{ vm.getFrameModelURL() }}\"></div></div></div>\n</div></md-card-content></md-card>");
$templateCache.put("/app/external/pedido/includes/_pedido-show-details-card-lens-prescription.html","<md-card><md-card-title><md-card-title-media><div class=\"md-media-sm card-media\" layout=\"row\" \nlayout-align=\"end center\"><md-icon md-font-icon=\"icon-pencil\" class=\"brown-900-fg\"></md-icon></div>\n</md-card-title-media><md-card-title-text layout=\"row\" layout-align=\"center center\"><span \ntranslate=\"PEDIDO.SHOW.TAB_LABEL.LENS_PRESCRIPTION\" class=\"md-title\"></span></md-card-title-text><md-card-title-media>\n<div class=\"md-media-sm card-media\" layout=\"row\" layout-align=\"end center\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"brown-900-fg\"></md-icon></div></md-card-title-media></md-card-title><md-card-content><div \nng-if=\"!(request.espec_od || request.espec_oe)\" class=\"padding-40\" style=\"text-align: center\" layout=\"row\" \nlayout-align=\"center center\" layout-fill><span class=\"md-body-2\">Não há dados de prescrição relacionados a este pedido\n</span></div><div layout-xs=\"column\" layout-sm=\"column\" layout-gt-sm=\"row\" \nng-if=\"request.espec_od || request.espec_oe\"><div flex layout=\"column\"><div layout=\"row\" layout-align=\"center center\">\n<h1 class=\"md-subhead\" translate=\"PEDIDO.SHOW.FIELD_SET_LABEL.PRESCRIPTION_RIGHT_EYE\"></h1></div><div flex \nlayout=\"column\" layout-margin><div layout=\"row\" flex><div flex layout=\"column\" class=\"margin-left-15 margin-right-15\">\n<md-subheader class=\"md-no-sticky\" translate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_SPHERICAL\"></md-subheader><md-divider \nclass=\"blue-500-bg\"></md-divider><p \nng-if=\"request.espec_od.esferico !== null && request.espec_od.esferico !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.espec_od.esferico| currency:\' \' }}</p><p \nng-if=\"request.espec_od.esferico === null || request.espec_od.esferico === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p></div><div flex layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" translate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_CIL\">\n</md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nng-if=\"request.espec_od.cil !== null && request.espec_od.cil !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.espec_od.cil| currency:\' \' }}</p><p \nng-if=\"request.espec_od.cil === null || request.espec_od.cil === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p></div><div flex layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_AXIS\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nng-if=\"request.espec_od.eixo !== null && request.espec_od.eixo !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.espec_od.eixo }}</p><p \nng-if=\"request.espec_od.eixo === null || request.espec_od.eixo === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p></div><div flex layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_ADDITION\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nng-if=\"request.espec_od.adicao !== null && request.espec_od.adicao !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.espec_od.adicao| currency:\' \' }}</p><p \nng-if=\"request.espec_od.adicao === null || request.espec_od.adicao === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p></div></div><div layout=\"row\" flex><div flex \nlayout=\"column\" class=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_PRIS_H\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nng-if=\"request.espec_od.prish !== null && request.espec_od.prish !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.espec_od.prish| currency:\' \' }}</p><p \nng-if=\"request.espec_od.prish === null || request.espec_od.prish === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p></div><div flex layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_PRIS_H_BASE\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nng-if=\"request.espec_od.prish_base  !== null && request.espec_od.prish_base !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.espec_od.prish_base }}</p><p \nng-if=\"request.espec_od.prish_base  === null || request.espec_od.prish_base  === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p></div><div flex layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_PRIS_V\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nng-if=\"request.espec_od.prisv !== null && request.espec_od.prisv !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.espec_od.prisv| currency:\' \' }}</p><p \nng-if=\"request.espec_od.prisv === null || request.espec_od.prisv === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p></div><div flex layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_PRIS_V_BASE\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nng-if=\"request.espec_od.prisv_base !== null && request.espec_od.prisv_base !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.espec_od.prisv_base }}</p><p \nng-if=\"request.espec_od.prisv_base === null || request.espec_od.prisv_base === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p></div></div></div></div><md-divider show-gt-sm \nclass=\"blue-500-bg\"></md-divider><div flex layout=\"column\"><div layout=\"row\" layout-align=\"center center\"><h1 \nclass=\"md-subhead\" translate=\"PEDIDO.SHOW.FIELD_SET_LABEL.PRESCRIPTION_LEFT_EYE\"></h1></div><div flex layout=\"column\" \nlayout-margin><div layout=\"row\" flex><div flex layout=\"column\" class=\"margin-left-15 margin-right-15\"><md-subheader \nclass=\"md-no-sticky\" translate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_SPHERICAL\"></md-subheader><md-divider class=\"blue-500-bg\">\n</md-divider><p ng-if=\"request.espec_oe.esferico !== null && request.espec_oe.esferico !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.espec_oe.esferico| currency:\' \' }}</p><p \nng-if=\"request.espec_oe.esferico === null || request.espec_oe.esferico  === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p></div><div flex layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" translate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_CIL\">\n</md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nng-if=\"request.espec_oe.cil !== null && request.espec_oe.cil !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.espec_oe.cil| currency:\' \' }}</p><p \nng-if=\"request.espec_oe.cil === null || request.espec_oe.cil  === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p><p ng-if=\"request.espec_od.value\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.espec_oe.cil }}</p></div><div flex layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_AXIS\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nng-if=\"request.espec_oe.eixo !== null && request.espec_oe.eixo !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.espec_oe.eixo }}</p><p \nng-if=\"request.espec_oe.eixo === null || request.espec_oe.eixo === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p></div><div flex layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_ADDITION\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nng-if=\"request.espec_oe.adicao !== null && request.espec_oe.adicao !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.espec_oe.adicao| currency:\' \' }}</p><p \nng-if=\"request.espec_oe.adicao === null || request.espec_oe.adicao === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p></div></div><div layout=\"row\" flex><div flex \nlayout=\"column\" class=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_PRIS_H\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nng-if=\"request.espec_oe.prish !== null && request.espec_oe.prish !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.espec_oe.prish| currency:\' \' }}</p><p \nng-if=\"request.espec_oe.prish === null || request.espec_oe.prish  === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p></div><div flex layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_PRIS_H_BASE\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nng-if=\"request.espec_oe.prish_base !== null && request.espec_oe.prish_base !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.espec_oe.prish_base }}</p><p \nng-if=\"request.espec_oe.prish_base === null || request.espec_oe.prish_base === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p></div><div flex layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_PRIS_V\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nng-if=\"request.espec_oe.prisv !== null && request.espec_oe.prisv !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.espec_oe.prisv| currency:\' \' }}</p><p \nng-if=\"request.espec_oe.prisv === null || request.espec_oe.prisv  === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p></div><div flex layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_PRIS_V_BASE\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nng-if=\"request.espec_oe.prisv_base !== null && request.espec_oe.prisv_base !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.espec_oe.prisv_base }}</p><p \nng-if=\"request.espec_oe.prisv_base === null || request.espec_oe.prisv_base === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p></div></div></div></div></div></md-card-content>\n</md-card>");
$templateCache.put("/app/external/pedido/includes/_pedido-show-details-card-lens-specification.html","<md-card><md-card-title><md-card-title-media><div class=\"md-media-sm card-media\" layout=\"row\" \nlayout-align=\"end center\"><md-icon md-font-icon=\"icon-format-list-numbers\" class=\"grey-900-fg\"></md-icon></div>\n</md-card-title-media><md-card-title-text layout=\"row\" layout-align=\"center center\"><span \ntranslate=\"PEDIDO.SHOW.TAB_LABEL.LENS_SPECIFICATION\" class=\"md-title\"></span></md-card-title-text><md-card-title-media>\n<div class=\"md-media-sm card-media\" layout=\"row\" layout-align=\"end center\"><md-icon \nmd-font-icon=\"icon-format-list-numbers\" class=\"grey-900-fg\"></md-icon></div></md-card-title-media></md-card-title>\n<md-card-content><div ng-if=\"!request.produto\" class=\"padding-40\" style=\"text-align: center\" layout=\"row\" \nlayout-align=\"center center\" layout-fill><span class=\"md-body-2\">Não há um produto relacionado a este pedido</span>\n</div><div layout=\"column\" ng-if=\"request.produto && request.produto.tipo === \'NORMAL\'\" flex><div \nng-if=\"!vm.isUserLab()\" layout=\"row\" layout-align=\"center center\" layout-margin><div layout=\"row\" \nlayout-align=\"center center\" class=\"margin-10\"><pl-square-image src=\"request.produto.thumb_src\" size=\"\'md\'\">\n</pl-square-image></div><div flex layout=\"column\"><div flex layout=\"row\" layout-margin><div flex layout=\"column\" \nclass=\"margin-right-15\"><md-subheader class=\"md-no-sticky\" translate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_NAME\">\n</md-subheader><md-divider class=\"blue-500-bg\"></md-divider><div layout=\"row\" layout-align=\"space-between center\"><div \nflex layout=\"column\"><p class=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.produto.nome }}</p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.produto.preco | currency : \'R$ \' : 2 }}</p></div><div \nlayout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-sunglasses\" \nng-style=\"{\'color\': request.produto.cor.codigo}\"></md-icon></div></div><br><div ng-if=\"request.itrack_id\" flex \nlayout=\"column\"><b>iTRACK LINE</b><md-divider class=\"blue-500-bg\"></md-divider><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.itrack.nome }}</p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ request.itrack_code }} - {{ request.itrack.preco | currency : \'R$ \' : 2 }}</p></div></div><div flex layout=\"column\" \nclass=\"margin-left-15\"><md-subheader class=\"md-no-sticky\" translate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_VISION_TYPE\">\n</md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p class=\"md-body-1 margin-vertical-5\">\n{{ request.produto.tipo_visao || \"-- -- -- --\"}}</p></div></div><div flex layout=\"row\" layout-margin><div flex \nlayout=\"column\" class=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_MATERIAL\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><div \nlayout=\"row\"><pl-square-image src=\"request.material.thumb_src\" size=\"\'sm\'\"></pl-square-image><div class=\"ml-8\" flex \nlayout=\"column\"><p class=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.material.nome }}</p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.material.preco | currency : \'R$ \' : 2 }}</p></div></div>\n</div><div flex layout=\"column\" class=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_TREATMENT\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><div \nlayout=\"row\"><pl-square-image src=\"request.tratamento.thumb_src\" size=\"\'sm\'\"></pl-square-image><div class=\"ml-8\" flex \nlayout=\"column\"><p class=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.tratamento.nome }}</p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.tratamento.preco | currency : \'R$ \' : 2 }}</p></div></div>\n</div></div><div layout=\"column\" ng-if=\"request.adicionais\" class=\"margin-top-10\"><md-subheader \nclass=\"md-no-sticky fit-subheader\">Adicionais</md-subheader><md-divider class=\"blue-500-bg\"></md-divider><div \nng-repeat=\"adittional in request.adicionais\" flex layout=\"row\" layout-align=\"space-between center\"><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ adittional.descricao }}</p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ adittional.valor | currency : \'R$ \' : 2 }}</p></div></div></div>\n</div><div ng-if=\"vm.isUserLab()\" layout=\"column\" layout-margin><div flex layout=\"row\" layout-margin><div flex \nlayout=\"column\" class=\"margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_NAME\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><div \nlayout=\"row\" layout-align=\"space-between center\"><div flex layout=\"column\"><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request._prod_nome_tec_snap }}</p></div><div layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-sunglasses\" ng-style=\"{\'color\': request.produto.cor.codigo}\">\n</md-icon></div></div><div ng-if=\"request.itrack_id\" flex layout=\"column\" class=\"margin-top-5\"><b>iTRACK LINE</b>\n<md-divider class=\"blue-500-bg\"></md-divider><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ request.itrack.nome }}</p><p class=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.itrack_code }}</p></div>\n</div><div flex layout=\"column\" class=\"margin-left-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_VISION_TYPE\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nclass=\"md-body-1 margin-vertical-5\">{{ request.produto.tipo_visao || \"-- -- -- --\"}}</p></div></div><div flex \nlayout=\"row\" layout-margin><div flex layout=\"column\" class=\"margin-left-15 margin-right-15\"><md-subheader \nclass=\"md-no-sticky\" translate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_MATERIAL\"></md-subheader><md-divider class=\"blue-500-bg\">\n</md-divider><div layout=\"row\"><div class=\"ml-8\" flex layout=\"column\"><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.material.nome_tecnico }}</p></div></div></div><div flex \nlayout=\"column\" class=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_TREATMENT\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><div \nlayout=\"row\"><div class=\"ml-8\" flex layout=\"column\"><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ request.tratamento.nome_tecnico }}</p></div></div></div></div><div layout=\"column\" ng-if=\"request.adicionais\" \nclass=\"margin-top-10\"><md-subheader class=\"md-no-sticky fit-subheader\">Adicionais</md-subheader><md-divider \nclass=\"blue-500-bg\"></md-divider><div ng-repeat=\"adittional in request.adicionais\" flex layout=\"row\" \nlayout-align=\"space-between center\"><p class=\"md-body-1 margin-bottom-0 margin-top-5\">{{ adittional.descricao }}</p>\n</div></div></div></div><div layout=\"column\" ng-if=\"request.produto && request.produto.tipo === \'GRESSIVE\'\" flex><div \nng-if=\"!vm.isUserLab()\" layout=\"row\" layout-align=\"center start\" layout-margin><div flex layout=\"column\" layout-margin>\n<div flex layout=\"column\" class=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_NAME\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><div \nlayout=\"row\"><pl-square-image src=\"request.produto.thumb_src\" size=\"\'sm\'\"></pl-square-image><div class=\"ml-8\" flex \nlayout=\"column\"><p class=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.produto.nome }}</p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.produto.preco | currency : \'R$ \' : 2 }}</p></div><div \nlayout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-sunglasses\" \nng-style=\"{\'color\': request.produto.cor.codigo}\"></md-icon></div></div></div><div flex layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky fit-subheader\">Configuração: Longe\n</md-subheader><md-divider class=\"blue-500-bg\"></md-divider><div layout=\"row\"><pl-square-image \nsrc=\"request.itemLonge.thumb_src\" size=\"\'sm\'\"></pl-square-image><div class=\"ml-8\" flex layout=\"column\"><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.itemLonge.nome }}</p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.itemLonge.preco | currency : \'R$ \' : 2 }}</p></div></div>\n</div><div flex layout=\"column\" class=\"margin-left-15 margin-right-15\"><md-subheader \nclass=\"md-no-sticky fit-subheader\">Configuração: Intermediário</md-subheader><md-divider class=\"blue-500-bg\">\n</md-divider><div layout=\"row\"><pl-square-image src=\"request.itemInterm.thumb_src\" size=\"\'sm\'\"></pl-square-image><div \nclass=\"ml-8\" flex layout=\"column\"><p class=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.itemInterm.nome }}</p><p\n class=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.itemInterm.preco | currency : \'R$ \' : 2 }}</p></div></div>\n</div><div flex layout=\"column\" class=\"margin-left-15 margin-right-15\"><md-subheader \nclass=\"md-no-sticky fit-subheader\">Configuração: Perto</md-subheader><md-divider class=\"blue-500-bg\"></md-divider><div \nlayout=\"row\"><pl-square-image src=\"request.itemPerto.thumb_src\" size=\"\'sm\'\"></pl-square-image><div class=\"ml-8\" flex \nlayout=\"column\"><p class=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.itemPerto.nome }}</p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.itemPerto.preco | currency : \'R$ \' : 2 }}</p></div></div>\n</div></div><div flex layout=\"column\" layout-margin><div flex layout=\"column\" class=\"margin-left-15\"><md-subheader \nclass=\"md-no-sticky\" translate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_VISION_TYPE\"></md-subheader><md-divider \nclass=\"blue-500-bg\"></md-divider><p class=\"md-body-1 margin-vertical-5\">\n{{ request.produto.tipo_visao || \"-- -- -- --\"}}</p></div><div flex layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_MATERIAL\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><div \nlayout=\"row\"><pl-square-image src=\"request.material.thumb_src\" size=\"\'sm\'\"></pl-square-image><div class=\"ml-8\" flex \nlayout=\"column\"><p class=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.material.nome }}</p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.material.preco | currency : \'R$ \' : 2 }}</p></div></div>\n</div><div flex layout=\"column\" class=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_TREATMENT\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><div \nlayout=\"row\"><pl-square-image src=\"request.tratamento.thumb_src\" size=\"\'sm\'\"></pl-square-image><div class=\"ml-8\" flex \nlayout=\"column\"><p class=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.tratamento.nome }}</p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.tratamento.preco | currency : \'R$ \' : 2 }}</p></div></div>\n</div></div></div><div ng-if=\"vm.isUserLab()\" layout=\"row\" layout-align=\"center start\" layout-margin><div flex \nlayout=\"column\" layout-margin><div flex layout=\"column\" class=\"margin-left-15 margin-right-15\"><md-subheader \nclass=\"md-no-sticky\" translate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_NAME\"></md-subheader><md-divider class=\"blue-500-bg\">\n</md-divider><div layout=\"row\"><div class=\"ml-8\" flex layout=\"column\"><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request._prod_nome_tec_snap }}</p></div><div layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-sunglasses\" ng-style=\"{\'color\': request.produto.cor.codigo}\">\n</md-icon></div></div></div><div flex layout=\"column\" class=\"margin-left-15 margin-right-15\"><md-subheader \nclass=\"md-no-sticky\">Configuração: Longe</md-subheader><md-divider class=\"blue-500-bg\"></md-divider><div layout=\"row\">\n<div class=\"ml-8\" flex layout=\"column\"><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ request.itemLonge.nome_tecnico }}</p></div></div></div><div flex layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\">Configuração: Intermediário</md-subheader>\n<md-divider class=\"blue-500-bg\"></md-divider><div layout=\"row\"><div class=\"ml-8\" flex layout=\"column\"><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.itemInterm.nome_tecnico }}</p></div></div></div><div flex \nlayout=\"column\" class=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\">Configuração: Perto\n</md-subheader><md-divider class=\"blue-500-bg\"></md-divider><div layout=\"row\"><div class=\"ml-8\" flex layout=\"column\"><p\n class=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.itemPerto.nome_tecnico }}</p></div></div></div></div><div \nflex layout=\"column\" layout-margin><div flex layout=\"column\" class=\"margin-left-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_VISION_TYPE\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nclass=\"md-body-1 margin-vertical-5\">{{ request.produto.tipo_visao || \"-- -- -- --\"}}</p></div><div flex \nlayout=\"column\" class=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_MATERIAL\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><div \nlayout=\"row\"><div class=\"ml-8\" flex layout=\"column\"><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ request.material.nome_tecnico }}</p></div></div></div><div flex layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_TREATMENT\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><div \nlayout=\"row\"><div class=\"ml-8\" flex layout=\"column\"><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ request.tratamento.nome_tecnico }}</p></div></div></div></div></div></div></md-card-content></md-card>");
$templateCache.put("/app/external/pedido/includes/_pedido-show-details-card-medidas.html","<md-card><md-card-title><md-card-title-media><div class=\"md-media-sm card-media\" layout=\"row\" \nlayout-align=\"end center\"><md-icon md-font-icon=\"icon-numeric\" class=\"blue-500-fg\"></md-icon></div>\n</md-card-title-media><md-card-title-text layout=\"row\" layout-align=\"center center\"><span class=\"md-title\">Medidas\n</span></md-card-title-text><md-card-title-media><div class=\"md-media-sm card-media\" layout=\"row\" \nlayout-align=\"end center\"><md-icon md-font-icon=\"icon-numeric\" class=\"blue-500-fg\"></md-icon></div>\n</md-card-title-media></md-card-title><md-card-content><div ng-if=\"!(request.medidas)\" class=\"padding-40\" \nstyle=\"text-align: center\" layout=\"row\" layout-align=\"center center\" layout-fill><span class=\"md-body-2\">\nNão há dados referentes a medidas das lentes deste pedido</span></div><div layout=\"column\" ng-if=\"request.medidas\"><div\n flex layout-xs=\"column\" layout-sm=\"column\" layout-gt-sm=\"row\" layout-margin><div style=\"width: 280px\" layout=\"row\" \nlayout-align=\"center center\"><img src=\"app/external/assets/images/eyeglass/medidaLente.png\" alt=\"Eyeglasses Frames\" \nstyle=\"height: 75%; width: 75%\"></div><div flex layout-xs=\"row\" layout-sm=\"row\" layout-gt-sm=\"column\" \nlayout-align-sm=\"space-between start\" class=\"margin-left-15 margin-right-15\"><div class=\"padding-bottom-10\" \nflex-sm=\"33\"><md-subheader class=\"md-no-sticky\" translate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_MEASURE_WEIGHT\"></md-subheader>\n<md-divider class=\"blue-500-bg\"></md-divider><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ request.medidas.largura }}</p></div><div class=\"padding-bottom-10\" flex-sm=\"33\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_MEASURE_HEIGHT\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.medidas.altura }}</p></div></div><div flex layout-xs=\"row\" \nlayout-sm=\"row\" layout-gt-sm=\"column\" layout-align-sm=\"space-between start\" class=\"margin-left-15 margin-right-15\"><div\n class=\"padding-bottom-10\" flex-sm=\"33\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_MEASURE_BRIDGE\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.medidas.ponte }}</p></div><div class=\"padding-bottom-10\" \nflex-sm=\"33\"><md-subheader class=\"md-no-sticky\" translate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_MEASURE_DIAGONAL\">\n</md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ request.medidas.diagonal }}</p></div></div><div flex layout-xs=\"row\" layout-sm=\"row\" layout-gt-sm=\"column\" \nlayout-align-sm=\"space-between start\" class=\"margin-left-15 margin-right-15\"><div class=\"padding-bottom-10\" \nflex-sm=\"33\"><md-subheader class=\"md-no-sticky\" translate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_MEASURE_PUPIL_HEIGHT_LEFT\">\n</md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ request.medidas.oe_altura_pupilar }}</p></div><div class=\"padding-bottom-10\" flex-sm=\"33\"><md-subheader \nclass=\"md-no-sticky\" translate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_MEASURE_PUPIL_HEIGHT_RIGTH\"></md-subheader><md-divider \nclass=\"blue-500-bg\"></md-divider><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ request.medidas.od_altura_pupilar }}</p></div></div><div flex layout-xs=\"row\" layout-sm=\"row\" layout-gt-sm=\"column\" \nlayout-align-sm=\"space-between start\" class=\"margin-left-15 margin-right-15\"><div class=\"padding-bottom-10\" \nflex-sm=\"33\"><md-subheader class=\"md-no-sticky\" translate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_MEASURE_DNP_LEFT\">\n</md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ request.medidas.oe_dnp }}</p></div><div class=\"padding-bottom-10\" flex-sm=\"33\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_MEASURE_DNP_RIGTH\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider>\n<p class=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.medidas.od_dnp }}</p></div></div></div><div flex \nlayout=\"row\" class=\"layout-margin\" style=\"margin-top: -22px\"><div style=\"width: 280px\"></div><div \nng-if=\"request.produto.tipo === \'GRESSIVE\'\"><md-subheader class=\"md-no-sticky fit-subheader\">\nAltura. Versão do corredor progressivo.</md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.altura_v_progressivo }}</p></div></div></div>\n</md-card-content></md-card>");
$templateCache.put("/app/external/pedido/includes/_pedido-show-details-card-observation.html","<md-card><md-card-title><md-card-title-media><div class=\"md-media-sm card-media\" layout=\"row\" \nlayout-align=\"end center\"><md-icon md-font-icon=\"icon-message\" class=\"green-900-fg\"></md-icon></div>\n</md-card-title-media><md-card-title-text layout=\"row\" layout-align=\"center center\"><span class=\"md-title\">Observações\n</span></md-card-title-text><md-card-title-media><div class=\"md-media-sm card-media\" layout=\"row\" \nlayout-align=\"end center\"><md-icon md-font-icon=\"icon-message\" class=\"green-900-fg\"></md-icon></div>\n</md-card-title-media></md-card-title><md-card-content><div layout-fill layout-xs=\"column\" layout-sm=\"column\" \nlayout-gt-sm=\"row\" layout-margin><div layout-xs=\"row\" layout-sm=\"row\" layout-align-sm=\"space-between center\" \nflex-gt-sm layout-gt-sm=\"column\" class=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\">Observações\n</md-subheader><md-divider hide-xs hide-sm class=\"blue-500-bg\"></md-divider><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ request.observacao? request.observacao : \'-- Sem observações adicionais. --\' }}</p></div></div></md-card-content>\n</md-card>");
$templateCache.put("/app/external/pedido/includes/_pedido-show-details-card-payment.html","<md-card><md-card-title><md-card-title-media><div class=\"md-media-sm card-media\" layout=\"row\" \nlayout-align=\"end center\"><md-icon md-font-icon=\"icon-coin\" class=\"green-900-fg\"></md-icon></div></md-card-title-media>\n<md-card-title-text layout=\"row\" layout-align=\"center center\"><span translate=\"PEDIDO.SHOW.TAB_LABEL.REQUEST_PAYMENT\" \nclass=\"md-title\"></span></md-card-title-text><md-card-title-media><div class=\"md-media-sm card-media\" layout=\"row\" \nlayout-align=\"end center\"><md-icon md-font-icon=\"icon-coin\" class=\"green-900-fg\"></md-icon></div></md-card-title-media>\n</md-card-title><md-card-content><div ng-if=\"!request.formaPagamento\" class=\"padding-40\" style=\"text-align: center\" \nlayout=\"row\" layout-align=\"center center\" layout-fill><span class=\"md-body-2\">\nNão há dados o suficiente para exibir o custo deste pedido</span></div><div ng-if=\"request.formaPagamento\" layout-fill \nlayout-xs=\"column\" layout-sm=\"column\" layout-gt-sm=\"row\" layout-margin><div layout-xs=\"row\" layout-sm=\"row\" \nlayout-align-sm=\"space-between center\" flex-gt-sm layout-gt-sm=\"column\" class=\"margin-left-15 margin-right-15\">\n<md-subheader class=\"md-no-sticky\">Valor total do pedido</md-subheader><md-divider hide-xs hide-sm class=\"blue-500-bg\">\n</md-divider><p class=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.vl_total | currency : \'R$ \' : 2 }}</p></div>\n<div layout-xs=\"row\" layout-sm=\"row\" layout-align-sm=\"space-between center\" flex-gt-sm layout-gt-sm=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\"><span>Acréscimo</span></md-subheader>\n<md-divider hide-xs hide-sm class=\"blue-500-bg\"></md-divider><p ng-if=\"request._form_pag\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request._form_pag.acrescimo}}%</p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ request.vl_acrescimo ? (request.vl_acrescimo | currency : \'R$ \' : 2) : \'R$ 0,00\'}}</p></div><div layout-xs=\"row\" \nlayout-sm=\"row\" layout-align-sm=\"space-between center\" flex-gt-sm layout-gt-sm=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\">Desconto</md-subheader><md-divider hide-xs \nhide-sm class=\"blue-500-bg\"></md-divider><p ng-if=\"request._form_pag && !request.voucher\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request._form_pag.desconto}}%</p><p ng-if=\"request.voucher\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.voucher.desconto_percent}}%</p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.vl_desconto | currency : \'R$ \' : 2 }}</p><span \nng-if=\"request.voucher\" class=\"secondary-text border p-5\">Voucher: {{request.voucher.titulo}} - <b>\n{{request.voucher.codigo}}</b></span></div><div layout-xs=\"row\" layout-sm=\"row\" layout-align-sm=\"space-between center\" \nflex-gt-sm layout-gt-sm=\"column\" class=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\">\nValor final do pedido</md-subheader><md-divider hide-xs hide-sm class=\"blue-500-bg\"></md-divider><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.vl_final | currency : \'R$ \' : 2 }}<md-button \nng-if=\"vm.showButtonChangeAmount()\" class=\"md-icon-button\"><md-tooltip>Alterar valores relativos ao pedido</md-tooltip>\n<md-icon ng-click=\"vm.changeOrderAmount($event)\" md-font-icon=\"icon-pencil\"></md-icon></md-button></p></div><div \nlayout-xs=\"row\" layout-sm=\"row\" layout-align-sm=\"space-between center\" flex-gt-sm layout-gt-sm=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\">Tipo de pagamento</md-subheader><md-divider \nhide-xs hide-sm class=\"blue-500-bg\"></md-divider><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ request._form_pag.nome}}<br>{{request._form_pag.label_parcela}}</p></div></div></md-card-content></md-card>");
$templateCache.put("/app/external/pedido/includes/_pedido-show-details-card-remote-cut.html","<md-card><md-card-title><md-card-title-media><div class=\"md-media-sm card-media\" layout=\"row\" \nlayout-align=\"end center\"><md-icon md-font-icon=\"icon-cut\" class=\"blue-900-fg\"></md-icon></div></md-card-title-media>\n<md-card-title-text layout=\"row\" layout-align=\"center center\"><span class=\"md-title\">Corte remoto</span>\n</md-card-title-text><md-card-title-media><div class=\"md-media-sm card-media\" layout=\"row\" layout-align=\"end center\">\n<md-icon md-font-icon=\"icon-cut\" class=\"blue-900-fg\"></md-icon></div></md-card-title-media></md-card-title>\n<md-card-content><div layout-fill layout-xs=\"column\" layout-sm=\"column\" layout-gt-sm=\"row\" layout-margin><div \nlayout-xs=\"row\" layout-sm=\"row\" layout-align-sm=\"space-between center\" flex-gt-sm layout-gt-sm=\"column\" \nclass=\"margin-left-15 margin-right-15\"><div ng-if=\"request.file_corte_remoto_src\" flex layout=\"column\" \nlayout-align=\"start center\"><span class=\"mb-8 mt-16\"><md-icon md-font-icon=\"icon-paperclip\"></md-icon>\n( Arquivo de corte ) </span><a flex layout=\"row\" layout-wrap=\"\" class=\"rf-pointer document-miniature\" target=\"_blank\" \nng-href=\"{{request.file_corte_remoto_src}}\"><md-icon md-font-icon=\"icon-cursor-pointer\" class=\"s60 icon-inv\"></md-icon>\n<small class=\"w-120\" style=\"white-space: break-spaces; word-break: break-all\">{{request.file_corte_remoto_src}}</small>\n</a></div><p ng-if=\"!request.file_corte_remoto_src\" class=\"md-body-1 margin-bottom-0 margin-top-5\">\n-- Nenhum arquivo de corte remoto foi adicionado a este pedido. --</p></div></div></md-card-content></md-card>");
$templateCache.put("/app/external/pedido/includes/_pedido-show-details-card-request-identification.html","<md-card><md-card-title><md-card-title-media><div class=\"md-media-sm card-media\" layout=\"row\" \nlayout-align=\"end center\"><md-icon md-font-icon=\"icon-book-variant\" class=\"indigo-800-fg\"></md-icon></div>\n</md-card-title-media><md-card-title-text layout=\"row\" layout-align=\"center center\"><span \ntranslate=\"PEDIDO.SHOW.TAB_LABEL.REQUEST_IDENTIFICATION\" class=\"md-title\"></span></md-card-title-text>\n<md-card-title-media><div class=\"md-media-sm card-media\" layout=\"row\" layout-align=\"end center\"><md-icon \nmd-font-icon=\"icon-book-variant\" class=\"indigo-800-fg\"></md-icon></div></md-card-title-media></md-card-title>\n<md-card-content><div flex layout=\"column\"><div layout-xs=\"column\" layout-sm=\"column\" layout-gt-sm=\"row\" layout-margin \nng-if=\"vm.isUserOtica() || vm.isUserAdmin()\"><div layout-xs=\"row\" layout-sm=\"row\" \nlayout-align-sm=\"space-between center\" flex-gt-sm layout-gt-sm=\"column\" class=\"margin-right-15\"><md-subheader \nclass=\"md-no-sticky\" translate=\"PEDIDO.SHOW.FIELD_LABEL.OS_NUMBER\"></md-subheader><md-divider hide-xs hide-sm \nclass=\"blue-500-bg\"></md-divider><div layout=\"column\"><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ request.nro_os }}</p></div></div><div layout-xs=\"row\" layout-sm=\"row\" layout-align-sm=\"space-between center\" \nflex-gt-sm layout-gt-sm=\"column\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.OPTICAL_SHOP_CLIENT\"></md-subheader><md-divider hide-xs hide-sm class=\"blue-500-bg\">\n</md-divider><div layout=\"column\"><p class=\"md-body-1 margin-bottom-0 margin-top-5\">{{ request.cliente }}</p></div>\n</div><div layout-xs=\"row\" layout-sm=\"row\" layout-align-sm=\"space-between center\" flex-gt-sm layout-gt-sm=\"column\">\n<md-subheader class=\"md-no-sticky\" translate=\"PEDIDO.SHOW.FIELD_LABEL.REQUEST_OPEN_BY\"></md-subheader><md-divider \nhide-xs hide-sm class=\"blue-500-bg\"></md-divider><div layout=\"column\"><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{request.vendedor.name}}</p></div></div></div><div layout-xs=\"column\" \nlayout-sm=\"column\" layout-gt-sm=\"row\" layout-margin><div flex-gt-sm=\"50\" layout=\"column\" class=\"margin-right-15\" \nng-if=\"vm.isUserAdmin() || vm.isUserPolo() || vm.isUserOtica()\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.OPTICAL_SHOP\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><div \nng-if=\"!request.otica\" class=\"padding-40\" style=\"text-align: center\" layout=\"row\" layout-align=\"center center\" \nlayout-fill><span class=\"md-body-2\">Não há uma Ótica relacionada a este pedido</span></div><div layout=\"column\" \nng-if=\"request.otica\"><div class=\"margin-bottom-0 margin-top-5\" layout=\"row\"><p flex=\"20\" \nclass=\"md-body-2 margin-bottom-0 margin-top-0\" translate=\"PEDIDO.SHOW.FIELD_LABEL.OPTICAL_SHOP_NAME\"></p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-0 margin-right-10 margin-left-10\">:</p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-0\">{{ request.otica.nome }}</p></div><div \nclass=\"margin-bottom-0 margin-top-5\" layout=\"row\"><p flex=\"20\" class=\"md-body-2 margin-bottom-0 margin-top-0\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.OPTICAL_SHOP_PHONE\"></p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-0 margin-right-10 margin-left-10\">:</p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-0\">{{ request.otica.telefone | w3Phone}}</p></div><div \nclass=\"margin-bottom-0 margin-top-5\" layout=\"row\"><p flex=\"20\" class=\"md-body-2 margin-bottom-0 margin-top-0\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.OPTICAL_SHOP_STREET\"></p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-0 margin-right-10 margin-left-10\">:</p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-0\">{{ vm.formatStreet(request.otica.rua, request.otica.numero) }}</p></div>\n<div class=\"margin-bottom-0 margin-top-5\" layout=\"row\"><p flex=\"20\" class=\"md-body-2 margin-bottom-0 margin-top-0\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.OPTICAL_SHOP_NEIGHBORHOOD\"></p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-0 margin-right-10 margin-left-10\">:</p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-0\">{{ request.otica.bairro }}</p></div><div \nclass=\"margin-bottom-0 margin-top-5\" layout=\"row\"><p flex=\"20\" class=\"md-body-2 margin-bottom-0 margin-top-0\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.OPTICAL_SHOP_CITY\"></p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-0 margin-right-10 margin-left-10\">:</p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-0\">{{ vm.formatCity(request.otica.city) }}</p></div></div></div><div \nflex-gt-sm=\"50\" layout=\"column\" class=\"margin-right-15\" \nng-if=\"vm.isUserAdmin() || vm.isUserPolo() || vm.isUserOtica()\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.POLO\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><div \nng-if=\"!request.polo\" class=\"padding-40\" style=\"text-align: center\" layout=\"row\" layout-align=\"center center\" \nlayout-fill><span class=\"md-body-2\">Não há uma Polo relacionada a este pedido</span></div><div layout=\"column\" \nng-if=\"request.polo\"><div class=\"margin-bottom-0 margin-top-5\" layout=\"row\"><p flex=\"20\" \nclass=\"md-body-2 margin-bottom-0 margin-top-0\" translate=\"PEDIDO.SHOW.FIELD_LABEL.POLO_NAME\"></p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-0 margin-right-10 margin-left-10\">:</p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-0\">{{ request.polo.nome }}</p></div><div \nclass=\"margin-bottom-0 margin-top-5\" layout=\"row\"><p flex=\"20\" class=\"md-body-2 margin-bottom-0 margin-top-0\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.POLO_PHONE\"></p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-0 margin-right-10 margin-left-10\">:</p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-0\">{{ request.polo.telefone | w3Phone }}</p></div><div \nclass=\"margin-bottom-0 margin-top-5\" layout=\"row\"><p flex=\"20\" class=\"md-body-2 margin-bottom-0 margin-top-0\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.POLO_STREET\"></p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-0 margin-right-10 margin-left-10\">:</p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-0\">{{ vm.formatStreet(request.polo.rua, request.polo.numero) }}</p></div>\n<div class=\"margin-bottom-0 margin-top-5\" layout=\"row\"><p flex=\"20\" class=\"md-body-2 margin-bottom-0 margin-top-0\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.POLO_NEIGHBORHOOD\"></p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-0 margin-right-10 margin-left-10\">:</p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-0\">{{ request.polo.bairro }}</p></div><div \nclass=\"margin-bottom-0 margin-top-5\" layout=\"row\"><p flex=\"20\" class=\"md-body-2 margin-bottom-0 margin-top-0\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.POLO_CITY\"></p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-0 margin-right-10 margin-left-10\">:</p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-0\">{{ vm.formatCity(request.polo.city) }}</p></div></div></div><div \nflex-gt-sm=\"50\" layout=\"column\" class=\"margin-right-15\" ng-if=\"vm.isUserAdmin()\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LAB\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><div \nng-if=\"!request.laboratorio\" class=\"padding-40\" style=\"text-align: center\" layout=\"row\" layout-align=\"center center\" \nlayout-fill><span class=\"md-body-2\">Não há um Laboratório relacionado a este pedido</span></div><div layout=\"column\" \nng-if=\"request.laboratorio\"><div class=\"margin-bottom-0 margin-top-5\" layout=\"row\"><p flex=\"20\" \nclass=\"md-body-2 margin-bottom-0 margin-top-0\" translate=\"PEDIDO.SHOW.FIELD_LABEL.LAB_NAME\"></p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-0 margin-right-10 margin-left-10\">:</p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-0\">{{ request.laboratorio.nome }}</p></div><div \nclass=\"margin-bottom-0 margin-top-5\" layout=\"row\"><p flex=\"20\" class=\"md-body-2 margin-bottom-0 margin-top-0\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LAB_PHONE\"></p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-0 margin-right-10 margin-left-10\">:</p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-0\">{{ request.laboratorio.telefone | w3Phone }}</p></div><div \nclass=\"margin-bottom-0 margin-top-5\" layout=\"row\"><p flex=\"20\" class=\"md-body-2 margin-bottom-0 margin-top-0\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LAB_STREET\"></p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-0 margin-right-10 margin-left-10\">:</p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-0\">\n{{ vm.formatStreet(request.laboratorio.rua, request.laboratorio.numero) }}</p></div><div \nclass=\"margin-bottom-0 margin-top-5\" layout=\"row\"><p flex=\"20\" class=\"md-body-2 margin-bottom-0 margin-top-0\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LAB_NEIGHBORHOOD\"></p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-0 margin-right-10 margin-left-10\">:</p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-0\">{{ request.laboratorio.bairro }}</p></div><div \nclass=\"margin-bottom-0 margin-top-5\" layout=\"row\"><p flex=\"20\" class=\"md-body-2 margin-bottom-0 margin-top-0\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LAB_CITY\"></p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-0 margin-right-10 margin-left-10\">:</p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-0\">{{ vm.formatCity(request.laboratorio.city) }}</p></div></div></div>\n</div></div></md-card-content></md-card>");
$templateCache.put("/app/external/pedido/includes/_pedido_form_product-additional-selector.html","<md-card><md-card-title \nstyle=\"border-style: solid; border-color: #006537; background-color: #00854c; padding: 6px!important\">\n<md-card-title-text layout=\"row\" layout-align=\"center center\"><span>ADICIONAIS</span></md-card-title-text>\n</md-card-title><md-card-content class=\"padding-top-16\" style=\"min-height: 203px\"><md-checkbox \nng-if=\"vm.row.produto.is_itrack\" ng-model=\"vm.enableItracklineCode\" aria-label=\"Checkbox 1\">Ativar código iTRACK LINE\n</md-checkbox><div ng-if=\"vm.enableItracklineCode\" style=\"margin-top: -12px!important\"><div flex layout=\"row\">\n<md-input-container flex class=\"margin-top-15 margin-bottom-0\"><label class=\"md-body-1\">Selecione um código</label>\n<md-select class=\"md-body-1\" ng-model=\"vm.row.itrack_id\" ng-required=\"false\"><md-option ng-value=\"{{code.id}}\" \nng-repeat=\"code in vm.codes\">{{code.nome}} - {{ code.preco | currency : \'R$ \' : 2 }}</md-option></md-select>\n</md-input-container><md-button ng-click=\"vm.showDetailITrackLine(); $event.stopPropagation();\" class=\"md-icon-button\" \naria-label=\"More\"><md-icon class=\"s24\" md-font-icon=\"icon-loupe\"></md-icon></md-button></div><md-input-container \nstyle=\"width: 100%\" flex class=\"md-body-1 margin-horizontal-5 margin-top-15 margin-bottom-0 fullwidth\"><label \nclass=\"md-body-1\">Código</label><input class=\"md-body-1\" title=\"Código\" name=\"itrack_code\" md-no-asterisk \nng-model=\"vm.row.itrack_code\" type=\"text\"></md-input-container></div><div flex layout=\"column\"><md-checkbox \nng-repeat=\"additional in vm.additionals\" ng-checked=\"vm.isAdditionalSelected(additional)\" \nng-click=\"vm.toggleAdditional(additional)\" aria-label=\"{{additional.descricao}}\" style=\"margin-bottom: 0px!important\">\n{{additional.descricao}} ({{additional.valor | currency : \'R$ \' : 2 }}).</md-checkbox></div></md-card-content>\n</md-card>");
$templateCache.put("/app/external/pedido/includes/_pedido_form_product-itrackline-selector.html","<md-card><md-card-title style=\"border-style: solid; border-color: #006537; background-color: #00854c\">\n<md-card-title-text layout=\"row\" layout-align=\"center center\"><span>Código iTRACKLINE</span></md-card-title-text>\n</md-card-title><md-card-content class=\"padding-top-16\"><md-content layout=\"column\" class=\"padding-0\" \nstyle=\"height: 142px\" ms-scroll><div layout=\"column\" layout-fill><md-checkbox ng-model=\"vm.enableItracklineCode\" \naria-label=\"Checkbox 1\" style=\"margin-bottom: -12px!important\">Ativar código iTRACK LINE</md-checkbox><div \nng-if=\"vm.enableItracklineCode\"><div flex layout=\"row\"><md-input-container flex class=\"margin-top-15 margin-bottom-0\">\n<label class=\"md-body-1\">Selecione um código</label><md-select class=\"md-body-1\" ng-model=\"vm.row.itrack_id\" \nng-required=\"false\"><md-option ng-value=\"{{code.id}}\" ng-repeat=\"code in vm.codes\">\n{{code.nome}} - {{ code.preco | currency : \'R$ \' : 2 }}</md-option></md-select></md-input-container><md-button \nng-click=\"vm.showDetailITrackLine(); $event.stopPropagation();\" class=\"md-icon-button\" aria-label=\"More\"><md-icon \nclass=\"s24\" md-font-icon=\"icon-loupe\"></md-icon></md-button></div><md-input-container style=\"width: 100%\" flex \nclass=\"md-body-1 margin-horizontal-5 margin-top-15 margin-bottom-0 fullwidth\"><label class=\"md-body-1\">Código</label>\n<input class=\"md-body-1\" title=\"Código\" name=\"itrack_code\" md-no-asterisk ng-model=\"vm.row.itrack_code\" type=\"text\">\n</md-input-container></div></div></md-content></md-card-content></md-card>");
$templateCache.put("/app/external/conta_bancaria/component/conta-bancaria-card/conta-bancaria-card.template.html","<md-card><md-card-title><md-card-title-text layout=\"row\" layout-align=\"center center\"><span class=\"font-weight-700\">\n{{vm.conta.favorecido | uppercase}}</span></md-card-title-text><md-card-title-media><div ng-transclude=\"actionMenu\">\n</div></md-card-title-media></md-card-title><md-card-content><div layout=\"column\"><div flex><div layout=\"row\" \nlayout-align=\"start center\" flex class=\"padding-5\"><span flex=\"40\" class=\"md-body-2 padding-right-5\">Tipo: </span><span\n flex class=\"md-body-1\">{{vm.entitySubLabel | uppercase }}</span></div><div layout=\"row\" layout-align=\"start center\" \nflex class=\"padding-5\"><span flex=\"40\" class=\"md-body-2 padding-right-5\">CPF: </span><span flex class=\"md-body-1\">\n{{vm.conta.cpf }}</span></div><div layout=\"row\" layout-align=\"start center\" class=\"padding-5\" flex><span flex=\"40\" \nclass=\"md-body-2 padding-right-5\">Banco:</span><div layout=\"column\" flex class=\"md-body-1\"><span>{{vm.conta.banco}}\n</span></div></div><div layout=\"row\" layout-align=\"start center\" class=\"padding-5\" flex><span flex=\"40\" \nclass=\"md-body-2 padding-right-5\">Agencia: </span><span flex class=\"md-body-1\">\n{{vm.conta.agencia || \' Não Informado\' }}</span></div><div layout=\"row\" layout-align=\"start center\" class=\"padding-5\" \nflex><span flex=\"40\" class=\"md-body-2 padding-right-5\">Conta: </span><span flex class=\"md-body-1\">\n{{vm.conta.conta || \' Não Informado\' }}</span></div><div layout=\"row\" layout-align=\"start center\" class=\"padding-5\" \nflex><span flex=\"40\" class=\"md-body-2 padding-right-5\">Descrição: </span><span flex class=\"md-body-1\">\n{{vm.conta.descricao || \' Não Informado\' }}</span></div></div></div></md-card-content><md-card-actions \nng-if=\"vm.select\" layout=\"row\" layout-align=\"none center\"><md-button flex class=\"md-raised md-accent\">{{vm.select}}\n</md-button></md-card-actions></md-card>");
$templateCache.put("/app/external/conta_bancaria/dialogs/create_app_session/create_app_session-dialog.html","<md-dialog class=\"single-dialog dialog-600\" aria-label=\"Create session\"><md-toolbar class=\"md-accent\" layout=\"column\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Sessão temporária\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Fechar\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div ng-if=\"vm.loading\" \nclass=\"mt-24\" layout=\"column\" layout-align=\"center center\"><span class=\"md-title mb-16 secondary-text\">\nAguarde, criando sessão temporária.</span><md-progress-circular md-diameter=\"96\"></md-progress-circular></div><div \nng-if=\"!vm.loading\" class=\"mt-24\" layout=\"column\" layout-align=\"center center\"><span \nclass=\"md-title mb-16 secondary-text\">Sessão criada.</span><p>Você será redirecionado.</p></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button type=\"button\" ng-click=\"vm.cancel()\" \nclass=\"md-warn\" aria-label=\"Cancelar\"><span>Fechar</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/external/conta_bancaria/dialogs/detail_payment/detail_payment-dialog.html","<md-dialog class=\"single-dialog dialog-600\" aria-label=\"Dialog\" translate-attr-aria-label=\"DIALOG.MANUTENCAO_DIALOG\">\n<md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Detalhes do pagamento: 31/08/2023</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Fechar\" translate \ntranslate-attr-aria-label=\"COMMON.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close s24\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><span class=\"md-title mb-16 secondary-text\">Detalhes do pagamento: 31/08/2023</span>\n<div class=\"mt-24\" layout=\"row\" layout-align=\"space-between start\"><div layout=\"column\"><span class=\"secondary-text\">\nCupons:</span> <span class=\"font-size-16 font-weight-500\">8</span></div><div layout=\"column\"><span \nclass=\"secondary-text\">Total:</span> <span class=\"green-fg font-size-16 font-weight-500\">{{255 | currency: \'R$ \'}}\n</span></div></div><table class=\"full-width mt-24\" style=\"width: 100%; border-collapse: collapse\"><thead><tr><th \nclass=\"border-bottom\">Pedido</th><th class=\"border-bottom\">Resgate</th><th class=\"border-bottom\">Valor</th></tr>\n</thead><tbody><tr><td class=\"border-bottom\"><div layout=\"column\"><span class=\"secondary-text\">OS:8989</span> <span \nclass=\"secondary-text\">ID:123123</span></div></td><td class=\"border-bottom\"><div layout=\"column\"><span \nclass=\"secondary-text\">20/08/2023</span> <span>#FSD98435NFSD</span></div></td><td class=\"border-bottom\"><span>\n{{255 | currency: \'R$ \'}}</span></td></tr><tr><td class=\"border-bottom\"><div layout=\"column\"><span \nclass=\"secondary-text\">OS:8989</span> <span class=\"secondary-text\">ID:123123</span></div></td><td \nclass=\"border-bottom\"><div layout=\"column\"><span class=\"secondary-text\">20/08/2023</span> <span>#FSD98435NFSD</span>\n</div></td><td class=\"border-bottom\"><span>{{255 | currency: \'R$ \'}}</span></td></tr></tbody></table>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button type=\"button\" \nng-click=\"vm.cancel()\" class=\"md-warn\" aria-label=\"Cancelar\"><span>Fechar</span></md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("/app/external/conta_bancaria/dialogs/form/conta_bancaria-dialog.html","<md-dialog class=\"single-dialog dialog-600\" aria-label=\"Dialog\" translate-attr-aria-label=\"DIALOG.MANUTENCAO_DIALOG\">\n<form name=\"dialogForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span ng-if=\"vm.isNew\" class=\"title\" \ntranslate=\"CONTA_BANCARIA.DIALOG.TITLE_NEW\">Adicionar nova conta bancária</span> <span ng-if=\"!vm.isNew\" class=\"title\" \ntranslate=\"COMMON.EDITAR\">Editar conta</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" \naria-label=\"Fechar\" translate translate-attr-aria-label=\"COMMON.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close s24\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\"><md-input-container flex><label>\nTipo de conta</label><md-select ng-model=\"vm.row.tipo\" required ng-disabled=\"vm.lockTipo\"><md-option value=\"PAGSEGURO\">\nPagSeguro</md-option><md-option value=\"CONTA_CORRENTE\">Conta Corrente</md-option><md-option value=\"POUPANCA\">Poupança\n</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container flex \nclass=\"padding-left-5 padding-right-5 md-icon-float md-block\"><label>Banco</label><input ng-model=\"vm.row.banco\" \ntype=\"text\"></md-input-container></div><div layout=\"row\"><md-input-container flex \nclass=\"padding-left-5 padding-right-5 md-icon-float md-block\"><label>\nConta {{vm.row.tipo === \'PAGSEGURO\'? \'(e-mail)\': \'(número)\'}}</label><input ng-model=\"vm.row.conta\" type=\"text\" \nng-required=\"true\"></md-input-container><md-input-container \nng-if=\"vm.row.tipo === \'PENDENTE\' || vm.row.tipo !== \'PAGSEGURO\'\" flex \nclass=\"padding-left-5 padding-right-5 md-icon-float md-block\"><label>Agência</label><input ng-model=\"vm.row.agencia\" \ntype=\"text\" ng-required=\"vm.row.tipo === \'PENDENTE\'\"></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"padding-left-5 padding-right-5 md-icon-float md-block\"><label>CPF</label><input ng-model=\"vm.row.cpf\" \ntype=\"text\" required mask=\"{{$root.fmask.cpf}}\"></md-input-container><md-input-container flex \nclass=\"padding-left-5 padding-right-5 md-icon-float md-block\"><label>Favorecido</label><input \nng-model=\"vm.row.favorecido\" type=\"text\" ng-required=\"true\"></md-input-container></div><md-input-container flex \nclass=\"padding-left-5 padding-right-5 md-icon-float md-block\"><label translate=\"CONTA_BANCARIA.FORM.DESCRICAO\">\nDescricao</label><textarea ng-model=\"vm.row.descricao\" rows=\"2\" required></textarea></md-input-container><small \nclass=\"secondary-text\">* Campos obrigatórios</small></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"end center\"><div layout=\"row\" layout-align=\"end center\"><md-button type=\"button\" ng-click=\"vm.cancel()\" \nclass=\"md-warn\" aria-label=\"Cancelar\"><span translate=\"COMMON.CANCELAR\">Cancelar</span></md-button><md-button \ntype=\"submit\" ng-if=\"!vm.isNew\" ng-click=\"vm.update()\" class=\"send-button md-accent md-raised\" aria-label=\"Salvar\" \nng-disabled=\"dialogForm.$invalid\"><span translate=\"COMMON.SALVAR\">Salvar</span></md-button><md-button type=\"submit\" \nng-if=\"vm.isNew\" ng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" aria-label=\"Adicionar\" \nng-disabled=\"dialogForm.$invalid || dialogForm.$pristine\"><span translate=\"COMMON.ADICIONAR\">Adicionar</span>\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("/app/external/conta_bancaria/dialogs/show/conta_bancaria-dialog.html","<md-dialog class=\"single-dialog dialog-600\" aria-label=\"Dialog\" translate-attr-aria-label=\"DIALOG.MANUTENCAO_DIALOG\">\n<md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Detalhes da conta</span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\" aria-label=\"Fechar\" translate translate-attr-aria-label=\"COMMON.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"w-296\"><span \nclass=\"md-title\">Cadastro</span><p>Tipo: <b>{{vm.row.tipo}}</b><br>\nEntidade tipo: {{vm.row.entity_type}} - {{vm.row.entity_sub}}<br>Cadastrado em: {{vm.row.created_at|w3DatePt}}</p><span\n class=\"md-title\">PIX</span><p>Tipo de chave: {{vm.row.pix_tipo}}<br>Chave: {{vm.row.pix_chave}}</p><span \nclass=\"md-title\">Conta bancária</span><p>Banco: {{vm.row.banco}}<br>Agência: {{vm.row.agencia}}<br>\nConta: {{vm.row.conta}}</p><span class=\"md-title\">Favorecido</span><p>Nome: {{vm.row.favorecido}}<br>\nCPF: {{vm.row.cpf}}<br>RG: {{vm.row.rg}}<br>Data de nascimento: {{vm.row.dt_nascimento}}<br>\nNome da mãe: {{vm.row.nome_mae}}</p><span class=\"md-title\">Contato</span><p>Celular: {{vm.row.celular}}<br>\nE-mail: {{vm.row.email}}</p><span class=\"md-title\">Endereço</span><p>Logradouro: {{vm.row.endereco}}<br>\nNúmero: {{vm.row.endereco_numero}}<br>Bairro: {{vm.row.bairro}}<br>Cidade: {{vm.row.cidade}}<br>CEP: {{vm.row.cep}}<br>\n</p><span class=\"md-title\">Observações</span><p>{{vm.row.descricao}}</p></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"end center\"><md-button type=\"button\" ng-click=\"vm.cancel()\" class=\"md-warn\" \naria-label=\"Cancelar\"><span>Fechar</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/external/fuse-core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("/app/external/fuse-core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("/app/external/fuse-core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("/app/external/fuse-core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title | translate}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title| translate}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("/app/external/fuse/acl/role/role-archive.html","<div id=\"gen-role\" class=\"page-layout carded fullwidth single-scroll model-page\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" flex><div class=\"heading\"><div layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"white-text mob-100\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon class=\"mr-8\" \nmd-font-icon=\"icon-bank\"></md-icon><span translate=\"ROLE.TITLE_ARCHIVE\">Role</span></div><div \nclass=\"product-count secondary-text\"><span translate=\"ROLE.TOTAL\" translate-values=\"{\'total\':vm.pagination.total}\">\nTotal de cadastros {vm.pagination.total}</span></div></div><div layout=\"row\" layout-align=\"end center\" class=\"mob-100\">\n<md-button ng-click=\"vm.searchActive = !vm.searchActive\" class=\"md-icon-button\" aria-label=\"Search\" translate \ntranslate-attr-aria-label=\"buscar\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip><span \ntranslate=\"ROLE.BUSCAR\">Buscar</span></md-tooltip></md-button><md-button ui-sref=\"app.role.new\" \nclass=\"md-fab md-primary mr-0\" aria-label=\"adicionar novo\" translate translate-attr-aria-label=\"COMMON.ADICIONAR_NOVO\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div><div ng-if=\"vm.searchActive\" \nclass=\"search-boxes animate-slide-down\" layout=\"column\"><div class=\"mb-8\" flex flex-gt-xs=\"100\" layout=\"column\" \nlayout-gt-xs=\"row\"><div flex class=\"search-item md-whiteframe-3dp mr-8 md-background-bg\" layout=\"row\" \nlayout-align=\"start center\"><input flex ng-model=\"vm.params.q\" class=\"md-primary-fg\" type=\"text\" \nplaceholder=\"{{\'ROLE.BUSCAR\'|translate}}\"></div><div layout=\"row\" layout-align=\"end end\"><md-button \nclass=\"md-accent md-raised md-icon-button\" aria-label=\"buscar\" ng-click=\"vm.search()\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><md-tooltip><span translate=\"ROLE.BUSCAR\">Buscar</span></md-tooltip></md-button>\n<md-button ng-show=\"vm.searchActive\" class=\"md-icon-button mr-0 md-raised\" ng-click=\"vm.clearFilter()\" \naria-label=\"Clear filter\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip>Limpar filtros</md-tooltip>\n</md-button></div></div></div></div><div class=\"content-card\"><md-content class=\"content no-padding\" ms-scroll><table \nclass=\"dataTable row-border hover\" ms-responsive-table w3-order-table=\"vm.params\" w3-change=\"vm.search()\"><thead><tr>\n<th class=\"secondary-text\" data-order=\"id\"><div class=\"table-header\"><span class=\"column-title\" translate=\"COMMON.ID\">\nID</span></div></th><th class=\"secondary-text\" data-order=\"name\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"ROLE.TABLE.NAME\">Name</span></div></th><th class=\"secondary-text\" data-order=\"display_name\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"ROLE.TABLE.DISPLAY_NAME\">Display name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"COMMON.ATUALIZADO_EM\">\nAtualizado em</span></div></th><th></th></tr></thead><tbody><tr class=\"tr-notfound\" ng-show=\" vm.archive.length == 0\">\n<td colspan=\"10\"><span translate=\"ROLE.SEM_RESULTADOS\">Nenhum resultado encontrado</span></td></tr><tr \nng-repeat=\"item in vm.archive\" class=\"hover-table\"><td ui-sref=\"app.role.edit({id:item.id})\" class=\"rf-pointer\">\n{{item.id}}</td><td ui-sref=\"app.role.edit({id:item.id})\" class=\"rf-pointer\">{{item.name}}</td><td>\n{{item.display_name}}</td><td><div>{{item.updated_at|w3DatePt}}</div><div><small><span class=\"column-title\" \ntranslate=\"COMMON.CRIADO_EM\">Criado em:</span> {{item.created_at|w3DatePt}}</small></div></td><td><md-menu><md-button \nclass=\"md-icon-button\" aria-label=\"mais opções\" translate translate-attr-aria-label=\"COMMON.MAIS_OPCOES\" \nng-click=\"$mdMenu.open()\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button ui-sref=\"app.role.show({id:item.id})\" class=\"md-accent\" aria-label=\"Editar\" translate \ntranslate-attr-aria-label=\"COMMON.EDITAR\"><md-icon md-font-icon=\"icon-eye\" class=\"icon s28\"></md-icon>\n{{\'COMMON.VISUALIZAR\'|translate}}</md-button></md-menu-item><md-menu-item><md-button \nui-sref=\"app.role.edit({id:item.id})\" class=\"md-accent\" aria-label=\"Editar\" translate \ntranslate-attr-aria-label=\"COMMON.EDITAR\"><md-icon md-font-icon=\"icon-border-color\" class=\"icon s28\"></md-icon>\n{{\'COMMON.EDITAR\'|translate}}</md-button></md-menu-item><md-divider></md-divider><md-menu-item><md-button \nng-click=\"vm.confirmDelete(item, $index, $event)\" class=\"md-warn\" aria-label=\"Excluir\" translate \ntranslate-attr-aria-label=\"COMMON.EXCLUIR\"><md-icon md-font-icon=\"icon-delete\" class=\"icon s26\"></md-icon>\n{{\'COMMON.EXCLUIR\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody><tfoot><tr><td \ncolspan=\"10\"><div layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\" layout-align-xs=\"none none\"><div \nlayout=\"row\" layout-align=\"start center\"><span translate=\"COMMON.EXIBINDO\">Exibindo</span><md-input-container \nclass=\"m-0\" style=\"top: -2px;    padding: 0 8px\"><md-select aria-label=\"Itens por página\" translate \ntranslate-attr-aria-label=\"COMMON.ITENS_POR_PAGINA\" ng-change=\"vm.search()\" ng-model=\"vm.params.paginate\"><md-option \nng-repeat=\"pag in [10, 15, 20, 25, 30, 50, 100]\" value=\"{{pag}}\">{{pag}} <span translate=\"COMMON.ITENS\">itens</span>\n</md-option></md-select></md-input-container><span translate=\"COMMON.POR_PAGINA\">por página</span></div><div \nlayout=\"row\" layout-align=\"end center\"><w3-page-table w3-pagination=\"vm.pagination\" w3-set-page=\"vm.setPage($page)\">\n</w3-page-table></div></div></td></tr></tfoot></table></md-content></div></div></div>");
$templateCache.put("/app/external/fuse/acl/role/role-form.html","<form ng-submit=\"vm.save()\" novalidate><div id=\"gen-role\" class=\"page-layout simple tabbed model-page\" layout=\"column\">\n<div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"start center\" layout-xs=\"column\" \nlayout-align-xs=\"space-between start\"><div class=\"white-fg flex-mobile-xs\" layout=\"row\" layout-align=\"start center\" \nflex><md-button ng-click=\"vm.goArchive()\" class=\"goto-products-button md-icon-button\" aria-label=\"voltar\" translate \ntranslate-attr-aria-label=\"ROLE.VOLTAR_ARCHIVE\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\"><div ng-if=\"vm.row.thumb\" class=\"md-avatar avatar contact-avatar huge\" \nhide-xs><img class=\"md-avatar avatar contact-avatar huge\" ng-src=\"{{vm.row.thumb_src}}\"></div><div layout=\"column\" \nlayout-align=\"start start\"><div layout=\"row\" layout-align=\"start center\"><div class=\"md-display-1 white-fg\">\n{{vm.row.name}}</div><span ng-if=\"!vm.row.deleted_at && !vm.isNew\" class=\"text-boxed md-accent-bg\" \ntranslate=\"ROLE.ATIVO\">Ativo</span> <span ng-if=\"vm.row.deleted_at && !vm.isNew\" class=\"text-boxed grey-500-bg\" \ntranslate=\"ROLE.INATIVO\">Inativo</span></div><div ng-if=\"vm.isNew\" class=\"md-display-1 white-fg\" \ntranslate=\"ROLE.FORM.TITLE_NEW\">Adicionar novo Role</div><div class=\"subtitle secondary-text\"><span ng-if=\"!vm.isNew\" \nclass=\"h2\" translate=\"ROLE.FORM.TITLE_EDIT\">Editar Role</span></div></div></div></div><div class=\"flex-mobile-xs\" \nlayout=\"row\" layout-align-xs=\"end end\"><md-button type=\"button\" ng-if=\"!vm.isNew\" ng-click=\"vm.confirmDelete($event)\" \nng-disabled=\"!vm.isNew && vm.row.deleted_at\" class=\"md-fab md-raised md-green-600-fg\" aria-label=\"Excluir\"><md-icon \nmd-font-icon=\"icon-trash\" class=\"red-500-fg\"></md-icon><md-tooltip><span translate=\"COMMON.EXCLUIR\">Excluir</span>\n</md-tooltip></md-button><md-button type=\"button\" ng-if=\"!vm.isNew\" ui-sref=\"app.role.show({id:vm.row.id})\" \nng-disabled=\"!vm.isNew && vm.row.deleted_at\" class=\"md-fab md-raised\" aria-label=\"ver\"><md-icon \nmd-font-icon=\"icon-eye\" class=\"md-accent-fg\"></md-icon><md-tooltip>{{\'COMMON.VISUALIZAR\'|translate}}</md-tooltip>\n</md-button><md-button type=\"submit\" class=\"md-fab md-raised md-green-600-fg\" \nng-disabled=\"!vm.isNew && vm.row.deleted_at\" aria-label=\"Salvar\"><md-icon md-font-icon=\"icon-content-save\" \nclass=\"green-600-fg\"></md-icon><md-tooltip><span translate=\"COMMON.SALVAR\">Salvar</span></md-tooltip></md-button></div>\n</div><div class=\"content\"><md-tabs md-dynamic-height><md-tab><md-tab-label><span \ntranslate=\"ROLE.FORM.GENERAL_INFORMATION\">Informações gerais</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp p-16\"><span class=\"secondary-text md-headline\" \ntranslate=\"ROLE.FORM.GENERAL_INFORMATION\">Informações gerais</span><md-input-container class=\"md-block\"><label \ntranslate=\"ROLE.FORM.NAME\">vm.row.name</label><input ng-model=\"vm.row.name\" type=\"text\" ng-required=\"true\">\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"ROLE.FORM.DISPLAY_NAME\">vm.row.display_name\n</label><input ng-model=\"vm.row.display_name\" type=\"text\" ng-required=\"true\"></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"ROLE.FORM.DESCRIPTION\">vm.row.description</label><input \nng-model=\"vm.row.description\" type=\"text\" ng-required=\"false\"></md-input-container><div class=\"md-actions\" \nlayout=\"row\" layout-align=\"end end\"><md-button type=\"submit\" class=\"md-fab grey-50-fg md-green-600-bg\" \naria-label=\"Salvar\"><md-icon md-font-icon=\"icon-content-save\" class=\"md-fab grey-50-fg\"></md-icon><md-tooltip><span \ntranslate=\"COMMON.SALVAR\">Salvar</span></md-tooltip></md-button></div></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"ROLE.FORM.PERMISSIONS\">Permissões</span></md-tab-label><md-tab-body><div class=\"mb-16\">\n<span class=\"secondary-text md-headline\" translate=\"ROLE.FORM.GROUP_PERMISSIONS\">grupos de permissões</span></div><div \nlayout-wrap layout=\"row\"><div ng-repeat=\"permission_group in vm.permissions_group\" flex-xs=\"100\" flex-sm=\"100\" \nflex-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\" class=\"padding-5 padding-vertical-15\"><md-card style=\"height: 100%\">\n<md-card-content><md-checkbox class=\"md-subhead\" ng-checked=\"vm.isGroupChecked(permission_group)\" \nng-click=\"vm.toggleAll(permission_group)\">{{ permission_group.group | uppercase}}</md-checkbox><md-list flex \nlayout-wrap layout=\"row\"><md-list-item ng-repeat=\"permission in vm.permissions\" \nng-if=\"permission.group==permission_group.group\" flex-xs=\"100\" flex-sm=\"50\" flex-md=\"100\" flex-lg=\"50\" flex-gt-lg=\"33\">\n<md-list flex><md-subheader class=\"md-no-sticky\"><md-checkbox ng-model=\"permission.checked\" \ntitle=\"{{permission.description}}\">{{ permission.display_name }}</md-checkbox></md-subheader></md-list></md-list-item>\n</md-list></md-card-content></md-card></div></div><div class=\"md-actions\" layout=\"row\" layout-align=\"end end\">\n<md-button type=\"submit\" class=\"md-fab grey-50-fg md-green-600-bg\" aria-label=\"Salvar\"><md-icon \nmd-font-icon=\"icon-content-save\" class=\"md-fab grey-50-fg\"></md-icon><md-tooltip><span translate=\"COMMON.SALVAR\">Salvar\n</span></md-tooltip></md-button></div></md-tab-body></md-tab></md-tabs></div></div></form>");
$templateCache.put("/app/external/fuse/acl/role/role-show.html","<div class=\"page-layout carded fullwidth single-scroll model-page\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" flex><div class=\"header pv-0-imp\"><div layout=\"row\" layout-align=\"space-between center\" \nlayout-xs=\"column\" layout-align-xs=\"space-between start\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button ng-click=\"vm.goArchive()\" \nclass=\"goto-products-button md-icon-button ml-0-imp\" aria-label=\"voltar\" translate><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"column\" layout-align=\"start start\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"md-display-1 white-fg\">{{\'ROLE.SHOW.SINGLE\'|translate}}: {{vm.row.nome}}</div><span ng-if=\"!vm.row.deleted_at\" \nclass=\"text-boxed md-accent-bg\" translate=\"ROLE.ATIVO\">Ativo</span> <span ng-if=\"vm.row.deleted_at\" \nclass=\"text-boxed grey-500-bg\" translate=\"ROLE.INATIVO\">Inativo</span></div><div class=\"subtitle secondary-text\"><span \nclass=\"h2\" translate=\"ROLE.SHOW.DETALHE_ITEM\">Detalhe do cadastro</span></div></div></div></div><div layout=\"row\" \nlayout-align=\"end end\" class=\"flex-mobile-xs\"><md-button type=\"button\" ui-sref=\"app.role.edit({id:vm.row.id})\" \nclass=\"md-fab md-raised md-accent\" aria-label=\"editar\"><md-icon md-font-icon=\"icon-pencil\" class=\"white-text\">\n</md-icon><md-tooltip>{{\'COMMON.EDITAR\'|translate}}</md-tooltip></md-button></div></div></div><div \nclass=\"content-card\"><md-content class=\"content\" ms-scroll><div class=\"mb-16\"><span \nclass=\"secondary-text md-display-1\" translate=\"ROLE.SHOW.INFOS_CADASTRAIS\">Informações cadastrais</span></div><div \nlayout=\"column\"><div class=\"mb-16\"><span class=\"secondary-text md-headline\" translate=\"ROLE.SHOW.GENERAL_INFORMATION\">\nInformações gerais</span></div><div layout=\"column\" layout-gt-sm=\"row\"><div flex flex-gt-sm=\"25\" class=\"font-size-16\">\n<span translate=\"ROLE.SHOW.NAME\" class=\"font-weight-500\"></span>:<br>{{vm.row.name}}</div><div flex flex-gt-sm=\"25\" \nclass=\"font-size-16\"><span translate=\"ROLE.SHOW.DISPLAY_NAME\" class=\"font-weight-500\"></span>:<br>\n{{vm.row.display_name}}</div><div flex class=\"font-size-16\"><span translate=\"ROLE.SHOW.DESCRIPTION\" \nclass=\"font-weight-500\"></span>:<br>{{vm.row.description}}</div></div><div class=\"mb-16 margin-top-10\"><span \nclass=\"secondary-text md-headline\" translate=\"ROLE.SHOW.GROUP_PERMISSIONS\">grupos de permissões</span></div><div \nlayout=\"row\" layout-wrap><div ng-repeat=\"group_permission in vm.row.group_permissions.grupos\" flex-xs=\"100\" \nflex-sm=\"100\" flex-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\" class=\"padding-5 padding-vertical-15\"><md-card \nstyle=\"height: 100%\"><md-card-content><h3 class=\"md-subhead\">{{ group_permission.name | uppercase}}</h3><md-list flex>\n<md-list-item ng-repeat=\"permission in group_permission.data\"><div layout=\"column\" layout-gt-sm=\"row\" flex \nlayout-align=\"center start\" layout-align-gt-sm=\"start center\"><div class=\"padding-5\"><span ng-if=\"permission.checked\" \nclass=\"text-boxed md-accent-bg\" translate=\"ROLE.ATIVO\">Ativo</span> <span ng-if=\"!permission.checked\" \nclass=\"text-boxed grey-500-bg\" translate=\"ROLE.INATIVO\">Inativo</span></div><div class=\"padding-5\"><span \nclass=\"md-body-2\">{{ permission.display_name }}</span></div><div class=\"padding-5\"><span \nclass=\"md-body-1 secondary-text\">{{permission.description}}</span></div></div></md-list-item></md-list>\n</md-card-content></md-card></div></div></div><md-divider class=\"mb-8\"></md-divider><div layout=\"column\"><small flex \nclass=\"font-size-16 secondary-text\"><span translate=\"COMMON.CRIADO_EM\">Criado em:</span> {{vm.row.created_at|w3DatePt}}\n</small> <span flex class=\"font-size-16 secondary-text\"><span translate=\"COMMON.ATUALIZADO_EM\">Atualizado em:</span>\n {{vm.row.updated_at|w3DatePt}}</span></div></md-content></div></div></div>");
$templateCache.put("/app/external/fuse/acl/test/test-acl.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" flex><div class=\"content-card\"><md-content class=\"content mb-60\" style=\"padding-top: 8px\"><h1>\nStatus de roles</h1><table class=\"table mb-60\" style=\"width:100%\"><thead><tr><th>ID</th><th>Name</th><th>Display Name\n</th><th>Description</th><th>Status</th></tr></thead><tbody><tr ng-repeat=\"tr in vm.roles\"><td class=\"border-bottom\">\n{{tr.id}}</td><td class=\"border-bottom\">{{tr.name}}</td><td class=\"border-bottom\">{{tr.display_name}}</td><td \nclass=\"border-bottom\">{{tr.description}}</td><td class=\"border-bottom\"><span rf-acl-hide-role=\"{{tr.name}}\" \nclass=\"text-boxed red-500-bg\">Não</span> <span rf-acl-show-role=\"{{tr.name}}\" class=\"text-boxed green-500-bg\">Sim\n</span></td></tr></tbody></table><h1>Status de permissions</h1><table class=\"table mb-60\" style=\"width:100%\"><thead>\n<tr><th>ID</th><th>Name</th><th>Group</th><th>Display Name</th><th>Description</th><th>Status</th></tr></thead><tbody>\n<tr ng-repeat=\"tr in vm.permisisons\"><td class=\"border-bottom\">{{tr.id}}</td><td class=\"border-bottom\">{{tr.name}}</td>\n<td class=\"border-bottom\">{{tr.group}}</td><td class=\"border-bottom\">{{tr.display_name}}</td><td class=\"border-bottom\">\n{{tr.description}}</td><td class=\"border-bottom\"><span rf-acl-hide-cam=\"{{tr.name}}\" class=\"text-boxed red-500-bg\">Não\n</span> <span rf-acl-show-cam=\"{{tr.name}}\" class=\"text-boxed green-500-bg\">Sim</span></td></tr></tbody></table>\n</md-content></div><div class=\"content-card\"><md-content class=\"content\" style=\"padding-top: 8px\"><span \nclass=\"md-title\">Roles - usuário logado</span><table class=\"table mb-60\" style=\"width:100%\"><thead><tr><th>ID</th><th>\nName</th><th>Display Name</th><th>Description</th></tr></thead><tbody><tr ng-repeat=\"tr in vm.row.roles\"><td \nclass=\"border-bottom\">{{tr.id}}</td><td class=\"border-bottom\">{{tr.name}}</td><td class=\"border-bottom\">\n{{tr.display_name}}</td><td class=\"border-bottom\">{{tr.description}}</td></tr></tbody></table><span \nclass=\"md-title mt-60\">Permissions - usuário logado</span><table class=\"table mt-20\" style=\"width:100%\"><thead><tr><th>\nID</th><th>Name</th><th>Group</th><th>Display Name</th><th>Description</th></tr></thead><tbody><tr \nng-repeat=\"tr in vm.row.permissions\"><td class=\"border-bottom\">{{tr.id}}</td><td class=\"border-bottom\">{{tr.name}}</td>\n<td class=\"border-bottom\">{{tr.group}}</td><td class=\"border-bottom\">{{tr.display_name}}</td><td class=\"border-bottom\">\n{{tr.description}}</td></tr></tbody></table></md-content></div></div></div>");
$templateCache.put("/app/external/fuse/cities/cities/cities-archive.html","<md-progress-linear ng-if=\"vm.loading\" md-mode=\"indeterminate\"></md-progress-linear><table \nclass=\"dataTable row-border hover\" ms-responsive-table w3-order-table=\"vm.params\" w3-change=\"vm.search()\"><thead><tr>\n<th class=\"secondary-text\" data-order=\"id\"><div class=\"table-header\"><span class=\"column-title\" translate=\"COMMON.ID\">\nID</span></div></th><th class=\"secondary-text\" data-order=\"city_name\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"CITIES.TABLE.NOME\">Nome</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"CITIES.TABLE.ESTADO\">Estado</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"CITIES.FORM.PAIS\">Pais</span>\n</div></th><th class=\"secondary-text\" data-order=\"created_at\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"COMMON.CRIADO_EM\">Criado em</span></div></th><th class=\"secondary-text\" data-order=\"updated_at\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"COMMON.ATUALIZADO_EM\">Atualizado em</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header text-right\"><span class=\"column-title\" translate=\"COMMON.OPCOES\">Opções\n</span></div></th></tr></thead><tbody><tr class=\"tr-notfound\" ng-show=\"vm.loading === false && vm.archive.length == 0\">\n<td colspan=\"10\"><span translate=\"CITIES.SEM_RESULTADOS\">Nenhum resultado encontrado</span></td></tr><tr \nng-repeat=\"item in vm.archive|orderBy:\'nome\'\" class=\"hover-table\"><td>{{item.id}}</td><td \nng-click=\"vm.showEdit(item, $event)\" class=\"pointer\">{{item.city_name}}</td><td>{{item.state.state_name}}</td><td>\n{{item.state.country.country_name}}</td><td>{{item.created_at|w3DatePt}}</td><td>{{item.updated_at|w3DatePt}}</td><td \nclass=\"text-right\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"mais opções\" translate \ntranslate-attr-aria-label=\"COMMON.MAIS_OPCOES\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.showEdit(item, $event)\" class=\"md-accent\" aria-label=\"Editar\" translate \ntranslate-attr-aria-label=\"COMMON.EDITAR\"><md-icon md-font-icon=\"icon-border-color\" class=\"icon s28\"></md-icon>\n{{\'COMMON.EDITAR\'|translate}}</md-button></md-menu-item><md-divider></md-divider><md-menu-item><md-button \nng-click=\"vm.confirmDelete(item, $index, $event)\" class=\"md-warn\" aria-label=\"Excluir\" translate \ntranslate-attr-aria-label=\"COMMON.EXCLUIR\"><md-icon md-font-icon=\"icon-delete\" class=\"icon s26\"></md-icon>\n{{\'COMMON.EXCLUIR\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody><tfoot><tr><td \ncolspan=\"10\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span \ntranslate=\"COMMON.EXIBINDO\">Exibindo</span><md-input-container class=\"m-0\" style=\"top: -2px;    padding: 0 8px\">\n<md-select aria-label=\"Itens por página\" translate translate-attr-aria-label=\"COMMON.ITENS_POR_PAGINA\" \nng-change=\"vm.search()\" ng-model=\"vm.params.paginate\"><md-option ng-repeat=\"pag in [10, 15, 20, 25, 30, 50, 100]\" \nvalue=\"{{pag}}\">{{pag}} <span translate=\"COMMON.ITENS\">itens</span></md-option></md-select></md-input-container><span \ntranslate=\"COMMON.POR_PAGINA\">por página</span></div><div layout=\"row\" layout-align=\"end center\"><w3-page-table \nw3-pagination=\"vm.pagination\" w3-set-page=\"vm.setPage($page)\"></w3-page-table></div></div></td></tr></tfoot></table>");
$templateCache.put("/app/external/fuse/cities/cities/cities-dialog.html","<md-dialog class=\"single-dialog dialog-600\" aria-label=\"Dialog\" translate-attr-aria-label=\"DIALOG.MANUTENCAO_DIALOG\">\n<form name=\"dialogForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span ng-if=\"vm.isNew\" \nclass=\"title\" translate=\"CITIES.ADICIONAR_NOVA_CIDADE\">Adicionar nova cidade</span> <span ng-if=\"!vm.isNew\" \nclass=\"title\" translate=\"CITIES.EDITAR_CIDADE\">Editar</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Fechar\" translate translate-attr-aria-label=\"COMMON.FECHAR_DIALOG\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div><div ng-if=\"!vm.isNew\" \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"single-name\">{{vm.row.city_name}}</div></div></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-icon-float md-block\"><label \ntranslate=\"CITIES.FORM.NOME_CITY\">Nome (obrigatório)</label><input ng-model=\"vm.row.city_name\" type=\"text\" \nng-required=\"true\" md-autofocus></md-input-container><md-input-container class=\"md-icon-float md-block\"><label \ntranslate=\"CITIES.FORM.PAIS_ID\">PAIS</label><md-select ng-model=\"vm.row.country_id\" md-on-open=\"vm.loadCountry();\" \nrequired><md-option ng-repeat=\"st in vm.countrys\" ng-value=\"st.id\">{{st.country_name}}</md-option></md-select>\n</md-input-container><br><md-input-container class=\"md-icon-float md-block\"><label translate=\"CITIES.FORM.ESTADO_ID\">\nEstado</label><md-select ng-model=\"vm.row.state_id\" md-on-open=\"vm.loadState(vm.row.country_id);\" \nng-disabled=\"!vm.row.country_id\"><md-option ng-repeat=\"st in vm.states\" ng-value=\"st.id\">{{st.state_name}}</md-option>\n</md-select></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><div \nlayout=\"row\" layout-align=\"end center\"><md-button type=\"button\" ng-click=\"vm.closeDialog()\" class=\"md-warn\" \naria-label=\"Cancelar\"><span translate=\"COMMON.CANCELAR\">Cancelar</span></md-button><md-button type=\"submit\" \nng-if=\"!vm.isNew\" ng-click=\"vm.update()\" class=\"send-button md-accent md-raised\" ng-disabled=\"dialogForm.$invalid\" \naria-label=\"Salvar\"><span translate=\"COMMON.SALVAR\">Salvar</span></md-button><md-button type=\"submit\" ng-if=\"vm.isNew\" \nng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" ng-disabled=\"dialogForm.$invalid || dialogForm.$pristine\" \naria-label=\"Adicionar\"><span translate=\"COMMON.ADICIONAR\">Adicionar</span></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("/app/external/fuse/cities/countrys/countrys-archive.html","<md-progress-linear ng-if=\"vm.loading\" md-mode=\"indeterminate\"></md-progress-linear><table \nclass=\"dataTable row-border hover\" ms-responsive-table w3-order-table=\"vm.params\" w3-change=\"vm.search()\"><thead><tr>\n<th class=\"secondary-text\" data-order=\"id\"><div class=\"table-header\"><span class=\"column-title\" translate=\"COMMON.ID\">\nID</span></div></th><th class=\"secondary-text\" data-order=\"country_name\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"CITIES.TABLE.NOME\">Nome</span></div></th><th class=\"secondary-text\" \ndata-order=\"country_code\"><div class=\"table-header\"><span class=\"column-title\" translate=\"CITIES.TABLE.COUNTRY_SIGLA\">\nSigla</span></div></th><th class=\"secondary-text\" data-order=\"created_at\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"COMMON.CRIADO_EM\">Criado em</span></div></th><th class=\"secondary-text\" \ndata-order=\"updated_at\"><div class=\"table-header\"><span class=\"column-title\" translate=\"COMMON.ATUALIZADO_EM\">\nAtualizado em</span></div></th><th class=\"secondary-text\"><div class=\"table-header text-right\"><span \nclass=\"column-title\" translate=\"COMMON.OPCOES\">Opções</span></div></th></tr></thead><tbody><tr class=\"tr-notfound\" \nng-show=\"vm.loading === false && vm.archive.length == 0\"><td colspan=\"10\"><span translate=\"CITIES.SEM_RESULTADOS\">\nNenhum resultado encontrado</span></td></tr><tr ng-repeat=\"item in vm.archive|orderBy:\'nome\'\" class=\"hover-table\"><td>\n{{item.id}}</td><td ng-click=\"vm.showEdit(item, $event)\" class=\"pointer\">{{item.country_name}}</td><td>\n{{item.country_code}}</td><td>{{item.created_at|w3DatePt}}</td><td>{{item.updated_at|w3DatePt}}</td><td \nclass=\"text-right\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"mais opções\" translate \ntranslate-attr-aria-label=\"COMMON.MAIS_OPCOES\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.showEdit(item, $event)\" class=\"md-accent\" aria-label=\"Editar\" translate \ntranslate-attr-aria-label=\"COMMON.EDITAR\"><md-icon md-font-icon=\"icon-border-color\" class=\"icon s28\"></md-icon>\n{{\'COMMON.EDITAR\'|translate}}</md-button></md-menu-item><md-divider></md-divider><md-menu-item><md-button \nng-click=\"vm.confirmDelete(item, $index, $event)\" class=\"md-warn\" aria-label=\"Excluir\" translate \ntranslate-attr-aria-label=\"COMMON.EXCLUIR\"><md-icon md-font-icon=\"icon-delete\" class=\"icon s26\"></md-icon>\n{{\'COMMON.EXCLUIR\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody><tfoot><tr><td \ncolspan=\"10\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span \ntranslate=\"COMMON.EXIBINDO\">Exibindo</span><md-input-container class=\"m-0\" style=\"top: -2px;    padding: 0 8px\">\n<md-select aria-label=\"Itens por página\" translate translate-attr-aria-label=\"COMMON.ITENS_POR_PAGINA\" \nng-change=\"vm.search()\" ng-model=\"vm.params.paginate\"><md-option ng-repeat=\"pag in [10, 15, 20, 25, 30, 50, 100]\" \nvalue=\"{{pag}}\">{{pag}} <span translate=\"COMMON.ITENS\">itens</span></md-option></md-select></md-input-container><span \ntranslate=\"COMMON.POR_PAGINA\">por página</span></div><div layout=\"row\" layout-align=\"end center\"><w3-page-table \nw3-pagination=\"vm.pagination\" w3-set-page=\"vm.setPage($page)\"></w3-page-table></div></div></td></tr></tfoot></table>");
$templateCache.put("/app/external/fuse/cities/countrys/countrys-dialog.html","<md-dialog class=\"single-dialog dialog-600\" aria-label=\"Dialog\" translate-attr-aria-label=\"DIALOG.MANUTENCAO_DIALOG\">\n<form name=\"dialogForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span ng-if=\"vm.isNew\" \nclass=\"title\" translate=\"CITIES.ADICIONAR_NOVO_PAIS\">Adicionar novo</span> <span ng-if=\"!vm.isNew\" class=\"title\" \ntranslate=\"CITIES.EDITAR_PAIS\">Editar</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Fechar\" translate translate-attr-aria-label=\"COMMON.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close s24\">\n</md-icon></md-button></div><div ng-if=\"!vm.isNew\" class=\"md-toolbar-tools md-toolbar-tools-middle\" flex \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"single-name\">{{vm.row.country_name}}</div></div></div></md-toolbar><md-dialog-content ms-scroll>\n<md-input-container class=\"md-icon-float md-block\"><label translate=\"CITIES.FORM.NOME_COUNTRY\">Nome (obrigatório)\n</label><input ng-model=\"vm.row.country_name\" type=\"text\" ng-required=\"true\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\"><label translate=\"CITIES.FORM.SIGLA\">Sigla (obrigatório)</label><input \nng-model=\"vm.row.country_code\" type=\"text\" ng-required=\"true\"></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"end center\"><div layout=\"row\" layout-align=\"end center\"><md-button \ntype=\"button\" ng-click=\"vm.closeDialog()\" class=\"md-warn\" aria-label=\"Cancelar\"><span translate=\"COMMON.CANCELAR\">\nCancelar</span></md-button><md-button type=\"submit\" ng-if=\"!vm.isNew\" ng-click=\"vm.update()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"dialogForm.$invalid\" aria-label=\"Salvar\"><span \ntranslate=\"COMMON.SALVAR\">Salvar</span></md-button><md-button type=\"submit\" ng-if=\"vm.isNew\" ng-click=\"vm.save()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"dialogForm.$invalid || dialogForm.$pristine\" \naria-label=\"Adicionar\"><span translate=\"COMMON.ADICIONAR\">Adicionar</span></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("/app/external/fuse/cities/states/states-archive.html","<md-progress-linear ng-if=\"vm.loading\" md-mode=\"indeterminate\"></md-progress-linear><table \nclass=\"dataTable row-border hover\" ms-responsive-table w3-order-table=\"vm.params\" w3-change=\"vm.search()\"><thead><tr>\n<th class=\"secondary-text\" data-order=\"id\"><div class=\"table-header\"><span class=\"column-title\" translate=\"COMMON.ID\">\nID</span></div></th><th class=\"secondary-text\" data-order=\"state_name\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"CITIES.TABLE.NOME\">Nome</span></div></th><th class=\"secondary-text\" \ndata-order=\"state_code\"><div class=\"table-header\"><span class=\"column-title\" translate=\"CITIES.TABLE.UF\">UF</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"CITIES.FORM.PAIS\">Pais</span></div></th><th class=\"secondary-text\" data-order=\"created_at\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"COMMON.CRIADO_EM\">Criado em</span></div></th><th \nclass=\"secondary-text\" data-order=\"updated_at\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"COMMON.ATUALIZADO_EM\">Atualizado em</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header text-right\"><span class=\"column-title\" translate=\"COMMON.OPCOES\">Opções</span></div></th></tr>\n</thead><tbody><tr class=\"tr-notfound\" ng-show=\"vm.loading === false && vm.archive.length == 0\"><td colspan=\"10\"><span \ntranslate=\"CITIES.SEM_RESULTADOS\">Nenhum resultado encontrado</span></td></tr><tr \nng-repeat=\"item in vm.archive|orderBy:\'nome\'\" class=\"hover-table\"><td>{{item.id}}</td><td \nng-click=\"vm.showEdit(item, $event)\" class=\"pointer\">{{item.state_name}}</td><td>{{item.state_code}}</td><td>\n{{item.country.country_name}}</td><td>{{item.created_at|w3DatePt}}</td><td>{{item.updated_at|w3DatePt}}</td><td \nclass=\"text-right\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"mais opções\" translate \ntranslate-attr-aria-label=\"COMMON.MAIS_OPCOES\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.showEdit(item, $event)\" class=\"md-accent\" aria-label=\"Editar\" translate \ntranslate-attr-aria-label=\"COMMON.EDITAR\"><md-icon md-font-icon=\"icon-border-color\" class=\"icon s28\"></md-icon>\n{{\'COMMON.EDITAR\'|translate}}</md-button></md-menu-item><md-divider></md-divider><md-menu-item><md-button \nng-click=\"vm.confirmDelete(item, $index, $event)\" class=\"md-warn\" aria-label=\"Excluir\" translate \ntranslate-attr-aria-label=\"COMMON.EXCLUIR\"><md-icon md-font-icon=\"icon-delete\" class=\"icon s26\"></md-icon>\n{{\'COMMON.EXCLUIR\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody><tfoot><tr><td \ncolspan=\"10\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span \ntranslate=\"COMMON.EXIBINDO\">Exibindo</span><md-input-container class=\"m-0\" style=\"top: -2px;    padding: 0 8px\">\n<md-select aria-label=\"Itens por página\" translate translate-attr-aria-label=\"COMMON.ITENS_POR_PAGINA\" \nng-change=\"vm.search()\" ng-model=\"vm.params.paginate\"><md-option ng-repeat=\"pag in [10, 15, 20, 25, 30, 50, 100]\" \nvalue=\"{{pag}}\">{{pag}} <span translate=\"COMMON.ITENS\">itens</span></md-option></md-select></md-input-container><span \ntranslate=\"COMMON.POR_PAGINA\">por página</span></div><div layout=\"row\" layout-align=\"end center\"><w3-page-table \nw3-pagination=\"vm.pagination\" w3-set-page=\"vm.setPage($page)\"></w3-page-table></div></div></td></tr></tfoot></table>");
$templateCache.put("/app/external/fuse/cities/states/states-dialog.html","<md-dialog class=\"single-dialog dialog-600\" aria-label=\"Dialog\" translate-attr-aria-label=\"DIALOG.MANUTENCAO_DIALOG\">\n<form name=\"dialogForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span ng-if=\"vm.isNew\" \nclass=\"title\" translate=\"CITIES.ADICIONAR_NOVO_ESTADO\">Adicionar novo</span> <span ng-if=\"!vm.isNew\" class=\"title\" \ntranslate=\"CITIES.EDITAR_ESTADO\">Editar</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Fechar\" translate translate-attr-aria-label=\"COMMON.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close s24\">\n</md-icon></md-button></div><div ng-if=\"!vm.isNew\" class=\"md-toolbar-tools md-toolbar-tools-middle\" flex \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"single-name\">{{vm.row.state_name}}</div></div></div></md-toolbar><md-dialog-content ms-scroll>\n<md-input-container class=\"md-icon-float md-block\"><label translate=\"CITIES.FORM.NOME_STATE\">Nome (obrigatório)</label>\n<input ng-model=\"vm.row.state_name\" type=\"text\" ng-required=\"true\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\"><label translate=\"CITIES.FORM.UF\">Uf (obrigatório)</label><input \nng-model=\"vm.row.state_code\" type=\"text\" ng-required=\"true\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\"><label translate=\"CITIES.FORM.PAIS_ID\">País</label><md-select \nng-model=\"vm.row.country_id\" required><md-option ng-repeat=\"pa in vm.countries\" ng-value=\"pa.id\">{{pa.country_name}}\n</md-option></md-select></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"end center\"><div layout=\"row\" layout-align=\"end center\"><md-button type=\"button\" \nng-click=\"vm.closeDialog()\" class=\"md-warn\" aria-label=\"Cancelar\"><span translate=\"COMMON.CANCELAR\">Cancelar</span>\n</md-button><md-button type=\"submit\" ng-if=\"!vm.isNew\" ng-click=\"vm.update()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"dialogForm.$invalid\" aria-label=\"Salvar\"><span translate=\"COMMON.SALVAR\">Salvar</span></md-button>\n<md-button type=\"submit\" ng-if=\"vm.isNew\" ng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"dialogForm.$invalid || dialogForm.$pristine\" aria-label=\"Adicionar\"><span translate=\"COMMON.ADICIONAR\">\nAdicionar</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("/app/external/fuse/auth/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll \nstyle=\"background-image: url(\'{{vm.bg_auth}}\')\"><div id=\"forgot-password-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><md-progress-linear \nng-disabled=\"!$root.w3Reload[\'rfpassord.remind\']\" md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear><div \nclass=\"fm-padding\"><div ng-if=\"!vm.logo\" class=\"logo md-accent-bg\"><span>{{vm.sigla}}</span></div><div ng-if=\"vm.logo\">\n<img ng-src=\"{{vm.logo}}\" width=\"128\" height=\"128\"></div><div class=\"title\" translate=\"FORGOTPASSWORD.TITLE\">\nRecover your password</div><form name=\"forgotPasswordForm\" novalidate><md-input-container class=\"md-block\" md-no-float>\n<label translate=\"FORGOTPASSWORD.EMAIL_ADRESS\">Email</label><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"forgotPasswordForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"FORGOTPASSWORD.ERRORS.EMAIL_REQUIRED\">\nEmail field is required</span></div><div ng-message=\"pattern\"><span translate=\"FORGOTPASSWORD.ERRORS.EMAIL_MUST_VALID\">\nEmail must be a valid e-mail address</span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"RESET MY PASSWORD\" \nng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine || $root.w3Reload[\'rfpassord.remind\']\" \ntranslate=\"FORGOTPASSWORD.SEND_RESET_LINK\" translate-attr-aria-label=\"FORGOTPASSWORD.SEND_RESET_LINK\" \nng-click=\"vm.sendResetPasswordLink()\">SEND RESET LINK</md-button></form><div class=\"login\" layout=\"row\" \nlayout-align=\"center center\"><a class=\"link\" ui-sref=\"auth.login\" translate=\"FORGOTPASSWORD.GO_BACK\">Go back to login\n</a></div></div></div></div></div>");
$templateCache.put("/app/external/fuse/auth/login-v2/login-v2.html","<div id=\"login-v2\" layout=\"row\" layout-align=\"start\" ng-style=\"{\'background-image\': \'url(\' + vm.bg_auth +\')\'}\"><div \nid=\"login-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div id=\"login-v2-form\"><div \nlayout=\"row\" layout-align=\"start center\"><div layout=\"column\" class=\"margin-right-5\"><md-button \nclass=\"md-raised md-icon-button\" ng-click=\"vm.returnHome()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n<md-tooltip><span data-translate=\"LOGIN_V2.BTN_RETURN_HOME_PAGE\"></span></md-tooltip></md-button></div><div \nlayout=\"column\" class=\"margin-right-24\" flex><div hide-gt-sm ng-if=\"!vm.logo\" class=\"logo md-accent-bg\"><span>\n{{vm.sigla}}</span></div><div ng-if=\"vm.logo && vm.showLogo\" layout=\"row\" layout-align=\"center center\"><img \nng-src=\"{{vm.logo}}\" class=\"logo-login\"></div><div layout=\"row\" layout-align=\"center center\"><div class=\"title\" \ntranslate=\"LOGIN_V2.TITLE\">Log in to your account</div></div></div></div><div class=\"description\" \ntranslate=\"LOGIN_V2.DESCRIPTION\">Sed mollis velit facilisis facilisis viverra</div><form name=\"loginForm\" \nng-submit=\"vm.login()\"><md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" \nng-model=\"vm.credentials.email\" placeholder=\"Email\" translate translate-attr-placeholder=\"LOGIN_V2.EMAIL\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"LOGIN_V2.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"LOGIN_V2.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span>\n</div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"password\" ng-model=\"vm.credentials.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"LOGIN_V2.PASSWORD\" required><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"LOGIN_V2.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div>\n</md-input-container><div class=\"remember-forgot-password\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-between center\"><a ui-sref=\"auth.forgot\" class=\"forgot-password md-accent-color\" \ntranslate=\"LOGIN_V2.FORGOT_PASSWORD\">Forgot Password?</a></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \ntranslate=\"LOGIN_V2.LOG_IN\" translate-attr-aria-label=\"LOGIN_V2.LOG_IN\">LOG IN</md-button></form></div></div><div \nid=\"login-v2-intro\" flex hide-xs><div ng-if=\"!vm.logo\" class=\"logo md-accent-bg\"><span>{{vm.sigla}}</span></div><div \nng-if=\"vm.logo\"><img ng-src=\"{{vm.logo}}\" width=\"128\" height=\"128\"></div><div class=\"title margint-t32\">{{vm.welcome}}\n</div><div class=\"description\">{{vm.welcome_text}}</div></div><div class=\"credits_auth mb-8 mr-8\" layout=\"row\" \nlayout-align=\"end end\"><a class=\"credits-logo no-style\" layout=\"row\" layout-align=\"center center\" \nhref=\"{{vm.credits_link}}\" target=\"_blank\"><small class=\"mr-8\">Desenvolvido por</small> <img \nng-src=\"{{vm.credits_auth_logo}}\"></a></div></div>");
$templateCache.put("/app/external/fuse/auth/reset-password/reset-password.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll \nstyle=\"background-image: url(\'{{vm.bg_auth}}\')\"><div id=\"reset-password-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div ng-if=\"!vm.logo\" \nclass=\"logo md-accent-bg\"><span>{{vm.sigla}}</span></div><div ng-if=\"vm.logo\"><img src=\"{{vm.logo}}\" width=\"128\" \nheight=\"128\"></div><div class=\"title\" translate=\"RESETPASSWORD.TITLE\" ng-if=\"!vm.welcome\">Reset your password</div><div\n class=\"title\" ng-if=\"vm.welcome\" layout=\"column\"><span>Bem vindo ao {{vm.appTitle}}</span> <span>\nPara finalizar o seu cadastro, insira o seu email e a defina a sua senha</span></div><form name=\"resetPasswordForm\" \nnovalidate><md-input-container class=\"md-block\" md-no-float><label translate=\"RESETPASSWORD.EMAIL_ADRESS\">Email</label>\n<input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"resetPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"RESETPASSWORD.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><label translate=\"RESETPASSWORD.PASSWORD\">\nPassword</label><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" required><div \nng-messages=\"registerForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><label translate=\"RESETPASSWORD.PASSWORD_CONFIRM\">Password (Confirm)\n</label><input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.form.password_confirmation\" required><div \nng-messages=\"resetPasswordForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"UPDATE MY PASSWORD\" ng-disabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine\" \ntranslate-attr-aria-label=\"RESETPASSWORD.UPDATE_PASSWORD\" ng-click=\"vm.resetPassword()\"><span ng-if=\"!vm.welcome\" \ndata-translate=\"RESETPASSWORD.UPDATE_PASSWORD\"></span> <span ng-if=\"vm.welcome\">Finalizar cadastro</span></md-button>\n</form></div></div></div>");
$templateCache.put("/app/external/fuse/components/rf-activities/activities.tmpl.html","<div class=\"rf-activities\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon-format-list-bulleted s18\"></i> <span class=\"section-title\" translate=\"RFACT.ACTIVITY\">Activity</span></div>\n<input type=\"search\" placeholder=\"Filtrar atividades\" ng-model=\"search\"><div class=\"section-content\"><div \nclass=\"activity\" layout=\"row\" layout-align=\"start center\" ng-repeat=\"activity in vm.activities|filter:search\">\n<w3-avatar w3-size=\"60\" w3-profile=\"activity.causer\"></w3-avatar><div layout=\"column\"><div \nclass=\"activity-member-name\">{{activity.causer.name}}</div><div class=\"activity-message\" \nng-bind-html=\"activity.description\"></div><div class=\"activity-time secondary-text\">\n{{activity.created_at|w3DatePt}} ({{activity.created_at|w3Moments}})</div></div></div></div></div>");
$templateCache.put("/app/external/fuse/components/rf-avatar/rf-avatar.tmpl.html","<div class=\"rf-avatar avatar width-{{size}} height-{{size}} {{classColor}}\" ng-class=\"{\'disable\': disable}\"><div \nng-if=\"!(profile.thumb_src && !onlyText)\" \nclass=\"white-text font-size-{{size/2}} width-{{size}} height-{{size}} layout-align-center-center\" layout=\"row\" \nlayout-align=\"center center\" style=\"\"><span \nstyle=\"font-size: {{size/2}}px;padding:{{size/4}}px;display: block;line-height: {{size/2}}px\">\n{{ profile.name.substr(0, 1).toUpperCase()}}</span></div><img ng-if=\"profile.thumb_src && !onlyText\" \nng-src=\"{{profile.thumb_src}}\" alt=\"{{profile.name}}\" style=\"border-radius: 50%\" \nclass=\"width-{{size}} height-{{size}}\" width=\"{{size}}\" height=\"{{size}}\"></div>");
$templateCache.put("/app/external/fuse/components/rf-comments/comments.tmpl.html","<div class=\"rf-comment\"><div class=\"section-content\"><div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\"><div \nlayout=\"row\" flex-gt-xs=\"70\"><rf-avatar rf-size=\"60\" rf-profile=\"vm.rowComment.profile\" rf-only-text=\"false\">\n</rf-avatar><md-input-container flex md-no-float><label translate=\"RFCOMMENTS.WRITE_A_COMMENT\">Write a comment..\n</label><textarea ms-scroll ng-model=\"vm.rowComment.message\"></textarea></md-input-container></div><div \nclass=\"slct-row\" flex-gt-xs=\"30\" flex-gt-sm=\"20\" layout=\"row\" layout-align=\"end center\"><md-input-container \nmd-no-float flex><label translate=\"RFCOMMENTS.SLECT_TYPE\">Tipo</label><md-select ng-model=\"vm.rowComment.type\">\n<md-option ng-value=\"op.key\" ng-repeat=\"op in vm.config.types\">{{op.label}}</md-option></md-select>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent md-fab send\" ng-click=\"vm.addNewComment();\" \nng-disabled=\"!vm.rowComment.message || $root.w3Reload[\'comment.save\']\" aria-label=\"Add\"><md-icon \nmd-font-icon=\"icon-send\" class=\"white-text\"></md-icon><md-tooltip><span translate=\"RFCOMMENTS.ADD_COMMENT\">\nAdicionar comentário</span></md-tooltip></md-button></div></div><div class=\"rf-comment\"><div class=\"section-content\">\n<div class=\"comment\" layout=\"row\" ng-repeat=\"comment in vm.comments\"><rf-avatar rf-size=\"60\" \nrf-profile=\"comment.profile\" rf-only-text=\"false\"></rf-avatar><div flex class=\"comment-bubble\" layout=\"column\">\n{{comment.message}}<div layout=\"column\" layout-gt-xs=\"row\"><div flex class=\"comment-member-name\">\n{{comment.profile.name}}</div><div layout=\"row\"><div ng-if=\"comment.type\" layout=\"row\" layout-align=\"start end\" flex>\n<span class=\"text-boxed\">{{comment.type}}</span></div><div class=\"comment-time secondary-text\" layout=\"row\" \nlayout-align=\"end end\">{{comment.created_at|w3Moments}}</div></div></div></div></div><div ng-if=\"!vm.comments.length\" \nclass=\"p-16\"><span translate=\"RFCOMMENTS.EPTY_COMMENTS\">Nenhum comentário encontrado.</span></div></div></div></div>\n</div>");
$templateCache.put("/app/external/fuse/components/rf-comments/rf-comments-list.tmpl.html","<div class=\"rf-comment\"><div class=\"section-content\"><div class=\"comment\" layout=\"row\" \nng-repeat=\"comment in vm.comments\"><rf-avatar rf-size=\"60\" rf-profile=\"comment.profile\" rf-only-text=\"false\">\n</rf-avatar><div flex class=\"comment-bubble\" layout=\"column\">{{comment.message}}<div layout=\"row\"><div flex \nclass=\"comment-member-name\">{{comment.profile.name}}</div><div ng-if=\"comment.type\" layout=\"row\" \nlayout-align=\"end end\"><span class=\"text-boxed\">{{comment.type}}</span></div><div class=\"comment-time secondary-text\">\n{{comment.created_at|w3Moments}}</div></div></div></div><div ng-if=\"!vm.comments.length\" class=\"p-16\"><span \ntranslate=\"RFCOMMENTS.EPTY_COMMENTS\">Nenhum comentário encontrado.</span></div></div></div>");
$templateCache.put("/app/external/fuse/components/rf-gallery/rf-gallery.html","<div class=\"rf-gallery\"><div layout=\"row\" layout-align=\"space-between center\"><span class=\"md-title\">{{vm.title}}\n</span><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button md-raised pull-right\" \naria-label=\"More\"><i class=\"icon icon-delete orange-700-fg\"></i></md-button><p><b>Remover:</b><br>\nAtenção! esta ação é irreversível.</p></div></div><w3-files-drop config=\"vm.configUploadCasal\" gallery=\"\'produtos\'\" \non-uploaded=\"vm.onFilesUploaded($files)\"></w3-files-drop><md-divider class=\"mtb16\"></md-divider><md-grid-list \nmd-cols-xs=\"1\" md-cols-sm=\"2\" md-cols-md=\"4\" md-cols-gt-md=\"8\" md-row-height-gt-md=\"1:1\" md-row-height=\"2:2\" \nmd-gutter=\"12px\" md-gutter-gt-sm=\"8px\" class=\"marcas-grid-list\"><md-grid-tile ng-repeat=\"mr in vm.galeria.$array\" \nng-style=\"{\'background-image\':\'url(\' + mr.imgThumb +\')\', \'background-size\': \'cover\'}\"><md-grid-tile-header \nlayout=\"row\" layout-align=\"space-between center\"><md-button type=\"button\" ng-click=\"mr.$removeData()\" \nclass=\"md-icon-button md-raised pull-right\" aria-label=\"More\"><i class=\"icon icon-delete orange-700-fg\"></i>\n</md-button></md-grid-tile-header></md-grid-tile></md-grid-list></div>");
$templateCache.put("/app/external/fuse/components/rf-input-city/rf-input-city.tpl.html","<md-autocomplete md-no-cache=\"true\" md-selected-item=\"vm.selectedItem\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchText)\" md-search-text=\"vm.searchText\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-items=\"item in vm.querySearch(vm.searchText)\" \nmd-item-text=\"item.city_name\" md-min-length=\"3\" md-floating-label=\"{{\'W3_INPUT_CITY.LABEL_REQ\'|translate}}\" \nmd-menu-class=\"autocomplete-custom-template\" class=\"rf-input-city\" ng-required=\"vm.required\"><md-item-template><span \nclass=\"item-title\"><span>{{item.city_name}} </span></span><span class=\"item-metadata\"><span class=\"item-metastat\">\n{{item.state.state_name}} - {{item.state.country.country_name}}</span></span></md-item-template><md-not-found><span \ntranslate=\"W3_INPUT_CITY.NOT_FOUND\">Nenhuma cidade encontrada</span> <span class=\"rf-btn-text\" ng-if=\"vm.openCreate\" \nng-click=\"vm.showCreateCity($event)\" translate=\"W3_INPUT_CITY.ADD_NOVO\">Novo</span></md-not-found></md-autocomplete>");
$templateCache.put("/app/external/fuse/layouts/content/content.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("/app/external/fuse/layouts/content-toolbar/content-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("/app/external/fuse/layouts/hor-nav-complete/hor-nav-complete.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("/app/external/fuse/layouts/vert-nav/vert-nav.html","<div id=\"vert-nav\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content></div></div>");
$templateCache.put("/app/external/fuse/layouts/vert-nav-comp-toolbar/vert-nav-comp-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'{{vm.openMenu}}\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\">\n</md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav \nid=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("/app/external/fuse/layouts/vert-nav-comp-toolbar2/vert-nav-comp-toolbar2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" \nms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div></div>");
$templateCache.put("/app/external/fuse/layouts/vert-nav-complete/vert-nav-complete.html","<div id=\"layout-vertical-navigation-complete\" class=\"template-layout\" layout=\"row\" flex><md-sidenav \nid=\"vertical-navigation\" class=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'{{vm.openMenu}}\')\" \nmd-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex \nlayout=\"column\"><md-toolbar aria-label=\"toolbar\" id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" \nui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav aria-label=\"quick\" id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("/app/external/fuse/layouts/vert-nav-toolbar/vert-nav-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" \nms-scroll ui-view=\"content\" flex></md-content></div></div></div>");
$templateCache.put("/app/external/fuse/layouts/vert-nav-toolbar2/vert-nav-toolbar2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" \nms-scroll ui-view=\"content\" flex></md-content></div></div></div>");
$templateCache.put("/app/external/fuse/logs/dialogs/logs-dialog.html","<md-dialog class=\"single-dialog dialog-600\" aria-label=\"Dialog\" translate-attr-aria-label=\"DIALOG.MANUTENCAO_DIALOG\">\n<form name=\"dialogForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Detalhes do log</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Fechar\" translate \ntranslate-attr-aria-label=\"COMMON.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close s24\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout=\"row\" layout-align=\"space-between none\" \nclass=\"p-8 mv-16 md-grey-300-bg\"><img class=\"vm.row.causer-image avatar huge\" ng-src=\"{{vm.row.causer.thumb_src}}\"><div\n layout=\"column\" layout-align=\"space-between start\"><b class=\"mt-16\">{{vm.row.causer.name}}</b> <span \nclass=\"secondary-text\">{{vm.row.causer.telefone}}<br>{{vm.row.causer.email}}<br>{{vm.row.causer.city.name_city}}</span>\n</div></div><div layout=\"row\" layout-align=\"space-between center\"><b>{{vm.row.log_name}}</b> <span>\n{{vm.row.created_at| w3DatePt}}</span></div><p>{{vm.row.description}}</p><div><div \nng-repeat=\"item in vm.row.properties.detectsChanges\">{{item.key}}: <del ng-if=\"item.old\" class=\"red-500-fg\"><b>\n{{item.old}}</b></del><md-icon ng-if=\"item.old && item.value\" class=\"s16\" md-font-icon=\"icon-arrow-right\"></md-icon><b \nng-if=\"item.value\" class=\"green-500-fg\">{{item.value}}</b><md-divider ng-if=\"!$last\"></md-divider></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><div layout=\"row\" \nlayout-align=\"end center\"><md-button type=\"button\" ng-click=\"vm.closeDialog()\" class=\"md-warn\" aria-label=\"Cancelar\">\n<span>Fechar</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("/app/external/fuse/report/actions/actions.html","<div layout=\"row\" layout-align=\"center center\"><md-button ng-if=\"report.buttons.indexOf(\'print\')>= 0\" \nng-disabled=\"disable\" ng-click=\"rp.execute(\'html\', \'print\')\"><md-icon class=\"blue-500-fg\" md-font-icon=\"icon-printer\">\n</md-icon><span>Imrimir</span></md-button><md-button ng-if=\"report.buttons.indexOf(\'view\')>= 0\" ng-disabled=\"disable\" \nng-click=\"rp.execute(\'html\')\"><md-icon md-font-icon=\"icon-eye\"></md-icon><span>Visualizar</span></md-button><md-button \nng-if=\"report.buttons.indexOf(\'pdf\')>= 0\" ng-disabled=\"disable\" ng-click=\"rp.execute(\'pdf\')\"><md-icon \nclass=\"red-900-fg\" md-font-icon=\"icon-file-pdf-box\"></md-icon><span>Exportar PDF</span></md-button><md-button \nng-if=\"report.buttons.indexOf(\'excel\')>= 0\" ng-disabled=\"disable\" ng-click=\"rp.execute(\'xls\')\"><md-icon \nclass=\"green-700-fg\" md-font-icon=\"icon-table-large\"></md-icon><span>Exportar Excel</span></md-button></div>");
$templateCache.put("/app/external/fuse/report/box/box.html","<div class=\"rf-report-box\"><md-subheader ng-if=\"report\" class=\"md-no-sticky md-white-bg\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"list-title\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"md-title\">{{report.label}}</span></div><div flex></div></div></md-subheader><ng-transclude></ng-transclude><div \nng-if=\"!report\" layout=\"column\" layout-align=\"center center\" class=\"h-300\"><h1>\nVocê ainda não selecionou nenhum relatório</h1><md-icon md-font-icon=\"icon-table-large\" \nclass=\"s80 h-80 amber-500-fg no-margin\"></md-icon><p class=\"secondary-text font-size-20\">\nSelecione ao lado um relatório para continuar.</p></div></div>");
$templateCache.put("/app/external/fuse/report/sidenav/sidenav.html","<div ms-scroll class=\"content scrollable\"><md-list ng-cloak=\"\" class=\"listdemoListControls\"><div \nng-repeat=\"group in list\"><md-subheader class=\"md-no-sticky\">{{group.name}}</md-subheader><md-list-item \nng-click=\"rp.setParams(item)\" ng-repeat=\"item in group.itens\"><p>{{ item.label}}</p></md-list-item><md-divider \nng-if=\"!$last\"></md-divider></div></md-list></div>");
$templateCache.put("/app/external/fuse/user/dialogs/new-user.html","<md-dialog class=\"single-dialog dialog-600\" aria-label=\"Dialog\" \ntranslate-attr-aria-label=\"APPLICATION.DIALOG.MANUTENCAO_DIALOG\"><form name=\"dialogForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" ng-if=\"!vm.showFormUser\">\nAdicionar permissão ao usuário</span> <span class=\"title\" ng-if=\"vm.showFormUser\">Adicionar usuário</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Fechar\" translate \ntranslate-attr-aria-label=\"COMMON.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close s24\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ng-if=\"!vm.showFormUser\" layout=\"column\" class=\"animate-slide-up\"><md-autocomplete \nmd-selected-item=\"vm.selectedItem\" md-search-text-change=\"vm.searchTextChange(vm.searchText)\" \nmd-search-text=\"vm.searchText\" md-selected-item-change=\"vm.setUser(item)\" \nmd-items=\"item in vm.querySearchUser(vm.searchText)\" md-item-text=\"item.name\" md-min-length=\"0\" md-delay=\"500\" \nplaceholder=\"Procurar usuário por nome\"><md-item-template><span md-highlight-text=\"vm.searchText\" \nmd-highlight-flags=\"^i\">{{item.name}} {{item.email}}</span></md-item-template><md-not-found>Usuário não encontrado. \n<span ng-click=\"vm.createUser()\" class=\"nostyle rf-pointer light-blue-500-fg\">Cadastrar novo usuário</span>\n</md-not-found></md-autocomplete><md-checkbox ng-model=\"vm.row.is_owner\" aria-label=\"is owner\" ng-if=\"vm.selectedItem\">\nPermitir que este usuário cadastre outros usuários.</md-checkbox><md-input-container \nng-if=\"vm.isMultiplePermissons() && vm.selectedItem\"><label>Permissão</label><md-select ng-model=\"vm.row.permission\" \nng-required=\"true\"><md-option ng-repeat=\"op in vm.permissions\" ng-value=\"op.key\">{{op.label}}</md-option></md-select>\n</md-input-container></md-dialog-content><md-dialog-content ng-if=\"vm.showFormUser\" layout=\"column\" \nclass=\"animate-slide-up\"><md-input-container><label>Nome</label><input type=\"text\" ng-model=\"vm.user.first_name\">\n</md-input-container><md-input-container class=\"no-margin\"><label>E-mail</label><input type=\"email\" \nng-model=\"vm.user.email\"></md-input-container><div flex layout=\"row\" ng-if=\"!vm.autoPassword\" \nclass=\"h-60 animate-slide-left\"><md-input-container flex><label>Senha</label><input type=\"password\" \nng-model=\"vm.user.password\"></md-input-container><md-input-container flex><label>Confirmar senha</label><input \ntype=\"password\" ng-model=\"vm.user.password_confirmation\"></md-input-container></div><md-checkbox \nng-model=\"vm.autoPassword\" aria-label=\"Gerar senha automaticamente\">Deixar que o usuário crie sua senha</md-checkbox>\n<md-input-container ng-if=\"vm.sendAccess\" class=\"md-block animate-slide-left\"><label>Mensagem para o usuário</label>\n<textarea ng-model=\"vm.message\" rows=\"3\" max-rows=\"3\"></textarea></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"end center\"><div ng-if=\"!vm.showFormUser\" layout=\"row\" \nlayout-align=\"end center\"><md-button type=\"button\" ng-click=\"vm.closeDialog()\" class=\"md-warn\" aria-label=\"Cancelar\">\n<span translate=\"COMMON.CANCELAR\">Cancelar</span></md-button><md-button type=\"submit\" ng-click=\"vm.save()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"dialogForm.$invalid\" aria-label=\"Adicionar\"><span \nng-if=\"vm.isNew\" translate=\"COMMON.ADICIONAR\">Adicionar </span><span ng-if=\"!vm.isNew\" translate=\"COMMON.SALVAR\">Salvar\n</span></md-button></div><div ng-if=\"vm.showFormUser\" layout=\"row\" layout-align=\"end center\"><md-button type=\"button\" \nng-click=\"vm.cancelCreateUser()\" class=\"md-warn\" aria-label=\"Cancelar\"><span translate=\"COMMON.CANCELAR\">Cancelar\n</span></md-button><md-button type=\"submit\" ng-click=\"vm.saveUser()\" class=\"send-button md-accent md-raised\" \naria-label=\"Adicionar\"><span>Adicionar usuário</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("/app/external/pedido/dialog/alterar-pedido-valor/alterar-pedido-valor-dialog.html","<md-dialog class=\"single-dialog dialog-600\" style=\"width: 100%; max-width: 800px\" aria-label=\"Dialog\" \ntranslate-attr-aria-label=\"PEDIDO.DIALOG.DECLINE_REQUEST_DIALOG.DIALOG_TITLE\"><md-toolbar class=\"md-accent\" \nstyle=\"background-color: {{vm.toolbarColor}}\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Alterar valor do pedido</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Fechar\" translate \ntranslate-attr-aria-label=\"COMMON.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close s24\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"p-0\" ng-if=\"vm.row\"><h3>Alterar pedido <strong>{{vm.row.referencia}}\n</strong> do cliente {{vm.row.cliente}}</h3><p>Você pode alterar alguns valores relacionados ao pedido</p><div \nlayout=\"row\"><md-input-container class=\"md-block\" flex><label>Fabricação R$</label><input name=\"vl_fabricacao\" \nng-model=\"vm.dataRow.vl_fabricacao\" type=\"text\" w3-currency limit=\"2\"></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Comissão vendedor R$</label><input name=\"comissao\" ng-model=\"vm.dataRow.vl_comissao\" \ntype=\"text\" w3-currency limit=\"2\"></md-input-container><md-input-container class=\"md-block\" flex><label>\nComissão Polo R$</label><input name=\"vl_comissao_polo\" ng-model=\"vm.dataRow.vl_comissao_polo\" type=\"text\" w3-currency \nlimit=\"2\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex><label>Acréscimo R$\n</label><input ng-model=\"vm.dataRow.vl_acrescimo\" type=\"text\" w3-money></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Desconto R$</label><input name=\"desconto\" ng-model=\"vm.dataRow.vl_desconto\" type=\"text\" \nw3-currency limit=\"2\"></md-input-container><md-input-container class=\"md-block\" flex><label>Total R$</label><input \nng-model=\"vm.dataRow.vl_total\" type=\"text\" w3-money></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"end center\"><div layout=\"row\" layout-align=\"end center\"><md-button \ntype=\"button\" ng-click=\"vm.cancel()\" class=\"md-warn\" aria-label=\"Cancelar\" translate-attr-aria-label=\"COMMON.CANCELAR\">\n<span>Fechar</span></md-button><md-button ng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" \naria-label=\"Adicionar\">Alterar valor</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("/app/external/pedido/dialog/cancelar-pedido/cancelar-pedido-dialog.html","<md-dialog class=\"single-dialog dialog-600\" style=\"width: 100%; max-width: 800px\" aria-label=\"Dialog\" \ntranslate-attr-aria-label=\"PEDIDO.DIALOG.DECLINE_REQUEST_DIALOG.DIALOG_TITLE\"><md-toolbar class=\"md-warn\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">Cancelar pedido</span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" aria-label=\"Fechar\" \ntranslate translate-attr-aria-label=\"COMMON.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close s24\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div class=\"p-0\" ng-if=\"vm.row\"><h3>Cancelar pedido</h3><p>\nDeseja realmente cancelar o pedido <strong>#{{vm.pedido.id}}</strong> do cliente <b>{{vm.pedido.cliente}}</b></p><div \nlayout=\"row\"><md-input-container class=\"md-block\" flex><label>Motivo do cancelamento</label><input \nng-model=\"vm.row.obs_cancelamento\" type=\"text\"></md-input-container></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"end center\"><div layout=\"row\" layout-align=\"end center\"><md-button type=\"button\" \nng-click=\"vm.close()\" class=\"md-warn\" aria-label=\"Cancelar\" translate-attr-aria-label=\"COMMON.CANCELAR\"><span>Fechar\n</span></md-button><md-button ng-click=\"vm.cancelPedido()\" class=\"send-button md-warn md-raised\" \naria-label=\"Adicionar\">Cancelar pedido</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("/app/external/pedido/dialog/detail-item-dialog/_detail-product.html","<div flex layout=\"row\" layout-align=\"space-between start\"><div flex class=\"pl-8\" layout=\"column\"><strong \nclass=\"md-body-1\">{{vm.tipo === \'ITEM_PRODUCT_GRESSIVE\'? \'Código\': \'Nome\'}}: {{vm.row.nome}}</strong> <span>\nTipo de visão: {{vm.row.tipo_visao}}</span> <span>Eixo: {{vm.row.eixo}}</span> <span>Diâmetro: {{vm.row.diametro}}\n</span> <span>Preço: <strong class=\"margin-left-5\">{{vm.row.preco|currency: \'R$\'}}</strong></span> <span>\nReferência: {{vm.row._ref}}</span></div><div><strong>Perscrição</strong><table class=\"simple\"><tr><td></td><td>Adição\n</td><td>Cilindríco</td><td>Esferico</td></tr><tr><td>Min.</td><td>{{vm.row.adicao_min}}</td><td>{{vm.row.cil_min}}\n</td><td>{{vm.row.esferico_min}}</td></tr><tr><td>Máx.</td><td>{{vm.row.adicao_max}}</td><td>{{vm.row.cil_max}}</td>\n<td>{{vm.row.esferico_max}}</td></tr></table></div></div>");
$templateCache.put("/app/external/pedido/dialog/detail-item-dialog/detail-item-dialog.html","<md-dialog class=\"single-dialog dialog-600\" style=\"width: 100%; max-width: 800px\" aria-label=\"Dialog\" \ntranslate-attr-aria-label=\"PEDIDO.DIALOG.DECLINE_REQUEST_DIALOG.DIALOG_TITLE\"><md-toolbar class=\"md-accent\" \nstyle=\"background-color: {{vm.toolbarColor}}\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Fechar\" translate \ntranslate-attr-aria-label=\"COMMON.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close s24\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"p-0\" ng-if=\"vm.row\"><div layout=\"row\"><pl-square-image \nsrc=\"vm.row.thumb_src\" size=\"\'lg\'\"></pl-square-image><ng-include flex \nsrc=\"\'/app/external/pedido/dialog/detail-item-dialog/_detail-product.html\'\" ng-if=\"vm.tipo === \'PRODUCT_NORMAL\'\">\n</ng-include><div class=\"pl-15\" layout=\"column\" \nng-if=\"vm.tipo === \'PRODUCT_GRESSIVE\' || vm.tipo === \'MATERIAL\' || vm.tipo === \'TRATAMENTO\' || vm.tipo === \'ITRACKLINE\'\" \nclass=\"pl-15\"><span layout=\"row\" layout-align=\"start base-line\">Nome: <strong class=\"margin-left-5\">{{vm.row.nome}}\n</strong></span> <span layout=\"row\" layout-align=\"start base-line\">Preço: <strong class=\"margin-left-5\">\n{{vm.row.preco|currency: \'R$\'}}</strong></span> <span>Referência: {{vm.row._ref}}</span></div><div class=\"pl-15\" \nlayout=\"column\" ng-if=\"vm.tipo === \'ITEM_PRODUCT_GRESSIVE\'\"><span layout=\"row\" layout-align=\"start center\">Código: \n<strong class=\"margin-left-5\">{{vm.row.nome}}</strong></span> <span>Tipo: {{vm.row.tipo | gressiveTipe}}</span> <span>\nCaracterísticas: {{vm.row.caracteristicas}}</span> <span layout=\"row\" layout-align=\"start center\">Preço: <strong \nclass=\"margin-left-5\">{{vm.row.preco|currency: \'R$\'}}</strong></span> <span>Referência: {{vm.row._ref}}</span></div>\n</div><br><md-divider ng-if=\"vm.row.especificacao && vm.row.especificacao.length\"></md-divider><br \nng-if=\"vm.row.especificacao && vm.row.especificacao.length\"><tab-show-especificacao \nng-if=\"vm.row.especificacao && vm.row.especificacao.length\" tabs=\"vm.row.especificacao\"></tab-show-especificacao></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><div layout=\"row\" \nlayout-align=\"end center\"><md-button type=\"button\" ng-click=\"vm.cancel()\" class=\"md-warn\" aria-label=\"Cancelar\" \ntranslate-attr-aria-label=\"COMMON.CANCELAR\"><span>Fechar</span></md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("/app/external/pedido/dialog/pedido-dialog-send-request-otica/pedido-dialog-send-request-otica.html","<md-dialog class=\"single-dialog dialog-600\" aria-label=\"Dialog\" style=\"overflow: hidden;height: 700px\" \ntranslate-attr-aria-label=\"PEDIDO.DIALOG.SEND_REQUEST.DIALOG_TITLE\"><form name=\"dialogForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Já revisou todos os dados do pedido?</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Fechar\" translate \ntranslate-attr-aria-label=\"COMMON.FECHAR_DIALOG\"><md-icon md-font-icon=\"icon-close s24\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll=\"\"><span class=\"md-body-1\">\nDeseja continuar o envio do pedido? Note que não será possívl editar o pedido após o aceite do POLO.</span><br><span>\nCliente: {{vm.request.cliente}}</span><br><span>Produto: {{ vm.request.produto.nome}}</span><br><div \nng-if=\"vm.request.itrack_id\"><span>iTRACK LINE: {{ vm.request.itrack.nome}}</span><br><span>\n{{ vm.request.itrack_code}} - {{ vm.request.itrack.preco | currency : \'R$ \' : 2}}</span></div><div layout=\"row\"><div \nflex layout=\"column\" class=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_MATERIAL\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><div \nlayout=\"row\"><pl-square-image ng-if=\"vm.request.material\" src=\"vm.request.material.thumb_src\" size=\"\'sm\'\">\n</pl-square-image><div class=\"ml-8\" flex layout=\"column\"><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ vm.request.material ? vm.request.material.nome : \'---\' }}</p><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ vm.request.material ? (vm.request.material.preco | currency : \'R$ \' : 2) : \'---\' }}</p></div></div></div><div flex \nlayout=\"column\" class=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_TREATMENT\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><div \nlayout=\"row\"><pl-square-image ng-if=\"vm.request.tratamento\" src=\"vm.request.tratamento.thumb_src\" size=\"\'sm\'\">\n</pl-square-image><div class=\"ml-8\" flex layout=\"column\"><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ vm.request.tratamento ? vm.request.tratamento.nome : \'---\'}}</p><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ vm.request.tratamento ? (vm.request.tratamento.preco | currency : \'R$ \' : 2) : \'---\' }}</p></div></div></div></div>\n<div layout=\"row\" ng-if=\"vm.request.produto.tipo === \'GRESSIVE\'\" class=\"margin-top-10\"><div flex=\"25\" layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky fit-subheader\">Configuração: Longe\n</md-subheader><md-divider class=\"blue-500-bg\"></md-divider><span ng-if=\"!vm.request.itemLonge\">---</span><div \nlayout=\"row\" ng-if=\"vm.request.itemLonge\"><pl-square-image src=\"vm.request.itemLonge.thumb_src\" size=\"\'sm\'\">\n</pl-square-image><div class=\"ml-8\" flex layout=\"column\"><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ vm.request.itemLonge.nome }}</p><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ vm.request.itemLonge.preco | currency : \'R$ \' : 2 }}</p></div></div></div><div flex=\"50\" layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky fit-subheader\">Configuração: Intermediário\n</md-subheader><md-divider class=\"blue-500-bg\"></md-divider><span ng-if=\"!vm.request.itemInterm\">---</span><div \nlayout=\"row\" ng-if=\"vm.request.itemInterm\"><pl-square-image src=\"vm.request.itemInterm.thumb_src\" size=\"\'sm\'\">\n</pl-square-image><div class=\"ml-8\" flex layout=\"column\"><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ vm.request.itemInterm.nome }}</p><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ vm.request.itemInterm.preco | currency : \'R$ \' : 2 }}</p></div></div></div><div flex=\"25\" layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky fit-subheader\">Configuração: Perto\n</md-subheader><md-divider class=\"blue-500-bg\"></md-divider><span ng-if=\"!vm.request.itemPerto\">---</span><div \nlayout=\"row\" ng-if=\"vm.request.itemPerto\"><pl-square-image src=\"vm.request.itemPerto.thumb_src\" size=\"\'sm\'\">\n</pl-square-image><div class=\"ml-8\" flex layout=\"column\"><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ vm.request.itemPerto.nome }}</p><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ vm.request.itemPerto.preco | currency : \'R$ \' : 2 }}</p></div></div></div></div><div layout=\"column\" \nng-if=\"vm.request.adicionais\" class=\"margin-top-10\"><md-subheader class=\"md-no-sticky fit-subheader\">Adicionais\n</md-subheader><md-divider class=\"blue-500-bg\"></md-divider><div ng-repeat=\"adittional in vm.request.adicionais\" flex \nlayout=\"row\" layout-align=\"space-between center\"><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ adittional.descricao }}</p><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ adittional.valor | currency : \'R$ \' : 2 }}</p></div></div><div ng-if=\"vm.request.espec_od || vm.request.espec_oe\" \nclass=\"border-top mt-16 pt-16\"><span><b>Perscrição</b></span><div layout=\"row\"><div flex layout=\"column\"><div \nlayout=\"row\" layout-align=\"center center\"><h1 class=\"md-subhead\" \ntranslate=\"PEDIDO.SHOW.FIELD_SET_LABEL.PRESCRIPTION_RIGHT_EYE\"></h1></div><div flex layout=\"column\" layout-margin><div \nlayout=\"row\" flex><div flex layout=\"column\" class=\"margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_SPHERICAL\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nng-if=\"vm.request.espec_od.esferico !== null && vm.request.espec_od.esferico !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ vm.request.espec_od.esferico| currency:\' \' }}</p><p \nng-if=\"vm.request.espec_od.esferico === null || vm.request.espec_od.esferico === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p></div><div flex layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" translate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_CIL\">\n</md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nng-if=\"vm.request.espec_od.cil !== null && vm.request.espec_od.cil !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ vm.request.espec_od.cil| currency:\' \' }}</p><p \nng-if=\"vm.request.espec_od.cil === null || vm.request.espec_od.cil === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p></div><div flex layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_AXIS\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nng-if=\"vm.request.espec_od.eixo !== null && vm.request.espec_od.eixo !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ vm.request.espec_od.eixo| currency:\' \' }}</p><p \nng-if=\"vm.request.espec_od.eixo === null || vm.request.espec_od.eixo === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p></div><div flex layout=\"column\" \nclass=\"margin-left-15\"><md-subheader class=\"md-no-sticky\" translate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_ADDITION\">\n</md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nng-if=\"vm.request.espec_od.adicao !== null && vm.request.espec_od.adicao !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ vm.request.espec_od.adicao| currency:\' \' }}</p><p \nng-if=\"vm.request.espec_od.adicao === null || vm.request.espec_od.adicao === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p></div></div><div layout=\"row\" flex><div flex \nlayout=\"column\" class=\"margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_PRIS_H\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nng-if=\"vm.request.espec_od.prish !== null && vm.request.espec_od.prish !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ vm.request.espec_od.prish| currency:\' \' }}</p><p \nng-if=\"vm.request.espec_od.prish === null || vm.request.espec_od.prish === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p></div><div flex layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_PRIS_H_BASE\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nng-if=\"vm.request.espec_od.prish_base  !== null && vm.request.espec_od.prish_base !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ vm.request.espec_od.prish_base }}</p><p \nng-if=\"vm.request.espec_od.prish_base  === null || vm.request.espec_od.prish_base  === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p></div><div flex layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_PRIS_V\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nng-if=\"vm.request.espec_od.prisv !== null && vm.request.espec_od.prisv !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ vm.request.espec_od.prisv| currency:\' \' }}</p><p \nng-if=\"vm.request.espec_od.prisv === null || vm.request.espec_od.prisv === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p></div><div flex layout=\"column\" \nclass=\"margin-left-15\"><md-subheader class=\"md-no-sticky\" translate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_PRIS_V_BASE\">\n</md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nng-if=\"vm.request.espec_od.prisv_base !== null && vm.request.espec_od.prisv_base !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ vm.request.espec_od.prisv_base }}</p><p \nng-if=\"vm.request.espec_od.prisv_base === null || vm.request.espec_od.prisv_base === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p></div></div></div></div><md-divider \nclass=\"blue-500-bg\"></md-divider><div flex layout=\"column\"><div layout=\"row\" layout-align=\"center center\"><h1 \nclass=\"md-subhead\" translate=\"PEDIDO.SHOW.FIELD_SET_LABEL.PRESCRIPTION_LEFT_EYE\"></h1></div><div flex layout=\"column\" \nlayout-margin><div layout=\"row\" flex><div flex layout=\"column\" class=\"margin-right-15\"><md-subheader \nclass=\"md-no-sticky\" translate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_SPHERICAL\"></md-subheader><md-divider class=\"blue-500-bg\">\n</md-divider><p ng-if=\"vm.request.espec_oe.esferico !== null && vm.request.espec_oe.esferico !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ vm.request.espec_oe.esferico| currency:\' \' }}</p><p \nng-if=\"vm.request.espec_oe.esferico === null || vm.request.espec_oe.esferico  === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p></div><div flex layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" translate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_CIL\">\n</md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nng-if=\"vm.request.espec_oe.cil !== null && vm.request.espec_oe.cil !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ vm.request.espec_oe.cil| currency:\' \' }}</p><p \nng-if=\"vm.request.espec_oe.cil === null || vm.request.espec_oe.cil  === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p><p ng-if=\"vm.request.espec_od.value\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ vm.request.espec_oe.cil }}</p></div><div flex layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_AXIS\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nng-if=\"vm.request.espec_oe.eixo !== null && vm.request.espec_oe.eixo !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ vm.request.espec_oe.eixo| currency:\' \' }}</p><p \nng-if=\"vm.request.espec_oe.eixo === null || vm.request.espec_oe.eixo === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p></div><div flex layout=\"column\" \nclass=\"margin-left-15\"><md-subheader class=\"md-no-sticky\" translate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_ADDITION\">\n</md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nng-if=\"vm.request.espec_oe.adicao !== null && vm.request.espec_oe.adicao !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ vm.request.espec_oe.adicao| currency:\' \' }}</p><p \nng-if=\"vm.request.espec_oe.adicao === null || vm.request.espec_oe.adicao === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p></div></div><div layout=\"row\" flex><div flex \nlayout=\"column\" class=\"margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_PRIS_H\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nng-if=\"vm.request.espec_oe.prish !== null && vm.request.espec_oe.prish !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ vm.request.espec_oe.prish| currency:\' \' }}</p><p \nng-if=\"vm.request.espec_oe.prish === null || vm.request.espec_oe.prish  === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p></div><div flex layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_PRIS_H_BASE\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nng-if=\"vm.request.espec_oe.prish_base !== null && vm.request.espec_oe.prish_base !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ vm.request.espec_oe.prish_base }}</p><p \nng-if=\"vm.request.espec_oe.prish_base === null || vm.request.espec_oe.prish_base === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p></div><div flex layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_PRIS_V\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nng-if=\"vm.request.espec_oe.prisv !== null && vm.request.espec_oe.prisv !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ vm.request.espec_oe.prisv| currency:\' \' }}</p><p \nng-if=\"vm.request.espec_oe.prisv === null || vm.request.espec_oe.prisv  === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p></div><div flex layout=\"column\" \nclass=\"margin-left-15\"><md-subheader class=\"md-no-sticky\" translate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_PRIS_V_BASE\">\n</md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nng-if=\"vm.request.espec_oe.prisv_base !== null && vm.request.espec_oe.prisv_base !== undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ vm.request.espec_oe.prisv_base }}</p><p \nng-if=\"vm.request.espec_oe.prisv_base === null || vm.request.espec_oe.prisv_base === undefined\" \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ \"-- -- -- --\"}}</p></div></div></div></div></div></div><div \nlayout=\"column\" ng-if=\"vm.request.medidas\" class=\"border-top mt-16 pt-16\"><span><b>Medidas</b></span><div flex \nlayout=\"row\"><div flex=\"14\" layout=\"column\" class=\"margin-left-15 margin-right-15\"><div class=\"padding-bottom-10\">\n<md-subheader class=\"md-no-sticky\" translate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_MEASURE_WEIGHT\"></md-subheader><md-divider \nclass=\"blue-500-bg\"></md-divider><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ vm.request.medidas.largura? vm.request.medidas.largura : \'---\' }}</p></div><div class=\"padding-bottom-10\">\n<md-subheader class=\"md-no-sticky\" translate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_MEASURE_HEIGHT\"></md-subheader><md-divider \nclass=\"blue-500-bg\"></md-divider><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ vm.request.medidas.altura? vm.request.medidas.altura : \'---\' }}</p></div></div><div flex=\"20\" layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><div class=\"padding-bottom-10\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_MEASURE_BRIDGE\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ vm.request.medidas.ponte? vm.request.medidas.ponte : \'---\' }}</p>\n</div><div class=\"padding-bottom-10\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_MEASURE_DIAGONAL\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider>\n<p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ vm.request.medidas.diagonal? vm.request.medidas.diagonal : \'---\' }}</p></div></div><div flex=\"26\" layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><div class=\"padding-bottom-10\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_MEASURE_PUPIL_HEIGHT_LEFT\"></md-subheader><md-divider class=\"blue-500-bg\">\n</md-divider><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ vm.request.medidas.oe_altura_pupilar? vm.request.medidas.oe_altura_pupilar : \'---\' }}</p></div><div class=\"\">\n<md-subheader class=\"md-no-sticky\" translate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_MEASURE_PUPIL_HEIGHT_RIGTH\"></md-subheader>\n<md-divider class=\"blue-500-bg\"></md-divider><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ vm.request.medidas.od_altura_pupilar? vm.request.medidas.od_altura_pupilar : \'---\' }}</p></div></div><div flex \nlayout=\"column\" class=\"margin-left-15 margin-right-15\"><div class=\"padding-bottom-10\"><md-subheader \nclass=\"md-no-sticky\" translate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_MEASURE_DNP_LEFT\"></md-subheader><md-divider \nclass=\"blue-500-bg\"></md-divider><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ vm.request.medidas.oe_dnp? vm.request.medidas.oe_dnp : \'---\' }}</p></div><div class=\"padding-bottom-10\">\n<md-subheader class=\"md-no-sticky\" translate=\"PEDIDO.SHOW.FIELD_LABEL.LENS_MEASURE_DNP_RIGTH\"></md-subheader>\n<md-divider class=\"blue-500-bg\"></md-divider><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ vm.request.medidas.od_dnp? vm.request.medidas.od_dnp : \'---\' }}</p></div></div></div><div flex layout=\"row\"><div \nclass=\"padding-bottom-0 margin-left-15 margin-right-15\" ng-if=\"vm.request.produto.tipo === \'GRESSIVE\'\"><md-subheader \nclass=\"md-no-sticky fit-subheader\">Altura. Versão do corredor progressivo.</md-subheader><md-divider \nclass=\"blue-500-bg\"></md-divider><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ vm.request.altura_v_progressivo? vm.request.altura_v_progressivo : \'---\' }}</p></div></div></div><div \nlayout=\"column\" class=\"border-top mt-16 pt-16\"><span><b>Armação</b></span><div layout=\"column\"><div flex layout=\"row\" \nlayout-margin><div flex layout=\"column\" class=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.EYEGLASS_FRAME_TYPE\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ vm.request.material_armacao_label? vm.request.material_armacao_label : \'---\' }}</p><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ vm.request.material_armacao && !vm.request.material_armacao_label? vm.request.material_armacao : \'---\' }}</p></div>\n<div flex layout=\"column\" class=\"margin-left-15 margin-right-15\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"PEDIDO.SHOW.FIELD_LABEL.EYEGLASS_FRAME_MODEL\"></md-subheader><md-divider class=\"blue-500-bg\"></md-divider>\n<div><img ng-if=\"vm.request\" ng-src=\"{{ vm.getFrameModelURL() }}\"></div></div></div></div></div><div layout=\"column\" \nclass=\"border-top mt-16 pt-16\"><span><b>Observações</b></span><div layout=\"column\"><div flex layout=\"row\" \nlayout-margin><div flex layout=\"column\" class=\"margin-left-15 margin-right-15\"><md-divider class=\"blue-500-bg\">\n</md-divider><div>{{ vm.request.observacao? vm.request.observacao : \'-- Sem observações adicionais. --\' }}</div></div>\n</div></div></div><div ng-if=\"vm.hasCorteRemoto()\" layout=\"column\" class=\"border-top mt-16 pt-16\"><span><b>Corte remoto\n</b></span><div layout=\"column\"><div flex layout=\"row\" layout-margin><div flex layout=\"column\" \nclass=\"margin-left-15 margin-right-15\"><md-divider class=\"blue-500-bg\"></md-divider><div \nng-if=\"vm.request.file_corte_remoto\" flex layout=\"column\" layout-align=\"start center\"><span class=\"mb-8 mt-16\"><md-icon\n md-font-icon=\"icon-paperclip\"></md-icon>( Arquivo de corte: ) </span><a class=\"rf-pointer document-miniature\" \ntarget=\"_blank\" disabled=\"!vm.request.file_corte_remoto_src\" ng-href=\"{{vm.request.file_corte_remoto.src}}\"><md-icon \nmd-font-icon=\"icon-cursor-pointer\" class=\"s40 icon-inv\"></md-icon><small>{{vm.request.file_corte_remoto}}</small></a>\n</div><div>\n{{ vm.request.file_corte_remoto? vm.request.observacao : \'-- Nenhum arquivo de corte remoto foi adicionado a este pedido. --\' }}\n</div></div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><div \nlayout=\"row\" layout-align=\"end center\"><md-button type=\"button\" ng-click=\"vm.cancel()\" class=\"md-warn\" \naria-label=\"Cancelar\" translate-attr-aria-label=\"COMMON.CANCELAR\"><span translate=\"COMMON.CANCELAR\">Cancelar</span>\n</md-button><md-button type=\"submit\" ng-click=\"vm.sendRequest()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"dialogForm.$invalid\" aria-label=\"Adicionar\" translate-attr-aria-label=\"COMMON.SALVAR\">Enviar</md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("/app/external/pedido/directive/pedido-actions/pedido-actions.html","<div layout=\"row\"><div ng-if=\"vm.isUserOtica()\" layout=\"row\"><div ng-if=\"vm.isStatusEqualsToNew()\" layout=\"row\">\n<md-button ng-disabled=\"!vm.canOticaRefuseRequest()\" type=\"button\" ng-click=\"vm.callDeclineRequestDialog()\" \nng-class=\"vm.canOticaRefuseRequest() ? \'md-fab md-raised md-red-500-bg\' : \'md-fab md-raised md-grey-600-bg\'\" \naria-label=\"recusar\"><md-icon md-font-icon=\"icon-thumb-down\" class=\"white-text\"></md-icon><md-tooltip>Cancelar pedido\n</md-tooltip></md-button><md-button type=\"button\" ng-click=\"vm.callSendRequestFromOticaToPolo()\" \nclass=\"md-fab md-raised md-green-500-bg\" aria-label=\"enviar\"><md-icon md-font-icon=\"icon-send\" class=\"white-text\">\n</md-icon><md-tooltip>{{\'PEDIDO.DIRECTIVE.REQUEST_ACTIONS_DIRECTIVE.BUTTON_TOOLTIP.SEND_FROM_OTICA_TO_POLO\'|translate}}\n</md-tooltip></md-button></div><md-button ng-if=\"vm.isStatusEqualsToNew() || vm.isStatusEqualsWaitingPolo()\" \ntype=\"button\" ui-sref=\"xsession.pedido.edit({id:request.id})\" class=\"md-fab md-raised md-accent\" aria-label=\"editar\">\n<md-icon md-font-icon=\"icon-pencil\" class=\"white-text\"></md-icon><md-tooltip>{{\'COMMON.EDITAR\'|translate}}</md-tooltip>\n</md-button><div ng-if=\"vm.isStatusEqualsToFinish()\" layout=\"row\"><md-button ng-disabled=\"!vm.canOticaFinishRequest()\" \ntype=\"button\" ng-click=\"vm.callFinishRequest()\" \nng-class=\"vm.canOticaFinishRequest() ? \'md-fab md-raised md-green-600-bg\' : \'md-fab md-raised md-grey-600-bg\'\" \naria-label=\"aceitar\"><md-icon md-font-icon=\"icon-thumb-up\" class=\"white-text\"></md-icon><md-tooltip>\n{{\'PEDIDO.DIRECTIVE.REQUEST_ACTIONS_DIRECTIVE.BUTTON_TOOLTIP.END_REQUEST\'|translate}}</md-tooltip></md-button></div>\n</div><div ng-if=\"vm.isUserPolo()\" layout=\"row\"><div ng-if=\"vm.isStatusEqualsWaitingPolo()\" layout=\"row\"><md-button \nng-disabled=\"!vm.canPoloRefuseRequest()\" type=\"button\" ng-click=\"vm.callDeclineRequestDialog()\" \nng-class=\"vm.canPoloRefuseRequest() ? \'md-fab md-raised md-red-500-bg\' : \'md-fab md-raised md-grey-600-bg\'\" \naria-label=\"recusar\"><md-icon md-font-icon=\"icon-thumb-down\" class=\"white-text\"></md-icon><md-tooltip>\n{{\'PEDIDO.DIRECTIVE.REQUEST_ACTIONS_DIRECTIVE.BUTTON_TOOLTIP.DECLINE\'|translate}}</md-tooltip></md-button><md-button \nng-disabled=\"!vm.canPoloSendRequestToAdmin()\" type=\"button\" ng-click=\"vm.callSendRequestFromPoloToAdmin()\" \nng-class=\"vm.canPoloSendRequestToAdmin() ? \'md-fab md-raised md-green-600-bg\' : \'md-fab md-raised md-grey-600-bg\'\" \naria-label=\"aceitar\"><md-icon md-font-icon=\"icon-thumb-up\" class=\"white-text\"></md-icon><md-tooltip>\n{{\'PEDIDO.DIRECTIVE.REQUEST_ACTIONS_DIRECTIVE.BUTTON_TOOLTIP.ACCEPT\'|translate}}</md-tooltip></md-button></div><div \nng-if=\"vm.isStatusEqualsDeliverToOtica()\" layout=\"row\"><md-button ng-disabled=\"!vm.canPoloSendRequestToOtica()\" \ntype=\"button\" ng-click=\"vm.callSendRequestFromPoloToOtica()\" \nng-class=\"vm.canPoloSendRequestToOtica() ? \'md-fab md-raised md-green-500-bg\' : \'md-fab md-raised md-grey-600-bg\'\" \naria-label=\"enviar\"><md-icon md-font-icon=\"icon-send\" class=\"white-text\"></md-icon><md-tooltip>\n{{\'PEDIDO.DIRECTIVE.REQUEST_ACTIONS_DIRECTIVE.BUTTON_TOOLTIP.SEND_FROM_ADMIN_TO_POLO\'|translate}}</md-tooltip>\n</md-button></div></div><div ng-if=\"vm.isUserAdmin()\" layout=\"row\"><div ng-if=\"vm.isStatusEqualsWaitingAdmin()\" \nlayout=\"row\"><md-button ng-disabled=\"!vm.canAdminRefuseRequest()\" type=\"button\" \nng-click=\"vm.callDeclineRequestDialog()\" \nng-class=\"vm.canAdminRefuseRequest() ? \'md-fab md-raised md-red-500-bg\' : \'md-fab md-raised md-grey-600-bg\'\" \naria-label=\"recusar\"><md-icon md-font-icon=\"icon-thumb-down\" class=\"white-text\"></md-icon><md-tooltip>\n{{\'PEDIDO.DIRECTIVE.REQUEST_ACTIONS_DIRECTIVE.BUTTON_TOOLTIP.DECLINE\'|translate}}</md-tooltip></md-button><md-button \nng-disabled=\"!vm.canAdminSendRequestToLab()\" type=\"button\" ng-click=\"vm.callSendRequestFromAdminToLab()\" \nng-class=\"vm.canAdminSendRequestToLab() ? \'md-fab md-raised md-green-600-bg\' : \'md-fab md-raised md-grey-600-bg\'\" \naria-label=\"aceitar\"><md-icon md-font-icon=\"icon-thumb-up\" class=\"white-text\"></md-icon><md-tooltip>\n{{\'PEDIDO.DIRECTIVE.REQUEST_ACTIONS_DIRECTIVE.BUTTON_TOOLTIP.ACCEPT\'|translate}}</md-tooltip></md-button></div><div \nlayout=\"row\"><md-button ng-if=\"vm.isStatusEqualsDeliverToPolo()\" ng-disabled=\"!vm.canAdminSendRequestToPolo()\" \ntype=\"button\" ng-click=\"vm.callSendRequestFromAdminToPolo()\" \nng-class=\"vm.canAdminSendRequestToPolo() ? \'md-fab md-raised md-green-500-bg\' : \'md-fab md-raised md-grey-600-bg\'\" \naria-label=\"enviar\"><md-icon md-font-icon=\"icon-send\" class=\"white-text\"></md-icon><md-tooltip>\n{{\'PEDIDO.DIRECTIVE.REQUEST_ACTIONS_DIRECTIVE.BUTTON_TOOLTIP.SEND_FROM_ADMIN_TO_POLO\'|translate}}</md-tooltip>\n</md-button><md-menu><md-button type=\"button\" ng-click=\"vm.openPrintMenu($mdMenu, $event)\" \nng-class=\"true ? \'md-fab md-raised md-blue-500-bg\' : \'md-fab md-raised md-grey-600-bg\'\" aria-label=\"editar\"><md-icon \nmd-font-icon=\"icon-printer\" class=\"white-text\"></md-icon><md-tooltip>\n{{\'PEDIDO.DIRECTIVE.REQUEST_ACTIONS_DIRECTIVE.BUTTON_TOOLTIP.PRINT_MENU\'|translate}}</md-tooltip></md-button>\n<md-menu-content><md-menu-item ng-if=\"request.printers.pedido\"><md-button type=\"button\" \nng-href=\"{{request.printers.pedido}}\" target=\"_blank\" class=\"md-raised\"><md-icon md-font-icon=\"icon-file-pdf\">\n</md-icon><span>Imprimir detalhes do pedido</span></md-button></md-menu-item><md-menu-item><md-button type=\"button\" \nng-click=\"vm.printPvcCarc()\" class=\"md-raised\"><md-icon md-font-icon=\"icon-credit-card\"></md-icon><span>\n{{\'PEDIDO.DIRECTIVE.REQUEST_ACTIONS_DIRECTIVE.BUTTON_TOOLTIP.PRINT_PVC_CARD\'|translate}}</span></md-button>\n</md-menu-item><md-menu-item><md-button type=\"button\" ng-click=\"vm.printPackingLabel()\" class=\"md-raised\"><md-icon \nmd-font-icon=\"icon-label-outline\"></md-icon><span>\n{{\'PEDIDO.DIRECTIVE.REQUEST_ACTIONS_DIRECTIVE.BUTTON_TOOLTIP.PRINT_PACKING_LABEL\'|translate}}</span></md-button>\n</md-menu-item><md-menu-item><md-button type=\"button\" ng-click=\"vm.printSelelrAwardLabel()\" class=\"md-raised\"><md-icon \nmd-font-icon=\"icon-label-outline\"></md-icon><span>\n{{\'PEDIDO.DIRECTIVE.REQUEST_ACTIONS_DIRECTIVE.BUTTON_TOOLTIP.PRINT_SELLER_AWARD_LABEL\'|translate}}</span></md-button>\n</md-menu-item><md-menu-item><md-button type=\"button\" ng-click=\"vm.openConfigureImpressora($event)\" class=\"md-raised\">\n<md-icon md-font-icon=\"icon-cog\"></md-icon><span>Configurar impressora</span></md-button></md-menu-item>\n</md-menu-content></md-menu><md-button ng-if=\"vm.enableCancel()\" type=\"button\" ng-click=\"vm.cancelConfirm($event)\" \nclass=\"md-fab md-raised md-red-500-bg\" aria-label=\"editar\"><md-icon md-font-icon=\"icon-cancel\" class=\"white-text\">\n</md-icon><md-tooltip>Cancelar pedido</md-tooltip></md-button></div></div><div ng-if=\"vm.isUserLab()\" layout=\"row\">\n<md-button ng-disabled=\"!vm.canLabRefuseRequest()\" type=\"button\" ng-click=\"vm.callDeclineRequestDialog()\" \nng-class=\"vm.canLabRefuseRequest() ? \'md-fab md-raised md-red-500-bg\' : \'md-fab md-raised md-grey-600-bg\'\" \naria-label=\"recusar\"><md-icon md-font-icon=\"icon-thumb-down\" class=\"white-text\"></md-icon><md-tooltip>\n{{\'PEDIDO.DIRECTIVE.REQUEST_ACTIONS_DIRECTIVE.BUTTON_TOOLTIP.DECLINE\'|translate}}</md-tooltip></md-button><md-button \nng-disabled=\"!vm.canLabAcceptRequest()\" type=\"button\" ng-click=\"vm.callAcceptRequestFromAdminDialog()\" \nng-class=\"vm.canLabAcceptRequest() ? \'md-fab md-raised md-green-600-bg\' : \'md-fab md-raised md-grey-600-bg\'\" \naria-label=\"aceitar\"><md-icon md-font-icon=\"icon-thumb-up\" class=\"white-text\"></md-icon><md-tooltip>\n{{\'PEDIDO.DIRECTIVE.REQUEST_ACTIONS_DIRECTIVE.BUTTON_TOOLTIP.ACCEPT\'|translate}}</md-tooltip></md-button><md-button \nng-disabled=\"!vm.canLabSendRequestToAdmin()\" type=\"button\" ng-click=\"vm.callSendRequestFromLabToAdmin()\" \nng-class=\"vm.canLabSendRequestToAdmin() ? \'md-fab md-raised md-green-500-bg\' : \'md-fab md-raised md-grey-600-bg\'\" \naria-label=\"enviar\"><md-icon md-font-icon=\"icon-send\" class=\"white-text\"></md-icon><md-tooltip>\n{{\'PEDIDO.DIRECTIVE.REQUEST_ACTIONS_DIRECTIVE.BUTTON_TOOLTIP.SEND_FROM_LAB_TO_ADMIN\'|translate}}</md-tooltip>\n</md-button></div><div layout=\"row\" ng-if=\"!vm.isUserAdmin()\" ng-if=\"request.printers.pedido\"><md-button \nng-if=\"!vm.isUserLab()\" type=\"button\" ng-href=\"{{request.printers.pedido}}\" target=\"_blank\" \nclass=\"md-fab md-raised blue-500-bg\"><md-icon class=\"white-text\" md-font-icon=\"icon-printer\"></md-icon><md-tooltip>\nImprimir detalhes do pedido</md-tooltip></md-button><md-button ng-if=\"vm.isUserLab()\" type=\"button\" \nng-href=\"{{request.printers.pedido_lab}}\" target=\"_blank\" class=\"md-fab md-raised blue-500-bg\"><md-icon \nclass=\"white-text\" md-font-icon=\"icon-printer\"></md-icon><md-tooltip>Imprimir detalhes do pedido</md-tooltip>\n</md-button></div></div>");
$templateCache.put("/app/external/pedido/directive/pedido-comment/pedido-comment.html","<div layout=\"column\" class=\"margin-15\"><md-divider ng-repeat=\"it in [1,2,3,4]\"></md-divider><div layout=\"row\" \nlayout-align=\"center center\"><h1 class=\"md-headline\" translate=\"PEDIDO.SHOW.COMMENTS_TITLE\"></h1></div><md-divider \nng-repeat=\"it in [1,2,3,4]\"></md-divider><rf-comments config=\"vm.commetConfig\" layout-margin></rf-comments></div>");
$templateCache.put("/app/external/pedido/directive/pedido-label/pedido-label.html","<div ng-if=\"vm.isUserAdmin() || vm.isUserPolo()\"><span ng-if=\"vm.id == \'ENVIO_POLO\'\" \nclass=\"text-boxed teal-300-bg white-500-fg\">{{vm.label}} </span><span ng-if=\"vm.id == \'ENVIO_ADMIN\'\" \nclass=\"text-boxed teal-600-bg white-500-fg\">{{vm.label}} </span><span ng-if=\"vm.id == \'ENVIO_OTICA\'\" \nclass=\"text-boxed teal-900-bg white-500-fg\">{{vm.label}} </span><span ng-if=\"vm.id == \'EXECUTANDO_LAB\'\" \nclass=\"text-boxed indigo-500-bg white-500-fg\">{{vm.label}} </span><span ng-if=\"vm.id == \'AGUARDANDO_POLO\'\" \nclass=\"text-boxed cyan-900-bg white-500-fg\">{{vm.label}} </span><span ng-if=\"vm.id == \'AGUARDANDO_ADMIN\'\" \nclass=\"text-boxed light-blue-300-bg white-500-fg\">{{vm.label}} </span><span ng-if=\"vm.id == \'AGUARDANDO_LAB\'\" \nclass=\"text-boxed blue-800-bg white-500-fg\">{{vm.label}}</span></div><div ng-if=\"vm.isUserLab()\"><span \nng-if=\"vm.id == \'ENVIO_POLO\' || vm.id == \'ENVIO_ADMIN\' || vm.id == \'ENVIO_OTICA\'\" \nclass=\"text-boxed teal-600-bg white-500-fg\">{{vm.label}} </span><span ng-if=\"vm.id == \'EXECUTANDO_LAB\'\" \nclass=\"text-boxed indigo-500-bg white-500-fg\">{{vm.label}} </span><span ng-if=\"vm.id == \'AGUARDANDO_LAB\'\" \nclass=\"text-boxed blue-500-bg white-500-fg\">{{vm.label}}</span></div><div ng-if=\"vm.isUserOtica()\"><span \nng-if=\"vm.id == \'ENVIO_POLO\' || vm.id == \'ENVIO_ADMIN\' || vm.id == \'ENVIO_OTICA\'\" \nclass=\"text-boxed teal-600-bg white-500-fg\">{{vm.label}} </span><span ng-if=\"vm.id == \'EXECUTANDO_LAB\'\" \nclass=\"text-boxed indigo-500-bg white-500-fg\">{{vm.label}} </span><span \nng-if=\"vm.id == \'AGUARDANDO_POLO\' || vm.id == \'AGUARDANDO_ADMIN\' || vm.id == \'AGUARDANDO_LAB\'\" \nclass=\"text-boxed blue-500-bg white-500-fg\">{{vm.label}}</span></div><span \nng-if=\"vm.id == \'CANCELADO_POLO\' || vm.id == \'CANCELADO_OTICA\' || vm.id == \'CANCELADO_LAB\' || vm.id == \'CANCELADO_ADMIN\'\" \nclass=\"text-boxed red-500-bg white-500-fg\">{{vm.label}} </span><span ng-if=\"vm.id == \'FINALIZADO\'\" \nclass=\"text-boxed green-500-bg white-500-fg\">{{vm.label}} </span><span ng-if=\"vm.id == \'RASCUNHO\'\" \nclass=\"text-boxed yellow-800-bg white-500-fg\">{{vm.label}} </span>");
$templateCache.put("/app/external/pedido/directive/pedido-show-details/pedido-show-details.html","<div layout=\"column\" ng-cloak ng-show=\"vm.isRequestValid()\"><div layout=\"column\"><div ng-if=\"vm.showCanceledMessage\" \nlayout=\"column\" layout-align=\"center center\"><span class=\"md-title red-500-fg font-weight-500\">Pedido Cancelado!! \n</span><span class=\"md-subhead red-500-fg\">\n{{request.obs_cancelamento || \'Nenhuma mensagem de cancelamento foi fornecida.\'}}</span></div><ng-include \nsrc=\"\'/app/external/pedido/includes/_pedido-show-details-card-request-identification.html\'\" ng-if=\"!vm.isUserLab()\">\n</ng-include><ng-include src=\"\'/app/external/pedido/includes/_pedido-show-details-card-lens-specification.html\'\">\n</ng-include><ng-include src=\"\'/app/external/pedido/includes/_pedido-show-details-card-lens-prescription.html\'\">\n</ng-include><ng-include src=\"\'/app/external/pedido/includes/_pedido-show-details-card-medidas.html\'\"></ng-include>\n<ng-include src=\"\'/app/external/pedido/includes/_pedido-show-details-card-eyeglasses-frame.html\'\"></ng-include>\n<ng-include src=\"\'/app/external/pedido/includes/_pedido-show-details-card-payment.html\'\" ng-if=\"!vm.isUserLab()\">\n</ng-include><div flex layout=\"row\" class=\"full-width\"><ng-include flex flex-auto \nsrc=\"\'/app/external/pedido/includes/_pedido-show-details-card-observation.html\'\"></ng-include><ng-include \nng-if=\"vm.hasCorteRemoto()\" flex flex-auto \nsrc=\"\'/app/external/pedido/includes/_pedido-show-details-card-remote-cut.html\'\"></ng-include></div></div></div>");
$templateCache.put("/app/external/pedido/directive/product-card-switch/product-card-switch.html","<product-specifications-gressive ng-if=\"vm.request.produto && vm.request.produto.tipo === \'GRESSIVE\'\" \nproduct=\"vm.request.produto\" default-gressive-itens=\"vm.defaultGressiveItens\"></product-specifications-gressive>\n<product-specifications ng-if=\"vm.request && vm.request.produto.tipo === \'NORMAL\'\" product=\"vm.request.produto\">\n</product-specifications><span ng-if=\"!vm.request.produto\">Sem produto selecionado </span>");
$templateCache.put("/app/external/pedido/directive/product-specifications/product-specifications.html","<md-card><md-card-title style=\"border-style: solid; border-color: #0066ff; background-color: #3399ff\">\n<md-card-title-text layout=\"row\" layout-align=\"center center\"><span>Projeto de Lente</span></md-card-title-text>\n</md-card-title><md-card-content class=\"padding-top-16\"><md-content layout=\"column\" class=\"padding-0\" \nstyle=\"height: 268px\" ms-scroll><div layout=\"column\" layout-fill><div layout=\"row\" layout-align=\"center center\" \nclass=\"padding-10\"><pl-square-image src=\"vm.product.thumb_src\" size=\"\'md\'\"></pl-square-image></div><div \nlayout=\"column\" class=\"padding-10\"><md-subheader class=\"md-no-sticky\" translate=\"PEDIDO.FORM.SUBHEADER_LENS\">\n</md-subheader><md-divider class=\"blue-300-bg\"></md-divider><div layout=\"row\"><div class=\"padding-5\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-sunglasses\" ng-style=\"{\'color\': vm.product.cor.codigo}\">\n</md-icon></div><div flex layout=\"column\" class=\"padding-5\"><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ vm.product.nome }}</p><div layout=\"row\" layout-align=\"space-between center\"><p \nclass=\"md-body-1 margin-bottom-0 margin-top-5\">{{ vm.product.preco | currency : \'R$ \' : 2 }}</p><small \nclass=\"secondary-text\">REF:{{vm.product._ref}}</small></div></div><md-button ng-click=\"vm.showDetail()\" \nclass=\"md-icon-button\" aria-label=\"More\"><md-icon class=\"s24\" md-font-icon=\"icon-loupe\"></md-icon></md-button></div>\n</div></div></md-content></md-card-content></md-card>");
$templateCache.put("/app/external/pedido/directive/product-specifications-gressive/product-specifications-gressive.html","<md-card><md-card-title class=\"amber-400-bg\" style=\"border-style: solid; border-color: #FFC107\"><md-card-title-text \nlayout=\"row\" layout-align=\"center center\"><md-icon class=\"s24 m-0\" md-font-icon=\"icon-crown\"></md-icon><span \nclass=\"ml-8\">Produto Hybrid</span></md-card-title-text></md-card-title><md-card-content class=\"padding-top-16\">\n<md-content layout=\"column\" class=\"padding-0\" style=\"height: 321px\" ms-scroll><div layout=\"column\"><div layout=\"row\" \nlayout-align=\"center center\"><pl-square-image src=\"vm.product.thumb_src\" size=\"\'sm\'\"></pl-square-image><div \nlayout=\"column\" class=\"padding-10\"><md-subheader class=\"md-no-sticky\" translate=\"PEDIDO.FORM.SUBHEADER_LENS\">\n</md-subheader><md-divider class=\"blue-300-bg\"></md-divider><div layout=\"row\"><div class=\"padding-5\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-sunglasses\" ng-style=\"{\'color\': vm.product.cor.codigo}\">\n</md-icon></div><div flex layout=\"column\" class=\"padding-5\"><p class=\"md-body-1 margin-bottom-0 margin-top-5\">\n{{ vm.product.nome }}</p></div><md-button ng-click=\"vm.showDetail(\'PRODUCT_NORMAL\')\" class=\"md-icon-button\" \naria-label=\"More\"><md-icon class=\"s24\" md-font-icon=\"icon-loupe\"></md-icon></md-button></div></div></div></div><div \nlayout=\"column\" layout-fill><div layout=\"row\" layout-align=\"none center\"><md-input-container flex \nclass=\"gressive-specifications\"><label>LONGE</label><md-select ng-model=\"vm.longe\" ng-change=\"vm.setCodigo()\">\n<md-option ng-repeat=\"op in vm.itens.longe\" ng-value=\"op\" layout=\"row\" layout-align=\"space-between center\" \nng-selected=\"op.id === vm.longe.id\"><span>{{op.nome|uppercase}}</span> <strong>{{op.preco | currency : \'R$ \' : 2 }}\n</strong> <small class=\"secondary-text\">REF.:{{op._ref}}</small></md-option></md-select></md-input-container><md-button\n ng-if=\"vm.longe\" ng-click=\"vm.showDetail(\'ITEM_PRODUCT_GRESSIVE\')\" class=\"md-icon-button\" aria-label=\"More\"><md-icon \nclass=\"s24\" md-font-icon=\"icon-loupe\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"none center\">\n<md-input-container flex class=\"gressive-specifications\"><label>INTERMEDIÁRIO</label><md-select \nng-model=\"vm.intermediario\" ng-change=\"vm.setCodigo()\"><md-option ng-repeat=\"op in vm.itens.intermediario\" \nng-value=\"op\" layout=\"row\" layout-align=\"space-between center\" ng-selected=\"op.id === vm.intermediario.id\"><span>\n{{op.nome|uppercase}}</span> <strong>{{op.preco | currency : \'R$ \' : 2 }}</strong> <small class=\"secondary-text\">\nREF.:{{op._ref}}</small></md-option></md-select></md-input-container><md-button ng-if=\"vm.intermediario\" \nng-click=\"vm.showDetail(\'ITEM_PRODUCT_GRESSIVE\')\" class=\"md-icon-button\" aria-label=\"More\"><md-icon class=\"s24\" \nmd-font-icon=\"icon-loupe\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"none center\"><md-input-container \nflex class=\"gressive-specifications\"><label>PERTO</label><md-select ng-model=\"vm.perto\" ng-change=\"vm.setCodigo()\">\n<md-option ng-repeat=\"op in vm.itens.perto\" ng-value=\"op\" layout=\"row\" layout-align=\"space-between center\" \nng-selected=\"op.id === vm.perto.id\"><span>{{op.nome|uppercase}}</span> <strong>{{op.preco | currency : \'R$ \' : 2 }}\n</strong> <small class=\"secondary-text\">REF.:{{op._ref}}</small></md-option></md-select></md-input-container><md-button\n ng-if=\"vm.perto\" ng-click=\"vm.showDetail(\'ITEM_PRODUCT_GRESSIVE\')\" class=\"md-icon-button\" aria-label=\"More\"><md-icon \nclass=\"s24\" md-font-icon=\"icon-loupe\"></md-icon></md-button></div></div></md-content></md-card-content><md-card-actions\n md-theme=\"docs-dark\" layout=\"column\" layout-align=\"none\"><div layout=\"row\" layout-align=\"space-between center\">\n<md-input-container class=\"width-140\"><label>Código</label><input ng-blur=\"vm.setItensByCodigo()\" ng-model=\"vm.codigo\">\n</md-input-container><strong>{{vm.price| currency : \'R$ \' : 2 }}</strong></div><small class=\"secondary-text\">\nREF.: {{vm.ref}}</small></md-card-actions></md-card>");
$templateCache.put("/app/external/w3/components/w3-activities/activities.tmpl.html","<div class=\"activities\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon-format-list-bulleted s18\"></i> <span class=\"section-title\" translate=\"W3ACT.ACTIVITY\">Activity</span></div>\n<input type=\"search\" placeholder=\"Filtrar atividades\" ng-model=\"search\"><div class=\"section-content\"><div \nclass=\"activity\" layout=\"row\" layout-align=\"start center\" ng-repeat=\"activity in vm.activities|filter:search\">\n<w3-avatar w3-size=\"60\" w3-profile=\"activity.causer\"></w3-avatar><div layout=\"column\"><div \nclass=\"activity-member-name\">{{activity.causer.name}}</div><div class=\"activity-message\" \nng-bind-html=\"activity.description\"></div><div class=\"activity-time secondary-text\">\n{{activity.created_at|w3DatePt}} ({{activity.created_at|w3Moments}})</div></div></div></div></div>");
$templateCache.put("/app/external/w3/components/w3-comments/comments.tmpl.html","<div class=\"comment\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-comment s18\">\n</i> <span class=\"section-title\" translate=\"COMMENTS.COMMENTS\">Comments</span></div><div class=\"section-content\"><div \nlayout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\"><div layout=\"row\" flex-gt-xs=\"70\"><w3-avatar w3-size=\"60\" \nw3-profile=\"$root.rapiProfile\"></w3-avatar><md-input-container flex md-no-float><label \ntranslate=\"COMMENTS.WRITE_A_COMMENT\">Write a comment..</label><textarea ms-scroll ng-model=\"vm.rowComment.message\">\n</textarea></md-input-container></div><div class=\"slct-row\" flex-gt-xs=\"30\" flex-gt-sm=\"20\" layout=\"row\" \nlayout-align=\"end center\"><md-input-container md-no-float flex><label translate=\"COMMENTS.SLECT_TYPE\">Tipo</label>\n<md-select ng-model=\"vm.rowComment.type\"><md-option value=\"mensagem\">Mensagem</md-option><md-option value=\"observacao\">\nObservação</md-option><md-option value=\"aviso\">Aviso</md-option><md-option value=\"sugestao\">Sugestão</md-option>\n</md-select></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent md-fab send\" \nng-click=\"vm.addNewComment();\" ng-disabled=\"!vm.rowComment.message || $root.w3Reload[\'comment.save\']\" aria-label=\"Add\">\n<md-icon md-font-icon=\"icon-send\" class=\"white-text\"></md-icon><md-tooltip><span translate=\"COMMENTS.ADD_COMMENT\">\nAdicionar comentário</span></md-tooltip></md-button></div></div><div class=\"comment\" layout=\"row\" \nng-repeat=\"comment in vm.comments\"><w3-avatar w3-size=\"60\" w3-profile=\"comment.profile\"></w3-avatar><div \nlayout=\"column\"><div class=\"comment-member-name\">{{comment.profile.name}}</div><div class=\"comment-bubble\" \nlayout=\"column\">{{comment.message}}<div ng-if=\"comment.type\" layout=\"row\" layout-align=\"end end\"><span \nclass=\"text-boxed\">{{comment.type}}</span></div></div><div class=\"comment-time secondary-text\">\n{{comment.created_at|w3Moments}}</div></div></div></div></div>");
$templateCache.put("/app/external/w3/components/w3-input-city/w3-input-city.tpl.html","<md-autocomplete md-no-cache=\"true\" md-selected-item=\"vm.selectedItem\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchText)\" md-search-text=\"vm.searchText\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-items=\"item in vm.querySearch(vm.searchText)\" \nmd-item-text=\"item.city_name\" md-min-length=\"3\" md-floating-label=\"{{\'W3_INPUT_CITY.LABEL_REQ\'|translate}}\" \nmd-menu-class=\"autocomplete-custom-template\" class=\"w3-input-city\" ng-required=\"true\"><md-item-template><span \nclass=\"item-title\"><span>{{item.city_name}} </span></span><span class=\"item-metadata\"><span class=\"item-metastat\">\n{{item.state.state_name}} - {{item.state.country.country_name}}</span></span></md-item-template><md-not-found><span \ntranslate=\"W3_INPUT_CITY.NOT_FOUND\">Nenhuma cidade encontrada</span> <span ng-if=\"vm.openCreate\" \nng-click=\"vm.showCreateCity($event)\" translate=\"W3_INPUT_CITY.ADD_NOVO\">Novo</span></md-not-found></md-autocomplete>");
$templateCache.put("/app/external/w3/components/w3-report-date/w3-report-date.tmpl.html","<div layout=\"row\" class=\"w3-report-date\" layout-align=\"space-between center\"><span flex class=\"md-subhead\">\nEu quero resultados de:</span><div layout=\"row\"><md-input-container class=\"w-145\"><label>Data</label><md-select \nng-model=\"vm.dt_column\"><md-option ng-value=\"opt.param\" ng-repeat=\"opt in vm.optionsTypeFilter|orderBy:\'label\'\">\n{{opt.label}}</md-option></md-select></md-input-container><md-input-container><label>Início:</label><input type=\"date\" \nng-model=\"vm.dt_start\"></md-input-container><md-input-container><label>Fim:</label><input type=\"date\" \nng-model=\"vm.dt_end\"></md-input-container></div></div><section class=\"w3-report-date-buttons\" flex layout=\"row\" \nlayout-sm=\"column\" layout-align-gt-sm=\"start center\"><md-button class=\"md-accent\" ng-click=\"vm.setFilter(op)\" \nng-repeat=\"op in vm.optionsFilter\">{{op.label}}</md-button></section>");
$templateCache.put("/app/external/w3/components/w3-uploud/button-upload.html","<div class=\"file-uploud\" layout=\"column\" layout-align=\"center center\"><img ng-click=\"vm.showpicker($event)\" \nng-src=\"{{vm.pathSrc|| \'assets/images/default/default-image.jpg\'}}\" ng-style=\"vm.styles\"><br><md-button type=\"button\" \nclass=\"md-raised btn-icon-text\" ng-click=\"vm.showpicker($event)\"><i class=\"icon icon-picture\"></i> Alterar imagem\n</md-button></div>");
$templateCache.put("/app/external/w3/components/w3-uploud/dialog-file-uploud.html","<md-dialog aria-label=\"Carregar arquivos\" class=\"file-uploud-dialog md-dialog-600\"><form><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>{{modal.title}}</h2><span flex></span><md-button type=\"button\" class=\"md-icon-button\" \nng-click=\"modal.close()\" aria-label=\"Fechar file uploud\"><i class=\"icon icon-close s32 white-text\"></i></md-button>\n</div><md-progress-linear ng-if=\"modal.file\" md-mode=\"determinate\" value=\"{{modal.file.progress}}\">\n</md-progress-linear></md-toolbar><md-dialog-content class=\"pd-b-0\"><div class=\"file-uploud-drop\"><div layout=\"column\">\n<div class=\"drop-box drop-dashed\" layout=\"row\" layout-align=\"center center\" ng-model=\"modal.file\" ngf-drop ngf-select \nngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"false\" ngf-allow-dir=\"false\" ngf-accept=\"\'image/*\'\" ngf-max-size=\"10MB\">\n<img ngf-thumbnail=\"modal.file\" class=\"image-picker\" width=\"150\"><div ng-hide=\"modal.file\"><i \nclass=\"icon icon-cloud-upload s30 margin-r8\"></i> <span>Soltar arquivos para anexar, ou clique aqui para <a>procurar.\n</a></span></div></div><small>O tamanho máximo de envio é de 6MB por arquivo.</small><div ngf-no-file-drop>\nSeu navegador não suporta esse método de upload de arquivo</div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button type=\"button\" ng-disabled=\"!modal.pathSrc\" ng-click=\"modal.clean()\" style=\"margin-right:0\" \nclass=\"md-warn\" aria-label=\"Uploud de imagens\">Remover imagem</md-button><span flex></span><md-button type=\"button\" \nng-click=\"modal.close()\" class=\"md-raised orange-800-fg\" aria-label=\"Fechar file uploud\">Cancelar</md-button><md-button\n ng-disabled=\"!modal.file\" ng-click=\"modal.upload()\" style=\"margin-right:0\" class=\"md-raised md-accent\" \naria-label=\"Uploud de imagens\">Enviar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("/app/external/w3/components/w3-uploud/file-uploud-drop.html","<form><div class=\"file-uploud-drop\"><div layout=\"column\"><div class=\"drop-box drop-dashed\" layout=\"row\" \nlayout-align=\"center center\" ngf-drop=\"vm.addFiles($files)\" ngf-select=\"vm.addFiles($files)\" \nngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-allow-dir=\"false\" ngf-accept=\"\'*/*\'\"><i \nclass=\"icon icon-cloud-upload s30 margin-r8\"></i> <span>Soltar arquivos para anexar, ou clique aqui para <a>procurar.\n</a></span></div><small class=\"padding-l8\">O tamanho máximo de envio é de 6MB por arquivo.</small><div \nngf-no-file-drop>Seu navegador não suporta esse método de upload de arquivo</div></div><div class=\"list-itens-uploud\" \nlayout=\"column\"><div class=\"item-ulpoud\" layout=\"row\" layout-xs=\"column\" flex ng-repeat=\"file in vm.files\"><div \nclass=\"bg-item-image\"><img ngf-thumbnail=\"file\" width=\"50\"></div><div flex layout=\"row\"><div flex \nclass=\"padding-l8 padding-t8\"><div layout=\"row\"><span class=\"trunk\" flex>{{file.name}}</span> <span class=\"padding-l8\">\n{{file.size|w3FileSize:1}}</span></div><md-progress-linear md-mode=\"determinate\" value=\"{{file.progress}}\">\n</md-progress-linear></div><md-button type=\"button\" aria-label=\"Remove arquivo selecionado\" \nng-click=\"vm.removeFiles($index)\" class=\"md-icon-button\"><i class=\"icon icon-close s32\"></i></md-button></div></div>\n</div><md-dialog-actions ng-if=\"vm.files.length\" layout=\"row\"><span flex></span><md-button type=\"button\" \nng-click=\"vm.reset()\" class=\"md-raised orange-800-fg\" aria-label=\"Fechar file uploud\">Cancelar</md-button><md-button \ntype=\"button\" ng-click=\"vm.upload()\" style=\"margin-right:0\" class=\"md-deep-purple-500-bg\" \naria-label=\"Uploud de imagens\"><i class=\"icon icon-cloud-upload s20 margin-r8 white-text\"></i> Uploud</md-button>\n</md-dialog-actions></div></form>");
$templateCache.put("/app/external/fuse-core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("/app/external/fuse-core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("/app/external/fuse/layouts/partials/navigation/horizontal-navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("/app/external/fuse/layouts/partials/navigation/vertical-navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp ph-16\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span ng-if=\"vm.logo\" class=\"logo-img\"><img ng-src=\"{{vm.logo}}\" \nalt=\"{{vm.title_project}}\"> </span><span ng-if=\"!vm.logo\" class=\"logo-image\">{{vm.sigla}}</span> <span \nng-if=\"!vm.logo\" class=\"logo-text\">{{vm.title_project}}</span></div><md-icon class=\"fold-toggle s18 no-margin\" \nmd-font-icon=\"icon-backburger\" aria-label=\"menu\" hide show-{{vm.openmenu}} ng-click=\"vm.toggleMsNavigationFolded()\">\n</md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\">\n</ms-navigation><div flex layout=\"column\" layout-align=\"end center\"><a class=\"credits-logo no-style\" layout=\"row\" \nlayout-align=\"center center\" ng-href=\"{{vm.credits_link}}\" target=\"_blank\"><small class=\"mr-8\">Desenvolvido por</small>\n <img class=\"h-25\" ng-src=\"{{vm.credits_logo}}\"> </a><span class=\"Secondary-text\">{{vm.versao}}</span></div>");
$templateCache.put("/app/external/fuse/layouts/partials/navigation/vertical-navigation2.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation><div flex \nlayout=\"column\" layout-align=\"end center\"><a class=\"credits-logo no-style\" layout=\"row\" layout-align=\"center center\" \nng-href=\"{{vm.credits_link}}\" target=\"_blank\"><small class=\"mr-8\">Desenvolvido por</small> <img class=\"h-25\" \nng-src=\"{{vm.credits_logo}}\"> </a><span class=\"Secondary-text\">{{vm.versao}}</span></div>");
$templateCache.put("/app/external/fuse/layouts/partials/quickpanel/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("/app/external/fuse/layouts/partials/quickpanel/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\" class=\"s16\"></md-icon>\n</md-button></form></div>");
$templateCache.put("/app/external/fuse/layouts/partials/quickpanel/notificacoes.html","<md-list class=\"friends\"><md-list-item class=\"friend md-3-line\" ng-repeat=\"item in vm.activities\"><rf-avatar \nrf-size=\"40\" rf-profile=\"item.profile\" rf-only-text=\"false\"></rf-avatar><div class=\"md-list-item-text no-margin\"><b>\n{{item.profile.name}}</b><h3 class=\"message\">{{item.description}}</h3><p class=\"time\">{{item.created_at}}</p></div>\n</md-list-item></md-list>");
$templateCache.put("/app/external/fuse/layouts/partials/quickpanel/quickpanel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.NOTIFICACOES\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'/app/external/fuse/layouts/partials/quickpanel/notificacoes.html\'\"></md-content></md-tab-body>\n</md-tab></md-tabs></md-content>");
$templateCache.put("/app/external/fuse/layouts/partials/quickpanel/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>\n{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>\n{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\">\n<span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" \naria-label=\"Notifications\" translate translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\">\n</md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch \nclass=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("/app/external/fuse/layouts/partials/toolbar/hor-toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><rf-avatar rf-size=\"40\" rf-profile=\"rapiProfile\" rf-only-text=\"false\"></rf-avatar></div><span \nclass=\"username\" hide show-gt-sm>{{rapiProfile.name}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" \nhide-xs></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdMenu.open()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Sair</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("/app/external/fuse/layouts/partials/toolbar/toolbar-no-quick.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button hide-gt-xs\" ng-click=\"vm.toggleSidenav(\'navigation\')\" \naria-label=\"Toggle navigation\" translate><md-icon md-font-icon=\"icon-menu\" aria-label=\"menu\" class=\"icon\"></md-icon>\n</md-button><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><rf-avatar rf-size=\"40\" rf-profile=\"rapiProfile\" rf-only-text=\"false\"></rf-avatar></div><span \nclass=\"username\" hide show-gt-sm>{{rapiProfile.name}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" \nhide-xs></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdMenu.open()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \naria-label=\"sair\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Sair</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar></div></div>");
$templateCache.put("/app/external/fuse/layouts/partials/toolbar/toolbar-no-quick2.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><rf-avatar rf-size=\"40\" rf-profile=\"rapiProfile\" rf-only-text=\"false\"></rf-avatar></div><span \nclass=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon>\n</div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdMenu.open()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar></div></div>");
$templateCache.put("/app/external/fuse/layouts/partials/toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button hide-{{vm.openMenu}}\" ng-click=\"vm.toggleSidenav(\'navigation\')\" \naria-label=\"Toggle navigation\" translate><md-icon md-font-icon=\"icon-menu\" aria-label=\"menu\" class=\"icon\"></md-icon>\n</md-button><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><rf-avatar rf-size=\"40\" rf-profile=\"rapiProfile\" rf-only-text=\"false\"></rf-avatar></div><span \nclass=\"username\" hide show-gt-sm>{{rapiProfile.name}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" \nhide-xs></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.profile\">\n<md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>Perfil</md-button></md-menu-item>\n<md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \naria-label=\"sair\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Sair</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("/app/external/fuse/layouts/partials/toolbar/toolbar2.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><rf-avatar rf-size=\"40\" rf-profile=\"rapiProfile\" rf-only-text=\"false\"></rf-avatar></div><span \nclass=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon>\n</div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdMenu.open()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("/app/external/w3/components/w3-uploud/button-upload/button-upload.html","<md-button ng-model=\"vm.file\" ngf-select=\"vm.upload()\" ngf-multiple=\"false\" ngf-allow-dir=\"false\" ngf-max-size=\"10MB\">\n{{vm.title}}</md-button>");
$templateCache.put("/app/external/fuse-core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("/app/external/fuse-core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("/app/external/fuse-core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("/app/external/fuse-core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("/app/external/fuse-core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("/app/external/fuse-core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("/app/external/fuse-core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("/app/external/fuse-core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("/app/external/fuse-core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("/app/external/fuse-core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("/app/external/fuse-core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("/app/external/fuse-core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("/app/external/fuse-core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");}]);